
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0a21"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0a21"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iqelV", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("cbQCu", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $8dff54558831dec9$export$a143d493d941bafc, (v) => $8dff54558831dec9$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $8dff54558831dec9$export$f99ded8fe4b79145, (v) => $8dff54558831dec9$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8dff54558831dec9$export$a143d493d941bafc;
var $8dff54558831dec9$export$e4cf37d7f6fb9e0a;
var $8dff54558831dec9$export$f99ded8fe4b79145;
var $8dff54558831dec9$export$599f31c3813fae4d;
'use strict';

var $6ocIT = parcelRequire("6ocIT");

var $1wLos = parcelRequire("1wLos");
const $8dff54558831dec9$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$8dff54558831dec9$export$a143d493d941bafc = $8dff54558831dec9$var$Buffer;
$8dff54558831dec9$export$e4cf37d7f6fb9e0a = $8dff54558831dec9$var$SlowBuffer;
$8dff54558831dec9$export$f99ded8fe4b79145 = 50;
const $8dff54558831dec9$var$K_MAX_LENGTH = 0x7fffffff;
$8dff54558831dec9$export$599f31c3813fae4d = $8dff54558831dec9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT = $8dff54558831dec9$var$typedArraySupport();
if (!$8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8dff54558831dec9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8dff54558831dec9$var$createBuffer(length) {
    if (length > $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8dff54558831dec9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8dff54558831dec9$var$allocUnsafe(arg);
    }
    return $8dff54558831dec9$var$from(arg, encodingOrOffset, length);
}
$8dff54558831dec9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8dff54558831dec9$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $8dff54558831dec9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8dff54558831dec9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8dff54558831dec9$var$isInstance(value, ArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, ArrayBuffer)) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($8dff54558831dec9$var$isInstance(value, SharedArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, SharedArrayBuffer))) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8dff54558831dec9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8dff54558831dec9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $8dff54558831dec9$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8dff54558831dec9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8dff54558831dec9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8dff54558831dec9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8dff54558831dec9$var$Buffer, Uint8Array);
function $8dff54558831dec9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8dff54558831dec9$var$alloc(size, fill, encoding) {
    $8dff54558831dec9$var$assertSize(size);
    if (size <= 0) return $8dff54558831dec9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $8dff54558831dec9$var$createBuffer(size).fill(fill, encoding) : $8dff54558831dec9$var$createBuffer(size).fill(fill);
    return $8dff54558831dec9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8dff54558831dec9$var$Buffer.alloc = function(size, fill, encoding) {
    return $8dff54558831dec9$var$alloc(size, fill, encoding);
};
function $8dff54558831dec9$var$allocUnsafe(size) {
    $8dff54558831dec9$var$assertSize(size);
    return $8dff54558831dec9$var$createBuffer(size < 0 ? 0 : $8dff54558831dec9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8dff54558831dec9$var$Buffer.allocUnsafe = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8dff54558831dec9$var$Buffer.allocUnsafeSlow = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
function $8dff54558831dec9$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $8dff54558831dec9$var$byteLength(string, encoding) | 0;
    let buf = $8dff54558831dec9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8dff54558831dec9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8dff54558831dec9$var$checked(array.length) | 0;
    const buf = $8dff54558831dec9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8dff54558831dec9$var$fromArrayView(arrayView) {
    if ($8dff54558831dec9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8dff54558831dec9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8dff54558831dec9$var$fromArrayLike(arrayView);
}
function $8dff54558831dec9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
function $8dff54558831dec9$var$fromObject(obj) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(obj)) {
        const len = $8dff54558831dec9$var$checked(obj.length) | 0;
        const buf = $8dff54558831dec9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $8dff54558831dec9$var$numberIsNaN(obj.length)) return $8dff54558831dec9$var$createBuffer(0);
        return $8dff54558831dec9$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $8dff54558831dec9$var$fromArrayLike(obj.data);
}
function $8dff54558831dec9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8dff54558831dec9$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $8dff54558831dec9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8dff54558831dec9$var$Buffer.alloc(+length);
}
$8dff54558831dec9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8dff54558831dec9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8dff54558831dec9$var$Buffer.compare = function compare(a, b) {
    if ($8dff54558831dec9$var$isInstance(a, Uint8Array)) a = $8dff54558831dec9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8dff54558831dec9$var$isInstance(b, Uint8Array)) b = $8dff54558831dec9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(a) || !$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8dff54558831dec9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$8dff54558831dec9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8dff54558831dec9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8dff54558831dec9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8dff54558831dec9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) buf = $8dff54558831dec9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8dff54558831dec9$var$byteLength(string, encoding) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8dff54558831dec9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $8dff54558831dec9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8dff54558831dec9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8dff54558831dec9$var$Buffer.byteLength = $8dff54558831dec9$var$byteLength;
function $8dff54558831dec9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $8dff54558831dec9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$latin1Slice(this, start, end);
        case 'base64':
            return $8dff54558831dec9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8dff54558831dec9$var$Buffer.prototype._isBuffer = true;
function $8dff54558831dec9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8dff54558831dec9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$8dff54558831dec9$var$swap(this, i, i + 1);
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $8dff54558831dec9$var$swap(this, i, i + 3);
        $8dff54558831dec9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $8dff54558831dec9$var$swap(this, i, i + 7);
        $8dff54558831dec9$var$swap(this, i + 1, i + 6);
        $8dff54558831dec9$var$swap(this, i + 2, i + 5);
        $8dff54558831dec9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $8dff54558831dec9$var$utf8Slice(this, 0, length);
    return $8dff54558831dec9$var$slowToString.apply(this, arguments);
};
$8dff54558831dec9$var$Buffer.prototype.toLocaleString = $8dff54558831dec9$var$Buffer.prototype.toString;
$8dff54558831dec9$var$Buffer.prototype.equals = function equals(b) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $8dff54558831dec9$var$Buffer.compare(this, b) === 0;
};
$8dff54558831dec9$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $8dff54558831dec9$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($8dff54558831dec9$var$customInspectSymbol) $8dff54558831dec9$var$Buffer.prototype[$8dff54558831dec9$var$customInspectSymbol] = $8dff54558831dec9$var$Buffer.prototype.inspect;
$8dff54558831dec9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8dff54558831dec9$var$isInstance(target, Uint8Array)) target = $8dff54558831dec9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8dff54558831dec9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8dff54558831dec9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $8dff54558831dec9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8dff54558831dec9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8dff54558831dec9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8dff54558831dec9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $8dff54558831dec9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8dff54558831dec9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8dff54558831dec9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8dff54558831dec9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8dff54558831dec9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8dff54558831dec9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8dff54558831dec9$var$utf8Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8dff54558831dec9$var$asciiWrite(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$asciiToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$base64Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$base64ToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$ucs2Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8dff54558831dec9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $8dff54558831dec9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8dff54558831dec9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8dff54558831dec9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6ocIT.fromByteArray(buf);
    else return $6ocIT.fromByteArray(buf.slice(start, end));
}
function $8dff54558831dec9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8dff54558831dec9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8dff54558831dec9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8dff54558831dec9$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8dff54558831dec9$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8dff54558831dec9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $8dff54558831dec9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8dff54558831dec9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8dff54558831dec9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8dff54558831dec9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8dff54558831dec9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$8dff54558831dec9$var$Buffer.prototype.readUintLE = $8dff54558831dec9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUintBE = $8dff54558831dec9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUint8 = $8dff54558831dec9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8dff54558831dec9$var$Buffer.prototype.readUint16LE = $8dff54558831dec9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8dff54558831dec9$var$Buffer.prototype.readUint16BE = $8dff54558831dec9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8dff54558831dec9$var$Buffer.prototype.readUint32LE = $8dff54558831dec9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8dff54558831dec9$var$Buffer.prototype.readUint32BE = $8dff54558831dec9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8dff54558831dec9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8dff54558831dec9$var$Buffer.prototype.readBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8dff54558831dec9$var$Buffer.prototype.readBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8dff54558831dec9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, true, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, false, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, true, 52, 8);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, false, 52, 8);
};
function $8dff54558831dec9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$8dff54558831dec9$var$Buffer.prototype.writeUintLE = $8dff54558831dec9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUintBE = $8dff54558831dec9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint8 = $8dff54558831dec9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8dff54558831dec9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8dff54558831dec9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $8dff54558831dec9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $8dff54558831dec9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8dff54558831dec9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, false, noAssert);
};
function $8dff54558831dec9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8dff54558831dec9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8dff54558831dec9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8dff54558831dec9$var$Buffer.isBuffer(val) ? val : $8dff54558831dec9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8dff54558831dec9$var$errors = {};
function $8dff54558831dec9$var$E(sym, getMessage, Base) {
    $8dff54558831dec9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8dff54558831dec9$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$8dff54558831dec9$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8dff54558831dec9$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8dff54558831dec9$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8dff54558831dec9$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8dff54558831dec9$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8dff54558831dec9$var$checkBounds(buf, offset, byteLength) {
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8dff54558831dec9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $8dff54558831dec9$var$checkBounds(buf, offset, byteLength);
}
function $8dff54558831dec9$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $8dff54558831dec9$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $8dff54558831dec9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8dff54558831dec9$var$validateNumber(value, type);
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $8dff54558831dec9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8dff54558831dec9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8dff54558831dec9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8dff54558831dec9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $8dff54558831dec9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $8dff54558831dec9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8dff54558831dec9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8dff54558831dec9$var$base64ToBytes(str) {
    return $6ocIT.toByteArray($8dff54558831dec9$var$base64clean(str));
}
function $8dff54558831dec9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8dff54558831dec9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8dff54558831dec9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8dff54558831dec9$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8dff54558831dec9$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $8dff54558831dec9$var$BufferBigIntNotDefined : fn;
}
function $8dff54558831dec9$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("6ocIT", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $4a6eda7d0e4e0857$export$d622b2ad8d90c771, (v) => $4a6eda7d0e4e0857$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $4a6eda7d0e4e0857$export$6100ba28696e12de, (v) => $4a6eda7d0e4e0857$export$6100ba28696e12de = v);
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
'use strict';
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup['-'.charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup['_'.charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("1wLos", function(module, exports) {

$parcel$export(module.exports, "read", () => $11cd8afb6c84e33a$export$aafa59e2e03f2942, (v) => $11cd8afb6c84e33a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $11cd8afb6c84e33a$export$68d8715fc104d294, (v) => $11cd8afb6c84e33a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("hSilF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d035b6734693e82f$export$2e2bcd8739ae039);
parcelRequire("jTmqR");

var $4NX2m = parcelRequire("4NX2m");

var $bOgnf = parcelRequire("bOgnf");

var $ikHJv = parcelRequire("ikHJv");

var $1QwlQ = parcelRequire("1QwlQ");

var $jA2UJ = parcelRequire("jA2UJ");

var $2rJ7D = parcelRequire("2rJ7D");

var $9snnZ = parcelRequire("9snnZ");

var $b7lSL = parcelRequire("b7lSL");

var $5J4VT = parcelRequire("5J4VT");

var $KjYoF = parcelRequire("KjYoF");
parcelRequire("eaQG2");

var $aR0P0 = parcelRequire("aR0P0");

var $9rddt = parcelRequire("9rddt");
// COLOR PALLETS:
// https://coolors.co/eb5e55-e4ff1a-e8aa14-6cd4ff-ff5714
// https://coolors.co/eb5e55-e8aa14-e4ff1a-6cd4ff-a8ea8d-bec66f-ff5714
// TODO:
// <all done!>
// COMPLETED:
// Game Start transition (after music select)
// Link audio fade in, fade out & chorusLoop to Album Object
// Combo Count
// Modify random function to prevent big fluctuations
// COLOR SCHEME + Blur effect around lines to help with neon effect
// BUG: Hover does not work properly on display resizing.
// Music Loading Sign at Select Menu, retry music load if fail
// Body Image Segmentation
// Bug: Select Menu. Remove song title when screen exit, otherwise title is displayed during back btn transition.
// IMP: Disable button after press & Prevent Button Double Click/Prevent simultaneous Player call
// Add AlbumArt Animations/Improvements
// Add options to select cursor/webcam mode
// Update page titles & hide cursor in webcam mode.
// Add Settings Modal
// create rectResizeV2, scale based on a center
// Cursor/Touch Mode: register clicks and press instead of hover; consider removing red dot
// Possible Bug: Displayed cursor radius may not reflect actual radius due to scalling.
// Ask user to rotate screen if at portrait rotation.
// End Game stats
// Full screen toggle using double click
// Instructional images
// Cursor Mode: real fullscreen do not exist in iPhones and iPads, set bounding box based on visibility on screen.
// Select Menu Background
// Webcam mode show popup to wait if taking too long.
// CANCELED:
// Create press and hold option for Word Object
// Maybe make the game easier (allow some clicks before word start time?)
// Move word if it's bounding circle is out of screen
// Change cursor on button hover so that it is easier to see. 
// Fix Camera problem (game may break if webcam resolution > screen resolution) [Not a problem]
class $d035b6734693e82f$var$MainGame {
    activeScreens = /** @type {Screen[]} */ new Array();
    songData = new Array();
    selectedSongIndex = 0;
    currentlyActiveScreen = /** @type {string | undefined} */ undefined;
    constructor(canvasCtx, width, height, offsetX, offsetY, mode, lang){
        this.canvasCtx = canvasCtx;
        this.width = width;
        this.height = height;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        this.mode = mode;
        this.lang = lang;
        this.player = new (0, $2rJ7D.Player)({
            app: {
                token: "TcA8uaS3v2TKzWRW"
            }
        });
        if (!canvasCtx.roundRect) {
            alert("\u73FE\u5728\u306E\u30D6\u30E9\u30A6\u30B6\u306F\u53E4\u3059\u304E\u308B\u305F\u3081\u3001\u3053\u306E\u30B2\u30FC\u30E0\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u307E\u305B\u3093\u3002\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B\u304B\u3001\u5225\u306E\u30D6\u30E9\u30A6\u30B6\u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002\nThe current browser is too old and is not supported by the game. Please update your browser or change to a different one.");
            window.close();
        }
        const testAudio = document.createElement('audio');
        testAudio.volume = 0.5;
        setTimeout(()=>{
            if (testAudio.volume != 0.5) alert("iOS\u306E\u5236\u9650\u306B\u3088\u308A\u3001\u30B2\u30FC\u30E0\u5185\u306E\u97F3\u58F0\u304C\u6B63\u3057\u304F\u30D5\u30A7\u30FC\u30C9\u30A4\u30F3\u30FB\u30D5\u30A7\u30FC\u30C9\u30A2\u30A6\u30C8\u3057\u306A\u3044\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\nDue to iOS constraints, the audio will not fade in and out properly in the game.");
        }, 100);
    // this.setActiveScreen('intro');
    }
    async load() {
        const promises = [
            new Promise(async (resolve, reject)=>{
                try {
                    console.log("Fetching Songs...");
                    this.songData = await (await fetch('./assets/data/songs.json')).json();
                    while(this.player.isLoading){
                        console.log("Waiting for player...");
                        await (0, $9snnZ.sleep)(500);
                    }
                    // console.log("Player Ready! Caching all track data...");
                    // try{
                    //   for (let i = 0; i < this.songData.length; i++){
                    //     await this.player.createFromSongUrl(...this.songData[i].textAliveData);
                    //   }
                    // }
                    // catch(e){
                    //   console.error(e);
                    //   console.warn("Failed to cache all track data, waiting 2 seconds and continuing...");
                    //   await sleep(2000);
                    // }
                    // this.player.addListener('onPause', (event) => event.preventDefault());
                    console.log("Player Ready! Caching first song...");
                    this.player.volume = 0;
                    let wait_counter = 2;
                    while(!this.currentSongData)try {
                        this.currentSongData = await this.player.createFromSongUrl(...this.songData[0].textAliveData);
                    } catch (e) {
                        if (wait_counter >= 8) {
                            alert(`\u{30A8}\u{30E9}\u{30FC}\u{FF1A}${this.songData[this.selectedSongIndex].title} \u{306E}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{306B}7\u{56DE}\u{5931}\u{6557}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}\u{30A2}\u{30D7}\u{30EA}\u{3092}\u{518D}\u{8D77}\u{52D5}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{FF01}
ERROR: FAILED TO LOAD ${this.songData[0].title} AFTER 7 ATTEMPTS! PLEASE RESTART THE APP!`);
                            throw e;
                        }
                        console.error(e);
                        console.warn(`Attempting to load first song again in ${wait_counter} seconds...`);
                        await (0, $9snnZ.sleep)(wait_counter * 1000);
                        wait_counter++;
                    }
                    // Fix player control problem on mobile 
                    // For some reason, if I don't force the song to reload, the app won't work on mobile browsers
                    this.currentSongData = undefined;
                    // console.dir(this.player);
                    console.log("Player loaded successfully!");
                    resolve();
                } catch (e) {
                    reject(e);
                }
            })
        ];
        console.dir(promises);
        for(let key in this.icons)promises.push(this.icons[key].load());
        for(let key in this.images)promises.push(this.images[key].load());
        await Promise.all(promises);
    // console.dir(this.songData);
    }
    updateScreenRes(width, height, offsetX, offsetY) {
        this.width = width;
        this.height = height;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        for(let i = 0; i < this.activeScreens.length; i++){
            this.activeScreens[i].screenState.width = width;
            this.activeScreens[i].screenState.height = height;
            this.activeScreens[i].screenState.offsetX = offsetX;
            this.activeScreens[i].screenState.offsetY = offsetY;
        }
    }
    setActiveScreen(screenName, screenArgs) {
        this.activeScreens[0]?.startOutroTransition();
        const newScreen = new (0, $4NX2m.default)(new (0, $4NX2m.ScreenState)(this.canvasCtx, 0, 0, this.width, this.height, this.offsetX, this.offsetY, this.mode, this.lang, this.player ? this.player.timer.position : undefined), screenArgs ? this.screens[screenName](...screenArgs) : this.screens[screenName]());
        newScreen.startIntroTransition();
        this.activeScreens.unshift(newScreen);
        this.currentlyActiveScreen = screenName;
    }
    icons = /** @type { {[id: string] : () => SVG[]} } */ {
        'play': new (0, $1QwlQ.SVG)('./assets/icons/play_arrow_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24.svg'),
        'prev': new (0, $1QwlQ.SVG)('./assets/icons/skip_previous_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24.svg'),
        'next': new (0, $1QwlQ.SVG)('./assets/icons/skip_next_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24.svg'),
        'note': new (0, $1QwlQ.SVG)('./assets/icons/music_note_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24.svg'),
        'headphones': new (0, $1QwlQ.SVG)('./assets/icons/headphones_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg'),
        'piano': new (0, $1QwlQ.SVG)('./assets/icons/piano_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg'),
        'radio': new (0, $1QwlQ.SVG)('./assets/icons/radio_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg'),
        'speaker': new (0, $1QwlQ.SVG)('./assets/icons/speaker_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg'),
        'album': new (0, $1QwlQ.SVG)('./assets/icons/album_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg'),
        'volume_up': new (0, $1QwlQ.SVG)('./assets/icons/volume_up_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg'),
        'graphic_eq': new (0, $1QwlQ.SVG)('./assets/icons/graphic_eq_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg'),
        'instant_mix': new (0, $1QwlQ.SVG)('./assets/icons/instant_mix_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg')
    };
    images = /** @type { {[id: string] : () => PNG[]} } */ {
        'miku_webcam_example': new (0, $1QwlQ.PNG)('./assets/images/Miku Webcam Example With Webcam Monitor Frame Final Compressed v2.png'),
        'rin_and_len_webcam_example': new (0, $1QwlQ.PNG)('./assets/images/Rin And Len Webcam Example With Webcam Monitor Frame Final Compressed v2.png'),
        'kaito_webcam_example': new (0, $1QwlQ.PNG)('./assets/images/Kaito Example No BG Compressed.png')
    };
    /**
   * Translates the difficulty label if required based on current settings.
   * @param {string} difficultyText 
   * @returns Translated Difficulty Label
   */ translateDifficultyText(difficultyText) {
        if (this.lang == 'jp') {
            if (difficultyText.trim().toLowerCase() == 'easy') return "\u7C21\u5358";
            else if (difficultyText.trim().toLowerCase() == 'intermediate') return "\u4E2D\u7D1A";
            else if (difficultyText.trim().toLowerCase() == 'hard') return "\u96E3\u3057\u3044";
        } else return difficultyText;
    }
    screens = /** @type { {[id: string] : () => Drawable[]} } */ {
        'intro': ()=>[
                new (0, $9rddt.default)(this.images['miku_webcam_example'], this.images['rin_and_len_webcam_example'], this.images['kaito_webcam_example']),
                new (0, $bOgnf.Text)(710, 140, "\u30BF\u30C3\u30D7\u30BF\u30C3\u30D7", (0, $KjYoF.rgb)(255, 87, 20), (0, $KjYoF.rgb)(255, 87, 20), true, 96, undefined, 'center'),
                new (0, $ikHJv.CircularButton)(710, 261, 50, "Start", ()=>{
                    console.log('start');
                    this.setActiveScreen('select_music');
                })
            ],
        // 'test': () => [
        //   new ScoreBoard(60000, 67000, 23, 52.3, [1,1,1,1,1,0,0,1,1,1,0,1,1,0,0,1,1,1,1,0,1,1,0,1], ()=>{})
        // ],
        'select_music': ()=>{
            // let songIndex = 0;
            let loadingCount = 0;
            const findLongestSegment = (segments)=>{
                let longestStart = 0;
                let longestDuration = 0;
                let currentChunkStart;
                let currentChunkEnd;
                for(let i = 0; i < segments.length; i++){
                    if (!currentChunkStart || segments[i].startTime != currentChunkEnd) {
                        currentChunkStart = segments[i].startTime;
                        currentChunkEnd = segments[i].endTime;
                    } else if (currentChunkEnd == segments[i].startTime) currentChunkEnd = segments[i].endTime;
                    if (currentChunkEnd - currentChunkStart > longestDuration) {
                        longestDuration = currentChunkEnd - currentChunkStart;
                        longestStart = currentChunkStart;
                    }
                }
                return [
                    longestStart,
                    longestDuration
                ];
            };
            const albumArtElm = new (0, $jA2UJ.default)(this.icons['note'], this.songData[0].title, this.songData[0].artist, this.translateDifficultyText(this.songData[0].difficulty), this.player, (0, $9snnZ.shuffleArray)([
                this.icons['note'],
                this.icons['headphones'],
                this.icons['piano'],
                this.icons['radio'],
                this.icons['speaker'],
                this.icons['album'],
                this.icons['volume_up'],
                this.icons['graphic_eq'],
                this.icons['instant_mix']
            ]));
            this.playerButtons = new Array();
            let playBtn, prevBtn, nextBtn;
            const updateAlbum = async ()=>{
                albumArtElm.title = this.songData[this.selectedSongIndex].title;
                albumArtElm.artist = this.songData[this.selectedSongIndex].artist;
                albumArtElm.difficulty = this.translateDifficultyText(this.songData[this.selectedSongIndex].difficulty);
                loadingCount++;
                playBtn.disabled = true;
                prevBtn.disabled = true;
                nextBtn.disabled = true;
                playBtn.loading = true;
                // const queue_number = loadingCount;
                // while (loadingCount > 1){
                //   if (loadingCount != queue_number){
                //     console.warn(`Song ${this.songData[this.selectedSongIndex].title} waiting in queue ${queue_number}/${loadingCount} for execution. Waiting 2 seconds...`)
                //     await sleep(2000);
                //   }
                // }
                if (!albumArtElm.currentSongPreviewStart || !albumArtElm.currentSongPreviewEnd) {
                    if (!this.currentSongData) this.currentSongData = await this.player.createFromSongUrl(...this.songData[this.selectedSongIndex].textAliveData);
                    const [previewStartTime, previewDuration] = findLongestSegment(this.player.getChoruses());
                    console.dir({
                        previewStartTime: previewStartTime,
                        previewDuration: previewDuration
                    });
                    console.log(previewStartTime + previewDuration);
                    albumArtElm.currentSongPreviewStart = previewStartTime - 500;
                    albumArtElm.currentSongPreviewEnd = previewStartTime + previewDuration;
                    this.player.requestMediaSeek(previewStartTime - 500);
                    this.player.requestPlay();
                    // console.dir(albumArtElm);
                    loadingCount--;
                    if (loadingCount <= 0) {
                        playBtn.disabled = false;
                        prevBtn.disabled = false;
                        nextBtn.disabled = false;
                        playBtn.loading = false;
                        console.dir(playBtn);
                    }
                } else albumArtElm.changeSongCallback = async ()=>{
                    console.log('callbackRunning');
                    try {
                        this.player.requestStop();
                        let wait_counter = 2;
                        while(true)try {
                            this.currentSongData = await this.player.createFromSongUrl(...this.songData[this.selectedSongIndex].textAliveData);
                            break;
                        // const prevSongData = this.currentSongData;
                        // this.currentSongData = await this.player.createFromSongUrl(...this.songData[this.selectedSongIndex].textAliveData);
                        // if (this.currentSongData.duration != prevSongData.duration || this.currentSongData.charCount != prevSongData.charCount){// Check if the new song has loaded.
                        //   break
                        // }
                        // else{
                        //   throw Error("new song cannot load yet")
                        // }
                        } catch (e) {
                            if (wait_counter >= 8) {
                                alert(`\u{30A8}\u{30E9}\u{30FC}\u{FF1A}${this.songData[this.selectedSongIndex].title} \u{306E}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{306B}7\u{56DE}\u{5931}\u{6557}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}\u{30A2}\u{30D7}\u{30EA}\u{3092}\u{518D}\u{8D77}\u{52D5}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{FF01}
ERROR: FAILED TO LOAD SONG ${this.songData[this.selectedSongIndex].title} AFTER 7 ATTEMPTS! PLEASE RESTART THE APP!`);
                                loadingCount--;
                                playBtn.disabled = true;
                                prevBtn.disabled = false;
                                nextBtn.disabled = false;
                                playBtn.loading = false;
                                throw e;
                            }
                            console.error(e);
                            console.warn(`Attempting to load music again in ${wait_counter} seconds...`);
                            await (0, $9snnZ.sleep)(wait_counter * 1000);
                            wait_counter++;
                        }
                        const [previewStartTime, previewDuration] = findLongestSegment(this.player.getChoruses());
                        albumArtElm.currentSongPreviewStart = previewStartTime - 500;
                        albumArtElm.currentSongPreviewEnd = previewStartTime + previewDuration;
                        this.player.requestMediaSeek(previewStartTime - 500);
                        this.player.requestPlay();
                        albumArtElm.lastLoopTrigger = undefined;
                        loadingCount--;
                        if (loadingCount <= 0) {
                            playBtn.disabled = false;
                            prevBtn.disabled = false;
                            nextBtn.disabled = false;
                            playBtn.loading = false;
                            console.dir(playBtn);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                };
            };
            playBtn = new (0, $ikHJv.IconButton)(710, 590, 50, this.icons['play'], "Play", ()=>{
                console.log('music_select');
                albumArtElm.playPressed = true;
                for(let i; i < this.playerButtons.length; i++)this.playerButtons[i].disabled = true;
                albumArtElm.stopMusicNow();
                if (!this.currentSongData) this.player.createFromSongUrl(...this.songData[this.selectedSongIndex].textAliveData).then((data)=>this.setActiveScreen('game', [
                        data,
                        this.songData[this.selectedSongIndex]
                    ]));
                else this.setActiveScreen('game', [
                    this.currentSongData,
                    this.songData[this.selectedSongIndex]
                ]);
            });
            prevBtn = new (0, $ikHJv.IconButton)(560, 590, 30, this.icons['prev'], "Previous", ()=>{
                console.log('music_prev');
                this.selectedSongIndex = this.selectedSongIndex > 0 ? this.selectedSongIndex - 1 : this.songData.length - 1;
                albumArtElm.stopMusicNow();
                updateAlbum();
            });
            nextBtn = new (0, $ikHJv.IconButton)(860, 590, 30, this.icons['next'], "Next", ()=>{
                console.log('music_next');
                this.selectedSongIndex = this.selectedSongIndex + 1 < this.songData.length ? this.selectedSongIndex + 1 : 0;
                albumArtElm.stopMusicNow();
                updateAlbum();
            });
            updateAlbum();
            return [
                albumArtElm,
                new (0, $ikHJv.CircularButton)(177.5, 75, 50, this.lang == 'jp' ? "\u623B\u308B" : "back", ()=>{
                    console.log('back');
                    albumArtElm.stopMusicNow();
                    this.setActiveScreen('intro');
                    setTimeout(()=>{
                        if (this.currentlyActiveScreen == 'intro') this.player.requestPause();
                    }, 750);
                }),
                playBtn,
                prevBtn,
                nextBtn
            ];
        },
        // 'game_temp': () => {
        //   const pointCounter = new PointsCounter('TEST',undefined, 0);
        //   setTimeout(() => {pointCounter.duration = 60000}, 3000)
        // return [
        //   pointCounter
        // ]},
        /**
     * 
     * @param {import("textalive-app-api").IVideo} selectedTrackData 
     */ 'game': (selectedTrackData, songData)=>{
            const pointCounter = new (0, $5J4VT.PointsCounter)(this.icons['note'], songData.title, songData.artist, this.translateDifficultyText(songData.difficulty), selectedTrackData.duration, 0, songData.segmentationColoursData);
            // Score
            let score = 0;
            // Combo
            let combo = 0;
            let highestCombo = 0;
            // Average Reaction Time
            let totalReactTime = 0;
            let totalClickedWordCount = 0;
            // Combo Bar & Missed Words Count
            let comboData = new Array();
            // const maxLyricfluctuation = this.height/4;
            console.dir(selectedTrackData);
            const punctuations = [
                "\uFF01",
                "\uFF1F",
                "\u3001",
                ",",
                "\uFF01)",
                "\uFF01\uFF09",
                "\uFF1F)",
                "\uFF1F\uFF09",
                "!",
                "\u2026"
            ];
            const removablePunctuations = [
                "\uFF08",
                "(",
                ")",
                "\uFF09",
                "\"",
                "\u300C",
                "\u300D",
                "\u201C",
                "\u201D"
            ];
            const waitForSongTiming = (songTime, callback)=>{
                const currentTime = this.player.timer.position;
                setTimeout(()=>{
                    const currentTimeNew = this.player.timer.position;
                    if (currentTimeNew < songTime) waitForSongTiming(songTime, callback);
                    else callback();
                }, songTime - currentTime);
            };
            /**
       * 
       * @param {import("textalive-app-api").IPhrase} phraseData 
       */ const renderPhrase = (phraseData)=>{
                const currentTime = this.player.timer.position;
                const newPhraseChildren = new Array();
                for(let i = 0; i < phraseData.children.length; i++){
                    if (phraseData.children[i + 2] && (phraseData.children[i + 1].text === "'" || phraseData.children[i + 1].text === "\u2019")) {
                        newPhraseChildren.push({
                            text: phraseData.children[i].text + phraseData.children[i + 1].text + phraseData.children[i + 2].text,
                            startTime: phraseData.children[i].startTime,
                            duration: phraseData.children[i + 2].endTime - phraseData.children[i].startTime
                        });
                        i += 2;
                    } else if (phraseData.children[i + 1] && punctuations.includes(phraseData.children[i + 1].text[0])) {
                        newPhraseChildren.push({
                            text: phraseData.children[i].text + phraseData.children[i + 1].text[0],
                            startTime: phraseData.children[i].startTime,
                            duration: phraseData.children[i + 1].endTime - phraseData.children[i].startTime
                        });
                        i++;
                    } else if (!removablePunctuations.includes(phraseData.children[i].text)) {
                        if (phraseData.children[i + 1] && removablePunctuations.includes(phraseData.children[i + 1].text)) {
                            newPhraseChildren.push({
                                text: phraseData.children[i].text,
                                startTime: phraseData.children[i].startTime,
                                duration: phraseData.children[i + 1].endTime - phraseData.children[i].startTime
                            });
                            i++;
                        } else newPhraseChildren.push({
                            text: phraseData.children[i].text,
                            startTime: phraseData.children[i].startTime,
                            duration: phraseData.children[i].duration
                        });
                    }
                }
                const splitLength = 1420 / (newPhraseChildren.length + 1);
                // maxScore += newPhraseChildren.length * 100;
                let prevYpos;
                const allowedWordJump = songData.wordMappingVariance;
                for(let i = 0; i < newPhraseChildren.length; i++){
                    const xPos = splitLength * (i + 1);
                    let yPos;
                    let maxPossibleYpos = prevYpos ? Math.min(prevYpos + allowedWordJump, 650) : 650;
                    let minPossibleYpos;
                    if (xPos < 300 || xPos > this.width - 200) minPossibleYpos = prevYpos ? Math.max(prevYpos - allowedWordJump, 200) : 200;
                    else minPossibleYpos = prevYpos ? Math.max(prevYpos - allowedWordJump, 80) : 80;
                    // MIN MAX Just in case
                    yPos = (0, $9snnZ.RandomNumber)(Math.min(maxPossibleYpos, minPossibleYpos), Math.max(maxPossibleYpos, minPossibleYpos));
                    prevYpos = yPos;
                    this.activeScreens[0].push(new (0, $b7lSL.Word)(newPhraseChildren[i].text, xPos, yPos, newPhraseChildren[i].startTime, newPhraseChildren[i].duration, currentTime, songData.wordSpeed, (self_word)=>{
                        console.log(`Pressed: ${newPhraseChildren[i].text}`);
                        score += 100;
                        combo++;
                        comboData.push(true);
                        highestCombo = Math.max(highestCombo, combo);
                        totalClickedWordCount++;
                        totalReactTime += self_word.currentPlayerPosition - self_word.startTime;
                        pointCounter.combo = combo;
                        pointCounter.score = score;
                    }, ()=>{
                        combo = 0;
                        comboData.push(false);
                        pointCounter.combo = combo;
                    }));
                // setTimeout(()=> {
                //   console.log(phraseData.children[i].text)
                // }, phraseData.children[i].startTime - currentTime)
                }
                if (phraseData.next) {
                    const nextTime = phraseData.endTime - songData.wordSpeed - 100; //Added extra 100 just in case.
                    if (nextTime - currentTime <= 0) renderPhrase(phraseData.next);
                    else // setTimeout(() => renderPhrase(phraseData.next), nextTime - currentTime)
                    waitForSongTiming(nextTime, ()=>renderPhrase(phraseData.next));
                } else {
                    const showStats = ()=>{
                        const maxScore = comboData.length * 100;
                        console.log(`Score: ${score}/${maxScore} (${score / maxScore * 100}%)`);
                        console.log(`Max Combo: ${highestCombo}`);
                        console.log(`Average Response Time: ${totalReactTime / totalClickedWordCount}ms`);
                        pointCounter.outroTimestamp = true;
                        this.activeScreens[0].push(new (0, $aR0P0.default)(score, maxScore, highestCombo, totalReactTime / totalClickedWordCount, comboData, ()=>{
                            this.setActiveScreen('select_music');
                        }));
                    // this.activeScreens[0].push(
                    //   new Text(1420/2, 730/2, `Score: ${score}/${maxScore} (${Math.floor(score/maxScore*100)}%)`, 'rgb(234, 12, 96)', undefined, true, 48, undefined, 'center', 'middle')
                    // )
                    // this.activeScreens[0].push(
                    //   new CircularButton(1420/2, 730/2 + 100, 50, "Exit", () => {
                    //     this.setActiveScreen('select_music');
                    //     // if (this.player.isPlaying){
                    //     //   this.player.requestStop();
                    //     // }
                    //   })
                    // )
                    };
                    waitForSongTiming(phraseData.endTime, showStats);
                }
            };
            setTimeout(()=>{
                // this.player.volume = 0;
                this.player.requestStop();
                this.player.requestMediaSeek(0);
                // this.player.requestPause();
                this.player.volume = 100;
            }, 1000);
            setTimeout(async ()=>{
                while(this.player.timer.position != 0)await (0, $9snnZ.sleep)(100);
                this.player.requestPlay();
                // pointCounter.duration = selectedTrackData.duration;
                console.dir(selectedTrackData);
                renderPhrase(selectedTrackData.firstPhrase);
            // const nextTime = selectedTrackData.firstPhrase.startTime - 1000;
            // if (nextTime > 0){
            //   setTimeout(()=> {
            //     renderPhrase(selectedTrackData.firstPhrase)
            //   }, nextTime)
            // }
            // else{
            //   renderPhrase(selectedTrackData.firstPhrase)
            // }
            }, 4000);
            return [
                pointCounter
            ];
        }
    };
    /**
   * Renders the Game onto the canvas
   * @param {number} animationStep 
   * @param {Cursor[]} cursors A list of cursor objects
   * @param {RenderableSegmentationMask | undefined} segmentationMask The Segmentation Mask if avaliable
   */ renderScreen(animationStep, cursors, segmentationMask) {
        const removableScreensIndexes = new Array();
        for(let i = this.activeScreens.length - 1; i >= 0; i--)if (i != 0 && this.activeScreens[i].screenState.transitionProgress <= 0 && this.activeScreens[i].transitionState == 'idle') removableScreensIndexes.push(i);
        else this.activeScreens[i].render(animationStep, cursors, this.player ? this.player.timer.position : undefined, segmentationMask);
        for(let i = 0; i < removableScreensIndexes.length; i++)this.activeScreens.splice(removableScreensIndexes[i] - i);
    }
}
var $d035b6734693e82f$export$2e2bcd8739ae039 = $d035b6734693e82f$var$MainGame;

});
parcelRegister("jTmqR", function(module, exports) {

$parcel$export(module.exports, "Drawable", () => $e7b48df2f87c29c1$export$f35845279390eafd);
parcelRequire("4NX2m");
class $e7b48df2f87c29c1$export$f35845279390eafd {
    width = undefined;
    height = undefined;
    initTime = /** @type {number | undefined} */ undefined;
    /**
  * Initialiases the drawable.
  * @param {number} x A positive number indicating x coordinate on screen
  * @param {number} y A positive number indicating y coordinate on screen
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  */ constructor(x, y, configureCanvas){
        this.x = x;
        this.y = y;
        this.configureCanvas = configureCanvas === false ? false : true;
        this.destroyed = false;
    }
    /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ configure(screenState) {}
    /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ render(screenState) {
        if (!this.initTime) this.initTime = screenState.animationStep;
        if (this.configureCanvas) this.configure(screenState);
    }
    destroy() {
        this.destroyed = true;
    }
}
class $e7b48df2f87c29c1$export$661ace3c0c22c1ff extends $e7b48df2f87c29c1$export$f35845279390eafd {
    /**
  * Initialiases the Dummy drawable.
  * @param {number} x A positive number indicating x coordinate on screen
  * @param {number} y A positive number indicating y coordinate on screen
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  */ constructor(x, y, configureCanvas){
        super(x, y, configureCanvas);
    }
    /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ configure(screenState) {}
    /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ render(screenState) {
        super.render(screenState);
    }
} // export class AnimatedDrawable extends Drawable{
 //   _animationProgress = /** @type {number} */ (0);
 //   animationStartTimestamp = /** @type {number | null} */ (null);
 //   /**
 //   * Initialiases the animateable drawable.
 //   * @param {number} x A positive number indicating x coordinate on screen
 //   * @param {number} y A positive number indicating y coordinate on screen
 //   * @param {number} [forwardAnimationDuration=2000] Duration of Forward Animation in milliseconds
 //   * @param {number} [reverseAnimationDuration=2000] Duration of Forward Animation in milliseconds
 //   * @param {number} [cycleAnimation=0] How many times to cycle between forward and reverse animation, set to -1 for infinite
 //   * @param {'forward'|'reverse'} [animationDirection='forward'] Starting direction of animation
 //   * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
 //   */
 //   constructor(x, y, forwardAnimationDuration, reverseAnimationDuration, cycleAnimation, animationDirection, configureCanvas){
 //     super(x, y, configureCanvas);
 //     this.forwardAnimationDuration = forwardAnimationDuration || 2000;
 //     this.reverseAnimationDuration = reverseAnimationDuration || 2000;
 //     this.cycleAnimation = cycleAnimation || 0;
 //     this.animationDirection = animationDirection || 'forward';
 //     this.animationCyclesCompleted = 0;
 //   }
 //   set animationProgress(value){
 //     if (value > 1){
 //       if (this.cycleAnimation < 0 || this.animationCyclesCompleted < this.cycleAnimation){
 //         this._animationProgress = 0;
 //         this.animationStartTimestamp = null;
 //         this.animationDirection = this.animationDirection === 'forward' ? 'reverse': 'forward';
 //         this.animationCyclesCompleted++;
 //       }
 //       else{
 //         this._animationProgress = 1
 //       }
 //     }
 //     else{
 //       this._animationProgress = value
 //     }
 //   }
 //   get animationProgress(){
 //     return this._animationProgress
 //   }
 //   /**
 //   * Renders the drawable for forward animation
 //   * @param {CanvasRenderingContext2D} canvasCtx The HTML canvas 2D rendering context
 //   * @param {number} animationProgress A positive number from 0 to 1 indicating current animation progress.
 //   */
 //   forwardAnimationRender(canvasCtx, animationProgress){}
 //   /**
 //   * Renders the drawable for reverse animation
 //   * @param {CanvasRenderingContext2D} canvasCtx The HTML canvas 2D rendering context
 //   * @param {number} animationProgress A positive number from 0 to 1 indicating current animation progress.
 //   */
 //   reverseAnimationRender(canvasCtx, animationProgress){}
 //   /**
 //   * Renders the drawable.
 //   * @param {CanvasRenderingContext2D} canvasCtx The HTML canvas 2D rendering context
 //   * @param {number} animationStep A positive number indicating current animation timeline
 //   */
 //   render(canvasCtx, animationStep) {
 //     super.render(canvasCtx, animationStep);
 //     if (!this.animationStartTimestamp){
 //       this.animationStartTimestamp = animationStep;
 //     }
 //     if (this.animationDirection === 'forward'){
 //       this.animationProgress = (animationStep - this.animationStartTimestamp)/this.forwardAnimationDuration;
 //       this.forwardAnimationRender(canvasCtx, this.animationProgress);
 //     }
 //     else if (this.animationDirection === 'reverse'){
 //       this.animationProgress = (animationStep - this.animationStartTimestamp)/this.reverseAnimationDuration;
 //       this.reverseAnimationRender(canvasCtx, this.animationProgress);
 //     }
 //   }
 // }

});
parcelRegister("4NX2m", function(module, exports) {

$parcel$export(module.exports, "ScreenState", () => $37f9889610efc275$export$39439fd577fef452);
$parcel$export(module.exports, "default", () => $37f9889610efc275$export$2e2bcd8739ae039);

var $eg79f = parcelRequire("eg79f");
parcelRequire("jTmqR");

var $arHBl = parcelRequire("arHBl");
parcelRequire("eaQG2");
class $37f9889610efc275$export$39439fd577fef452 {
    devlopmentScreenWidth = 1420;
    devlopmentScreenHeight = 730;
    /**
   * Initialises a Screen State
   * @param {CanvasRenderingContext2D} canvasCtx The Canvas Rendering Context
   * @param {number} animationStep The animation timeline stepping
   * @param {number} transitionProgress Screen Intro and Outro Transition Progress ranging from 0 to 1
   * @param {number} width The screen width
   * @param {number} height The screen height
   * @param {number} offsetX The screen offset x coordinate. Defaults to 0 if not specified.
   * @param {number} offsetY The screen offset y coordinate. Defaults to 0 if not specified.
   * @param {'touch' | 'cursor' | 'webcam'} gameMode The current mode of the game.
   * @param {number|undefined} playerPosition The current player position if avalable
   */ constructor(canvasCtx, animationStep, transitionProgress, width, height, offsetX, offsetY, gameMode, lang, playerPosition){
        this.canvasCtx = canvasCtx;
        this.animationStep = animationStep;
        this.transitionProgress = transitionProgress;
        this.width = width;
        this.height = height;
        this.offsetX = offsetX || 0;
        this.offsetY = offsetY || 0;
        this.lang = lang;
        this.gameMode = gameMode;
        this.playerPosition = playerPosition;
    }
    /**
   * Changes the x coordinate based on the current screen's dimentions. 
   * Cannot be used for width.
   * @param {number} value The x coordinate
   * @returns {number} The resized x coordinate value
   */ X(value) {
        // return value;
        return value / this.devlopmentScreenWidth * this.width + this.offsetX;
    }
    // /**
    //  * Changes the width based on the current screen's dimentions. 
    //  * Cannot be used for x coordinate.
    //  * @param {number} value The width
    //  * @returns {number} The resized width value
    //  */
    // W(value){
    //   // return value;
    //   return ((value/this.devlopmentScreenWidth)*this.width);
    // }
    /**
   * Changes the y coordinate based on the current screen's dimentions. 
   * Cannot be used for height.
   * @param {number} value The y coordinate
   * @returns {number} The resized y coordinate value
   */ Y(value) {
        // return value;
        return value / this.devlopmentScreenHeight * this.height + this.offsetY;
    }
    // /**
    //  * Changes the height based on the current screen's dimentions. 
    //  * Cannot be used for y coordinate.
    //  * @param {number} value The height
    //  * @returns {number} The resized height value
    //  */
    // H(value){
    //   // return value;
    //   return ((value/this.devlopmentScreenHeight)*this.height);
    // }
    /**
   * Changes the size based on the current screen's dimentions via area.
   * @param {number} value The size for font size, circle radius, etc.
   * @returns {number} The resized size value
   */ S(value) {
        // return value;
        return value / (this.devlopmentScreenWidth * this.devlopmentScreenHeight) * (this.width * this.height);
    }
    /**
   * Changes the x, y, width, and height for a rectangle so that it displays properly on diffrent screen dimentions.
   */ rectResize(x, y, width, height, useTransitionProgress) {
        const transitionProgressFinal = useTransitionProgress ? this.transitionProgress : 1;
        const [finalWidth, finalHeight] = [
            width * transitionProgressFinal,
            height * transitionProgressFinal
        ];
        const [finalRenderableWidth, finalRenderableHeight] = [
            this.S(finalWidth),
            this.S(finalHeight)
        ];
        const [newX, newY] = [
            this.X(x + finalWidth / 2) - finalRenderableWidth / 2,
            this.Y(y + finalHeight / 2) - finalRenderableHeight / 2
        ];
        return [
            newX,
            newY,
            finalRenderableWidth,
            finalRenderableHeight
        ];
    }
    rectResizeV2Static(x, y, width, height) {
        const scalingWidth = width / this.devlopmentScreenWidth * this.width / width;
        const scalingHeight = height / this.devlopmentScreenHeight * this.height / height;
        const scaling = Math.max(scalingWidth, scalingHeight);
        return [
            this.X(x),
            this.Y(y),
            width * scaling,
            height * scaling
        ];
    }
    /**
   * For collision detection only, changes cursor coordinates and size based on the current screen size
   * @param {Cursor[]} cursors The list of cursors to change
   * @returns {Cursor[]} A list of changed cursors
   */ fixCursor(cursors) {
        const newCursors = new Array();
        for(let i = 0; i < cursors.length; i++)newCursors.push(new (0, $eg79f.default)((cursors[i].x - this.offsetX) / this.width * this.devlopmentScreenWidth, (cursors[i].y - this.offsetY) / this.height * this.devlopmentScreenHeight, cursors[i].type, cursors[i].radius));
        return newCursors;
    }
}
class $37f9889610efc275$var$Screen {
    transitionState = /** @type {'intro' | 'idle' | 'outro'}*/ 'idle';
    transitionDuration = 750;
    transitionStartTimestamp = /** @type {number | null}*/ null;
    /**
  * Initialiases screen object.
  * @param {ScreenState} screenState The current state of the screen
  * @param {Drawable[]} [drawables = []] Drawable Elements to put in the screen
  */ constructor(screenState, drawables){
        this.screenState = screenState;
        this.drawables = drawables;
        this.transitionProgress = screenState.transitionProgress;
    }
    /**
   * Adds a new drawable to the screen.
   * @param {Drawable} drawable The drawable element to add to the screen.
   */ push(drawable) {
        this.drawables.push(drawable);
    }
    /**
   * Renders the screen
   * @param {number} animationStep 
   * @param {Cursor[]} cursors A list of cursor objects
   * @param {number|undefined} playerPosition The current player position if avalable
   * @param {RenderableSegmentationMask | undefined} segmentationMask The Segmentation Mask if avaliable
   */ render(animationStep, cursors, playerPosition, segmentationMask) {
        // Handle Transitions
        if (this.transitionStartTimestamp === -1) this.transitionStartTimestamp = animationStep;
        if (this.transitionState !== 'idle' && this.transitionStartTimestamp < animationStep) {
            if (animationStep - this.transitionStartTimestamp >= this.transitionDuration) {
                // Ensure transitionProgress at max/min
                this.transitionProgress = this.transitionState === 'intro' ? 1 : 0;
                this.transitionState = 'idle';
            } else if (this.transitionState === 'intro') this.transitionProgress = (0, $arHBl.easeInOutQuart)(Math.min((animationStep - this.transitionStartTimestamp) / this.transitionDuration, 1));
            else if (this.transitionState === 'outro') this.transitionProgress = (0, $arHBl.easeInOutQuart)(Math.max(1 - (animationStep - this.transitionStartTimestamp) / this.transitionDuration, 0));
        }
        // Render Objects
        this.screenState = new $37f9889610efc275$export$39439fd577fef452(this.screenState.canvasCtx, animationStep, this.transitionProgress, this.screenState.width, this.screenState.height, this.screenState.offsetX, this.screenState.offsetY, this.screenState.gameMode, this.screenState.lang, playerPosition);
        // const newCursors = this.screenState.fixCursor(cursors);
        const removableDrawableIndexes = [];
        for(let i = 0; i < this.drawables.length; i++){
            const drawableToRender = this.drawables[i];
            if (drawableToRender.destroyed) removableDrawableIndexes.push(i);
            else {
                if (drawableToRender.updateHover) drawableToRender.updateHover(cursors, this.screenState);
                if (drawableToRender.takesSegmentationMask) drawableToRender.render(this.screenState, segmentationMask);
                else drawableToRender.render(this.screenState);
            }
        }
        for(let i = 0; i < removableDrawableIndexes.length; i++)this.drawables.splice(removableDrawableIndexes[i] - i, 1);
    }
    /**
   * Starts the Screen's Intro transition
   * @param {number} [animationStep=-1] The current animation timestamp
   */ startIntroTransition(animationStep) {
        this.transitionStartTimestamp = animationStep || -1;
        this.transitionState = 'intro';
    }
    /**
   * Starts the Screen's Outro transition
   * @param {number} [animationStep=-1] The current animation timestamp
   */ startOutroTransition(animationStep) {
        this.transitionStartTimestamp = animationStep || -1;
        this.transitionState = 'outro';
    }
}
var $37f9889610efc275$export$2e2bcd8739ae039 = $37f9889610efc275$var$Screen;

});
parcelRegister("eg79f", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6181ace6227859d$export$2e2bcd8739ae039);
class $a6181ace6227859d$export$2e2bcd8739ae039 {
    // x = 0;
    // y = 0;
    // type = 'right';
    // radius = 50;
    constructor(x, y, type, radius, creationTimestamp){
        this.x = x;
        this.y = y;
        this.type = type || "right";
        this.radius = radius != undefined ? radius : 50;
        this.creationTimestamp = creationTimestamp;
    }
}

});

parcelRegister("arHBl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.linear = $79ae3f56e0390b8d$var$linear;
module.exports.easeInSine = $79ae3f56e0390b8d$var$easeInSine;
module.exports.easeOutSine = $79ae3f56e0390b8d$var$easeOutSine;
module.exports.easeInOutSine = $79ae3f56e0390b8d$var$easeInOutSine;
module.exports.easeInQuad = $79ae3f56e0390b8d$var$easeInQuad;
module.exports.easeOutQuad = $79ae3f56e0390b8d$var$easeOutQuad;
module.exports.easeInOutQuad = $79ae3f56e0390b8d$var$easeInOutQuad;
module.exports.easeInCubic = $79ae3f56e0390b8d$var$easeInCubic;
module.exports.easeOutCubic = $79ae3f56e0390b8d$var$easeOutCubic;
module.exports.easeInOutCubic = $79ae3f56e0390b8d$var$easeInOutCubic;
module.exports.easeInQuart = $79ae3f56e0390b8d$var$easeInQuart;
module.exports.easeOutQuart = $79ae3f56e0390b8d$var$easeOutQuart;
module.exports.easeInOutQuart = $79ae3f56e0390b8d$var$easeInOutQuart;
module.exports.easeInQuint = $79ae3f56e0390b8d$var$easeInQuint;
module.exports.easeOutQuint = $79ae3f56e0390b8d$var$easeOutQuint;
module.exports.easeInOutQuint = $79ae3f56e0390b8d$var$easeInOutQuint;
module.exports.easeInExpo = $79ae3f56e0390b8d$var$easeInExpo;
module.exports.easeOutExpo = $79ae3f56e0390b8d$var$easeOutExpo;
module.exports.easeInOutExpo = $79ae3f56e0390b8d$var$easeInOutExpo;
module.exports.easeInCirc = $79ae3f56e0390b8d$var$easeInCirc;
module.exports.easeOutCirc = $79ae3f56e0390b8d$var$easeOutCirc;
module.exports.easeInOutCirc = $79ae3f56e0390b8d$var$easeInOutCirc;
module.exports.easeInBack = $79ae3f56e0390b8d$var$easeInBack;
module.exports.easeOutBack = $79ae3f56e0390b8d$var$easeOutBack;
module.exports.easeInOutBack = $79ae3f56e0390b8d$var$easeInOutBack;
module.exports.easeInElastic = $79ae3f56e0390b8d$var$easeInElastic;
module.exports.easeOutElastic = $79ae3f56e0390b8d$var$easeOutElastic;
module.exports.easeInOutElastic = $79ae3f56e0390b8d$var$easeInOutElastic;
module.exports.easeOutBounce = $79ae3f56e0390b8d$var$easeOutBounce;
module.exports.easeInBounce = $79ae3f56e0390b8d$var$easeInBounce;
module.exports.easeInOutBounce = $79ae3f56e0390b8d$var$easeInOutBounce;
// Based on https://gist.github.com/gre/1650294
// No easing, no acceleration
function $79ae3f56e0390b8d$var$linear(t) {
    return t;
}
// Slight acceleration from zero to full speed
function $79ae3f56e0390b8d$var$easeInSine(t) {
    return -1 * Math.cos(t * (Math.PI / 2)) + 1;
}
// Slight deceleration at the end
function $79ae3f56e0390b8d$var$easeOutSine(t) {
    return Math.sin(t * (Math.PI / 2));
}
// Slight acceleration at beginning and slight deceleration at end
function $79ae3f56e0390b8d$var$easeInOutSine(t) {
    return -0.5 * (Math.cos(Math.PI * t) - 1);
}
// Accelerating from zero velocity
function $79ae3f56e0390b8d$var$easeInQuad(t) {
    return t * t;
}
// Decelerating to zero velocity
function $79ae3f56e0390b8d$var$easeOutQuad(t) {
    return t * (2 - t);
}
// Acceleration until halfway, then deceleration
function $79ae3f56e0390b8d$var$easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}
// Accelerating from zero velocity
function $79ae3f56e0390b8d$var$easeInCubic(t) {
    return t * t * t;
}
// Decelerating to zero velocity
function $79ae3f56e0390b8d$var$easeOutCubic(t) {
    var t1 = t - 1;
    return t1 * t1 * t1 + 1;
}
// Acceleration until halfway, then deceleration
function $79ae3f56e0390b8d$var$easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}
// Accelerating from zero velocity
function $79ae3f56e0390b8d$var$easeInQuart(t) {
    return t * t * t * t;
}
// Decelerating to zero velocity
function $79ae3f56e0390b8d$var$easeOutQuart(t) {
    var t1 = t - 1;
    return 1 - t1 * t1 * t1 * t1;
}
// Acceleration until halfway, then deceleration
function $79ae3f56e0390b8d$var$easeInOutQuart(t) {
    var t1 = t - 1;
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * t1 * t1 * t1 * t1;
}
// Accelerating from zero velocity
function $79ae3f56e0390b8d$var$easeInQuint(t) {
    return t * t * t * t * t;
}
// Decelerating to zero velocity
function $79ae3f56e0390b8d$var$easeOutQuint(t) {
    var t1 = t - 1;
    return 1 + t1 * t1 * t1 * t1 * t1;
}
// Acceleration until halfway, then deceleration
function $79ae3f56e0390b8d$var$easeInOutQuint(t) {
    var t1 = t - 1;
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * t1 * t1 * t1 * t1 * t1;
}
// Accelerate exponentially until finish
function $79ae3f56e0390b8d$var$easeInExpo(t) {
    if (t === 0) return 0;
    return Math.pow(2, 10 * (t - 1));
}
// Initial exponential acceleration slowing to stop
function $79ae3f56e0390b8d$var$easeOutExpo(t) {
    if (t === 1) return 1;
    return -Math.pow(2, -10 * t) + 1;
}
// Exponential acceleration and deceleration
function $79ae3f56e0390b8d$var$easeInOutExpo(t) {
    if (t === 0 || t === 1) return t;
    var scaledTime = t * 2;
    var scaledTime1 = scaledTime - 1;
    if (scaledTime < 1) return 0.5 * Math.pow(2, 10 * scaledTime1);
    return 0.5 * (-Math.pow(2, -10 * scaledTime1) + 2);
}
// Increasing velocity until stop
function $79ae3f56e0390b8d$var$easeInCirc(t) {
    var scaledTime = t / 1;
    return -1 * (Math.sqrt(1 - scaledTime * t) - 1);
}
// Start fast, decreasing velocity until stop
function $79ae3f56e0390b8d$var$easeOutCirc(t) {
    var t1 = t - 1;
    return Math.sqrt(1 - t1 * t1);
}
// Fast increase in velocity, fast decrease in velocity
function $79ae3f56e0390b8d$var$easeInOutCirc(t) {
    var scaledTime = t * 2;
    var scaledTime1 = scaledTime - 2;
    if (scaledTime < 1) return -0.5 * (Math.sqrt(1 - scaledTime * scaledTime) - 1);
    return 0.5 * (Math.sqrt(1 - scaledTime1 * scaledTime1) + 1);
}
// Slow movement backwards then fast snap to finish
function $79ae3f56e0390b8d$var$easeInBack(t) {
    var magnitude = arguments.length <= 1 || arguments[1] === undefined ? 1.70158 : arguments[1];
    var scaledTime = t / 1;
    return scaledTime * scaledTime * ((magnitude + 1) * scaledTime - magnitude);
}
// Fast snap to backwards point then slow resolve to finish
function $79ae3f56e0390b8d$var$easeOutBack(t) {
    var magnitude = arguments.length <= 1 || arguments[1] === undefined ? 1.70158 : arguments[1];
    var scaledTime = t / 1 - 1;
    return scaledTime * scaledTime * ((magnitude + 1) * scaledTime + magnitude) + 1;
}
// Slow movement backwards, fast snap to past finish, slow resolve to finish
function $79ae3f56e0390b8d$var$easeInOutBack(t) {
    var magnitude = arguments.length <= 1 || arguments[1] === undefined ? 1.70158 : arguments[1];
    var scaledTime = t * 2;
    var scaledTime2 = scaledTime - 2;
    var s = magnitude * 1.525;
    if (scaledTime < 1) return 0.5 * scaledTime * scaledTime * ((s + 1) * scaledTime - s);
    return 0.5 * (scaledTime2 * scaledTime2 * ((s + 1) * scaledTime2 + s) + 2);
}
// Bounces slowly then quickly to finish
function $79ae3f56e0390b8d$var$easeInElastic(t) {
    var magnitude = arguments.length <= 1 || arguments[1] === undefined ? 0.7 : arguments[1];
    if (t === 0 || t === 1) return t;
    var scaledTime = t / 1;
    var scaledTime1 = scaledTime - 1;
    var p = 1 - magnitude;
    var s = p / (2 * Math.PI) * Math.asin(1);
    return -(Math.pow(2, 10 * scaledTime1) * Math.sin((scaledTime1 - s) * (2 * Math.PI) / p));
}
// Fast acceleration, bounces to zero
function $79ae3f56e0390b8d$var$easeOutElastic(t) {
    var magnitude = arguments.length <= 1 || arguments[1] === undefined ? 0.7 : arguments[1];
    var p = 1 - magnitude;
    var scaledTime = t * 2;
    if (t === 0 || t === 1) return t;
    var s = p / (2 * Math.PI) * Math.asin(1);
    return Math.pow(2, -10 * scaledTime) * Math.sin((scaledTime - s) * (2 * Math.PI) / p) + 1;
}
// Slow start and end, two bounces sandwich a fast motion
function $79ae3f56e0390b8d$var$easeInOutElastic(t) {
    var magnitude = arguments.length <= 1 || arguments[1] === undefined ? 0.65 : arguments[1];
    var p = 1 - magnitude;
    if (t === 0 || t === 1) return t;
    var scaledTime = t * 2;
    var scaledTime1 = scaledTime - 1;
    var s = p / (2 * Math.PI) * Math.asin(1);
    if (scaledTime < 1) return -0.5 * (Math.pow(2, 10 * scaledTime1) * Math.sin((scaledTime1 - s) * (2 * Math.PI) / p));
    return Math.pow(2, -10 * scaledTime1) * Math.sin((scaledTime1 - s) * (2 * Math.PI) / p) * 0.5 + 1;
}
// Bounce to completion
function $79ae3f56e0390b8d$var$easeOutBounce(t) {
    var scaledTime = t / 1;
    if (scaledTime < 1 / 2.75) return 7.5625 * scaledTime * scaledTime;
    else if (scaledTime < 2 / 2.75) {
        var scaledTime2 = scaledTime - 1.5 / 2.75;
        return 7.5625 * scaledTime2 * scaledTime2 + 0.75;
    } else if (scaledTime < 2.5 / 2.75) {
        var _scaledTime = scaledTime - 2.25 / 2.75;
        return 7.5625 * _scaledTime * _scaledTime + 0.9375;
    } else {
        var _scaledTime2 = scaledTime - 2.625 / 2.75;
        return 7.5625 * _scaledTime2 * _scaledTime2 + 0.984375;
    }
}
// Bounce increasing in velocity until completion
function $79ae3f56e0390b8d$var$easeInBounce(t) {
    return 1 - $79ae3f56e0390b8d$var$easeOutBounce(1 - t);
}
// Bounce in and bounce out
function $79ae3f56e0390b8d$var$easeInOutBounce(t) {
    if (t < 0.5) return $79ae3f56e0390b8d$var$easeInBounce(t * 2) * 0.5;
    return $79ae3f56e0390b8d$var$easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
}

});

parcelRegister("eaQG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a51adc6d6735c298$export$2e2bcd8739ae039);
parcelRequire("4NX2m");
class $a51adc6d6735c298$export$2e2bcd8739ae039 {
    /**
   * Provides functions to manipulate and render segmentation masks
   * @param {ImageData} mask The segmentation mask output from BlazePose Model
   * @param {number} scaling The amount to rescale the mask before it can be displayed
   */ constructor(mask, scaling){
        this.mask = mask;
        this.scaling = scaling;
    }
    recolor_mask(r, g, b, a) {
        const data = this.mask.data;
        for(let i = 0; i < data.length; i += 4)if (data[i] > 0) {
            data[i] = r; //     R
            data[i + 1] = g; //   G
            data[i + 2] = b; //   B
            data[i + 3] *= a; //  A
        }
    }
    /**
   * Draws the mask unto the canvas
   * @param {ScreenState} screenState The ScreenState Object
   */ render(screenState) {
        // Reference: https://stackoverflow.com/q/3448347/18573662
        const tmpCanvas = new OffscreenCanvas(this.mask.width, this.mask.height);
        tmpCanvas.getContext("2d").putImageData(this.mask, 0, 0);
        // screenState.canvasCtx.imageSmoothingEnabled = false;
        screenState.canvasCtx.drawImage(tmpCanvas, 0, 0, this.mask.width * this.scaling, this.mask.height * this.scaling);
    // screenState.canvasCtx.imageSmoothingEnabled = true;
    }
}

});



parcelRegister("bOgnf", function(module, exports) {

$parcel$export(module.exports, "Text", () => $899110c588a7e695$export$5f1af8db9871e1d6);

var $jTmqR = parcelRequire("jTmqR");
parcelRequire("4NX2m");
class $899110c588a7e695$export$5605b828765d3f46 extends (0, $jTmqR.Drawable) {
    /**
  * Initialiases the Static Text drawable.
  * @param {number} x A positive number indicating x coordinate on screen
  * @param {number} y A positive number indicating y coordinate on screen
  * @param {string} text The text to render
  * @param {string | CanvasGradient | CanvasPattern} colour The text color
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  * @param {number} [fontSize=48] The font size
  * @param {string} [font='Yusei Magic'] The text font
  * @param {CanvasTextAlign} [textAlign='left'] The text alignment
  * @param {CanvasTextBaseline} [textBaseline='alphabetic'] The text baseline
  */ constructor(x, y, text, colour, configureCanvas, fontSize, font, textAlign, textBaseline){
        super(x, y, configureCanvas);
        this.text = text;
        this.fontSize = fontSize || 48;
        this.colour = colour || 'blue';
        this.font = font || 'Yusei Magic';
        this.textAlign = textAlign || 'left';
        this.textBaseline = textBaseline || 'alphabetic';
    }
    /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ configure(screenState) {
        screenState.canvasCtx.fillStyle = this.colour;
        screenState.canvasCtx.font = `${screenState.S(this.fontSize * screenState.transitionProgress)}px ${this.font}`;
        screenState.canvasCtx.textAlign = this.textAlign;
        screenState.canvasCtx.textBaseline = this.textBaseline;
    }
    /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ render(screenState) {
        super.render(screenState);
        screenState.canvasCtx.fillText(this.text, screenState.X(this.x), screenState.Y(this.y));
    }
}
class $899110c588a7e695$export$5f1af8db9871e1d6 extends $899110c588a7e695$export$5605b828765d3f46 {
    /**
  * Initialiases the Static Text drawable.
  * @param {number} x A positive number indicating x coordinate on screen
  * @param {number} y A positive number indicating y coordinate on screen
  * @param {string} text The text to render
  * @param {string | CanvasGradient | CanvasPattern} [colour='blue'] The text color
  * @param {string | CanvasGradient | CanvasPattern} [shadowColour='yellow'] The text shadow color
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  * @param {number} [fontSize=48] The font size
  * @param {string} [font='Yusei Magic'] The text font
  * @param {CanvasTextAlign} [textAlign='left'] The text alignment
  * @param {CanvasTextBaseline} [textBaseline='alphabetic'] The text baseline
  */ constructor(x, y, text, colour, shadowColour, configureCanvas, fontSize, font, textAlign, textBaseline){
        super(x, y, configureCanvas);
        this.text = text;
        this.fontSize = fontSize || 48;
        this.colour = colour || 'blue';
        this.shadowColour = shadowColour || 'yellow';
        this.font = font || 'Yusei Magic';
        this.textAlign = textAlign || 'left';
        this.textBaseline = textBaseline || 'alphabetic';
    }
    /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ configure(screenState) {
        screenState.canvasCtx.fillStyle = this.colour;
        screenState.canvasCtx.strokeStyle = 'white';
        screenState.canvasCtx.shadowColor = this.shadowColour;
        screenState.canvasCtx.shadowBlur = 15;
        screenState.canvasCtx.font = `${screenState.S(this.fontSize * screenState.transitionProgress)}px ${this.font}`;
        screenState.canvasCtx.textAlign = this.textAlign;
        screenState.canvasCtx.textBaseline = this.textBaseline;
    }
    /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ render(screenState) {
        super.render(screenState);
        const [xPos, yPos] = [
            screenState.X(this.x),
            screenState.Y(this.y)
        ];
        // screenState.canvasCtx.beginPath();
        // console.log(this.colour);
        screenState.canvasCtx.globalAlpha = screenState.transitionProgress;
        screenState.canvasCtx.fillStyle = this.colour;
        screenState.canvasCtx.fillText(this.text, xPos, yPos);
        screenState.canvasCtx.lineWidth = 3;
        screenState.canvasCtx.strokeText(this.text, xPos, yPos);
        screenState.canvasCtx.shadowBlur = 0;
        screenState.canvasCtx.globalAlpha = 1;
    }
}
class $899110c588a7e695$export$dcea6317e863a7b6 extends (0, $jTmqR.Drawable) {
    /**
  * Initialiases the Animated Text drawable.
  * @param {number} x A positive number indicating x coordinate on screen.
  * @param {number} y A positive number indicating y coordinate on screen.
  * @param {string} text The text to render.
  * @param {"ltr" | "rtl"} animationDirection The direction in which the text should be animated.
  * @param {number} [targetFontSize] The target font size to animate to.
  * @param {boolean} [destroyOnFinish=true] Destroy self when animation finishes.
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  * @param {string} [font='Yusei Magic'] The text font
  */ constructor(x, y, text, animationDirection, targetFontSize, configureCanvas, font){
        super(x, y, configureCanvas);
        this.text = text;
        this.animationDirection = animationDirection;
        this.targetFontSize = targetFontSize;
        this.font = font || 'Yusei Magic';
    // this.animationProgress = 0;
    }
    /**
   * @param {string} value
   */ set text(value) {
        this.textParsed = value.split("");
    }
    get text() {
        return this.textParsed.join("");
    }
    /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ configure(screenState) {
        screenState.canvasCtx.textBaseline = 'middle';
        screenState.canvasCtx.textAlign = this.animationDirection == 'ltr' ? 'left' : 'right';
    }
    /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ render(screenState) {
        super.render(screenState);
        // const animationProgress = Math.abs(Math.sin(screenState.animationStep/500));
        // const animationOffset = (1/this.textParsed.length)*(1-animationProgress);
        if (this.animationDirection == 'ltr') for(let i = this.textParsed.length - 1; i >= 0; i--){
            const fontSize = screenState.S(Math.abs(Math.sin((screenState.animationStep + i * 50) / 500)) * this.targetFontSize * screenState.transitionProgress);
            screenState.canvasCtx.font = `${fontSize}px ${this.font}`;
            const xPos = screenState.X(this.x + i * fontSize);
            const yPos = screenState.Y(this.y);
            screenState.canvasCtx.strokeText(this.textParsed[i], xPos, yPos);
            screenState.canvasCtx.fillText(this.textParsed[i], xPos, yPos);
        }
        else {
            const lastCharOffsetXPos = this.textParsed.length * this.targetFontSize;
            for(let i = 0; i < this.textParsed.length; i++){
                const fontSize = screenState.S(Math.abs(Math.sin((screenState.animationStep + i * 50) / 500)) * this.targetFontSize * screenState.transitionProgress);
                screenState.canvasCtx.font = `${fontSize}px ${this.font}`;
                const xPos = screenState.X(this.x + lastCharOffsetXPos - (this.textParsed.length - 1 - i) * fontSize);
                const yPos = screenState.Y(this.y);
                screenState.canvasCtx.strokeText(this.textParsed[i], xPos, yPos);
                screenState.canvasCtx.fillText(this.textParsed[i], xPos, yPos);
            }
        }
    }
}

});

parcelRegister("ikHJv", function(module, exports) {

$parcel$export(module.exports, "__check_circle_collision", () => $d58c04b51b404a2f$export$e5d4379aa841429f);
$parcel$export(module.exports, "CircularButtonBase", () => $d58c04b51b404a2f$export$c3dc6b4f63b21d70);
$parcel$export(module.exports, "CircularButton", () => $d58c04b51b404a2f$export$3fb72b1e9dfdaf37);
$parcel$export(module.exports, "IconButton", () => $d58c04b51b404a2f$export$c25acd513dcc8062);

var $jTmqR = parcelRequire("jTmqR");
parcelRequire("eg79f");
parcelRequire("4NX2m");
parcelRequire("1QwlQ");

var $KjYoF = parcelRequire("KjYoF");
/**
 * Checks if the center of the circle is intersecting a rectangle.
 * @param {number} center_x The x coordinate of the center of the circle
 * @param {number} center_y The y coordinate of the center of the circle
 * @param {number} rect_x The x coordinate of the rectangle
 * @param {number} rect_y The y coordinate of the rectangle
 * @param {number} rect_w The width of the rectangle
 * @param {number} rect_h The height of the rectangle
 * @returns {Boolean} True if the circle center is intersecting the rectangle.
 */ function $d58c04b51b404a2f$var$__check_center(center_x, center_y, rect_x, rect_y, rect_w, rect_h) {
    return Boolean(center_x >= rect_x && center_x <= rect_x + rect_w && center_y >= rect_y && center_y <= rect_y + rect_h);
}
/**
 * Checks if the circle is intersecting the rectangle based on a side of the rectangle.
 * @param {number} center_x The x coordinate of the center of the circle
 * @param {number} center_y The y coordinate of the center of the circle
 * @param {number} radius The radius of the circle
 * @param {number} rect_x1 The first x coordinate of side of the rectangle
 * @param {number} rect_y1 The first y coordinate of side of the rectangle
 * @param {number} rect_x2 The second x coordinate of side of the rectangle
 * @param {number} rect_y2 The second x coordinate of side of the rectangle
 * @returns {Boolean} True if the shortest distance between the cricle center 
 * and a side of a rectangle is less than the circle's radius.
 * (i.e., the circle is intersecting the rectangle.)
 */ function $d58c04b51b404a2f$var$__check_distance(center_x, center_y, radius, rect_x1, rect_y1, rect_x2, rect_y2) {
    // TODO: This algorithim is not working. 
    // Step 1: Create equation of line (y=mx+c) from 2 coordinates.
    // m = (y2-y1)/(x2-x1)
    // y=mx+c
    // c=y-mx
    const m = (rect_y2 - rect_y1) / (rect_x2 - rect_x1);
    const c = rect_y1 - m * rect_x1;
    // Step 2: Create a new line, perpendicular to the first line, but still
    // intersecting the circle's center
    // y2=(m2)(x2)+c2
    // m2 = -1/m
    // c2=y2-(m2)(x2)
    const m2 = -1 / m; // TODO: Possible division by zero error!
    const c2 = center_y - m2 * center_x;
    // Step 3: Solve the simultaneuos equations (y=mx+c and y2=(m2)(x2)+c2) 
    // to check where the 2 lines intersect.
    // 
    // let (x3, y3) be the coordinates at which the to lines intersect. 
    // m(x3)+c = (m2)(x3) + c2
    // (m - m2)(x3) = c2 - c
    // x3 = (c2-c)/(m-m2)
    // y3 = m(x3) + c = (m2)(x3)+c2
    const x3 = (c2 - c) / (m - m2);
    const y3 = m * x3 + c;
    // Step 4: Check if the distance between the point of intersection is smaller than 
    // the circle's radius.
    // distance = √((x3-center_x)^2+(y3-center_y)^2)
    return Boolean(Math.sqrt((x3 - center_x) ** 2 + (y3 - center_y) ** 2) <= radius);
}
function $d58c04b51b404a2f$export$e5d4379aa841429f(center_x, center_y, radius, center_x2, center_y2, radius_2) {
    const dist_between_cricles = Math.sqrt((center_x2 - center_x) ** 2 + (center_y2 - center_y) ** 2);
    const collision_distance = radius + radius_2;
    return dist_between_cricles < collision_distance;
}
class $d58c04b51b404a2f$export$b0bb876e969289cd extends (0, $jTmqR.Drawable) {
    width = 0;
    height = 0;
    hover_progress = 0;
    hover_duration = 2300;
    unhover_duration = 1000;
    first_hover_timestamp = /** @type {number | null} */ null;
    stop_hover_timestamp = /** @type {number | null} */ null;
    clickHandlerRan = false;
    onClick = /** @type {(cursor: ButtonBase) => any | void} */ (cursor)=>{};
    /**
  * Initialiases the drawable.
  * @param {number} x A positive number indicating x coordinate on screen
  * @param {number} y A positive number indicating y coordinate on screen
  * @param {number} width The width of the button.
  * @param {number} height The height of the button.
  * @param {(cursor: ButtonBase) => any | void} onClick The button's click handler.
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  */ constructor(x, y, width, height, onClick, configureCanvas){
        super(x, y, configureCanvas);
        this.width = width;
        this.height = height;
        this.onClick = onClick;
    }
    /**
   * Checks if cursors are intersecting object.
   * @param {Cursor[]} cursors A list of cursors to check
   * @returns {Boolean} true if there are cursors intersecting the object.
   */ checkHover(cursors) {
        for(let i = 0; i < cursors.length; i++){
            if ($d58c04b51b404a2f$var$__check_center(cursors[i].x, cursors[i].y, this.x, this.y, this.width, this.height) || $d58c04b51b404a2f$var$__check_distance(cursors[i].x, cursors[i].y, cursors[i].radius, this.x, this.y, this.x + this.width, this.y) || $d58c04b51b404a2f$var$__check_distance(cursors[i].x, cursors[i].y, cursors[i].radius, this.x + this.width, this.y, this.x + this.width, this.y + this.height) || $d58c04b51b404a2f$var$__check_distance(cursors[i].x, cursors[i].y, cursors[i].radius, this.x + this.width, this.y + this.height, this.x, this.y + this.height) || $d58c04b51b404a2f$var$__check_distance(cursors[i].x, cursors[i].y, cursors[i].radius, this.x, this.y + this.height, this.x, this.y)) return true;
        }
        return false;
    }
    /**
   * Update the object's state based on the state of the cursor.
   * @param {Cursor[]} cursors The list of cursor objects to check if the button is colliding with the cursor. 
   * @param {number} animationStep A positive number indicating current animation timeline
   */ updateHover(cursors, animationStep) {
        //Referecne: https://stackoverflow.com/a/402019/18573662
        // console.log(__check_distance(cursor.x, cursor.y, cursor.radius, this.x, this.y, (this.x + this.width), this.y))
        if (this.checkHover(cursors)) {
            this.stop_hover_timestamp = null;
            if (!this.first_hover_timestamp) this.first_hover_timestamp = animationStep;
            this.hover_progress = Math.min((animationStep - this.first_hover_timestamp) / this.hover_duration, 1);
            if (this.hover_progress >= 1 && !this.clickHandlerRan) {
                this.onClick(this);
                this.clickHandlerRan = true;
            }
            return true;
        } else {
            this.first_hover_timestamp = null;
            if (!this.stop_hover_timestamp) this.stop_hover_timestamp = animationStep;
            this.hover_progress = Math.max(1 - (animationStep - this.stop_hover_timestamp) / this.unhover_duration, 0);
            if (this.hover_progress < 1 && this.clickHandlerRan) this.clickHandlerRan = false;
            return false;
        }
    }
}
class $d58c04b51b404a2f$export$a9274fafe30bd5a6 extends $d58c04b51b404a2f$export$b0bb876e969289cd {
    /**
  * Initialiases the Rect Button Drawable.
  * @param {number} x A positive number indicating x coordinate on screen
  * @param {number} y A positive number indicating y coordinate on screen
  * @param {number} width The width of the button.
  * @param {number} height The height of the button.
  * @param {string} text The text to render.
  * @param {(cursor: Cursor) => any | void} onClick The button's click handler.
  * @param {number | DOMPointInit | (number | DOMPointInit)[]} border_radius The border radius of the rectangle
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  * @param {number} [fontSize=48] The font size
  * @param {string} [font='Yusei Magic'] The text font
  */ constructor(x, y, width, height, text, onClick, border_radius, configureCanvas, fontSize, font){
        super(x, y, width, height, onClick, configureCanvas);
        this.text = text;
        this.fontSize = fontSize || 48;
        this.font = font || 'Yusei Magic';
        this.border_radius = border_radius || 10;
    }
    /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ configure(screenState) {
        screenState.canvasCtx.font = `${screenState.S(this.fontSize * screenState.transitionProgress)}px ${this.font}`;
        screenState.canvasCtx.textAlign = 'center';
        screenState.canvasCtx.textBaseline = 'middle';
    }
    /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ render(screenState) {
        super.render(screenState);
        screenState.canvasCtx.fillText(this.text, screenState.X(this.x + this.width / 2), screenState.Y(this.y + this.height / 2));
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.roundRect(screenState.X(this.x), screenState.Y(this.y), screenState.X(this.width * screenState.transitionProgress), screenState.Y(this.height * screenState.transitionProgress), screenState.S(this.border_radius));
        screenState.canvasCtx.fill();
    }
}
class $d58c04b51b404a2f$export$c3dc6b4f63b21d70 extends (0, $jTmqR.Drawable) {
    radius = 0;
    hover_progress = 0;
    hover_duration = 2300;
    unhover_duration = 1000;
    first_hover_timestamp = /** @type {number | null} */ null;
    stop_hover_timestamp = /** @type {number | null} */ null;
    clickHandlerRan = false;
    onClick = /** @type {(button: CircularButton) => any | void} */ (button)=>{};
    disabled = false;
    /**
  * Initialiases the drawable.
  * @param {number} x A positive number indicating x coordinate on screen
  * @param {number} y A positive number indicating y coordinate on screen
  * @param {number} radius The radius of the circle.
  * @param {(cursor: CircularButton) => any | void} onClick The button's click handler.
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  */ constructor(x, y, radius, onClick, configureCanvas){
        super(x, y, configureCanvas);
        this.radius = radius;
        this.onClick = onClick;
    }
    /**
   * Checks if cursors are intersecting object.
   * @param {Cursor[]} cursors A list of cursors to check
   * @param {ScreenState} screenState The current state of the screen
   * @returns {number | undefined} index of the first cursor that is intersecting the object.
   */ checkHover(cursors, screenState) {
        const [newX, newY, newRadius] = [
            screenState.X(this.x),
            screenState.Y(this.y),
            screenState.S(this.radius)
        ];
        for(let i = 0; i < cursors.length; i++){
            if ($d58c04b51b404a2f$export$e5d4379aa841429f(cursors[i].x, cursors[i].y, cursors[i].radius, newX, newY, newRadius)) return i;
        }
    }
    /**
   * Update the object's state based on the state of the cursor.
   * @param {Cursor[]} cursors The list of cursor objects to check if the button is colliding with the cursor. 
   * @param {ScreenState} screenState The current state of the screen
   */ updateHover(cursors, screenState) {
        const animationStep = screenState.animationStep;
        const hover_cursor_index = this.checkHover(cursors, screenState);
        if (!this.disabled && hover_cursor_index != undefined) {
            if (cursors[hover_cursor_index].type == "touch") this.hover_duration = 500;
            if (!this.first_hover_timestamp) this.first_hover_timestamp = animationStep - (this.stop_hover_timestamp ? this.hover_progress * this.hover_duration : 0);
            this.stop_hover_timestamp = null;
            this.hover_progress = Math.min((animationStep - this.first_hover_timestamp) / this.hover_duration, 1);
            if (this.hover_progress >= 1 && !this.clickHandlerRan) {
                this.onClick(this);
                this.clickHandlerRan = true;
            }
            return true;
        } else {
            if (!this.stop_hover_timestamp) {
                this.stop_hover_timestamp = animationStep - (this.first_hover_timestamp ? (1 - this.hover_progress) * this.unhover_duration : this.unhover_duration);
                this.hover_duration = 2300; //This is a temporary fix
            }
            this.first_hover_timestamp = null;
            this.hover_progress = Math.max(1 - (animationStep - this.stop_hover_timestamp) / this.unhover_duration, 0);
            if (this.hover_progress < 1 && this.clickHandlerRan) this.clickHandlerRan = false;
            return false;
        }
    }
}
class $d58c04b51b404a2f$export$3fb72b1e9dfdaf37 extends $d58c04b51b404a2f$export$c3dc6b4f63b21d70 {
    /**
  * Initialiases the  drawable.
  * @param {number} x A positive number indicating x coordinate on screen
  * @param {number} y A positive number indicating y coordinate on screen 
  * @param {number} radius The radius of the circle.
  * @param {string} text The text to render.
  * @param {(button: CircularButton) => any | void} onClick The button's click handler.
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  * @param {number} [fontSize=28] The font size
  * @param {string} [font='Yusei Magic'] The text font
  */ constructor(x, y, radius, text, onClick, configureCanvas, fontSize, font){
        super(x, y, radius, onClick, configureCanvas);
        this.text = text;
        this.fontSize = fontSize || 28;
        this.font = font || 'Yusei Magic';
    }
    /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ configure(screenState) {
        const transitionProgress = this.overrideTransitionProgress != undefined ? this.overrideTransitionProgress : screenState.transitionProgress;
        screenState.canvasCtx.font = `${screenState.S(this.fontSize * transitionProgress)}px ${this.font}`;
        screenState.canvasCtx.textAlign = 'center';
        screenState.canvasCtx.textBaseline = 'middle';
    }
    /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ render(screenState) {
        super.render(screenState);
        const transitionProgress = this.overrideTransitionProgress != undefined ? this.overrideTransitionProgress : screenState.transitionProgress;
        const xPos = this.overrideXpos != undefined ? this.overrideXpos : screenState.X(this.x);
        const yPos = this.overrideYpos != undefined ? this.overrideYpos : screenState.Y(this.y);
        const radius = screenState.S(this.radius * transitionProgress);
        const inner_radius = screenState.S((this.radius - 2) * transitionProgress);
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.arc(xPos, yPos, radius, 0, 2 * Math.PI);
        screenState.canvasCtx.fillStyle = this.hover_progress > 0 ? (0, $KjYoF.rgb)(108, 212, 255) : (0, $KjYoF.rgb)(15, 223, 23);
        screenState.canvasCtx.fill();
        screenState.canvasCtx.setLineDash([
            screenState.S(8),
            screenState.S(4)
        ]);
        screenState.canvasCtx.lineDashOffset = -(screenState.animationStep / 50 % screenState.S(12));
        screenState.canvasCtx.lineWidth = screenState.S(3);
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.arc(xPos, yPos, inner_radius, 0, 2 * Math.PI);
        // screenState.canvasCtx.strokeStyle = 'blue'
        screenState.canvasCtx.shadowBlur = 15;
        screenState.canvasCtx.shadowColor = (0, $KjYoF.rgb)(228, 255, 26);
        screenState.canvasCtx.strokeStyle = (0, $KjYoF.rgb)(228, 255, 26);
        screenState.canvasCtx.stroke();
        screenState.canvasCtx.shadowBlur = 0;
        screenState.canvasCtx.setLineDash([]);
        screenState.canvasCtx.lineDashOffset = 0;
        // screenState.canvasCtx.lineWidth = 3;
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.arc(xPos, yPos, inner_radius, -Math.PI / 2, 2 * Math.PI * this.hover_progress - Math.PI / 2);
        // screenState.canvasCtx.strokeStyle = rgb(228, 255, 26);
        screenState.canvasCtx.stroke();
        screenState.canvasCtx.fillStyle = (0, $KjYoF.rgb)(228, 255, 26);
        screenState.canvasCtx.fillText(this.text, xPos, yPos);
    }
}
class $d58c04b51b404a2f$export$c25acd513dcc8062 extends $d58c04b51b404a2f$export$c3dc6b4f63b21d70 {
    loading = false;
    /**
  * Initialiases the drawable.
  * @param {number} x A positive number indicating x coordinate on screen
  * @param {number} y A positive number indicating y coordinate on screen 
  * @param {number} radius The radius of the circle.
  * @param {SVG} icon The SVG Icon to render.
  * @param {string} text The text to render.
  * @param {(button: CircularButton) => any | void} onClick The button's click handler.
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  * @param {number} [fontSize=21] The font size
  * @param {string} [font='Yusei Magic'] The text font
  */ constructor(x, y, radius, icon, text, onClick, configureCanvas, fontSize, font){
        super(x, y, radius, onClick, configureCanvas);
        this.icon = icon;
        this.text = text;
        this.fontSize = fontSize || 21;
        this.font = font || 'Yusei Magic';
    }
    /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ configure(screenState) {
        screenState.canvasCtx.font = `${screenState.S(this.fontSize * screenState.transitionProgress)}px ${this.font}`;
        screenState.canvasCtx.textAlign = 'center';
        screenState.canvasCtx.textBaseline = 'middle';
    }
    /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ render(screenState) {
        super.render(screenState);
        const xPos = screenState.X(this.x);
        const yPos = screenState.Y(this.y);
        const radius = screenState.S(this.radius * screenState.transitionProgress);
        const inner_radius = screenState.S((this.radius - 2) * screenState.transitionProgress);
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.arc(xPos, yPos, radius, 0, 2 * Math.PI);
        screenState.canvasCtx.fillStyle = this.hover_progress > 0 ? (0, $KjYoF.rgb)(108, 212, 255) : (0, $KjYoF.rgb)(15, 223, 23);
        screenState.canvasCtx.fill();
        screenState.canvasCtx.setLineDash([
            screenState.S(8),
            screenState.S(4)
        ]);
        screenState.canvasCtx.lineDashOffset = -(screenState.animationStep / 50 % screenState.S(12));
        screenState.canvasCtx.lineWidth = screenState.S(3);
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.arc(xPos, yPos, inner_radius, 0, 2 * Math.PI);
        screenState.canvasCtx.shadowBlur = 15;
        screenState.canvasCtx.shadowColor = (0, $KjYoF.rgb)(228, 255, 26);
        screenState.canvasCtx.strokeStyle = (0, $KjYoF.rgb)(228, 255, 26);
        screenState.canvasCtx.stroke();
        screenState.canvasCtx.shadowBlur = 0;
        screenState.canvasCtx.setLineDash([]);
        screenState.canvasCtx.lineDashOffset = 0;
        // screenState.canvasCtx.lineWidth = 3;
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.arc(xPos, yPos, inner_radius, -Math.PI / 2, 2 * Math.PI * this.hover_progress - Math.PI / 2);
        screenState.canvasCtx.stroke();
        if (this.loading) {
            const spinnerOffset = screenState.animationStep / 1000 % 2000 * 2 * Math.PI;
            screenState.canvasCtx.beginPath();
            screenState.canvasCtx.strokeStyle = (0, $KjYoF.rgba)(255, 255, 22, screenState.transitionProgress);
            screenState.canvasCtx.arc(xPos, yPos, inner_radius / 2, spinnerOffset, 0.5 * Math.PI + spinnerOffset);
            screenState.canvasCtx.stroke();
        } else this.icon.render(screenState.canvasCtx, xPos, yPos, radius * 2, radius * 2, (0, $KjYoF.rgba)(255, 255, 22, screenState.transitionProgress));
        screenState.canvasCtx.fillStyle = "black";
        screenState.canvasCtx.fillText(this.text, xPos, yPos + radius + this.fontSize);
    }
}

});
parcelRegister("1QwlQ", function(module, exports) {

$parcel$export(module.exports, "SVG", () => $1583be1278aed2b5$export$13f4b12aafeba5d6);
$parcel$export(module.exports, "PNG", () => $1583be1278aed2b5$export$1f536085c24cc947);
// const degToRadConversionConst = Math.PI/180
// const degToRad = (deg) => deg*degToRadConversionConst;
class $1583be1278aed2b5$export$13f4b12aafeba5d6 {
    /**
   * Initialises an new SVG Object.
   * @param {string} path_to_svg The SVG file path.
   */ constructor(path_to_svg){
        this.file_path = path_to_svg;
    }
    /**
   * Fetches the SVG object from the server and parses the data.
   */ async load() {
        const data = await (await fetch(this.file_path)).text();
        const svgParser = new DOMParser();
        const svg = svgParser.parseFromString(data, "text/html");
        [this.orignalX, this.orignalY, this.orignalWidth, this.originalHeight] = svg.getElementsByTagName("svg")[0].getAttribute("viewBox").split(" ").map((n)=>Number(n));
        this.paths = Array.from(svg.getElementsByTagName("path")).map((d)=>d.getAttribute('d'));
    }
    /**
   * Renders the SVG image on a given canvas context.
   * @param {CanvasRenderingContext2D} canvasCtx The canvas rendering context.
   * @param {number} x The center x coordinate of the SVG image. TAKE NOTE I SAID CENTER!!!
   * @param {number} y The center y coordinate of the SVG image. TAKE NOTE I SAID CENTER!!!
   * @param {number} width The width of the SVG Image.
   * @param {number} height The height of the SVG Image.
   * @param {string} colour The icon fill colour.
   * @param {number} rotation The rotation of the SVG Image.
   */ render(canvasCtx, x, y, width, height, colour, rotation) {
        if (this.paths && this.paths.length > 0) {
            canvasCtx.fillStyle = colour;
            // References: 
            // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/translate
            // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/scale
            const baseOffsetX = this.orignalX * -1 * (width / this.orignalWidth) + x;
            const baseOffsetY = this.orignalY * -1 * (height / this.originalHeight) + y;
            // canvasCtx.translate(baseOffsetX, baseOffsetY);
            // const rotationRad = degToRad(rotation || 90);
            // const rotationOffset = rotationRad + Math.PI*1.25;
            // canvasCtx.rotate(rotationRad)
            // canvasCtx.translate(width/-2,height/-2);
            // const rotationRadius = Math.sqrt((width/2)**2 + (height/2)**2);
            // canvasCtx.translate((height/2)*Math.cos(rotationOffset), (width/2)*Math.sin(rotationOffset));
            canvasCtx.translate(baseOffsetX - width / 2, baseOffsetY - height / 2);
            canvasCtx.scale(width / this.orignalWidth, height / this.originalHeight);
            for(let i = 0; i < this.paths.length; i++)canvasCtx.fill(new Path2D(this.paths[i]));
            canvasCtx.setTransform(1, 0, 0, 1, 0, 0);
        }
    }
}
class $1583be1278aed2b5$export$1f536085c24cc947 {
    /**
   * Initialises an new PNG Object.
   * @param {string} path_to_png The PNG file path.
   */ constructor(path_to_png){
        this.file_path = path_to_png;
    }
    /**
   * Fetches the PNG object from the server and parses the data.
   */ async load() {
        const img = new Image();
        img.src = this.file_path;
        await img.decode();
        this.img = img;
        this.width = img.width;
        this.height = img.height;
    }
    /**
   * Renders the PNG image on a given canvas context.
   * @param {CanvasRenderingContext2D} canvasCtx The canvas rendering context.
   * @param {number} x The x coordinate of the SVG image.
   * @param {number} y The y coordinate of the SVG image.
   * @param {number} width The width of the SVG Image.
   * @param {number} height The height of the SVG Image.
   */ render(canvasCtx, x, y, width, height) {
        canvasCtx.drawImage(this.img, x, y, width, height);
    }
}

});

parcelRegister("KjYoF", function(module, exports) {

$parcel$export(module.exports, "rgba", () => $08b3ca3e2104efb3$export$4e46ac54fc82cf3b);
$parcel$export(module.exports, "rgb", () => $08b3ca3e2104efb3$export$8972dc0e6ad9238f);
$parcel$export(module.exports, "fadeRGB", () => $08b3ca3e2104efb3$export$df8f13a6bfd83605);
const $08b3ca3e2104efb3$export$4e46ac54fc82cf3b = (r, g, b, a)=>`rgba(${r}, ${g}, ${b}, ${a})`;
const $08b3ca3e2104efb3$export$8972dc0e6ad9238f = (r, g, b)=>`rgb(${r}, ${g}, ${b})`;
function $08b3ca3e2104efb3$export$df8f13a6bfd83605(r1, g1, b1, r2, g2, b2, transitionAmount) {
    const r = r1 + (r2 - r1) * transitionAmount;
    const g = g1 + (g2 - g1) * transitionAmount;
    const b = b1 + (b2 - b1) * transitionAmount;
    return [
        r,
        g,
        b
    ];
}

});


parcelRegister("jA2UJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e413a3c704a0c21a$export$2e2bcd8739ae039);
parcelRequire("4NX2m");

var $jTmqR = parcelRequire("jTmqR");
parcelRequire("1QwlQ");

var $KjYoF = parcelRequire("KjYoF");

var $arHBl = parcelRequire("arHBl");

var $dDUeu = parcelRequire("dDUeu");
parcelRequire("9snnZ");
class $e413a3c704a0c21a$export$2e2bcd8739ae039 extends (0, $jTmqR.Drawable) {
    currentSongPreviewStart = undefined;
    currentSongPreviewEnd = undefined;
    lastLoopTrigger = undefined;
    playPressed = false;
    // This function will set when there is a new song to change to.
    changeSongCallback = /** @type {undefined | Promise<any>} */ undefined;
    // The above function must modify currentSongPreviewStart, currentSongPreviewEnd and set player position manually.
    /**
  * Initialiases the Static Text drawable.
  * @param {SVG} icon The Icon to diplay before the text.
  * @param {string} title The song title.
  * @param {string} artist The artist.
  * @param {import("textalive-app-api").IPlayer} player The textalive player object
  * @param {SVG[]} bgIcons A list of icons to display in the background. Must be an odd number of icons
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  */ constructor(icon, title, artist, difficulty, player, bgIcons, configureCanvas){
        super(710, 365, configureCanvas);
        this.icon = icon;
        this.title = title;
        this.artist = artist;
        this.difficulty = difficulty;
        this.player = player;
        this.bgIcons = bgIcons;
        this.width = 437;
        this.height = 430;
    }
    stopMusicNow() {
        console.log('stopCalled');
        this.currentSongPreviewEnd = this.player.timer.position; // + 1000
    }
    /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ configure(screenState) {
        //Handle Audio Looping
        if (screenState.playerPosition && this.currentSongPreviewStart && this.currentSongPreviewEnd) {
            const fadeInPreviewEndsMs = this.currentSongPreviewStart + 1000;
            const fadeOutPreviewEndsMs = this.currentSongPreviewEnd + 750;
            if (this.lastLoopTrigger > screenState.playerPosition) this.lastLoopTrigger = undefined;
            if (screenState.playerPosition <= fadeInPreviewEndsMs) this.player.volume = (0, $arHBl.easeInCubic)(Math.max(1 - (fadeInPreviewEndsMs - screenState.playerPosition) / 1000, 0)) * 100;
            else if (screenState.playerPosition > fadeInPreviewEndsMs && screenState.playerPosition <= this.currentSongPreviewEnd) this.player.volume = 100;
            else if (screenState.playerPosition <= fadeOutPreviewEndsMs) this.player.volume = (0, $arHBl.easeInCubic)((fadeOutPreviewEndsMs - screenState.playerPosition) / 750) * 100;
            else if (!this.lastLoopTrigger && screenState.playerPosition > fadeOutPreviewEndsMs) {
                console.log('loopCall');
                this.lastLoopTrigger = screenState.playerPosition;
                if (this.changeSongCallback) {
                    this.changeSongCallback();
                    this.changeSongCallback = undefined;
                // As mentioned earlier, the above function must modify currentSongPreviewStart, currentSongPreviewEnd and set player position manually.
                } else this.player.requestMediaSeek(this.currentSongPreviewStart - 500);
            } else this.player.volume = 0;
        }
    }
    /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ render(screenState) {
        super.render(screenState);
        // Background
        screenState.canvasCtx.globalAlpha = screenState.transitionProgress;
        screenState.canvasCtx.fillStyle = "#FFD966";
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.rect(screenState.offsetX, screenState.offsetY, screenState.width, screenState.height);
        screenState.canvasCtx.fill();
        screenState.canvasCtx.globalAlpha = screenState.transitionProgress / 2;
        const bgIconsSize = screenState.height / 10;
        const bgIconsMovementAmount = screenState.animationStep / 3000 % this.bgIcons.length;
        const bgIconsOffset = bgIconsSize * bgIconsMovementAmount;
        const offScreenAmt = bgIconsSize * this.bgIcons.length;
        let iconIndex = 0;
        let moveLeft = screenState.animationStep / 3000 % (this.bgIcons.length * 2) >= this.bgIcons.length;
        for(let i = -offScreenAmt; i < screenState.height + offScreenAmt; i += bgIconsSize){
            for(let j = -offScreenAmt; j < screenState.width + offScreenAmt; j += bgIconsSize){
                // if (iconIndex%this.bgIcons.length == 0){
                //   // this.bgIcons = shuffleArray(this.bgIcons);
                //   [this.bgIcons[0], this.bgIcons[this.bgIcons.length-1]] = [this.bgIcons[this.bgIcons.length-1], this.bgIcons[0]]
                // }
                this.bgIcons[iconIndex % this.bgIcons.length].render(screenState.canvasCtx, j + bgIconsSize / 2 + (moveLeft ? -bgIconsOffset : bgIconsOffset), i + bgIconsSize / 2 + bgIconsOffset, bgIconsSize, bgIconsSize, (0, $KjYoF.rgba)(100, 100, 100, screenState.transitionProgress / 2));
                iconIndex++;
            }
            moveLeft = !moveLeft;
        }
        screenState.canvasCtx.globalAlpha = screenState.transitionProgress;
        const mp3PlayerDisplayArt = new (0, $dDUeu.default)(435, 0, 550, 696, screenState);
        screenState.canvasCtx.fillStyle = (0, $KjYoF.rgb)(88, 192, 235);
        screenState.canvasCtx.lineWidth = 0;
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.roundRect(...mp3PlayerDisplayArt.rectResizeV2(93, 45, 57, 70), [
            10
        ]);
        // screenState.canvasCtx.fill();
        screenState.canvasCtx.roundRect(...mp3PlayerDisplayArt.rectResizeV2(18, 130, 57, 147), [
            10
        ]);
        screenState.canvasCtx.fill();
        screenState.canvasCtx.fillStyle = (0, $KjYoF.rgb)(5, 213, 3);
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.rect(...mp3PlayerDisplayArt.rectResizeV2(408, 0, 22, 50));
        screenState.canvasCtx.fill();
        screenState.canvasCtx.fillStyle = (0, $KjYoF.rgb)(15, 223, 23);
        screenState.canvasCtx.strokeStyle = 'white';
        screenState.canvasCtx.lineWidth = 2;
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.roundRect(...mp3PlayerDisplayArt.rectResizeV2(394, 30, 49, 123), [
            25
        ]);
        screenState.canvasCtx.fill();
        screenState.canvasCtx.stroke();
        screenState.canvasCtx.fillStyle = (0, $KjYoF.rgb)(108, 212, 255);
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.roundRect(...mp3PlayerDisplayArt.rectResizeV2(28, 56, 494, 640), [
            60
        ]);
        screenState.canvasCtx.fill();
        screenState.canvasCtx.stroke();
        // const [rextX, rextY] = [screenState.X(492), screenState.Y(85)];
        // const [rectWidth, rectHeight] = [screenState.S(this.width*screenState.transitionProgress), screenState.S(this.height*screenState.transitionProgress)]
        const iconSize = screenState.S(75);
        const [centreX, centreY] = [
            screenState.X(this.x),
            screenState.Y(this.y)
        ];
        screenState.canvasCtx.fillStyle = 'blue';
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.roundRect(...mp3PlayerDisplayArt.rectResizeV2(57, 85, this.width, this.height), [
            50
        ]);
        screenState.canvasCtx.fill();
        // screenState.canvasCtx.stroke();
        const centreY2 = screenState.Y(294);
        screenState.canvasCtx.font = `bold ${screenState.S(45)}px Yusei Magic`;
        screenState.canvasCtx.textAlign = 'center';
        screenState.canvasCtx.textBaseline = 'middle';
        const txtBounding = screenState.canvasCtx.measureText(this.title);
        const txtHeight = txtBounding.actualBoundingBoxAscent + txtBounding.actualBoundingBoxDescent;
        const timeSinceInit = screenState.animationStep - this.initTime;
        const textColor = (0, $KjYoF.rgba)(255, 255, 255, timeSinceInit >= 750 && this.playPressed ? 1 : screenState.transitionProgress);
        this.icon.render(screenState.canvasCtx, centreX, centreY2 - txtHeight - iconSize / 2, iconSize, iconSize, textColor);
        // screenState.canvasCtx.beginPath();
        screenState.canvasCtx.fillStyle = textColor;
        //750 is Screen Transition Time. We don't want outro animation when play is pressed.
        screenState.canvasCtx.fillText(this.title, centreX, centreY2);
        screenState.canvasCtx.font = `${screenState.S(28)}px Yusei Magic`;
        const txtBounding2 = screenState.canvasCtx.measureText(this.artist);
        const txtHeight2 = txtBounding2.actualBoundingBoxAscent + txtBounding2.actualBoundingBoxDescent;
        // screenState.canvasCtx.fillStyle = rgba(255,255, 255, screenState.transitionProgress);
        screenState.canvasCtx.fillText(this.artist, centreX, centreY2 + txtHeight + 10);
        // screenState.canvasCtx.fill();
        // screenState.canvasCtx
        screenState.canvasCtx.fillText(this.difficulty, centreX, centreY2 + txtHeight + txtHeight2 + 20);
        screenState.canvasCtx.globalAlpha = 1;
    }
}

});
parcelRegister("dDUeu", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eea898072aed2ab$export$2e2bcd8739ae039);
parcelRequire("4NX2m");
class $9eea898072aed2ab$var$GroupedComponent {
    /**
   * 
   * @param {number} x 
   * @param {number} y 
   * @param {number} width 
   * @param {number} height 
   * @param {ScreenState} screenState 
   */ constructor(x, y, width, height, screenState){
        this.width = width;
        this.height = height;
        this.screenState = screenState;
        const scalingWidth = width / this.screenState.devlopmentScreenWidth * this.screenState.width / width;
        const scalingHeight = height / this.screenState.devlopmentScreenHeight * this.screenState.height / height;
        this.scaling = Math.max(scalingWidth, scalingHeight);
        this.renderWidth = width * this.scaling;
        this.renderHeight = height * this.scaling;
        this.x = screenState.offsetX + (x + width / 2) / screenState.devlopmentScreenWidth * screenState.width - this.renderWidth / 2;
        this.y = screenState.offsetY + (y + height / 2) / screenState.devlopmentScreenHeight * screenState.height - this.renderHeight / 2;
        this.center_x = this.x + this.renderWidth / 2;
        this.center_y = this.y + this.renderHeight / 2;
    }
    calculateCenter(x, y, width, height) {
        return [
            x + width / 2,
            y + height / 2
        ];
    }
    rectResizeV2(x, y, width, height, customTransitionProgress) {
        const transitionProgressFinal = customTransitionProgress != undefined ? customTransitionProgress : this.screenState.transitionProgress;
        const [finalWidth, finalHeight] = [
            width * transitionProgressFinal * this.scaling,
            height * transitionProgressFinal * this.scaling
        ];
        return [
            this.x + (x + width / 2) * this.scaling - finalWidth / 2,
            this.y + (y + height / 2) * this.scaling - finalHeight / 2,
            finalWidth,
            finalHeight
        ];
    }
    resizeXY(x, y, customTransitionProgress) {
        const transitionProgressFinal = customTransitionProgress != undefined ? customTransitionProgress : this.screenState.transitionProgress;
        const [widthDiff, heightDiff] = [
            (this.center_x - x * this.scaling) * transitionProgressFinal,
            (this.center_y - y * this.scaling) * transitionProgressFinal
        ];
        return [
            this.x + this.center_x - widthDiff,
            this.y + this.center_y - heightDiff
        ];
    }
    /**
   * Resize X and Y coordinates with transitioning from a predefined bounding center coordinates 
   * (I have no idea what i'm saying but i know exactly what this function does XD.
   * Hope to find a better way to describe this.)
   * @param {number} x 
   * @param {number} y 
   * @param {number} centerX 
   * @param {number} centreY 
   * @param {number | undefined} customTransitionProgress 
   * @returns Resized Coordinates
   */ resizeXY_V2(x, y, centerX, centreY, customTransitionProgress) {
        const transitionProgressFinal = customTransitionProgress != undefined ? customTransitionProgress : this.screenState.transitionProgress;
        const [widthDiff, heightDiff] = [
            (centerX - (this.x + x * this.scaling)) * transitionProgressFinal,
            (centreY - (this.y + y * this.scaling)) * transitionProgressFinal
        ];
        return [
            centerX - widthDiff,
            centreY - heightDiff
        ];
    }
    resizeLine(x, y, x2, y2, customTransitionProgress) {
        const transitionProgressFinal = customTransitionProgress != undefined ? customTransitionProgress : this.screenState.transitionProgress;
        const [center_x, center_y] = [
            (x + x2) / 2,
            (y + y2) / 2
        ];
        const [widthDiff, heightDiff] = [
            (x2 - x) / 2 * transitionProgressFinal,
            (y2 - y) / 2 * transitionProgressFinal
        ];
        return [
            ...this.resizeXY(center_x - widthDiff, center_y - heightDiff, transitionProgressFinal),
            ...this.resizeXY(center_x + widthDiff, center_y + heightDiff, transitionProgressFinal)
        ];
    }
}
var $9eea898072aed2ab$export$2e2bcd8739ae039 = $9eea898072aed2ab$var$GroupedComponent;

});

parcelRegister("9snnZ", function(module, exports) {

$parcel$export(module.exports, "sleep", () => $6e28de83dcfd6250$export$e772c8ff12451969);
$parcel$export(module.exports, "RandomNumber", () => $6e28de83dcfd6250$export$b2cc5abb6c13c1ec);
$parcel$export(module.exports, "shuffleArray", () => $6e28de83dcfd6250$export$7ac3a88d34a76e7);
const $6e28de83dcfd6250$export$e772c8ff12451969 = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $6e28de83dcfd6250$export$b2cc5abb6c13c1ec = (min, max)=>Math.floor(Math.random() * (max - min + 1)) + min;
function $6e28de83dcfd6250$export$7ac3a88d34a76e7(array) {
    for(let i = 0; i < array.length; i++){
        const newI = Math.floor(Math.random() * (i + 1));
        // [array[i], array[newI]] = [array[newI], array[i]]
        const tmp = array[i];
        array[i] = array[newI];
        array[newI] = tmp;
    }
    return array;
}

});


parcelRegister("2rJ7D", function(module, exports) {

$parcel$export(module.exports, "Player", () => $1c811abb26f94012$export$2616165974278734);
/** textalive-app-api v0.4.0 | Copyright 2024 AIST TextAlive Project <textalive-ml@aist.go.jp> (https://textalive.jp) */ parcelRequire("agjCl");
var $7O3nv = parcelRequire("7O3nv");
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self && self;
var $1c811abb26f94012$var$e = {
    exports: {}
};
!function(t) {
    function e(t, e, r) {
        for(var n = r && "number" != typeof e ? r(e) : e, i = 0, o = t.length; i < o;){
            var s = i + o >>> 1;
            (r ? r(t[s]) : t[s]) < n ? i = s + 1 : o = s;
        }
        return i;
    }
    t.sortedIndex = e, Object.defineProperty(t, "__esModule", {
        value: !0
    });
}($1c811abb26f94012$var$e.exports);
var $1c811abb26f94012$var$r = $1c811abb26f94012$var$e.exports, $1c811abb26f94012$export$6ba26ae1c58c0147 = {
    NONE: 0,
    PHRASE: 1,
    WORD: 2,
    CHAR: 4,
    GRAPHIC: 8,
    ALL: 63,
    PUBLIC: 64
}, $1c811abb26f94012$var$i = /^https?:\/\/uploader\.ongaaccel\.jp\/files\?guid=([a-zA-Z0-9]+)/i, $1c811abb26f94012$var$o = /^https?:\/\/songle\.jp\/uploads\/([a-zA-Z0-9]+)\.mp3$/i, $1c811abb26f94012$var$s = /^uploaded:([a-zA-Z0-9]+)$/i, $1c811abb26f94012$var$a = /^songle\.jp\/uploads\/([a-zA-Z0-9]+)\.mp3$/i, $1c811abb26f94012$var$u = /^https?:\/\/piapro\.jp\/t\/([^/]+)(\/[0-9]+)?$/i, $1c811abb26f94012$var$c = {
    getSongPathFromUrl: function(t) {
        if ($1c811abb26f94012$var$c.isUploaderUrl(t)) {
            var e = $1c811abb26f94012$var$o.exec(t);
            if (e) return "songle.jp/uploads/".concat(e[1], ".mp3");
            var r = $1c811abb26f94012$var$i.exec(t);
            if (r) return "songle.jp/uploads/".concat(r[1], ".mp3");
        }
        return /https?:\/\/(.+)/.exec(t)[1];
    },
    isUploaderUrl: function(t) {
        return $1c811abb26f94012$var$o.test(t) || $1c811abb26f94012$var$i.test(t);
    },
    isUploaderPath: function(t) {
        return $1c811abb26f94012$var$a.test(t) || $1c811abb26f94012$var$s.test(t);
    },
    getUploaderGuid: function(t) {
        var e = $1c811abb26f94012$var$a.exec(t);
        if (e) return e[1];
        var r = $1c811abb26f94012$var$s.exec(t);
        return r ? r[1] : null;
    },
    getSongUrlFromUploaderGuid: function(t) {
        return t ? "https://songle.jp/uploads/".concat(t, ".mp3") : null;
    },
    getAltSongUrlFromUploaderGuid: function(t) {
        return t ? "https://api.textalive.jp/songle/me/uploads/".concat(t) : null;
    },
    getSongUrlFromPath: function(t) {
        var e = $1c811abb26f94012$var$c.getUploaderGuid(t);
        return e ? $1c811abb26f94012$var$c.getSongUrlFromUploaderGuid(e) : "https://".concat(t);
    },
    isYouTubeUrl: function(t) {
        return /^https?:\/\/((www|m)\.)?youtube\.com/i.test(t);
    },
    isNicovideoUrl: function(t) {
        return /^https?:\/\/(www\.)?nicovideo.jp/i.test(t);
    },
    isVideoSiteUrl: function(t) {
        return $1c811abb26f94012$var$c.isYouTubeUrl(t) || $1c811abb26f94012$var$c.isNicovideoUrl(t);
    },
    isPiaproUrl: function(t) {
        return $1c811abb26f94012$var$u.test(t);
    }
}, $1c811abb26f94012$var$l = /^https:\/\/songle\.jp\/api\/v[0-9]+\/users\/(.+)\/uploads\/(.+)$/, $1c811abb26f94012$var$p = function(t) {
    return $1c811abb26f94012$var$l.test(t);
}, $1c811abb26f94012$var$h = function(t) {
    var e = $1c811abb26f94012$var$l.exec(t);
    return e ? {
        user: e[1],
        identifier: e[2]
    } : {
        user: null,
        identifier: null
    };
}, $1c811abb26f94012$var$d = function() {
    function t() {}
    return t.prototype.isLicenseLoading = function(t) {
        return !t || !t.song || void 0 === t.lyrics || void 0 === t.backgroundImage;
    }, t.prototype.checkLicenses = function(t) {
        return !this.isLicenseLoading(t) && this.checkLicense(t.song) && this.checkLicense(t.lyrics) && this.checkLicense(t.backgroundImage);
    }, t.prototype.checkLicense = function(t) {
        return null === t || (1 === t.contentType ? this.checkMusicLicense(t.license) : 2 === t.contentType ? this.checkTextLicense(t.license) : 0 === t.contentType && (!!this.isBackgroundColorAsset(t) || this.checkBackgroundImageLicense(t.license)));
    }, t.prototype.checkMusicLicense = function(t) {
        return t.condition && t.condition.uploader || !(!t.condition || t.condition.ns || t.condition.nc || t.condition.org || t.condition.clb);
    }, t.prototype.checkTextLicense = function(t) {
        return t.condition && t.condition.uploader || !(!t.condition || t.condition.ns || t.condition.org || t.condition.clb);
    }, t.prototype.checkBackgroundImageLicense = function(t) {
        return !(!t.condition || t.condition.ns || t.condition.nc || t.condition.org || t.condition.clb);
    }, t.prototype.isUploaderAsset = function(t) {
        return t && t.url && ($1c811abb26f94012$var$c.isUploaderUrl(t.url) || $1c811abb26f94012$var$p(t.url));
    }, t.prototype.isPiaproAsset = function(t) {
        return t && t.url && $1c811abb26f94012$var$c.isPiaproUrl(t.url);
    }, t.prototype.isBlankBackgroundAsset = function(t) {
        return !t || !t.originalUrl;
    }, t.prototype.isBackgroundColorAsset = function(t) {
        var e = t && t.originalUrl ? t.originalUrl : "";
        return /^#[0-9a-fA-F]{3,6}$/.test(e);
    }, t.prototype.isBackgroundPiaproImageAsset = function(t) {
        var e = t && t.originalUrl ? t.originalUrl : "";
        return $1c811abb26f94012$var$c.isPiaproUrl(e);
    }, t.prototype.isBackgroundSpecialImageAsset = function(t) {
        var e = t && t.originalUrl ? t.originalUrl : "";
        return /^snowmiku2016-([0-9]{2})$/.test(e);
    }, t.prototype.getQueryParameter = function(t) {
        return !t || t.license && !this.checkBackgroundImageLicense(t.license) ? null : t.originalUrl;
    }, t;
}(), $1c811abb26f94012$var$f = function(t, e) {
    return $1c811abb26f94012$var$f = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }, $1c811abb26f94012$var$f(t, e);
}, $1c811abb26f94012$var$y = function() {
    return $1c811abb26f94012$var$y = Object.assign || function(t) {
        for(var e, r = 1, n = arguments.length; r < n; r++)for(var i in e = arguments[r])Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
        return t;
    }, $1c811abb26f94012$var$y.apply(this, arguments);
};
function $1c811abb26f94012$var$g(t, e, r, n) {
    return new (r || (r = Promise))(function(e, i) {
        function o(t) {
            try {
                a(n.next(t));
            } catch (t) {
                i(t);
            }
        }
        function s(t) {
            try {
                a(n.throw(t));
            } catch (t) {
                i(t);
            }
        }
        function a(t) {
            var n;
            t.done ? e(t.value) : (n = t.value, n instanceof r ? n : new r(function(t) {
                t(n);
            })).then(o, s);
        }
        a((n = n.apply(t, [])).next());
    });
}
function $1c811abb26f94012$var$v(t, e) {
    var r, n, i, o, s = {
        label: 0,
        sent: function() {
            if (1 & i[0]) throw i[1];
            return i[1];
        },
        trys: [],
        ops: []
    };
    return o = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
        return this;
    }), o;
    function a(a) {
        return function(u) {
            return function(a) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; o && (o = 0, a[0] && (s = 0)), s;)try {
                    if (r = 1, n && (i = 2 & a[0] ? n.return : a[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, a[1])).done) return i;
                    switch(n = 0, i && (a = [
                        2 & a[0],
                        i.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            i = a;
                            break;
                        case 4:
                            return s.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            s.label++, n = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = s.ops.pop(), s.trys.pop();
                            continue;
                        default:
                            if (!((i = (i = s.trys).length > 0 && i[i.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                s = 0;
                                continue;
                            }
                            if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                                s.label = a[1];
                                break;
                            }
                            if (6 === a[0] && s.label < i[1]) {
                                s.label = i[1], i = a;
                                break;
                            }
                            if (i && s.label < i[2]) {
                                s.label = i[2], s.ops.push(a);
                                break;
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue;
                    }
                    a = e.call(t, s);
                } catch (t) {
                    a = [
                        6,
                        t
                    ], n = 0;
                } finally{
                    r = i = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                u
            ]);
        };
    }
}
"function" == typeof SuppressedError && SuppressedError;
var $1c811abb26f94012$var$m = {
    fallback: {
        protocol: "https"
    },
    songle: {
        domain: "songle.jp"
    },
    textalive: {
        domain: "api.textalive.jp"
    },
    content: {
        domain: "content.textalive.jp"
    },
    client: {
        version: "0.10.0",
        axios: null
    }
};
function $1c811abb26f94012$var$b(e, r, n) {
    var i, o, s;
    return $1c811abb26f94012$var$g(this, 0, void 0, function() {
        var a;
        return $1c811abb26f94012$var$v(this, function(u) {
            switch(u.label){
                case 0:
                    a = {
                        responseType: (null == n ? void 0 : n.responseType) || "json"
                    }, r && (a.params = r), (null == n ? void 0 : n.auth) && (a.auth = {
                        username: null === (i = n.auth) || void 0 === i ? void 0 : i.username,
                        password: null === (o = n.auth) || void 0 === o ? void 0 : o.password
                    }), (null == n ? void 0 : n.withCredentials) && (a.withCredentials = !0), a.headers = {}, 0 === e.indexOf($1c811abb26f94012$var$m.textalive.server) && ($1c811abb26f94012$var$m.textalive.appToken && (a.headers["x-ta-app-token"] = $1c811abb26f94012$var$m.textalive.appToken), $1c811abb26f94012$var$m.textalive.authUser && $1c811abb26f94012$var$m.textalive.authToken && (a.headers["x-ta-auth-user"] = $1c811abb26f94012$var$m.textalive.authUser, a.headers["x-ta-auth-token"] = $1c811abb26f94012$var$m.textalive.authToken)), (null == n ? void 0 : n.headers) && (a.headers = $1c811abb26f94012$var$y($1c811abb26f94012$var$y({}, a.headers), n.headers)), u.label = 1;
                case 1:
                    return u.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]), [
                        4,
                        ((null == n ? void 0 : n.client) || (null === (s = $1c811abb26f94012$var$m.client) || void 0 === s ? void 0 : s.axios) || (0, $7O3nv.default)).get(e, a)
                    ];
                case 2:
                    return [
                        2,
                        u.sent()
                    ];
                case 3:
                    return u.sent(), [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
}
function $1c811abb26f94012$var$_(t) {
    var e, r, n = 0;
    if (0 === t.length) return n;
    for(e = 0, r = t.length; e < r; e++)n = (n << 5) - n + t.charCodeAt(e), n |= 0;
    return n;
}
$1c811abb26f94012$var$m.songle.protocol = $1c811abb26f94012$var$m.songle.protocol || $1c811abb26f94012$var$m.fallback.protocol, $1c811abb26f94012$var$m.songle.server = "".concat($1c811abb26f94012$var$m.songle.protocol, "://").concat($1c811abb26f94012$var$m.songle.domain), $1c811abb26f94012$var$m.textalive.protocol = $1c811abb26f94012$var$m.textalive.protocol || $1c811abb26f94012$var$m.fallback.protocol, $1c811abb26f94012$var$m.textalive.server = "".concat($1c811abb26f94012$var$m.textalive.protocol, "://").concat($1c811abb26f94012$var$m.textalive.domain), $1c811abb26f94012$var$m.textalive.appToken = null, $1c811abb26f94012$var$m.content.protocol = $1c811abb26f94012$var$m.content.protocol || $1c811abb26f94012$var$m.fallback.protocol, $1c811abb26f94012$var$m.content.server = "".concat($1c811abb26f94012$var$m.content.protocol, "://").concat($1c811abb26f94012$var$m.content.domain);
var $1c811abb26f94012$var$w = new (function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return function(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
        function r() {
            this.constructor = t;
        }
        $1c811abb26f94012$var$f(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
    }(e, t), Object.defineProperty(e.prototype, "endpoint", {
        get: function() {
            return "".concat($1c811abb26f94012$var$m.textalive.server, "/etc/license");
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.read = function(t, e) {
        var r;
        return void 0 === e && (e = !0), $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var n, i;
            return $1c811abb26f94012$var$v(this, function(o) {
                switch(o.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b(this.endpoint, {
                                url: t,
                                token: $1c811abb26f94012$var$_("ta" + t),
                                skipOptoutCheck: !!e || void 0
                            })
                        ];
                    case 1:
                        return !(n = o.sent()) || 200 !== n.status || (null === (r = n.data) || void 0 === r ? void 0 : r.error) ? [
                            2,
                            {
                                originalUrl: null,
                                license: {
                                    code: n ? n.status : 404
                                }
                            }
                        ] : ((i = n.data).license.code = n.status, 0 === i.contentType && (i.css = 'url("' + i.contentUrl + '")'), [
                            2,
                            i
                        ]);
                }
            });
        });
    }, e;
}($1c811abb26f94012$var$d));
function $1c811abb26f94012$var$P(e, r, n) {
    var i;
    return $1c811abb26f94012$var$g(this, 0, void 0, function() {
        var o;
        return $1c811abb26f94012$var$v(this, function(s) {
            switch(s.label){
                case 0:
                    r || (r = {}), o = {
                        responseType: (null == n ? void 0 : n.responseType) || "json"
                    }, (null == n ? void 0 : n.withCredentials) && (o.withCredentials = !0), o.headers = {}, 0 === e.indexOf($1c811abb26f94012$var$m.textalive.server) && ($1c811abb26f94012$var$m.textalive.appToken && (o.headers["x-ta-app-token"] = $1c811abb26f94012$var$m.textalive.appToken), $1c811abb26f94012$var$m.textalive.authUser && $1c811abb26f94012$var$m.textalive.authToken && (o.headers["x-ta-auth-user"] = $1c811abb26f94012$var$m.textalive.authUser, o.headers["x-ta-auth-token"] = $1c811abb26f94012$var$m.textalive.authToken)), (null == n ? void 0 : n.postToken) && (o.headers["x-ta-post-token"] = n.postToken), (null == n ? void 0 : n.headers) && (o.headers || (o.headers = {}), o.headers = $1c811abb26f94012$var$y($1c811abb26f94012$var$y({}, o.headers), n.headers)), s.label = 1;
                case 1:
                    return s.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]), [
                        4,
                        ((null == n ? void 0 : n.client) || (null === (i = $1c811abb26f94012$var$m.client) || void 0 === i ? void 0 : i.axios) || (0, $7O3nv.default)).post(e, r, o)
                    ];
                case 2:
                    return [
                        2,
                        s.sent()
                    ];
                case 3:
                    return s.sent(), [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
}
var $1c811abb26f94012$var$E = "data:text/plain;base64,";
function $1c811abb26f94012$export$9167496004a18c0(t) {
    return "string" == typeof t && 0 === t.indexOf($1c811abb26f94012$var$E);
}
function $1c811abb26f94012$export$8a3afe04b75316cd(t) {
    if (!$1c811abb26f94012$export$9167496004a18c0(t)) return null;
    var e = t.split(",")[1];
    return decodeURIComponent(atob(e).split("").map(function(t) {
        return "%" + ("00" + t.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
}
function $1c811abb26f94012$export$c8ddbc4478af1a1c(t) {
    return "string" != typeof t ? null : $1c811abb26f94012$var$E + btoa(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g, function(t, e) {
        return String.fromCharCode(parseInt("0x" + e));
    }));
}
function $1c811abb26f94012$var$x(t, e, r, n, i) {
    var o = void 0 === window.screenLeft ? screen.left : window.screenLeft, s = void 0 === window.screenTop ? screen.top : window.screenTop, a = (window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width) / 2 - r / 2 + o, u = (window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height) / 2 - n / 2 + s, c = window.open(t, e, "width=" + r + ",height=" + n + ",top=" + u + ",left=" + a + "," + i);
    return window.focus && c.focus(), c;
}
var $1c811abb26f94012$var$A = new (function() {
    function t() {
        this.listeners = [], this.pollingTimeout = null;
    }
    return Object.defineProperty(t.prototype, "endpoint", {
        get: function() {
            return "".concat($1c811abb26f94012$var$m.textalive.server, "/");
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "songleEndpoint", {
        get: function() {
            return "".concat($1c811abb26f94012$var$m.songle.server, "/");
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.isLoading = function() {
        return !!this.userProfile;
    }, t.prototype.spoof = function(t) {
        this.userProfile = t;
    }, t.prototype.getServerStatus = function() {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            return $1c811abb26f94012$var$v(this, function(t) {
                return [
                    2,
                    this.serverStatus || this.doGetServerStatus()
                ];
            });
        });
    }, t.prototype.doGetServerStatus = function() {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var t;
            return $1c811abb26f94012$var$v(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.serverStatusRequest || (this.serverStatusRequest = $1c811abb26f94012$var$b(this.endpoint, null, {
                            withCredentials: !0
                        })), [
                            4,
                            this.serverStatusRequest
                        ];
                    case 1:
                        return t = e.sent(), this.serverStatusRequest = null, t && 200 === t.status ? (this.serverStatus = t.data, [
                            2,
                            this.serverStatus
                        ]) : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.getProfile = function() {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            return $1c811abb26f94012$var$v(this, function(t) {
                return [
                    2,
                    this.userProfile || this.doGetProfile()
                ];
            });
        });
    }, t.prototype.doGetProfile = function() {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var t;
            return $1c811abb26f94012$var$v(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.userProfileRequest || (this.userProfileRequest = $1c811abb26f94012$var$b("".concat(this.endpoint, "profile"), null, {
                            withCredentials: !0
                        })), [
                            4,
                            this.userProfileRequest
                        ];
                    case 1:
                        return t = e.sent(), this.userProfileRequest = null, t && 200 === t.status ? (this.emitUserProfile(t.data), this.userProfile = t.data, [
                            2,
                            this.userProfile
                        ]) : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.getMergingUsers = function() {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var t;
            return $1c811abb26f94012$var$v(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.endpoint, "profile/merge"), null, {
                                withCredentials: !0
                            })
                        ];
                    case 1:
                        return (t = e.sent()) && 200 === t.status && t.data ? [
                            2,
                            [
                                t.data.user,
                                t.data.mergeWith
                            ]
                        ] : [
                            2,
                            [
                                null,
                                null
                            ]
                        ];
                }
            });
        });
    }, t.prototype.mergeUsers = function() {
        var t;
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r, n, i, o, s;
            return $1c811abb26f94012$var$v(this, function(a) {
                switch(a.label){
                    case 0:
                        return [
                            4,
                            this.getToken()
                        ];
                    case 1:
                        return e = a.sent(), [
                            4,
                            $1c811abb26f94012$var$P("".concat(this.endpoint, "profile/merge"), null, {
                                postToken: e,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        if (!(r = a.sent()) || 200 !== r.status || !(null === (t = r.data) || void 0 === t ? void 0 : t.success)) return [
                            2,
                            null
                        ];
                        for(n = r.data.user, i = 0, o = this.listeners; i < o.length; i++)(s = o[i]).onUserMerged && s.onUserMerged(n);
                        return [
                            2,
                            n
                        ];
                }
            });
        });
    }, t.prototype.updateUser = function(t) {
        var e;
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r, n, i, o;
            return $1c811abb26f94012$var$v(this, function(s) {
                switch(s.label){
                    case 0:
                        return [
                            4,
                            this.getToken()
                        ];
                    case 1:
                        return r = s.sent(), [
                            4,
                            $1c811abb26f94012$var$P("".concat(this.endpoint, "profile"), t, {
                                postToken: r,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (n = s.sent()) && 200 === n.status && (null === (e = n.data) || void 0 === e ? void 0 : e.success) ? (i = n.data.user, [
                            4,
                            this.getProfile()
                        ]) : [
                            2,
                            null
                        ];
                    case 3:
                        return (o = s.sent()).user = i, this.emitUserProfile(o), [
                            2,
                            i
                        ];
                }
            });
        });
    }, t.prototype.isYouTubeUser = function(t) {
        return t && t.user && "string" == typeof t.user.youtubeIdString;
    }, t.prototype.isPiaproUser = function(t) {
        return t && t.user && "string" == typeof t.user.piaproIdString;
    }, t.prototype.isSongleUser = function(t) {
        return t && t.user && ("number" == typeof t.user.songleUserId && t.user.songleUserId >= 0 || "string" == typeof t.user.songleAccessToken);
    }, t.prototype.isSpoofingSongleUser = function(t) {
        return this.isSongleUser(t) && ("number" != typeof t.user.id || t.user.id < 0);
    }, t.prototype.addListener = function(t) {
        t && this.listeners.push(t);
    }, t.prototype.removeListener = function(t) {
        this.listeners = this.listeners.filter(function(e) {
            return e !== t;
        });
    }, t.prototype.emitUserProfile = function(t) {
        this.userProfile = t;
        for(var e = 0, r = this.listeners; e < r.length; e++){
            var n = r[e];
            n.onUserProfileUpdated && n.onUserProfileUpdated(t), this.userProfile.user ? n.onUserLoggedIn && n.onUserLoggedIn(t.user) : n.onUserLoggedOut && n.onUserLoggedOut();
        }
    }, t.prototype.authenticate = function(t, e) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.endpoint, "profile/logins/basic"), null, {
                                auth: {
                                    username: String(t),
                                    password: e
                                },
                                withCredentials: !0
                            })
                        ];
                    case 1:
                        return (r = n.sent()) && 200 === r.status && r.data ? [
                            2,
                            r.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loginTwitter = function(t) {
        return this.login(t, "twitter");
    }, t.prototype.loginGitHub = function(t) {
        return this.login(t, "github");
    }, t.prototype.loginYouTube = function(t) {
        return this.login(t, "youtube");
    }, t.prototype.loginPiapro = function(t) {
        return this.login(t, "piapro");
    }, t.prototype.loginSongle = function(t) {
        return this.login(t, "songle");
    }, t.prototype.login = function(t, e) {
        return t && t.preventDefault(), !!e && ($1c811abb26f94012$var$x("".concat(this.endpoint, "profile/logins/").concat(e), "TextAliveAuth", 600, 480, "status=no,toolbar=no,menubar=no"), this.startMonitoringAuthState(), !1);
    }, t.prototype.logoutTwitter = function(t) {
        return this.logout(t, "twitter");
    }, t.prototype.logoutGitHub = function(t) {
        return this.logout(t, "github");
    }, t.prototype.logoutYouTube = function(t) {
        return this.logout(t, "youtube");
    }, t.prototype.logoutPiapro = function(t) {
        return this.logout(t, "piapro");
    }, t.prototype.logoutSongle = function(t) {
        return this.logout(t, "songle");
    }, t.prototype.logout = function(t, e) {
        return void 0 === e && (e = null), t && t.preventDefault(), $1c811abb26f94012$var$x("".concat(this.endpoint, "profile/logouts/").concat(e || "all"), "TextAliveAuth", 600, 480, "status=no,toolbar=no,menubar=no"), this.startMonitoringAuthState(), !1;
    }, t.prototype.startMonitoringAuthState = function() {
        var t = this;
        this.pollingTimeout && (clearTimeout(this.pollingTimeout), this.pollingTimeout = null);
        var e = function(r) {
            if (r.data && r.data.textalive) {
                if (r.source.postMessage("close", r.origin), r.data.merge) return t.getMergingUsers().then(function(e) {
                    for(var r = e[0], n = e[1], i = 0, o = t.listeners; i < o.length; i++){
                        var s = o[i];
                        s.onUserMergeRequired && s.onUserMergeRequired(r, n);
                    }
                }).catch(function() {}), void window.removeEventListener("message", e);
                t.doGetProfile(), window.removeEventListener("message", e);
            }
        };
        window.addEventListener("message", e);
    }, t.prototype.getToken = function() {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            return $1c811abb26f94012$var$v(this, function(t) {
                return this.userProfile ? [
                    2,
                    this.userProfile.status.token
                ] : this.token ? [
                    2,
                    this.token
                ] : [
                    2,
                    this.doGetToken()
                ];
            });
        });
    }, t.prototype.doGetToken = function() {
        var t;
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e;
            return $1c811abb26f94012$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.endpoint, "profile/token"), null, {
                                withCredentials: !0
                            })
                        ];
                    case 1:
                        return e = r.sent(), (null === (t = null == e ? void 0 : e.data) || void 0 === t ? void 0 : t.token) && (this.token = e.data.token), [
                            2,
                            this.token
                        ];
                }
            });
        });
    }, t;
}()), $1c811abb26f94012$var$R = new (function() {
    function t() {}
    return Object.defineProperty(t.prototype, "endpoint", {
        get: function() {
            return "".concat($1c811abb26f94012$var$m.textalive.server, "/text-parser/");
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.parse = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r;
            return $1c811abb26f94012$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$A.getToken()
                        ];
                    case 1:
                        return e = n.sent(), [
                            4,
                            $1c811abb26f94012$var$P(this.endpoint, {
                                text: t
                            }, {
                                postToken: e,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (r = n.sent()) && 200 === r.status ? [
                            2,
                            r.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t;
}()), $1c811abb26f94012$var$C = new (function() {
    function t() {}
    return Object.defineProperty(t.prototype, "endpoint", {
        get: function() {
            return "".concat($1c811abb26f94012$var$m.content.server, "/fonts");
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.listAvailableFonts = function() {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var t = this;
            return $1c811abb26f94012$var$v(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.data ? [
                            3,
                            2
                        ] : [
                            4,
                            this.fetchInfo()
                        ];
                    case 1:
                        e.sent(), e.label = 2;
                    case 2:
                        return this.data && this.data.fontFamilies ? [
                            2,
                            Object.keys(this.data.fontFamilies).map(function(e) {
                                return $1c811abb26f94012$var$y({
                                    key: e
                                }, t.data.fontFamilies[e]);
                            })
                        ] : [
                            2,
                            []
                        ];
                }
            });
        });
    }, t.prototype.getFrequentChars = function() {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            return $1c811abb26f94012$var$v(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.data ? [
                            3,
                            2
                        ] : [
                            4,
                            this.fetchInfo()
                        ];
                    case 1:
                        t.sent(), t.label = 2;
                    case 2:
                        return [
                            2,
                            this.data && this.data.frequentChars || ""
                        ];
                }
            });
        });
    }, t.prototype.clearCache = function() {
        this.data = null;
    }, t.prototype.fetchInfo = function() {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var t, e, r, n;
            return $1c811abb26f94012$var$v(this, function(i) {
                switch(i.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.endpoint, "/index.json"))
                        ];
                    case 1:
                        if (!(t = i.sent()) || 200 !== t.status || !t.data) return this.data = null, [
                            2,
                            null
                        ];
                        for(r in this.data = t.data, e = this.data.fontUrlPrefix, this.data.fontFamilies)(n = this.data.fontFamilies[r]).typesquare || n.typekit || n.google || n.url || (n.url = "".concat(e, "/").concat(r, "-all.css"), n.compactUrl = "".concat(e, "/").concat(r, ".css"));
                        return [
                            2
                        ];
                }
            });
        });
    }, t;
}());
var $1c811abb26f94012$var$N = new RegExp("\\b([CDEFGAB](?:b|bb)*(?:#|##|sus|maj|min|aug|m|M)*[\\d/]*(?:[CDEFGAB](?:b|bb)*(?:#|##|sus|maj|min|aug|m|M)*[\\d/]*)*\\-){2}");
function $1c811abb26f94012$var$k(t, e, r) {
    return !$1c811abb26f94012$var$N.test(t) && !t.match(/[（(].+(?:転載|書き起こし).*[）)]/) && (!t.match(/(作詞|作曲).+(作詞|作曲)/) || 0 !== e && e !== r.length - 2);
}
function $1c811abb26f94012$var$j(t) {
    return !t.match(new RegExp("[\uFF08(]?\u203B"));
}
var $1c811abb26f94012$var$I = {}, $1c811abb26f94012$var$U = {}, $1c811abb26f94012$var$F = function() {
    function t() {}
    return Object.defineProperty(t.prototype, "endpoint", {
        get: function() {
            return "".concat($1c811abb26f94012$var$m.songle.server, "/lyrics/");
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "localLyricsEndpoint", {
        get: function() {
            return "".concat($1c811abb26f94012$var$m.textalive.server, "/etc/lyrics");
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "timingEndpoint", {
        get: function() {
            return "".concat($1c811abb26f94012$var$m.songle.server, "/songs/");
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "lyricsParserEndpoint", {
        get: function() {
            return $1c811abb26f94012$var$m.songle.server;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "lyricsPostEndpoint", {
        get: function() {
            return $1c811abb26f94012$var$m.songle.server;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.isUploaderUrl = function(t) {
        return $1c811abb26f94012$var$p(t);
    }, t.prototype.parseUploaderUrl = function(t) {
        return $1c811abb26f94012$var$h(t);
    }, t.prototype.getRecentlySynchronizedList = function(t) {
        return void 0 === t && (t = {}), $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r;
            return $1c811abb26f94012$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return e = {}, "number" == typeof t ? e.page = t : t && (e.page = t.page, e.per_page = t.perPage), [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.endpoint, "recently_synchronized.json"), e)
                        ];
                    case 1:
                        return (r = n.sent()) && 200 === r.status ? [
                            2,
                            r.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.load = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e;
            return $1c811abb26f94012$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.timingEndpoint + t, "/lyrics.json"))
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.clearCache = function() {
        $1c811abb26f94012$var$I = {};
    }, t.prototype.loadDetail = function(t, e) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r, n;
            return $1c811abb26f94012$var$v(this, function(i) {
                switch(i.label){
                    case 0:
                        return $1c811abb26f94012$var$I[t] && $1c811abb26f94012$var$I[t][e] ? [
                            2,
                            $1c811abb26f94012$var$I[t][e]
                        ] : [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.timingEndpoint + t, "/lyrics/").concat(e < 0 ? "latest" : e, ".json"))
                        ];
                    case 1:
                        return (r = i.sent()) && 200 === r.status ? (n = r.data, $1c811abb26f94012$var$I[t] || ($1c811abb26f94012$var$I[t] = {}), $1c811abb26f94012$var$I[t][n.id] = n, e < 0 && ($1c811abb26f94012$var$I[t][-1] = n), [
                            2,
                            n
                        ]) : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loadDiffs = function(t, e) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.timingEndpoint + t, "/lyrics/").concat(e, "/diffs.json"))
                        ];
                    case 1:
                        return (r = n.sent()) && 200 === r.status ? [
                            2,
                            r.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loadDiff = function(t, e, r) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            return $1c811abb26f94012$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.timingEndpoint + t, "/lyrics/").concat(e).concat(r < 0 ? "" : 0 === r ? "/original" : "/diffs/".concat(r, "/lyrics"), ".json"))
                        ];
                    case 1:
                        return [
                            2,
                            n.sent().data
                        ];
                }
            });
        });
    }, t.prototype.loadAllRevisionsForSong = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r, n, i, o, s, a, u, c, l;
            return $1c811abb26f94012$var$v(this, function(p) {
                switch(p.label){
                    case 0:
                        return [
                            4,
                            this.load(t)
                        ];
                    case 1:
                        if (!(e = p.sent())) return [
                            2,
                            null
                        ];
                        r = [], n = 0, i = e.lyrics, p.label = 2;
                    case 2:
                        return n < i.length ? (o = i[n], [
                            4,
                            this.loadDetail(t, o.id)
                        ]) : [
                            3,
                            6
                        ];
                    case 3:
                        return s = p.sent(), [
                            4,
                            this.loadDiffs(t, s.id)
                        ];
                    case 4:
                        if (a = p.sent(), r.push({
                            lyrics: s,
                            updated_at: new Date(s.created_at)
                        }), Array.isArray(a)) for(u = 0, c = a; u < c.length; u++)l = c[u], r.push({
                            diff_id: l.id,
                            source_id: l.source_id,
                            lyrics: s,
                            updated_at: new Date(l.updated_at)
                        });
                        p.label = 5;
                    case 5:
                        return n++, [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            2,
                            r.sort(function(t, e) {
                                var r = e.updated_at.getTime() - t.updated_at.getTime();
                                return 0 === r ? e.diff_id - t.diff_id : r;
                            })
                        ];
                }
            });
        });
    }, t.prototype.getLatestRevision = function(t) {
        return t.filter(function(t) {
            return !(t.lyrics.processing || t.lyrics.failed);
        })[0];
    }, t.prototype.fetchLocalLyricBody = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r, n, i;
            return $1c811abb26f94012$var$v(this, function(o) {
                switch(o.label){
                    case 0:
                        return this.verbose && ("string" == typeof t ? console.log("load locally-stored lyrics for song code", t) : console.log("load locally-stored lyrics for lyric id", t)), e = {}, "string" == typeof t ? e.code = t : e.lyricId = t, [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.localLyricsEndpoint, "/token"), e)
                        ];
                    case 1:
                        return !(r = o.sent()) || 200 !== r.status || r.data.error ? [
                            2,
                            null
                        ] : (n = r.data.token, e.token = n, [
                            4,
                            $1c811abb26f94012$var$b(this.localLyricsEndpoint, e)
                        ]);
                    case 2:
                        return (i = o.sent()) && 200 === i.status ? (this.verbose && console.log("loaded locally-stored lyrics with params", e), [
                            2,
                            i.data
                        ]) : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.fetchSongleLyricBody = function(t, e) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r, n, i, o, s, a, u, c, l, p, h;
            return $1c811abb26f94012$var$v(this, function(d) {
                switch(d.label){
                    case 0:
                        if (!(r = this.parseUploaderUrl(t)).identifier) throw new Error("unsupported lyrics url ".concat(t));
                        return [
                            4,
                            $1c811abb26f94012$var$A.getProfile()
                        ];
                    case 1:
                        if (n = d.sent(), !$1c811abb26f94012$var$A.isSongleUser(n)) throw new Error("Songle authentication is required");
                        return i = "".concat(t, "//").concat(e), $1c811abb26f94012$var$U[i] ? [
                            2,
                            $1c811abb26f94012$var$U[i]
                        ] : ($1c811abb26f94012$var$A.isSpoofingSongleUser(n) && (s = n.user, a = s.songleUserId, u = s.songleAccessToken, c = s.songleRefreshToken, o = {
                            songleUserId: a,
                            songleAccessToken: u,
                            songleRefreshToken: c
                        }), [
                            4,
                            $1c811abb26f94012$var$b("".concat($1c811abb26f94012$var$m.textalive.server, "/songle/users/").concat(r.user, "/uploads/").concat(r.identifier), o, {
                                withCredentials: !0,
                                responseType: "text"
                            })
                        ]);
                    case 2:
                        return l = d.sent(), p = null == l ? void 0 : l.data, h = p ? {
                            text: p,
                            url: t
                        } : null, p && ($1c811abb26f94012$var$U[i] = h), [
                            2,
                            h
                        ];
                }
            });
        });
    }, t.prototype.fetchPiaproLyricBody = function(t, e) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r, n, i, o, s;
            return $1c811abb26f94012$var$v(this, function(a) {
                switch(a.label){
                    case 0:
                        if (!$1c811abb26f94012$var$c.isPiaproUrl(t)) throw new Error("unsupported lyrics url ".concat(t));
                        return r = "".concat(t, "//").concat(e), $1c811abb26f94012$var$U[r] ? [
                            2,
                            $1c811abb26f94012$var$U[r]
                        ] : [
                            4,
                            $1c811abb26f94012$var$w.read(t, !0)
                        ];
                    case 1:
                        if (n = a.sent(), !$1c811abb26f94012$var$w.isPiaproAsset(n)) throw new Error("unsupported piapro lyrics url ".concat(t));
                        return i = $1c811abb26f94012$export$8a3afe04b75316cd(n.contentUrl), [
                            4,
                            this.parseLyricBody(i, e)
                        ];
                    case 2:
                        return o = a.sent(), (s = o ? {
                            text: o,
                            artist: {
                                name: n.authorName,
                                url: n.authorPath ? "https://piapro.jp".concat(n.authorPath) : null
                            },
                            name: n.name,
                            url: t
                        } : null) && ($1c811abb26f94012$var$U[r] = s), [
                            2,
                            s
                        ];
                }
            });
        });
    }, t.prototype.fetchInternalLyricBody = function(t, e) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$v(this, function(n) {
                if (r = new URL(t), "undefined" == typeof location || location.protocol !== r.protocol || location.hostname !== r.hostname) throw new Error("direct access not supported for lyrics url ".concat(t));
                return [
                    2,
                    this.fetchCrossOriginLyricBody(t, e)
                ];
            });
        });
    }, t.prototype.fetchCrossOriginLyricBody = function(t, e) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r, n, i, o, s;
            return $1c811abb26f94012$var$v(this, function(a) {
                switch(a.label){
                    case 0:
                        return r = "".concat(t, "//").concat(e), $1c811abb26f94012$var$U[r] ? [
                            2,
                            $1c811abb26f94012$var$U[r]
                        ] : [
                            4,
                            $1c811abb26f94012$var$b(t, null, {
                                responseType: "text"
                            })
                        ];
                    case 1:
                        return n = a.sent(), i = null == n ? void 0 : n.data, n && 200 === n.status && i ? [
                            4,
                            this.parseLyricBody(i, e)
                        ] : (this.verbose && console.error("direct access not supported for lyrics url ".concat(t)), [
                            2,
                            this.fetchProxiedLyricBody(t, e)
                        ]);
                    case 2:
                        return o = a.sent(), (s = o ? {
                            text: o,
                            url: t
                        } : null) && ($1c811abb26f94012$var$U[r] = s), [
                            2,
                            s
                        ];
                }
            });
        });
    }, t.prototype.fetchProxiedLyricBody = function(t, e) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r, n, i;
            return $1c811abb26f94012$var$v(this, function(o) {
                switch(o.label){
                    case 0:
                        return r = "".concat(t, "//").concat(e), $1c811abb26f94012$var$U[r] ? [
                            2,
                            $1c811abb26f94012$var$U[r]
                        ] : (this.verbose && console.log("load lyrics from the external server", t), [
                            4,
                            $1c811abb26f94012$var$L(this.lyricsParserEndpoint + e, function(e) {
                                return new Promise(function(r, n) {
                                    e.Songle.Utils.url2Lyric(t, function(t) {
                                        return r(t);
                                    }, function(t) {
                                        return n(t);
                                    });
                                });
                            }, this.verbose)
                        ]);
                    case 1:
                        return n = o.sent(), (i = n ? {
                            text: n,
                            url: t
                        } : null) && ($1c811abb26f94012$var$U[r] = i), [
                            2,
                            i
                        ];
                }
            });
        });
    }, t.prototype.parseLyricBody = function(t, e) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return n.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]), [
                            4,
                            $1c811abb26f94012$var$L(this.lyricsParserEndpoint + e, function(e) {
                                return e.Songle.Utils.parseLyric(t);
                            }, this.verbose)
                        ];
                    case 1:
                        return r = n.sent(), [
                            3,
                            3
                        ];
                    case 2:
                        return n.sent(), r = function(t) {
                            return function(t) {
                                return t = function(t) {
                                    var e, r = t.split(/\n/);
                                    return r.forEach(function(t, r) {
                                        t.match(/^\S+：\S+$/m) && (e = r);
                                    }), void 0 !== e && e < 5 ? r.slice(e + 1).join("\n") : t;
                                }(t), t = function(t) {
                                    for(var e, r, n, i, o, s = new RegExp("[\uFF08(]?(.)\u7E70\u308A\u8FD4\u3057[)\uFF09]?", "g"); null !== (r = s.exec(t));)n = r[1], i = new RegExp("^(" + n + "[\\s\\S]+?)(?=\\n\\n[^\\u3000|\\s])", "m"), null !== (o = t.match(i)) && (e = o[1].replace(new RegExp("^" + n, "m"), "").replace(new RegExp("^\\n"), "").replace(new RegExp("^\\u3000", "mg"), ""), t = (t = t.replace(i, function() {
                                        return e;
                                    })).replace(new RegExp("[\uFF08\\(]?" + n + "\u7E70\u308A\u8FD4\u3057[\\)\uFF09]?", "g"), e).replace(new RegExp("^" + n, "m"), ""));
                                    return t;
                                }(t = t.split(/\n/).filter($1c811abb26f94012$var$k).join("\n")), t = function(t) {
                                    var e = new RegExp("[\\u4E00-\\u9FAF|\\uFF66-\\uFF9D|\\u31F0-\\u31FF]+[\uFF08\\(]([\\u3041-\\u3096\\u309D-\\u309F]+)[\\)\uFF09]", "g");
                                    return t.replace(e, function(t, e) {
                                        return e;
                                    });
                                }(t), t.split(/\n/).filter($1c811abb26f94012$var$j).join("\n").replace(/\n\n+/g, "\n\n").replace(/\n+$/g, "\n");
                            }(t.replace(/^\ufeff/, "").replace(/\r/, "").split(/\n/).filter($1c811abb26f94012$var$k).filter(function(t) {
                                return !t.match(/^#/);
                            }).join("\n").replace(/^\s+/, ""));
                        }(t), [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.clearLyricBodyCache = function() {
        $1c811abb26f94012$var$U = {};
    }, t.prototype.fetchLyricBody = function(t, e) {
        var r, n, i = e.parserPath, o = e.directAccess;
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, s;
            return $1c811abb26f94012$var$v(this, function(a) {
                switch(a.label){
                    case 0:
                        if ($1c811abb26f94012$export$9167496004a18c0(t)) return this.verbose && console.log("load lyrics from the data url", t), [
                            2,
                            {
                                text: $1c811abb26f94012$export$8a3afe04b75316cd(t)
                            }
                        ];
                        if (this.isUploaderUrl(t)) return [
                            2,
                            this.fetchSongleLyricBody(t, i)
                        ];
                        if ($1c811abb26f94012$var$c.isPiaproUrl(t)) return [
                            2,
                            this.fetchPiaproLyricBody(t, i)
                        ];
                        a.label = 1;
                    case 1:
                        return a.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]), e = new URL(t), o || "undefined" != typeof location && location.protocol !== e.protocol && "https:" !== e.protocol ? [
                            3,
                            4
                        ] : "undefined" != typeof location && location.hostname !== e.hostname ? [
                            3,
                            2
                        ] : (o = !0, [
                            3,
                            4
                        ]);
                    case 2:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.localLyricsEndpoint, "/cors"), {
                                url: t
                            })
                        ];
                    case 3:
                        s = a.sent(), o = s && 200 === s.status && (null === (n = null === (r = s.data) || void 0 === r ? void 0 : r.data) || void 0 === n ? void 0 : n.enabled), a.label = 4;
                    case 4:
                        return o ? (this.verbose && console.log("load lyrics directly", t), [
                            2,
                            this.fetchCrossOriginLyricBody(t, i)
                        ]) : [
                            3,
                            6
                        ];
                    case 5:
                        return a.sent(), [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2,
                            this.fetchProxiedLyricBody(t, i)
                        ];
                }
            });
        });
    }, t.prototype.post = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r;
            return $1c811abb26f94012$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return e = t.forceUpdate ? {
                            url: t.lyricsUrl,
                            force_create: "true"
                        } : {
                            url: t.lyricsUrl
                        }, [
                            4,
                            $1c811abb26f94012$var$P("".concat(this.lyricsPostEndpoint, "/songs/").concat(t.songId, "/lyrics.json"), e)
                        ];
                    case 1:
                        return (r = n.sent()) && 200 === r.status && r.data ? [
                            2,
                            {
                                success: !0,
                                lyricsId: r.data.id
                            }
                        ] : [
                            2,
                            {
                                success: !1,
                                error: "failed to update lyrics url"
                            }
                        ];
                }
            });
        });
    }, t.prototype.postPrivate = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r, n, i, o, s, a, u, c, l, p;
            return $1c811abb26f94012$var$v(this, function(h) {
                switch(h.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$A.getProfile()
                        ];
                    case 1:
                        if (e = h.sent(), !$1c811abb26f94012$var$A.isSongleUser(e)) throw new Error("Songle authentication is required");
                        return $1c811abb26f94012$var$A.isSpoofingSongleUser(e) ? (n = e.user, i = n.songleUserId, o = n.songleAccessToken, s = n.songleRefreshToken, a = {
                            songleUserId: i,
                            songleAccessToken: o,
                            songleRefreshToken: s
                        }, r = "?" + Object.keys(a).map(function(t) {
                            return "".concat(t, "=").concat(encodeURIComponent(a[t]));
                        }).join("&")) : r = "", u = t.songId, c = t.lyricsText, (l = new FormData).append("text", c), [
                            4,
                            $1c811abb26f94012$var$P("".concat($1c811abb26f94012$var$m.textalive.server, "/songle/me/songs/").concat(u, "/lyrics.json").concat(r), l, {
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (p = h.sent()) && 200 === p.status && p.data ? [
                            2,
                            {
                                success: !0,
                                lyrics: p.data.data.lyric
                            }
                        ] : [
                            2,
                            {
                                success: !1,
                                error: "failed to post lyrics text"
                            }
                        ];
                }
            });
        });
    }, t.prototype.update = function(t) {
        var e;
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$P("".concat(this.lyricsPostEndpoint, "/songs/").concat(t.songCode, "/lyrics/").concat(t.lyricsId, "/diffs.json"), t.lyricsData ? {
                                lyric: JSON.stringify(t.lyricsData)
                            } : {
                                source_diff_id: t.lyricsDiffId
                            })
                        ];
                    case 1:
                        return r = n.sent(), [
                            2,
                            (null === (e = null == r ? void 0 : r.data) || void 0 === e ? void 0 : e.lyric_diff) ? {
                                success: 200 === r.status,
                                lyricsId: r.data.lyric_diff.lyric_id,
                                lyricsDiffId: r.data.lyric_diff.id
                            } : {
                                success: 200 === r.status
                            }
                        ];
                }
            });
        });
    }, t;
}();
function $1c811abb26f94012$var$L(t, e, r) {
    var n, i = this;
    return "undefined" == typeof window || !(null === (n = null === window || void 0 === window ? void 0 : window.navigator) || void 0 === n ? void 0 : n.userAgent) || window.navigator.userAgent.includes("Node.js") || window.navigator.userAgent.includes("jsdom") ? function(t, e, r) {
        return r && console.log("parse lyrics: loading on Node.js", t), new Promise(function(r, n) {
            $1c811abb26f94012$var$b(t, {
                responseType: "text"
            }).then(function(t) {
                var i = t.data, o = new Function("let g=global;global={};".concat(i, ";let res=global;global=g")), s = {};
                try {
                    o.bind(s)(), r(e(s));
                } catch (t) {
                    n(t);
                }
            }).catch(n);
        });
    }(t, e, r) : (r && console.log("parse lyrics: loading", t), new Promise(function(n, o) {
        try {
            var s = document.createElement("script"), a = null;
            window.module && (a = window.module, delete window.module), s.src = t, s.onload = function() {
                return $1c811abb26f94012$var$g(i, 0, void 0, function() {
                    var i, u;
                    return $1c811abb26f94012$var$v(this, function(c) {
                        switch(c.label){
                            case 0:
                                document.body.removeChild(s), r && console.log("parse lyrics: load", t), window.Songle && window.Songle.Utils && window.Songle.Utils.url2Lyric || (a && (window.module = a), o("url2Lyric not found")), c.label = 1;
                            case 1:
                                return c.trys.push([
                                    1,
                                    3,
                                    4,
                                    5
                                ]), i = n, [
                                    4,
                                    e(window)
                                ];
                            case 2:
                                return i.apply(void 0, [
                                    c.sent()
                                ]), [
                                    3,
                                    5
                                ];
                            case 3:
                                return u = c.sent(), o(u), [
                                    3,
                                    5
                                ];
                            case 4:
                                return a && (window.module = a), [
                                    7
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }, s.onerror = function(t) {
                return o(t.message);
            }, document.body.appendChild(s);
        } catch (e) {
            console.error("failed to call lyrics parser", t, e);
        }
    }));
}
var $1c811abb26f94012$var$D = new $1c811abb26f94012$var$F, $1c811abb26f94012$var$M = {}, $1c811abb26f94012$var$B = {}, $1c811abb26f94012$var$V = new (function() {
    function t() {}
    return Object.defineProperty(t.prototype, "endpoint", {
        get: function() {
            return $1c811abb26f94012$var$m.textalive.server;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "songleEndpoint", {
        get: function() {
            return $1c811abb26f94012$var$m.songle.server;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.getSongPathFromUrl = function(t) {
        return $1c811abb26f94012$var$c.getSongPathFromUrl(t);
    }, t.prototype.isUploaderUrl = function(t) {
        return $1c811abb26f94012$var$c.isUploaderUrl(t);
    }, t.prototype.isUploaderPath = function(t) {
        return $1c811abb26f94012$var$c.isUploaderPath(t);
    }, t.prototype.getUploaderGuid = function(t) {
        return $1c811abb26f94012$var$c.getUploaderGuid(t);
    }, t.prototype.getAltSongUrlFromUploaderGuid = function(t) {
        return $1c811abb26f94012$var$c.getAltSongUrlFromUploaderGuid(t);
    }, t.prototype.getSongUrlFromUploaderGuid = function(t) {
        return $1c811abb26f94012$var$c.getSongUrlFromUploaderGuid(t);
    }, t.prototype.getSongUrlFromPath = function(t) {
        return $1c811abb26f94012$var$c.getSongUrlFromPath(t);
    }, t.prototype.isYouTubeUrl = function(t) {
        return $1c811abb26f94012$var$c.isYouTubeUrl(t);
    }, t.prototype.isNicovideoUrl = function(t) {
        return $1c811abb26f94012$var$c.isNicovideoUrl(t);
    }, t.prototype.isVideoSiteUrl = function(t) {
        return $1c811abb26f94012$var$c.isVideoSiteUrl(t);
    }, t.prototype.isPiaproUrl = function(t) {
        return $1c811abb26f94012$var$c.isPiaproUrl(t);
    }, t.prototype.load = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r;
            return $1c811abb26f94012$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return e = t.code || "number" == typeof t.id && String(t.id) || encodeURIComponent(t.songPath), $1c811abb26f94012$var$M[e] ? [
                            2,
                            $1c811abb26f94012$var$M[e]
                        ] : ($1c811abb26f94012$var$M[e] = this.doLoad(e), [
                            4,
                            $1c811abb26f94012$var$M[e]
                        ]);
                    case 1:
                        return r = n.sent(), this.use(r), [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.use = function(t) {
        if (t) {
            var e = String(t.song.id), r = t.song.code, n = this.getSongPathFromUrl(t.song.permalink);
            $1c811abb26f94012$var$M[e] = $1c811abb26f94012$var$M[r] = $1c811abb26f94012$var$M[n] = Promise.resolve(t);
        }
    }, t.prototype.clearCache = function() {
        $1c811abb26f94012$var$M = {}, $1c811abb26f94012$var$B = {};
    }, t.prototype.doLoad = function(t) {
        var e;
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r, n, i;
            return $1c811abb26f94012$var$v(this, function(o) {
                switch(o.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.songleEndpoint, "/songs/").concat(t, "?format=json"))
                        ];
                    case 1:
                        return (r = o.sent()) && 200 === r.status ? (n = r.data, this.isUploaderUrl(null === (e = null == n ? void 0 : n.song) || void 0 === e ? void 0 : e.permalink) ? [
                            4,
                            this.doLoadPrivateSong(n.song.id)
                        ] : [
                            3,
                            3
                        ]) : [
                            2,
                            null
                        ];
                    case 2:
                        if (i = o.sent()) return n.status = n.status || {}, n.status.owner = !0, [
                            2,
                            $1c811abb26f94012$var$y($1c811abb26f94012$var$y({}, n), {
                                song: i
                            })
                        ];
                        n.status = n.status || {}, n.status.owner = !1, o.label = 3;
                    case 3:
                        return [
                            2,
                            n
                        ];
                }
            });
        });
    }, t.prototype.doLoadPrivateSong = function(t) {
        var e, r;
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var n, i, o, s, a, u, c;
            return $1c811abb26f94012$var$v(this, function(l) {
                switch(l.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$A.getProfile()
                        ];
                    case 1:
                        return n = l.sent(), $1c811abb26f94012$var$A.isSongleUser(n) ? ($1c811abb26f94012$var$A.isSpoofingSongleUser(n) && (o = n.user, s = o.songleUserId, a = o.songleAccessToken, u = o.songleRefreshToken, i = {
                            songleUserId: s,
                            songleAccessToken: a,
                            songleRefreshToken: u
                        }), [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.endpoint, "/songle/me/songs/").concat(t, ".json"), i, {
                                withCredentials: !0
                            })
                        ]) : [
                            2,
                            null
                        ];
                    case 2:
                        return (c = l.sent()) && 200 === c.status && (null === (r = null === (e = c.data) || void 0 === e ? void 0 : e.data) || void 0 === r ? void 0 : r.song) ? [
                            2,
                            c.data.data.song
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loadInfo = function(t, e) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$v(this, function(n) {
                return r = this.cacheKey(t, e), $1c811abb26f94012$var$B[r] || ($1c811abb26f94012$var$B[r] = this.doLoadInfo(t, {
                    min: !0,
                    revisions: null == e ? void 0 : e.revisions
                })), [
                    2,
                    $1c811abb26f94012$var$B[r]
                ];
            });
        });
    }, t.prototype.loadDetailInfo = function(t, e) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$v(this, function(n) {
                return r = this.cacheKey(t, e) + "/dt", $1c811abb26f94012$var$B[r] || ($1c811abb26f94012$var$B[r] = this.doLoadInfo(t, {
                    min: !1,
                    revisions: null == e ? void 0 : e.revisions
                })), [
                    2,
                    $1c811abb26f94012$var$B[r]
                ];
            });
        });
    }, t.prototype.cacheKey = function(t, e) {
        var r = String(t);
        return (null == e ? void 0 : e.revisions) && ("number" == typeof e.revisions.chord && (r += "/cd" + e.revisions.chord), "number" == typeof e.revisions.beat && (r += "/bt" + e.revisions.beat), "number" == typeof e.revisions.chorus && (r += "/cr" + e.revisions.chorus)), r;
    }, t.prototype.doLoadInfo = function(t, e) {
        var r = void 0 === e ? {
            min: !0
        } : e, n = r.min, i = r.revisions;
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r;
            return $1c811abb26f94012$var$v(this, function(o) {
                switch(o.label){
                    case 0:
                        return e = {
                            min: n ? 1 : 0
                        }, "number" == typeof (null == i ? void 0 : i.chord) && (e.chord_revision_id = i.chord), "number" == typeof (null == i ? void 0 : i.beat) && (e.beat_revision_id = i.beat), "number" == typeof (null == i ? void 0 : i.chorus) && (e.chorus_revision_id = i.chorus), [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.songleEndpoint, "/songs/").concat(t, "/info.json"), e)
                        ];
                    case 1:
                        return (r = o.sent()) && 200 === r.status ? [
                            2,
                            r.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loadVocalAmplitude = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e;
            return $1c811abb26f94012$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.songleEndpoint, "/songs/").concat(t, "/vamplitude.json"))
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status && e.data ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loadValenceArousal = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e;
            return $1c811abb26f94012$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.songleEndpoint, "/songs/").concat(t, "/av.json"))
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status && e.data ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.list = function(t) {
        return void 0 === t && (t = {}), $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e;
            return $1c811abb26f94012$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b(this.endpoint + "/songs", t)
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.listPrivate = function(t) {
        return void 0 === t && (t = {}), $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r, n, i, o, s, a;
            return $1c811abb26f94012$var$v(this, function(u) {
                switch(u.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$A.getProfile()
                        ];
                    case 1:
                        return e = u.sent(), $1c811abb26f94012$var$A.isSongleUser(e) ? (r = {}, $1c811abb26f94012$var$A.isSpoofingSongleUser(e) && (n = e.user, i = n.songleUserId, o = n.songleAccessToken, s = n.songleRefreshToken, r = {
                            songleUserId: i,
                            songleAccessToken: o,
                            songleRefreshToken: s
                        }), "number" == typeof t.page && (r.page = t.page), "number" == typeof t.perPage && (r.per_page = t.perPage), [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.endpoint, "/songle/me/songs.json"), $1c811abb26f94012$var$y($1c811abb26f94012$var$y({}, r), {
                                private: !0
                            }), {
                                withCredentials: !0
                            })
                        ]) : [
                            2,
                            {
                                data: null,
                                error: "Songle authentication is required"
                            }
                        ];
                    case 2:
                        return (a = u.sent()) && 200 === a.status ? [
                            2,
                            a.data
                        ] : [
                            2,
                            {
                                data: null,
                                error: "private songs not found"
                            }
                        ];
                }
            });
        });
    }, t.prototype.create = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            return $1c811abb26f94012$var$v(this, function(e) {
                return [
                    2,
                    this.doCreate(t, !1)
                ];
            });
        });
    }, t.prototype.createPrivate = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e;
            return $1c811abb26f94012$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$A.getProfile()
                        ];
                    case 1:
                        return e = r.sent(), $1c811abb26f94012$var$A.isSongleUser(e) ? [
                            2,
                            this.doCreate(t, !0)
                        ] : [
                            2,
                            {
                                success: !1,
                                song: null,
                                error: "Songle authentication is required"
                            }
                        ];
                }
            });
        });
    }, t.prototype.doCreate = function(t, e) {
        var r, n;
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var i, o, s, a, u;
            return $1c811abb26f94012$var$v(this, function(c) {
                switch(c.label){
                    case 0:
                        return i = t.url, o = t.name, s = t.artistName, [
                            4,
                            $1c811abb26f94012$var$A.getToken()
                        ];
                    case 1:
                        return a = c.sent(), [
                            4,
                            $1c811abb26f94012$var$P(e ? this.endpoint + "/etc/songs/private" : this.endpoint + "/etc/songs", {
                                url: i,
                                name: o,
                                artist: s
                            }, {
                                postToken: a,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (u = c.sent()) && 200 === u.status ? e ? [
                            2,
                            {
                                success: !0,
                                song: u.data.data.song
                            }
                        ] : [
                            2,
                            {
                                success: !0,
                                song: u.data.song
                            }
                        ] : [
                            2,
                            {
                                success: !1,
                                error: ((null === (r = null == u ? void 0 : u.data) || void 0 === r ? void 0 : r.data) ? u.data.data.message : null === (n = null == u ? void 0 : u.data) || void 0 === n ? void 0 : n.message) || "failed to register a song"
                            }
                        ];
                }
            });
        });
    }, t.prototype.uploadPrivate = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r, n, i, o, s, a, u, c;
            return $1c811abb26f94012$var$v(this, function(l) {
                switch(l.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$A.getProfile()
                        ];
                    case 1:
                        if (e = l.sent(), !$1c811abb26f94012$var$A.isSongleUser(e)) throw new Error("Songle authentication is required");
                        return $1c811abb26f94012$var$A.isSpoofingSongleUser(e) ? (n = e.user, i = n.songleUserId, o = n.songleAccessToken, s = n.songleRefreshToken, a = {
                            songleUserId: i,
                            songleAccessToken: o,
                            songleRefreshToken: s
                        }, r = "?" + Object.keys(a).map(function(t) {
                            return "".concat(t, "=").concat(encodeURIComponent(a[t]));
                        }).join("&")) : r = "", (u = new FormData).append("file", t), [
                            4,
                            $1c811abb26f94012$var$P("".concat(this.endpoint, "/songle/me/uploads.json").concat(r), u, {
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (c = l.sent()) && 200 === c.status && c.data ? [
                            2,
                            c.data.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.search = function(t, e) {
        return void 0 === e && (e = !0), $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.songleEndpoint, "/songs/search.json"), {
                                q: t,
                                lyrics: e ? 1 : 0
                            })
                        ];
                    case 1:
                        return (r = n.sent()) && 200 === r.status && r.data ? [
                            2,
                            {
                                success: !0,
                                data: r.data
                            }
                        ] : [
                            2,
                            {
                                success: !1
                            }
                        ];
                }
            });
        });
    }, t.prototype.copySongMap = function(t) {
        var e;
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r, n, i, o;
            return $1c811abb26f94012$var$v(this, function(s) {
                switch(s.label){
                    case 0:
                        return r = t.sourceId, n = t.destinationId, i = t.types || [
                            "beat",
                            "chord",
                            "chorus",
                            "melody"
                        ], [
                            4,
                            $1c811abb26f94012$var$P("".concat(this.endpoint, "/songle/me/songs/").concat(n, "/actions/copy_music_map.json"), {
                                source_id: r,
                                types: i
                            }, {
                                withCredentials: !0
                            })
                        ];
                    case 1:
                        return (o = s.sent()) && (null === (e = o.data) || void 0 === e ? void 0 : e.success) ? [
                            2,
                            {
                                success: !0
                            }
                        ] : [
                            2,
                            {
                                success: !1,
                                error: null == o ? void 0 : o.data
                            }
                        ];
                }
            });
        });
    }, t.prototype.createStage = function() {
        var t;
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r;
            return $1c811abb26f94012$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$A.getProfile()
                        ];
                    case 1:
                        return e = n.sent(), [
                            4,
                            $1c811abb26f94012$var$P("".concat(this.endpoint, "/etc/songs/stage"), null, {
                                postToken: null === (t = null == e ? void 0 : e.status) || void 0 === t ? void 0 : t.token,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return [
                            2,
                            (null == (r = n.sent()) ? void 0 : r.data) || null
                        ];
                }
            });
        });
    }, t;
}()), $1c811abb26f94012$var$G = function() {
    function t() {}
    return Object.defineProperty(t.prototype, "endpoint", {
        get: function() {
            return "".concat($1c811abb26f94012$var$m.textalive.server, "/templates/");
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.list = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e;
            return $1c811abb26f94012$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.endpoint), t)
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.load = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e;
            return $1c811abb26f94012$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.endpoint + t))
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loadByName = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r, n;
            return $1c811abb26f94012$var$v(this, function(i) {
                switch(i.label){
                    case 0:
                        return r = "latest", t && (e = t.match(/(.+)@([0-9]+)/)) && (t = e[1], r = e[2]), [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.endpoint + t, "/").concat(r))
                        ];
                    case 1:
                        return (n = i.sent()) && 200 === n.status ? [
                            2,
                            n.data
                        ] : "latest" !== r ? [
                            2,
                            this.loadByName(t)
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.loadForVideo = function(t, e) {
        return void 0 === e && (e = {
            script: !0,
            withoutAuthors: !0
        }), $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.endpoint, "for/").concat(t), e)
                        ];
                    case 1:
                        return (r = n.sent()) && 200 === r.status ? [
                            2,
                            r.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.create = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r, n;
            return $1c811abb26f94012$var$v(this, function(i) {
                switch(i.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$A.getToken()
                        ];
                    case 1:
                        return e = i.sent(), [
                            4,
                            $1c811abb26f94012$var$P(this.endpoint, t, {
                                postToken: e,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (r = i.sent()) ? 200 !== r.status || Array.isArray(r.data) || r.data.error ? (n = Array.isArray(r.data) ? {
                            parseErrors: r.data
                        } : r.data, [
                            2,
                            $1c811abb26f94012$var$y($1c811abb26f94012$var$y({}, n), {
                                success: !1
                            })
                        ]) : [
                            2,
                            $1c811abb26f94012$var$y($1c811abb26f94012$var$y({}, r.data), {
                                success: !0
                            })
                        ] : [
                            2,
                            {
                                success: !1
                            }
                        ];
                }
            });
        });
    }, t.prototype.listContributors = function(t, e) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.endpoint).concat(t, "/").concat(e, "/contributors"))
                        ];
                    case 1:
                        return (r = n.sent()) && 200 === r.status ? [
                            2,
                            r.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t;
}(), $1c811abb26f94012$var$q = new $1c811abb26f94012$var$G, $1c811abb26f94012$var$W = new (function() {
    function t() {}
    return Object.defineProperty(t.prototype, "endpoint", {
        get: function() {
            return "".concat($1c811abb26f94012$var$m.textalive.server, "/videos/");
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "rendererEndpoint", {
        get: function() {
            return "".concat($1c811abb26f94012$var$m.textalive.server, "/renderer/");
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.list = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e;
            return $1c811abb26f94012$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.endpoint), t)
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.load = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r, n, i, o, s, a;
            return $1c811abb26f94012$var$v(this, function(u) {
                switch(u.label){
                    case 0:
                        return e = {}, [
                            4,
                            $1c811abb26f94012$var$A.getProfile()
                        ];
                    case 1:
                        return r = u.sent(), $1c811abb26f94012$var$A.isSpoofingSongleUser(r) && (n = r.user, i = n.songleUserId, o = n.songleAccessToken, s = n.songleRefreshToken, e = {
                            songleUserId: i,
                            songleAccessToken: o,
                            songleRefreshToken: s
                        }), [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.endpoint + t), e, {
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (a = u.sent()) && 200 === a.status ? [
                            2,
                            a.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.create = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r;
            return $1c811abb26f94012$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$A.getToken()
                        ];
                    case 1:
                        return e = n.sent(), [
                            4,
                            $1c811abb26f94012$var$P(this.endpoint, t, {
                                postToken: e,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (r = n.sent()) ? 200 !== r.status || r.data.error ? [
                            2,
                            $1c811abb26f94012$var$y($1c811abb26f94012$var$y({}, r.data), {
                                success: !1
                            })
                        ] : [
                            2,
                            $1c811abb26f94012$var$y($1c811abb26f94012$var$y({}, r.data), {
                                success: !0
                            })
                        ] : [
                            2,
                            {
                                success: !1
                            }
                        ];
                }
            });
        });
    }, t.prototype.delete = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e, r;
            return $1c811abb26f94012$var$v(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$A.getToken()
                        ];
                    case 1:
                        return e = n.sent(), [
                            4,
                            $1c811abb26f94012$var$P("".concat(this.endpoint, "delete"), {
                                id: t
                            }, {
                                postToken: e,
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (r = n.sent()) && 200 === r.status ? [
                            2,
                            {
                                success: !0,
                                video: r.data
                            }
                        ] : [
                            2,
                            {
                                success: !1,
                                video: null
                            }
                        ];
                }
            });
        });
    }, t.prototype.listContributors = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e;
            return $1c811abb26f94012$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.endpoint).concat(t, "/contributors"), null, {
                                withCredentials: !0
                            })
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.listRenderings = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e;
            return $1c811abb26f94012$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.rendererEndpoint, "list"), {
                                videoId: t
                            }, {
                                withCredentials: !0
                            })
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.getRenderingStatus = function(t) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var e;
            return $1c811abb26f94012$var$v(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$b("".concat(this.rendererEndpoint, "status"), {
                                id: t
                            }, {
                                withCredentials: !0
                            })
                        ];
                    case 1:
                        return (e = r.sent()) && 200 === e.status ? [
                            2,
                            e.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.render = function(t, e, r) {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var n, i, o;
            return $1c811abb26f94012$var$v(this, function(s) {
                switch(s.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$A.getToken()
                        ];
                    case 1:
                        return n = s.sent(), i = {
                            token: n,
                            videoId: t,
                            quality: e
                        }, r && (i.authentication = !0), [
                            4,
                            $1c811abb26f94012$var$P("".concat(this.rendererEndpoint, "render"), i, {
                                withCredentials: !0
                            })
                        ];
                    case 2:
                        return (o = s.sent()) && 200 === o.status ? [
                            2,
                            o.data
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.getDownloadInfo = function() {
        return $1c811abb26f94012$var$g(this, 0, void 0, function() {
            var t;
            return $1c811abb26f94012$var$v(this, function(e) {
                switch(e.label){
                    case 0:
                        return t = {
                            endpoint: "".concat(this.rendererEndpoint, "download")
                        }, [
                            4,
                            $1c811abb26f94012$var$A.getToken()
                        ];
                    case 1:
                        return [
                            2,
                            (t.token = e.sent(), t)
                        ];
                }
            });
        });
    }, t;
}()), $1c811abb26f94012$var$Y = {
    asset: $1c811abb26f94012$var$w,
    endpoint: $1c811abb26f94012$var$m,
    lyrics: $1c811abb26f94012$var$D,
    song: $1c811abb26f94012$var$V,
    template: $1c811abb26f94012$var$q,
    text: $1c811abb26f94012$var$R,
    font: $1c811abb26f94012$var$C,
    user: $1c811abb26f94012$var$A,
    video: $1c811abb26f94012$var$W
}, $1c811abb26f94012$var$z = function(t, e) {
    return $1c811abb26f94012$var$z = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }, $1c811abb26f94012$var$z(t, e);
};
function $1c811abb26f94012$var$J(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function r() {
        this.constructor = t;
    }
    $1c811abb26f94012$var$z(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
}
function $1c811abb26f94012$var$H(t, e, r) {
    if (2 === arguments.length) for(var n, i = 0, o = e.length; i < o; i++)!n && i in e || (n || (n = Array.prototype.slice.call(e, 0, i)), n[i] = e[i]);
    return t.concat(n || Array.prototype.slice.call(e));
}
"function" == typeof SuppressedError && SuppressedError;
var $1c811abb26f94012$export$892596cec99bc70e = function() {
    function t(t) {
        this.a = 0, this.r = 0, this.g = 0, this.b = 0, this.from(t);
    }
    return Object.defineProperty(t.prototype, "value", {
        get: function() {
            return this.valueArgb;
        },
        set: function(t) {
            this.fromNumber(t, !0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "valueArgb", {
        get: function() {
            return this.valueRgb + 16777216 * (255 & this.a);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "valueRgb", {
        get: function() {
            return ((255 & this.r) << 8 | 255 & this.g) << 8 | 255 & this.b;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "hexRgb", {
        get: function() {
            return ("000000" + (16777215 & this.value).toString(16)).slice(-6);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "hexA", {
        get: function() {
            return ("00" + (255 & this.a).toString(16)).slice(-2);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "rgb", {
        get: function() {
            return "#".concat(this.hexRgb);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "cssRgb", {
        get: function() {
            return "rgb(" + this.r + "," + this.g + "," + this.b + ")";
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "rgba", {
        get: function() {
            return "".concat(this.rgb).concat(this.hexA);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "argb", {
        get: function() {
            return "0x".concat(this.hexA).concat(this.rgb.substring(1));
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "cssRgba", {
        get: function() {
            return "rgba(" + this.r + "," + this.g + "," + this.b + "," + this.a / 255 + ")";
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.eq = function(e) {
        return typeof this == typeof e && e instanceof t && this.value === e.value;
    }, t.prototype.toString = function(t) {
        return void 0 === t && (t = !0), t ? this.rgba : this.rgb;
    }, t.prototype.from = function(t) {
        if (void 0 === t && (t = "#000"), "object" == typeof t) {
            if (!t) return;
            return "number" == typeof t.value ? void (this.value = t.value) : "number" == typeof t.r && "number" == typeof t.g && "number" == typeof t.b ? (this.a = "number" == typeof t.a ? t.a : 255, this.r = t.r, this.g = t.g, void (this.b = t.b)) : void 0;
        }
        "string" == typeof t ? this.fromString(t) : "number" == typeof t && this.fromNumber(t);
    }, t.prototype.fromString = function(t) {
        if (t) {
            if ("#" === t.charAt(0) && (t = t.substring(1)), 4 === t.length) {
                var e = t.charAt(0), r = t.charAt(1), n = t.charAt(2), i = t.charAt(3);
                t = "".concat(e).concat(e).concat(r).concat(r).concat(n).concat(n).concat(i).concat(i);
            } else 3 === t.length && (e = t.charAt(0), r = t.charAt(1), n = t.charAt(2), t = "".concat(e).concat(e).concat(r).concat(r).concat(n).concat(n)), 6 === t.length && (t = "".concat(t, "ff"));
            var o = parseInt("".concat(t.substring(6)).concat(t.substring(0, 6)), 16);
            this.fromNumber(o, !0);
        }
    }, t.prototype.fromNumber = function(t, e) {
        void 0 === e && (e = !0), isNaN(t) || (this.a = e ? t >>> 24 & 255 : 0, this.r = t >>> 16 & 255, this.g = t >>> 8 & 255, this.b = t >>> 0 & 255);
    }, t;
}();
var $1c811abb26f94012$var$Z = function() {
    function t(t, e, r) {
        void 0 === t && (t = "Noto Sans Japanese"), void 0 === e && (e = 40), void 0 === r && (r = ""), this._family = t, this._size = e, this._style = r;
    }
    return Object.defineProperty(t.prototype, "family", {
        get: function() {
            return this._family;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "size", {
        get: function() {
            return this._size;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "style", {
        get: function() {
            return this._style;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.deriveFamily = function(e) {
        return new t(e, this._size, this._style);
    }, t.prototype.deriveStyle = function(e) {
        return new t(this._family, this._size, e);
    }, t.prototype.deriveSize = function(e) {
        return new t(this._family, e, this._style);
    }, t.prototype.clone = function() {
        return new t(this._family, this._size, this._style);
    }, t.prototype.eq = function(t) {
        return this._family === t._family && this._size === t._size && this._style === t._style;
    }, t.prototype.toString = function(t) {
        void 0 === t && (t = 1);
        var e, r = function(t) {
            if (!t || t.length <= 0) return [];
            for(var e = [], r = "", n = !1, i = !1, o = !1, s = 0, a = t; s < a.length; s++){
                var u = a[s];
                if (i ? o ? o = !1 : "\\" === u ? o = !0 : u === i && (i = !1) : '"' === u || "'" === u ? i = u : "," === u && (n = !0), n) {
                    var c = r.trim();
                    "" !== c && e.push(c), r = "", n = !1;
                } else r += u;
            }
            var l = r.trim();
            return "" !== l && e.push(l), e;
        }(this._family);
        return e = r.length < 1 ? "" : r.length > 1 ? " " + r.join(", ") : (e = r[0]).length > 1 && e[0] !== e[e.length - 1] || "'" !== e[0] && '"' !== e[0] ? " '".concat(e, "'") : " ".concat(e), this._style + (this._style.length > 0 ? " " : "") + this._size * t + "px" + e;
    }, t;
}(), $1c811abb26f94012$export$52786b6f4da3c973 = function() {
    function t() {}
    return Object.defineProperty(t.prototype, "duration", {
        get: function() {
            return this.endTime - this.startTime;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.contains = function(t) {
        return t >= this.startTime && t <= this.endTime;
    }, t.prototype.overlaps = function(t, e) {
        if ("object" == typeof t) return this.overlaps(t.startTime, t.endTime);
        var r = t;
        return this.contains(r) || this.contains(e) || this.startTime <= r && this.endTime >= e;
    }, t.prototype.progress = function(t) {
        return this.contains(t) ? (t - this.startTime) / this.duration : -1;
    }, t;
}(), $1c811abb26f94012$var$K = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e._parent = null, e._children = [], e._previous = null, e._next = null, e._runtime = null, e._templates = [], e;
    }
    return $1c811abb26f94012$var$J(e, t), Object.defineProperty(e.prototype, "video", {
        get: function() {
            return this.parent && this.parent.video;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "children", {
        get: function() {
            return this._children;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "previous", {
        get: function() {
            return this._previous;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "next", {
        get: function() {
            return this._next;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "startTime", {
        get: function() {
            return this._data ? this._data.startTime : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "endTime", {
        get: function() {
            return this._data ? this._data.endTime : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "duration", {
        get: function() {
            return this.endTime - this.startTime;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "rendering", {
        get: function() {
            return this._runtime ? this._runtime.rendering : null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "graphics", {
        get: function() {
            return this._runtime ? this._runtime.graphics : null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "templates", {
        get: function() {
            return this._templates.slice();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "templateCount", {
        get: function() {
            return this._templates.length;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.maximize = function() {
        var t = !1, e = this.endTime, r = Math.max(null === this._parent ? 0 : this._parent.startTime, null === this._previous ? 0 : this._previous.endTime);
        r !== this.startTime && (this.moveWithChildren(r - this.startTime), t = !0);
        var n = Math.min(null === this._parent ? this.video.duration : this._parent.endTime, null === this._next ? this.video.duration : this._next.startTime);
        return n !== this.endTime && (this._data.endTime = n, t = e !== n), t;
    }, e.prototype.moveWithChildren = function(t) {
        var e = [];
        for(e.push(this); e.length > 0;){
            var r = e.pop();
            null != r._children && r._children.forEach(function(t) {
                return e.push(t);
            }), r._data.startTime += t, r._data.endTime += t;
        }
    }, e.prototype.getTemplate = function(t) {
        return void 0 === t && (t = 0), t < 0 || t >= this._templates.length ? null : this._templates[t];
    }, e.prototype.addTemplateAt = function(t, e) {
        this._templates.splice(e, 0, t), t.assignedUnit = this;
    }, e.prototype.addTemplate = function(t) {
        this._templates.push(t), t.assignedUnit = this;
    }, e.prototype.removeTemplates = function() {
        for(var t = this._templates.slice(); this._templates.length > 0;)this._templates.pop();
        return t;
    }, e.prototype.removeTemplateAt = function(t) {
        if (t < 0 || t >= this._templates.length) return null;
        var e = this._templates.splice(t, 1)[0];
        return e.assignedUnit = null, e;
    }, e.prototype.removeTemplate = function(t) {
        for(var e = 0; e < this._templates.length; e++){
            var r = this._templates[e];
            if (r === t) return this._templates.splice(e, 1), t.assignedUnit = null, r;
        }
        return null;
    }, e.prototype.getType = function() {
        return $1c811abb26f94012$export$6ba26ae1c58c0147.NONE;
    }, e.prototype.toString = function() {
        return "RenderingUnit";
    }, e;
}($1c811abb26f94012$export$52786b6f4da3c973);
function $1c811abb26f94012$var$Q(t, e) {
    return "number" == typeof e && !isNaN(e) && e > t ? e : t;
}
function $1c811abb26f94012$var$tt(t, e) {
    return "number" == typeof e && !isNaN(e) && e < t ? e : t;
}
var $1c811abb26f94012$var$et = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $1c811abb26f94012$var$J(e, t), Object.defineProperty(e.prototype, "text", {
        get: function() {
            var t = "";
            return this.children.forEach(function(e) {
                t += e.text;
            }), t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "color", {
        get: function() {
            return this.children.reduce(function(t, e) {
                return null === t ? e.color : void 0 === t || t.eq(e.color) ? t : void 0;
            }, null);
        },
        set: function(t) {
            null !== t && this.children.forEach(function(e) {
                e.color = t;
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "font", {
        set: function(t) {
            null !== t && this.children.forEach(function(e) {
                e.font = t;
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "fontFamily", {
        get: function() {
            return this.children.reduce(function(t, e) {
                var r = e.fontFamily;
                return void 0 === t || null !== t && t !== r ? void 0 : r;
            }, null);
        },
        set: function(t) {
            this.children.forEach(function(e) {
                e.fontFamily = t;
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "fontStyle", {
        get: function() {
            return this.children.reduce(function(t, e) {
                var r = e.fontStyle;
                return void 0 === t || null !== t && t !== r ? void 0 : r;
            }, null);
        },
        set: function(t) {
            this.children.forEach(function(e) {
                e.fontStyle = t;
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "fontSize", {
        get: function() {
            return this.children.length <= 0 ? 0 : this.children.reduce(function(t, e) {
                return t + e.fontSize;
            }, 0) / this.children.length;
        },
        set: function(t) {
            this.children.forEach(function(e) {
                e.fontSize = t;
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "advance", {
        get: function() {
            return this.children.reduce(function(t, e) {
                return t + e.advance;
            }, 0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "ascent", {
        get: function() {
            return this.children.reduce(function(t, e) {
                return Math.max(t, e.ascent);
            }, 0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "descent", {
        get: function() {
            return this.children.reduce(function(t, e) {
                return Math.max(t, e.descent);
            }, 0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "height", {
        get: function() {
            return this.ascent + this.descent;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.expandTime = function(t) {
        return {
            startTime: $1c811abb26f94012$var$tt(this.startTime, t.startTime),
            endTime: $1c811abb26f94012$var$Q(this.endTime, t.endTime)
        };
    }, e.prototype.toString = function() {
        return this.text;
    }, e;
}($1c811abb26f94012$var$K), $1c811abb26f94012$var$rt = function(t) {
    function e(e) {
        var r = t.call(this) || this;
        return r._data = e, r._font = new $1c811abb26f94012$var$Z(e && e.fontFamily, e && e.fontSize, e && e.fontStyle), r._color = new $1c811abb26f94012$export$892596cec99bc70e, r;
    }
    return $1c811abb26f94012$var$J(e, t), Object.defineProperty(e.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "previous", {
        get: function() {
            return this._previous;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "next", {
        get: function() {
            return this._next;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "text", {
        get: function() {
            return this._data && this._data.char || "?";
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "advance", {
        get: function() {
            return this._runtime ? this._runtime.advance : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "ascent", {
        get: function() {
            return this._runtime ? this._runtime.ascent : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "descent", {
        get: function() {
            return this._runtime ? this._runtime.descent : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "font", {
        get: function() {
            return this._font;
        },
        set: function(t) {
            null === t || this.font.eq(t) || (this._font = t.clone(), this._data.fontFamily = t.family, this._data.fontSize = t.size, this._data.fontStyle = t.style, this._runtime && this._runtime.onFontUpdate(this.font));
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "fontFamily", {
        get: function() {
            return this.font.family;
        },
        set: function(t) {
            this.font.family !== t && (this._font = this.font.deriveFamily(t), this._data.fontFamily = t, this._runtime && this._runtime.onFontUpdate(this.font));
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "fontStyle", {
        get: function() {
            return this.font.style;
        },
        set: function(t) {
            this.font.style !== t && (this._font = this.font.deriveStyle(t), this._data.fontStyle = t, this._runtime && this._runtime.onFontUpdate(this.font));
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "fontSize", {
        get: function() {
            return this.font.size;
        },
        set: function(t) {
            isNaN(t) || this.font.size === t || (this._font = this.font.deriveSize(t), this._data.fontSize = t, this._runtime && this._runtime.onFontUpdate(this.font));
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "color", {
        get: function() {
            return this._color;
        },
        set: function(t) {
            t && !t.eq(this.color) && (this._color = t, this._runtime && this._runtime.onColorUpdate(t));
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.getType = function() {
        return $1c811abb26f94012$export$6ba26ae1c58c0147.CHAR;
    }, e;
}($1c811abb26f94012$var$et), $1c811abb26f94012$var$nt = function(t) {
    function e(e) {
        var r = t.call(this) || this;
        return r._data = e, r;
    }
    return $1c811abb26f94012$var$J(e, t), e.prototype.getType = function() {
        return $1c811abb26f94012$export$6ba26ae1c58c0147.GRAPHIC;
    }, e.prototype.toString = function() {
        return "Graphic";
    }, e;
}($1c811abb26f94012$var$K), $1c811abb26f94012$var$it = function(t) {
    function e(e) {
        var r = t.call(this) || this;
        return r._data = e, r;
    }
    return $1c811abb26f94012$var$J(e, t), Object.defineProperty(e.prototype, "parent", {
        get: function() {
            return this._parent;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "children", {
        get: function() {
            return this._children.slice();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "previous", {
        get: function() {
            return this._previous;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "next", {
        get: function() {
            return this._next;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "startTime", {
        get: function() {
            return this.firstChar ? this.firstChar.startTime : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "endTime", {
        get: function() {
            return this.lastChar ? this.lastChar.endTime : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "pos", {
        get: function() {
            return this._data && this._data.pos || "";
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "rawPos", {
        get: function() {
            return this._data && this._data.rawPoS || "";
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "language", {
        get: function() {
            return this._data && this._data.language || "";
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "countDown", {
        get: function() {
            return this._data ? this._data.countDown : -1;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "countUp", {
        get: function() {
            return this._data ? this._data.countUp : -1;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "initialCount", {
        get: function() {
            return this._data ? this._data.initialCount : -1;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "charCount", {
        get: function() {
            return this._children.length;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstChar", {
        get: function() {
            return this._children.length <= 0 ? null : this._children[0];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastChar", {
        get: function() {
            return this._children.length <= 0 ? null : this._children[this._children.length - 1];
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.addChar = function(t) {
        if (t) {
            this._children.length > 0 && (t._previous = this.lastChar, this.lastChar._next = t), this._children.push(t), t._parent = this;
            var e = this.expandTime(t), r = e.startTime, n = e.endTime;
            this._data.startTime = r, this._data.endTime = n;
        }
    }, e.prototype.findIndex = function(t) {
        return t instanceof $1c811abb26f94012$var$rt ? this._children.indexOf(t) : -1;
    }, e.prototype.getType = function() {
        return $1c811abb26f94012$export$6ba26ae1c58c0147.WORD;
    }, e;
}($1c811abb26f94012$var$et), $1c811abb26f94012$var$ot = function(t) {
    function e(e, r) {
        var n = t.call(this) || this;
        return n._video = e, n._data = r, n.createUnits(), n;
    }
    return $1c811abb26f94012$var$J(e, t), e.prototype.createUnits = function() {
        var t = this, e = this._data;
        e && Array.isArray(e.words) && e.words.forEach(function(e) {
            if (e) {
                var r = new $1c811abb26f94012$var$it(e);
                Array.isArray(e.characters) && e.characters.forEach(function(t) {
                    return r.addChar(new $1c811abb26f94012$var$rt(t));
                }), t.addWord(r);
            }
        });
    }, Object.defineProperty(e.prototype, "children", {
        get: function() {
            return this._children.slice();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "previous", {
        get: function() {
            return this._previous;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "next", {
        get: function() {
            return this._next;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "video", {
        get: function() {
            return this._video;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "startTime", {
        get: function() {
            return this.firstChar ? this.firstChar.startTime : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "endTime", {
        get: function() {
            return this.lastChar ? this.lastChar.endTime : 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "wordCount", {
        get: function() {
            return this._children.length;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "charCount", {
        get: function() {
            return this._children.reduce(function(t, e) {
                return t + e.charCount;
            }, 0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstWord", {
        get: function() {
            return this._children.length <= 0 ? null : this._children[0];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastWord", {
        get: function() {
            return this._children.length <= 0 ? null : this._children[this._children.length - 1];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstChar", {
        get: function() {
            var t = this.firstWord;
            return null === t ? null : t.firstChar;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastChar", {
        get: function() {
            var t = this.lastWord;
            return null === t ? null : t.lastChar;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.getWord = function(t) {
        return t < 0 || t >= this._children.length ? null : this._children[t];
    }, e.prototype.getChar = function(t) {
        if (t < 0) return null;
        for(var e = 0, r = this.firstWord;;){
            if (!r) return null;
            if (e + r.children.length > t) break;
            e += r.children.length, r = r.next;
        }
        return r.children[t - e];
    }, e.prototype.addWord = function(t) {
        if (t) {
            this._children.length > 0 && (t._previous = this.lastWord, t._previous._next = t, t.firstChar._previous = t._previous.lastChar, t._previous.lastChar._next = t.firstChar), this._children.push(t), t._parent = this;
            var e = this.expandTime(t), r = e.startTime, n = e.endTime;
            this._data.startTime = r, this._data.endTime = n;
        }
    }, e.prototype.findIndex = function(t) {
        if (t instanceof $1c811abb26f94012$var$it) return this._children.indexOf(t);
        if (t instanceof $1c811abb26f94012$var$rt) {
            for(var e = 0, r = !1, n = 0, i = this._children; n < i.length; n++){
                var o = i[n], s = o.findIndex(t);
                if (!(s < 0)) {
                    e += s, r = !0;
                    break;
                }
                e += o.charCount;
            }
            return r ? e : -1;
        }
        return -1;
    }, e.prototype.getType = function() {
        return $1c811abb26f94012$export$6ba26ae1c58c0147.PHRASE;
    }, e;
}($1c811abb26f94012$var$et);
function $1c811abb26f94012$export$9bae06dfae5441df(t, e, n) {
    if (!t || t.length <= 0) return null;
    var i = $1c811abb26f94012$var$r.sortedIndex(t, e, function(t) {
        return t.endTime;
    });
    if (i < 0) return null;
    if (n && "endTime" in n && "number" == typeof n.endTime) {
        i >= t.length && (i = t.length - 1);
        var o = e, s = n.endTime;
        return t[i].overlaps(o, s) ? t[i] : i < 1 ? null : t[i - 1].overlaps(o, s) ? t[i - 1] : null;
    }
    return i >= t.length ? null : n && "loose" in n && n.loose || t[i].contains(e) ? t[i] : null;
}
function $1c811abb26f94012$export$212614cfc0556d1e(t, e, n) {
    if (!t || t.length <= 0) return {
        current: null,
        entered: [],
        left: [],
        previous: null,
        next: null
    };
    var i = $1c811abb26f94012$var$r.sortedIndex(t, e, function(t) {
        return t.startTime;
    });
    i < t.length && t[i].startTime === e && i++;
    var o, s, a, u = i - 1 < 0 ? -1 : t[i - 1].startTime <= e && t[i - 1].endTime > e ? i - 2 : i - 1, c = $1c811abb26f94012$var$r.sortedIndex(t, n, function(t) {
        return t.endTime;
    });
    c >= t.length ? (o = -1, s = -1, a = t[c - 1].endTime > e ? t.length : 0) : (t[c].startTime > n ? (o = -1, s = c) : c + 1 >= t.length || t[c + 1].startTime > n ? (o = t[c].endTime > n && t[c].startTime <= n ? c : -1, s = c + 1) : (o = c + 1, s = c + 2), a = t[c].endTime <= n ? c + 1 : c);
    var l = u >= 0 ? t[u] : null, p = s >= 0 && s < t.length ? t[s] : null;
    return {
        current: o >= 0 ? t[o] : null,
        entered: t.slice(i, s),
        left: t.slice(u + 1, a),
        previous: l,
        next: p
    };
}
var $1c811abb26f94012$var$ut = function(t) {
    function e(e) {
        var r = t.call(this) || this;
        return r._credits = [], r._phrases = [], r._graphics = [], r.data = e || {}, r.createUnits(), r;
    }
    return $1c811abb26f94012$var$J(e, t), Object.defineProperty(e.prototype, "credits", {
        get: function() {
            return this._credits.slice();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "phrases", {
        get: function() {
            return this._phrases.slice();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "words", {
        get: function() {
            return this._phrases.reduce(function(t, e) {
                return t.splice.apply(t, $1c811abb26f94012$var$H([
                    t.length,
                    0
                ], e._children, !1)), t;
            }, []);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "chars", {
        get: function() {
            return this.words.reduce(function(t, e) {
                return t.splice.apply(t, $1c811abb26f94012$var$H([
                    t.length,
                    0
                ], e._children, !1)), t;
            }, []);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "graphics", {
        get: function() {
            return this._graphics.slice();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "rendering", {
        get: function() {
            return this._runtime.rendering;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "duration", {
        get: function() {
            return this.data.duration || 0;
        },
        set: function(t) {
            this.data.duration = t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "startTime", {
        get: function() {
            return this.data.startTime || 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "endTime", {
        get: function() {
            return this.data.endTime || 0;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "creditCount", {
        get: function() {
            return this._credits.length;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "phraseCount", {
        get: function() {
            return this._phrases.length;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "graphicCount", {
        get: function() {
            return this._graphics.length;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "wordCount", {
        get: function() {
            return this._phrases.reduce(function(t, e) {
                return t + e.wordCount;
            }, 0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "charCount", {
        get: function() {
            return this._phrases.reduce(function(t, e) {
                return t + e.charCount;
            }, 0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstCredit", {
        get: function() {
            return this._credits.length <= 0 ? null : this._credits[0];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastCredit", {
        get: function() {
            return this._credits.length <= 0 ? null : this._credits[this._credits.length - 1];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstPhrase", {
        get: function() {
            return this._phrases.length <= 0 ? null : this._phrases[0];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastPhrase", {
        get: function() {
            return this._phrases.length <= 0 ? null : this._phrases[this._phrases.length - 1];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstWord", {
        get: function() {
            var t;
            return (null === (t = this.firstPhrase) || void 0 === t ? void 0 : t.firstWord) || null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastWord", {
        get: function() {
            var t;
            return (null === (t = this.lastPhrase) || void 0 === t ? void 0 : t.lastWord) || null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstChar", {
        get: function() {
            var t;
            return (null === (t = this.firstWord) || void 0 === t ? void 0 : t.firstChar) || null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastChar", {
        get: function() {
            var t;
            return (null === (t = this.lastWord) || void 0 === t ? void 0 : t.lastChar) || null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "firstGraphic", {
        get: function() {
            return this._graphics.length <= 0 ? null : this._graphics[0];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "lastGraphic", {
        get: function() {
            return this._graphics.length <= 0 ? null : this._graphics[this._graphics.length - 1];
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.createUnits = function() {
        var t, e, r = this;
        Array.isArray(this.data.credits) ? (this.data.credits.sort($1c811abb26f94012$var$ct), this.data.credits.forEach(function(t) {
            return r.doAddCredit(new $1c811abb26f94012$var$ot(r, t), !1);
        }), this.organizeTimings(null === (t = this.firstCredit) || void 0 === t ? void 0 : t.firstChar)) : this.data.credits = [], Array.isArray(this.data.phrases) ? (this.data.phrases.sort($1c811abb26f94012$var$ct), this.data.phrases.forEach(function(t) {
            return r.doAddPhrase(new $1c811abb26f94012$var$ot(r, t), !1);
        }), this.organizeTimings(null === (e = this.firstPhrase) || void 0 === e ? void 0 : e.firstChar)) : this.data.phrases = [], Array.isArray(this.data.graphics) ? (this.data.graphics.sort($1c811abb26f94012$var$ct), this.data.graphics.forEach(function(t) {
            return r.doAddGraphic(new $1c811abb26f94012$var$nt(t), !1);
        })) : this.data.graphics = [];
    }, e.prototype.organizeTimings = function(t) {
        for(; t;)t.startTime === t.endTime && t.maximize(), t = t.next;
    }, e.prototype.exportData = function(t) {
        this.updateTemplateData(t);
        for(var r = e.exportUnitData(this.data.credits, !0), n = r.units, i = r.templateClasses, o = e.exportUnitData(this.data.phrases, !1), s = o.units, a = o.templateClasses, u = e.exportUnitData(this.data.graphics, !0), c = u.units, l = u.templateClasses, p = i.concat(a, l).filter(function(t, e, r) {
            return r.indexOf(t) === e;
        }), h = {}; p.length > 0;){
            var d = p.shift(), f = t.getByName(d);
            if (f) {
                h[d] = f.id;
                for(var y = 0, g = t.getRequiredTemplates(f.script); y < g.length; y++){
                    var v = g[y];
                    h[v] || p.push(v);
                }
            } else console.log("template class not found", d);
        }
        return {
            credits: n,
            phrases: s,
            graphics: c,
            templateClasses: h
        };
    }, e.exportUnitData = function(t, r) {
        if (void 0 === r && (r = !1), !t) return {
            units: [],
            templateClasses: []
        };
        for(var n = [], i = [], o = 0, s = t; o < s.length; o++){
            var a = s[o], u = {
                templates: a.templates ? a.templates.map(function(t) {
                    var e = t.type;
                    i.push(e);
                    var r = {};
                    return Object.keys(t.value).forEach(function(e) {
                        var n = t.value[e];
                        r[e] = "object" == typeof n ? Object.assign({}, n) : n;
                    }), {
                        type: e,
                        value: r
                    };
                }) : []
            }, c = void 0;
            if (a.words) {
                var l = a, p = e.exportUnitData(l.words);
                u.words = p.units, c = p.templateClasses;
            } else if (a.characters) {
                var h = a, d = e.exportUnitData(h.characters);
                u.characters = d.units, c = d.templateClasses;
            } else {
                for(var f = 0, y = [
                    "fontFamily",
                    "fontSize",
                    "fontStyle"
                ]; f < y.length; f++){
                    var g = y[f];
                    a[g] && (u[g] = a[g]);
                }
                c = [];
            }
            r && (u.startTime = a.startTime, u.endTime = a.endTime), n.push(u), i = i.concat(c);
        }
        return {
            units: n,
            templateClasses: i = i.filter(function(t, e, r) {
                return r.indexOf(t) === e;
            })
        };
    }, e.prototype.updateTemplateData = function(t) {
        e.updateTemplateDataForUnits(t, this.firstCredit, this.data.credits), e.updateTemplateDataForUnits(t, this.firstPhrase, this.data.phrases), e.updateTemplateDataForUnits(t, this.firstGraphic, this.data.graphics);
    }, e.updateTemplateDataForUnits = function(t, r, n) {
        if (r && n) for(var i = 0, o = n; i < o.length; i++){
            var s = o[i];
            s.templates = [];
            for(var a = 0; a < r.templateCount; a++){
                var u = r.getTemplate(a), c = t.exportInstance(u);
                s.templates.push(c);
            }
            if (s.words) {
                var l = s;
                e.updateTemplateDataForUnits(t, r.children[0], l.words);
            } else if (s.characters) {
                var p = s;
                e.updateTemplateDataForUnits(t, r.children[0], p.characters);
            }
            r = r.next;
        }
    }, e.prototype.addCredit = function(t) {
        this.doAddCredit(t, !0);
    }, e.prototype.doAddCredit = function(t, e) {
        var r = this.addRenderingUnit(this._credits, t);
        e && this.data.credits.splice(r, 0, t._data), this._runtime && this._runtime.addCredit(t);
    }, e.prototype.addPhrase = function(t) {
        this.doAddPhrase(t, !0);
    }, e.prototype.doAddPhrase = function(t, e) {
        var r = this.addRenderingUnit(this._phrases, t);
        e && this.data.phrases.splice(r, 0, t._data), this._runtime && this._runtime.addPhrase(t);
    }, e.prototype.addGraphic = function(t) {
        this.doAddGraphic(t, !0);
    }, e.prototype.doAddGraphic = function(t, e) {
        if (t) {
            var r = this.addRenderingUnit(this._graphics, t);
            e && this.data.graphics.splice(r, 0, t._data), this._runtime && this._runtime.addGraphic(t);
        }
    }, e.prototype.addRenderingUnit = function(t, e) {
        if (e) {
            var n = $1c811abb26f94012$var$r.sortedIndex(t, e, $1c811abb26f94012$var$lt), i = n > 0 ? t[n - 1] : null, o = n < t.length ? t[n] : null;
            if (t.splice(n, 0, e), i && (e._previous = i, e._previous._next = e), o && (o._previous = e, e._next = o), e instanceof $1c811abb26f94012$var$ot && e.wordCount > 0) {
                for(var s = i; s && !s.lastWord;)s = s.previous;
                for(var a = o; a && !a.firstWord;)a = a.next;
                if (s && (e.firstWord._previous = s.lastWord, s.lastWord._next = e.firstWord), a && (e.lastWord._next = a.firstWord, a.firstWord._previous = e.lastWord), e.charCount > 0) {
                    for(var u = null == s ? void 0 : s.lastWord; u && null === u.lastChar;)u = u.previous;
                    for(var c = null == a ? void 0 : a.firstWord; c && null === c.firstChar;)c = c.next;
                    u && (e.firstChar._previous = u.lastChar, u.lastChar._next = e.firstChar), c && (e.lastChar._next = c.firstChar, c.firstChar._previous = e.lastChar);
                }
            }
            return this.updateStartAndEndTime(), n;
        }
    }, e.prototype.removeCredit = function(t) {
        var e = this.removeRenderingUnit(this._credits, t);
        return !(e < 0 || (this.data.credits.splice(e, 1), this._runtime && this._runtime.removeCredit(t), 0));
    }, e.prototype.removeCredits = function() {
        var t = this;
        this._runtime && this._credits.forEach(function(e) {
            return t._runtime.removeCredit(e);
        }), this._credits = [], this.data.credits.splice(0, this.data.credits.length);
    }, e.prototype.removePhrase = function(t) {
        var e = this.removeRenderingUnit(this._phrases, t);
        return !(e < 0 || (this.data.phrases.splice(e, 1), this._runtime && this._runtime.removePhrase(t), 0));
    }, e.prototype.removePhrases = function() {
        var t = this;
        this._runtime && this._phrases.forEach(function(e) {
            return t._runtime.removePhrase(e);
        }), this._phrases = [], this.data.phrases.splice(0, this.data.phrases.length);
    }, e.prototype.removeGraphic = function(t) {
        var e = this.removeRenderingUnit(this._graphics, t);
        return !(e < 0 || (this.data.graphics.splice(e, 1), this._runtime && this._runtime.removeGraphic(t), 0));
    }, e.prototype.removeGraphics = function() {
        var t = this;
        this._runtime && this._graphics.forEach(function(e) {
            return t._runtime.removeGraphic(e);
        }), this._graphics = [], this.data.graphics.splice(0, this.data.graphics.length), this.rendering.reset();
    }, e.prototype.removeRenderingUnit = function(t, e) {
        var n = $1c811abb26f94012$var$r.sortedIndex(t, e, $1c811abb26f94012$var$lt);
        if (n < 0 || t[n] !== e) return -1;
        if (t.splice(n, 1), e instanceof $1c811abb26f94012$var$ot) {
            if (e.charCount > 0) {
                for(var i = e._previous; i && null === i.lastChar;)i = i.previous;
                for(var o = e._next; o && null === o.firstChar;)o = o.next;
                i && o ? (i.lastChar._next = o.firstChar, o.firstChar._previous = i.lastChar) : i ? i.lastChar._next = null : o && (o.firstChar._previous = null);
            }
            if (e.wordCount > 0) {
                for(i = e._previous; i && null === i.lastWord;)i = i.previous;
                for(o = e._next; o && null === o.firstWord;)o = o.next;
                i && o ? (i.lastWord._next = o.firstWord, o.firstWord._previous = i.lastWord) : i ? i.lastWord._next = null : o && (o.firstWord._previous = null);
            }
        }
        e._previous && (e._previous._next = e._next), e._next && (e._next._previous = e._previous), this.updateStartAndEndTime();
    }, e.prototype.updateStartAndEndTime = function() {
        var t, e, r, n, i, o, s, a;
        this.data.endTime = Math.max((null === (e = null === (t = this.lastCredit) || void 0 === t ? void 0 : t.lastChar) || void 0 === e ? void 0 : e.endTime) || 0, (null === (r = this.lastChar) || void 0 === r ? void 0 : r.endTime) || 0, (null === (n = this.lastGraphic) || void 0 === n ? void 0 : n.endTime) || 0);
        var u = null === (o = null === (i = this.firstCredit) || void 0 === i ? void 0 : i.firstChar) || void 0 === o ? void 0 : o.startTime, c = null === (s = this.firstChar) || void 0 === s ? void 0 : s.startTime, l = null === (a = this.firstGraphic) || void 0 === a ? void 0 : a.startTime;
        this.data.startTime = Math.min("number" == typeof u ? u : Number.MAX_VALUE, "number" == typeof c ? c : Number.MAX_VALUE, "number" == typeof l ? l : Number.MAX_VALUE, this.data.endTime);
    }, e.prototype.findIndex = function(t) {
        if (t instanceof $1c811abb26f94012$var$ot) return (e = this._phrases.indexOf(t)) >= 0 ? e : this._credits.indexOf(t);
        if (t instanceof $1c811abb26f94012$var$it) {
            for(var e = 0, r = !1, n = 0, i = this._phrases; n < i.length; n++){
                if (!((u = (a = i[n]).findIndex(t)) < 0)) {
                    e += u, r = !0;
                    break;
                }
                e += a.wordCount;
            }
            return r ? e : -1;
        }
        if (t instanceof $1c811abb26f94012$var$rt) {
            e = 0, r = !1;
            for(var o = 0, s = this._phrases; o < s.length; o++){
                var a, u;
                if (!((u = (a = s[o]).findIndex(t)) < 0)) {
                    e += u, r = !0;
                    break;
                }
                e += a.charCount;
            }
            return r ? e : -1;
        }
        return t instanceof $1c811abb26f94012$var$nt ? this._graphics.indexOf(t) : -1;
    }, e.prototype.getCredit = function(t) {
        return t < 0 || t >= this._credits.length ? null : this._credits[t];
    }, e.prototype.getPhrase = function(t) {
        return t < 0 || t >= this._phrases.length ? null : this._phrases[t];
    }, e.prototype.getWord = function(t) {
        if (t < 0) return null;
        for(var e = 0, r = this.firstPhrase;;){
            if (!r) return null;
            if (e + r.children.length > t) break;
            e += r.children.length, r = r.next;
        }
        return r.children[t - e];
    }, e.prototype.getChar = function(t) {
        if (t < 0) return null;
        for(var e = 0, r = this.firstWord;;){
            if (!r) return null;
            if (e + r.children.length > t) break;
            e += r.children.length, r = r.next;
        }
        return r.children[t - e];
    }, e.prototype.getGraphic = function(t) {
        return t < 0 || t >= this._graphics.length ? null : this._graphics[t];
    }, e.prototype.findCredit = function(t, e) {
        return $1c811abb26f94012$export$9bae06dfae5441df(this._credits, t, e);
    }, e.prototype.findCreditChange = function(t, e) {
        return $1c811abb26f94012$export$212614cfc0556d1e(this._credits, t, e);
    }, e.prototype.findPhrase = function(t, e) {
        return $1c811abb26f94012$export$9bae06dfae5441df(this._phrases, t, e);
    }, e.prototype.findPhraseChange = function(t, e) {
        return $1c811abb26f94012$export$212614cfc0556d1e(this._phrases, t, e);
    }, e.prototype.findWord = function(t, e) {
        var r = this.findPhrase(t, e);
        return r ? $1c811abb26f94012$export$9bae06dfae5441df(r._children, t, e) : null;
    }, e.prototype.findWordChange = function(t, e) {
        return $1c811abb26f94012$export$212614cfc0556d1e(this.words, t, e);
    }, e.prototype.findChar = function(t, e) {
        var r = this.findWord(t, e);
        return r ? $1c811abb26f94012$export$9bae06dfae5441df(r._children, t, e) : null;
    }, e.prototype.findCharChange = function(t, e) {
        return $1c811abb26f94012$export$212614cfc0556d1e(this.chars, t, e);
    }, e.prototype.findGraphic = function(t, e) {
        return $1c811abb26f94012$export$9bae06dfae5441df(this._graphics, t, e);
    }, e.prototype.findGraphicChange = function(t, e) {
        return $1c811abb26f94012$export$212614cfc0556d1e(this._graphics, t, e);
    }, e;
}($1c811abb26f94012$export$52786b6f4da3c973);
function $1c811abb26f94012$var$ct(t, e) {
    return t.startTime - e.startTime;
}
function $1c811abb26f94012$var$lt(t) {
    return t.startTime;
}
var $1c811abb26f94012$export$26e6ecd136a15474 = function() {
    function t(t, e, r, n, i, o) {
        void 0 === t && (t = 1), void 0 === e && (e = 0), void 0 === r && (r = 0), void 0 === n && (n = 1), void 0 === i && (i = 0), void 0 === o && (o = 0), this.setValues(t, e, r, n, i, o);
    }
    return t.prototype.setValues = function(t, e, r, n, i, o) {
        return void 0 === t && (t = 1), void 0 === e && (e = 0), void 0 === r && (r = 0), void 0 === n && (n = 1), void 0 === i && (i = 0), void 0 === o && (o = 0), this.a = t, this.b = e, this.c = r, this.d = n, this.tx = i, this.ty = o, this;
    }, t.prototype.append = function(t, e, r, n, i, o) {
        var s = this.a, a = this.b, u = this.c, c = this.d;
        return 1 == t && 0 == e && 0 == r && 1 == n || (this.a = s * t + u * e, this.b = a * t + c * e, this.c = s * r + u * n, this.d = a * r + c * n), this.tx = s * i + u * o + this.tx, this.ty = a * i + c * o + this.ty, this;
    }, t.prototype.prepend = function(t, e, r, n, i, o) {
        var s = this.a, a = this.c, u = this.tx;
        return this.a = t * s + r * this.b, this.b = e * s + n * this.b, this.c = t * a + r * this.d, this.d = e * a + n * this.d, this.tx = t * u + r * this.ty + i, this.ty = e * u + n * this.ty + o, this;
    }, t.prototype.appendMatrix = function(t) {
        return this.append(t.a, t.b, t.c, t.d, t.tx, t.ty);
    }, t.prototype.prependMatrix = function(t) {
        return this.prepend(t.a, t.b, t.c, t.d, t.tx, t.ty);
    }, t.prototype.appendTransform = function(e, r, n, i, o, s, a, u, c) {
        var l, p, h;
        return o % 360 ? (l = o * t.DEG_TO_RAD, p = Math.cos(l), h = Math.sin(l)) : (p = 1, h = 0), s || a ? (s *= t.DEG_TO_RAD, a *= t.DEG_TO_RAD, this.append(Math.cos(a), Math.sin(a), -Math.sin(s), Math.cos(s), e, r), this.append(p * n, h * n, -h * i, p * i, 0, 0)) : this.append(p * n, h * n, -h * i, p * i, e, r), (u || c) && (this.tx -= u * this.a + c * this.c, this.ty -= u * this.b + c * this.d), this;
    }, t.prototype.prependTransform = function(e, r, n, i, o, s, a, u, c) {
        var l, p, h;
        return o % 360 ? (l = o * t.DEG_TO_RAD, p = Math.cos(l), h = Math.sin(l)) : (p = 1, h = 0), (u || c) && (this.tx -= u, this.ty -= c), s || a ? (s *= t.DEG_TO_RAD, a *= t.DEG_TO_RAD, this.prepend(p * n, h * n, -h * i, p * i, 0, 0), this.prepend(Math.cos(a), Math.sin(a), -Math.sin(s), Math.cos(s), e, r)) : this.prepend(p * n, h * n, -h * i, p * i, e, r), this;
    }, t.prototype.rotate = function(e) {
        e *= t.DEG_TO_RAD;
        var r = Math.cos(e), n = Math.sin(e), i = this.a, o = this.b;
        return this.a = i * r + this.c * n, this.b = o * r + this.d * n, this.c = -i * n + this.c * r, this.d = -o * n + this.d * r, this;
    }, t.prototype.skew = function(e, r) {
        return e *= t.DEG_TO_RAD, r *= t.DEG_TO_RAD, this.append(Math.cos(r), Math.sin(r), -Math.sin(e), Math.cos(e), 0, 0), this;
    }, t.prototype.scale = function(t, e) {
        return this.a *= t, this.b *= t, this.c *= e, this.d *= e, this;
    }, t.prototype.translate = function(t, e) {
        return this.tx += this.a * t + this.c * e, this.ty += this.b * t + this.d * e, this;
    }, t.prototype.identity = function() {
        return this.a = this.d = 1, this.b = this.c = this.tx = this.ty = 0, this;
    }, t.prototype.invert = function() {
        var t = this.a, e = this.b, r = this.c, n = this.d, i = this.tx, o = t * n - e * r;
        return this.a = n / o, this.b = -e / o, this.c = -r / o, this.d = t / o, this.tx = (r * this.ty - n * i) / o, this.ty = -(t * this.ty - e * i) / o, this;
    }, t.prototype.isIdentity = function() {
        return 0 === this.tx && 0 === this.ty && 1 === this.a && 0 === this.b && 0 === this.c && 1 === this.d;
    }, t.prototype.equals = function(t) {
        return this.tx === t.tx && this.ty === t.ty && this.a === t.a && this.b === t.b && this.c === t.c && this.d === t.d;
    }, t.prototype.transformPoint = function(t, e, r) {
        return r.x = t * this.a + e * this.c + this.tx, r.y = t * this.b + e * this.d + this.ty, r;
    }, t.prototype.decompose = function(e) {
        void 0 === e && (e = {}), e.x = this.tx, e.y = this.ty, e.scaleX = Math.sqrt(this.a * this.a + this.b * this.b), e.scaleY = Math.sqrt(this.c * this.c + this.d * this.d);
        var r = Math.atan2(-this.c, this.d), n = Math.atan2(this.b, this.a);
        return Math.abs(1 - r / n) < 1e-5 ? (e.rotation = n / t.DEG_TO_RAD, this.a < 0 && this.d >= 0 && (e.rotation += e.rotation <= 0 ? 180 : -180), e.skewX = e.skewY = 0) : (e.skewX = r / t.DEG_TO_RAD, e.skewY = n / t.DEG_TO_RAD), e;
    }, t.prototype.copy = function(t) {
        return this.setValues(t.a, t.b, t.c, t.d, t.tx, t.ty);
    }, t.prototype.clone = function() {
        return new t(this.a, this.b, this.c, this.d, this.tx, this.ty);
    }, t.prototype.toString = function() {
        return "[".concat(this.constructor.name, " (a=").concat(this.a, " b=").concat(this.b, " c=").concat(this.c, " d=").concat(this.d, " tx=").concat(this.tx, " ty=").concat(this.ty, ")]");
    }, t.DEG_TO_RAD = Math.PI / 180, t.identity = new t, t;
}(), $1c811abb26f94012$export$baf26146a414f24a = function() {
    function t(t, e) {
        void 0 === t && (t = 0), void 0 === e && (e = 0), this.setValues(t, e);
    }
    return t.prototype.setValues = function(t, e) {
        return void 0 === t && (t = 0), void 0 === e && (e = 0), this.x = t, this.y = e, this;
    }, t.prototype.copy = function(t) {
        return this.x = t.x, this.y = t.y, this;
    }, t.prototype.clone = function() {
        return new t(this.x, this.y);
    }, t.prototype.toString = function() {
        return "[".concat(this.constructor.name, " (x=").concat(this.x, " y=").concat(this.y, ")]");
    }, t;
}(), $1c811abb26f94012$var$dt = function() {
    function t() {
        this.tx = new $1c811abb26f94012$export$26e6ecd136a15474, this.alpha = 0, this.composite = "", this.visible = !0;
    }
    return t.prototype.reset = function() {}, t;
}(), $1c811abb26f94012$var$ft = function() {
    function t() {
        this.rendering = new $1c811abb26f94012$var$dt;
    }
    return t.prototype.addCredit = function(t) {
        this.doAddPhrase(t);
    }, t.prototype.removeCredit = function(t) {
        t._runtime = null;
    }, t.prototype.addPhrase = function(t) {
        this.doAddPhrase(t);
    }, t.prototype.removePhrase = function(t) {
        t._runtime = null;
    }, t.prototype.doAddPhrase = function(t) {
        t._runtime = {
            graphics: {
                clear: function() {}
            },
            rendering: new $1c811abb26f94012$var$dt,
            update: function() {}
        };
        for(var e = t.firstWord; e;){
            e._runtime = {
                graphics: {
                    clear: function() {}
                },
                rendering: new $1c811abb26f94012$var$dt,
                update: function() {}
            };
            for(var r = e.firstChar; r && (r._runtime = {
                graphics: {
                    clear: function() {}
                },
                rendering: new $1c811abb26f94012$var$dt,
                update: function() {},
                advance: 0,
                ascent: 0,
                descent: 0,
                onFontUpdate: function() {},
                onColorUpdate: function() {}
            }, r !== e.lastChar);)r = r.next;
            if (e === t.lastWord) break;
            e = e.next;
        }
    }, t.prototype.addGraphic = function(t) {
        t._runtime = {
            graphics: {
                clear: function() {}
            },
            rendering: new $1c811abb26f94012$var$dt,
            update: function() {}
        };
    }, t.prototype.removeGraphic = function(t) {
        t._runtime = null;
    }, t;
}(), $1c811abb26f94012$var$yt = function() {
    function t() {
        this.wrapperTable = {};
    }
    return t.prototype.isGraphics = function() {
        return !1;
    }, t.prototype.setCanvas = function() {
        return Promise.resolve();
    }, t.prototype.createRuntime = function(t) {
        return function(t, e, r, n) {
            return new (r || (r = Promise))(function(e, i) {
                function o(t) {
                    try {
                        a(n.next(t));
                    } catch (t) {
                        i(t);
                    }
                }
                function s(t) {
                    try {
                        a(n.throw(t));
                    } catch (t) {
                        i(t);
                    }
                }
                function a(t) {
                    var n;
                    t.done ? e(t.value) : (n = t.value, n instanceof r ? n : new r(function(t) {
                        t(n);
                    })).then(o, s);
                }
                a((n = n.apply(t, [])).next());
            });
        }(this, 0, void 0, function() {
            var e, r, n;
            return function(t, e) {
                var r, n, i, o, s = {
                    label: 0,
                    sent: function() {
                        if (1 & i[0]) throw i[1];
                        return i[1];
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: a(0),
                    throw: a(1),
                    return: a(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                    return this;
                }), o;
                function a(a) {
                    return function(u) {
                        return function(a) {
                            if (r) throw new TypeError("Generator is already executing.");
                            for(; o && (o = 0, a[0] && (s = 0)), s;)try {
                                if (r = 1, n && (i = 2 & a[0] ? n.return : a[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, a[1])).done) return i;
                                switch(n = 0, i && (a = [
                                    2 & a[0],
                                    i.value
                                ]), a[0]){
                                    case 0:
                                    case 1:
                                        i = a;
                                        break;
                                    case 4:
                                        return s.label++, {
                                            value: a[1],
                                            done: !1
                                        };
                                    case 5:
                                        s.label++, n = a[1], a = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        a = s.ops.pop(), s.trys.pop();
                                        continue;
                                    default:
                                        if (!((i = (i = s.trys).length > 0 && i[i.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                            s = 0;
                                            continue;
                                        }
                                        if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                                            s.label = a[1];
                                            break;
                                        }
                                        if (6 === a[0] && s.label < i[1]) {
                                            s.label = i[1], i = a;
                                            break;
                                        }
                                        if (i && s.label < i[2]) {
                                            s.label = i[2], s.ops.push(a);
                                            break;
                                        }
                                        i[2] && s.ops.pop(), s.trys.pop();
                                        continue;
                                }
                                a = e.call(t, s);
                            } catch (t) {
                                a = [
                                    6,
                                    t
                                ], n = 0;
                            } finally{
                                r = i = 0;
                            }
                            if (5 & a[0]) throw a[1];
                            return {
                                value: a[0] ? a[1] : void 0,
                                done: !0
                            };
                        }([
                            a,
                            u
                        ]);
                    };
                }
            }(this, function(i) {
                for(this.video = t, t._runtime = new $1c811abb26f94012$var$ft, e = t.firstCredit; e;)t._runtime.addCredit(e), e = e.next;
                for(r = t.firstPhrase; r;)t._runtime.addPhrase(r), r = r.next;
                for(n = t.firstGraphic; n;)t._runtime.addGraphic(n), n = n.next;
                return [
                    2,
                    t._runtime
                ];
            });
        });
    }, t.prototype.reset = function() {
        var t, e;
        this.resetTextUnitsFrom(this.video.firstCredit), this.resetTextUnitsFrom(null === (t = this.video.firstCredit) || void 0 === t ? void 0 : t.firstWord), this.resetTextUnitsFrom(null === (e = this.video.firstCredit) || void 0 === e ? void 0 : e.firstChar), this.resetTextUnitsFrom(this.video.firstPhrase), this.resetTextUnitsFrom(this.video.firstWord), this.resetTextUnitsFrom(this.video.firstChar), this.video._runtime.rendering.reset();
    }, t.prototype.resetTextUnitsFrom = function(t) {
        for(; t;)t.rendering.reset(), t.graphics.clear(), t = t.next;
    }, t.prototype.update = function() {
        var t, e;
        this.updateCharsFrom(null === (t = this.video.firstCredit) || void 0 === t ? void 0 : t.firstChar), this.updateCharsFrom(null === (e = this.video.firstPhrase) || void 0 === e ? void 0 : e.firstChar);
    }, t.prototype.updateCharsFrom = function(t) {
        for(; t;)t._runtime.update(), t = t.next;
    }, t.prototype.updateStageTx = function() {}, t;
}();
function $1c811abb26f94012$var$gt(t) {
    if (void 0 !== t && "function" != typeof t) {
        if ("object" != typeof t) return t;
        if (null === t) return null;
        if (t instanceof $1c811abb26f94012$export$892596cec99bc70e) return {
            type: "Color",
            value: {
                r: t.r,
                g: t.g,
                b: t.b,
                a: t.a
            }
        };
        throw new Error;
    }
}
function $1c811abb26f94012$var$vt(t, e) {
    if ("object" != typeof t || null === t) return t;
    if (t.type && (e[t.type] || "Color" === t.type)) {
        var r;
        if ("Color" === t.type) {
            var n = new $1c811abb26f94012$export$892596cec99bc70e;
            n.r = Number(t.value.r), n.g = Number(t.value.g), n.b = Number(t.value.b), n.a = Number(t.value.a), r = n;
        } else {
            for(var i = new e[t.type], o = 0, s = Object.keys(t.value); o < s.length; o++){
                var a = s[o];
                i[a] = t.value[a];
            }
            r = i;
        }
        return r;
    }
}
var $1c811abb26f94012$var$mt, $1c811abb26f94012$var$bt, $1c811abb26f94012$var$_t, $1c811abb26f94012$var$wt, $1c811abb26f94012$var$Pt, $1c811abb26f94012$var$Et, $1c811abb26f94012$var$Ot, $1c811abb26f94012$var$St, $1c811abb26f94012$var$Tt, $1c811abb26f94012$var$xt, $1c811abb26f94012$var$At, $1c811abb26f94012$var$Rt, $1c811abb26f94012$var$Ct, $1c811abb26f94012$var$Nt, $1c811abb26f94012$var$kt, $1c811abb26f94012$var$jt, $1c811abb26f94012$var$It, $1c811abb26f94012$var$Ut, $1c811abb26f94012$var$Ft, $1c811abb26f94012$var$Lt, $1c811abb26f94012$var$Dt = function(t, e) {
    return $1c811abb26f94012$var$bt = String(t), $1c811abb26f94012$var$_t = $1c811abb26f94012$var$bt.length, function(t) {
        for(var e in $1c811abb26f94012$var$mt = t || {}, $1c811abb26f94012$var$Mt)Object.prototype.hasOwnProperty.call($1c811abb26f94012$var$mt, e) || ($1c811abb26f94012$var$mt[e] = $1c811abb26f94012$var$Mt[e]);
        $1c811abb26f94012$var$wt = $1c811abb26f94012$var$mt.sourceFile || null;
    }(e), $1c811abb26f94012$var$Ct = 1, $1c811abb26f94012$var$Pt = $1c811abb26f94012$var$Nt = 0, $1c811abb26f94012$var$Rt = !0, $1c811abb26f94012$var$pr(), function(t) {
        $1c811abb26f94012$var$kt = $1c811abb26f94012$var$jt = $1c811abb26f94012$var$Pt, $1c811abb26f94012$var$mt.locations && ($1c811abb26f94012$var$It = new $1c811abb26f94012$var$ar), $1c811abb26f94012$var$Ut = $1c811abb26f94012$var$Lt = null, $1c811abb26f94012$var$Ft = [], $1c811abb26f94012$var$hr();
        var e = t || $1c811abb26f94012$var$Or(), r = !0;
        for(t || (e.body = []); $1c811abb26f94012$var$xt !== $1c811abb26f94012$var$Jt;){
            var n = $1c811abb26f94012$var$Fr();
            e.body.push(n), r && $1c811abb26f94012$var$xr(n) && $1c811abb26f94012$var$wr(!0), r = !1;
        }
        return $1c811abb26f94012$var$Tr(e, "Program");
    }($1c811abb26f94012$var$mt.program);
}, $1c811abb26f94012$var$Mt = {
    ecmaVersion: 5,
    strictSemicolons: !1,
    allowTrailingCommas: !0,
    forbidReserved: !1,
    locations: !1,
    onComment: null,
    ranges: !1,
    program: null,
    sourceFile: null,
    directSourceFile: null
}, $1c811abb26f94012$var$Bt = function(t, e) {
    for(var r = 1, n = 0;;){
        $1c811abb26f94012$var$ir.lastIndex = n;
        var i = $1c811abb26f94012$var$ir.exec(t);
        if (!(i && i.index < e)) break;
        ++r, n = i.index + i[0].length;
    }
    return {
        line: r,
        column: e - n
    };
};
function $1c811abb26f94012$var$Vt(t, e) {
    var r = $1c811abb26f94012$var$Bt($1c811abb26f94012$var$bt, t);
    e += " (" + r.line + ":" + r.column + ")";
    var n = new SyntaxError(e);
    throw n.pos = t, n.loc = r, n.raisedAt = $1c811abb26f94012$var$Pt, n;
}
var $1c811abb26f94012$var$Gt = [], $1c811abb26f94012$var$qt = {
    type: "num"
}, $1c811abb26f94012$var$Wt = {
    type: "regexp"
}, $1c811abb26f94012$var$Yt = {
    type: "string"
}, $1c811abb26f94012$var$zt = {
    type: "name"
}, $1c811abb26f94012$var$Jt = {
    type: "eof"
}, $1c811abb26f94012$var$Ht = {
    keyword: "break"
}, $1c811abb26f94012$var$Xt = {
    keyword: "case",
    beforeExpr: !0
}, $1c811abb26f94012$var$Zt = {
    keyword: "catch"
}, $1c811abb26f94012$var$$t = {
    keyword: "continue"
}, $1c811abb26f94012$var$Kt = {
    keyword: "debugger"
}, $1c811abb26f94012$var$Qt = {
    keyword: "default"
}, $1c811abb26f94012$var$te = {
    keyword: "do",
    isLoop: !0
}, $1c811abb26f94012$var$ee = {
    keyword: "else",
    beforeExpr: !0
}, $1c811abb26f94012$var$re = {
    keyword: "finally"
}, $1c811abb26f94012$var$ne = {
    keyword: "for",
    isLoop: !0
}, $1c811abb26f94012$var$ie = {
    keyword: "function"
}, $1c811abb26f94012$var$oe = {
    keyword: "if"
}, $1c811abb26f94012$var$se = {
    keyword: "return",
    beforeExpr: !0
}, $1c811abb26f94012$var$ae = {
    keyword: "switch"
}, $1c811abb26f94012$var$ue = {
    keyword: "throw",
    beforeExpr: !0
}, $1c811abb26f94012$var$ce = {
    keyword: "try"
}, $1c811abb26f94012$var$le = {
    keyword: "var"
}, $1c811abb26f94012$var$pe = {
    keyword: "while",
    isLoop: !0
}, $1c811abb26f94012$var$he = {
    keyword: "with"
}, $1c811abb26f94012$var$de = {
    keyword: "new",
    beforeExpr: !0
}, $1c811abb26f94012$var$fe = {
    keyword: "this"
}, $1c811abb26f94012$var$ye = {
    keyword: "null",
    atomValue: null
}, $1c811abb26f94012$var$ge = {
    keyword: "true",
    atomValue: !0
}, $1c811abb26f94012$var$ve = {
    keyword: "false",
    atomValue: !1
}, $1c811abb26f94012$var$me = {
    keyword: "in",
    binop: 7,
    beforeExpr: !0
}, $1c811abb26f94012$var$be = {
    break: $1c811abb26f94012$var$Ht,
    case: $1c811abb26f94012$var$Xt,
    catch: $1c811abb26f94012$var$Zt,
    continue: $1c811abb26f94012$var$$t,
    debugger: $1c811abb26f94012$var$Kt,
    default: $1c811abb26f94012$var$Qt,
    do: $1c811abb26f94012$var$te,
    else: $1c811abb26f94012$var$ee,
    finally: $1c811abb26f94012$var$re,
    for: $1c811abb26f94012$var$ne,
    function: $1c811abb26f94012$var$ie,
    if: $1c811abb26f94012$var$oe,
    return: $1c811abb26f94012$var$se,
    switch: $1c811abb26f94012$var$ae,
    throw: $1c811abb26f94012$var$ue,
    try: $1c811abb26f94012$var$ce,
    var: $1c811abb26f94012$var$le,
    while: $1c811abb26f94012$var$pe,
    with: $1c811abb26f94012$var$he,
    null: $1c811abb26f94012$var$ye,
    true: $1c811abb26f94012$var$ge,
    false: $1c811abb26f94012$var$ve,
    new: $1c811abb26f94012$var$de,
    in: $1c811abb26f94012$var$me,
    instanceof: {
        keyword: "instanceof",
        binop: 7,
        beforeExpr: !0
    },
    this: $1c811abb26f94012$var$fe,
    typeof: {
        keyword: "typeof",
        prefix: !0,
        beforeExpr: !0
    },
    void: {
        keyword: "void",
        prefix: !0,
        beforeExpr: !0
    },
    delete: {
        keyword: "delete",
        prefix: !0,
        beforeExpr: !0
    }
}, $1c811abb26f94012$var$_e = {
    type: "[",
    beforeExpr: !0
}, $1c811abb26f94012$var$we = {
    type: "]"
}, $1c811abb26f94012$var$Pe = {
    type: "{",
    beforeExpr: !0
}, $1c811abb26f94012$var$Ee = {
    type: "}"
}, $1c811abb26f94012$var$Oe = {
    type: "(",
    beforeExpr: !0
}, $1c811abb26f94012$var$Se = {
    type: ")"
}, $1c811abb26f94012$var$Te = {
    type: ",",
    beforeExpr: !0
}, $1c811abb26f94012$var$xe = {
    type: ";",
    beforeExpr: !0
}, $1c811abb26f94012$var$Ae = {
    type: ":",
    beforeExpr: !0
}, $1c811abb26f94012$var$Re = {
    type: "."
}, $1c811abb26f94012$var$Ce = {
    type: "?",
    beforeExpr: !0
}, $1c811abb26f94012$var$Ne = {
    binop: 10,
    beforeExpr: !0
}, $1c811abb26f94012$var$ke = {
    isAssign: !0,
    beforeExpr: !0
}, $1c811abb26f94012$var$je = {
    isAssign: !0,
    beforeExpr: !0
}, $1c811abb26f94012$var$Ie = {
    postfix: !0,
    prefix: !0,
    isUpdate: !0
}, $1c811abb26f94012$var$Ue = {
    prefix: !0,
    beforeExpr: !0
}, $1c811abb26f94012$var$Fe = {
    binop: 1,
    beforeExpr: !0
}, $1c811abb26f94012$var$Le = {
    binop: 2,
    beforeExpr: !0
}, $1c811abb26f94012$var$De = {
    binop: 3,
    beforeExpr: !0
}, $1c811abb26f94012$var$Me = {
    binop: 4,
    beforeExpr: !0
}, $1c811abb26f94012$var$Be = {
    binop: 5,
    beforeExpr: !0
}, $1c811abb26f94012$var$Ve = {
    binop: 6,
    beforeExpr: !0
}, $1c811abb26f94012$var$Ge = {
    binop: 7,
    beforeExpr: !0
}, $1c811abb26f94012$var$qe = {
    binop: 8,
    beforeExpr: !0
}, $1c811abb26f94012$var$We = {
    binop: 9,
    prefix: !0,
    beforeExpr: !0
}, $1c811abb26f94012$var$Ye = {
    binop: 10,
    beforeExpr: !0
};
function $1c811abb26f94012$var$ze(t) {
    t = t.split(" ");
    var e = "", r = [];
    t: for(var n = 0; n < t.length; ++n){
        for(var i = 0; i < r.length; ++i)if (r[i][0].length == t[n].length) {
            r[i].push(t[n]);
            continue t;
        }
        r.push([
            t[n]
        ]);
    }
    function o(t) {
        if (1 == t.length) return e += "return str === " + JSON.stringify(t[0]) + ";";
        e += "switch(str){";
        for(var r = 0; r < t.length; ++r)e += "case " + JSON.stringify(t[r]) + ":";
        e += "return true}return false;";
    }
    if (r.length > 3) {
        for(r.sort(function(t, e) {
            return e.length - t.length;
        }), e += "switch(str.length){", n = 0; n < r.length; ++n){
            var s = r[n];
            e += "case " + s[0].length + ":", o(s);
        }
        e += "}";
    } else o(t);
    return new Function("str", e);
}
var $1c811abb26f94012$var$Je, $1c811abb26f94012$var$He = $1c811abb26f94012$var$ze("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile"), $1c811abb26f94012$var$Xe = $1c811abb26f94012$var$ze("class enum extends super const export import"), $1c811abb26f94012$var$Ze = $1c811abb26f94012$var$ze("implements interface let package private protected public static yield"), $1c811abb26f94012$var$$e = $1c811abb26f94012$var$ze("eval arguments"), $1c811abb26f94012$var$Ke = $1c811abb26f94012$var$ze("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"), $1c811abb26f94012$var$Qe = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/, $1c811abb26f94012$var$tr = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F0\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", $1c811abb26f94012$var$er = new RegExp("[" + $1c811abb26f94012$var$tr + "]"), $1c811abb26f94012$var$rr = new RegExp("[" + $1c811abb26f94012$var$tr + "\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u0620-\u0649\u0672-\u06D3\u06E7-\u06E8\u06FB-\u06FC\u0730-\u074A\u0800-\u0814\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0840-\u0857\u08E4-\u08FE\u0900-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962-\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09D7\u09DF-\u09E0\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2-\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5F-\u0B60\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C01-\u0C03\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62-\u0C63\u0C66-\u0C6F\u0C82\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2-\u0CE3\u0CE6-\u0CEF\u0D02\u0D03\u0D46-\u0D48\u0D57\u0D62-\u0D63\u0D66-\u0D6F\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E34-\u0E3A\u0E40-\u0E45\u0E50-\u0E59\u0EB4-\u0EB9\u0EC8-\u0ECD\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F41-\u0F47\u0F71-\u0F84\u0F86-\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1029\u1040-\u1049\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u170E-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17B2\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1920-\u192B\u1930-\u193B\u1951-\u196D\u19B0-\u19C0\u19C8-\u19C9\u19D0-\u19D9\u1A00-\u1A15\u1A20-\u1A53\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1B46-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C00-\u1C22\u1C40-\u1C49\u1C5B-\u1C7D\u1CD0-\u1CD2\u1D00-\u1DBE\u1E01-\u1F15\u200C\u200D\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2D81-\u2D96\u2DE0-\u2DFF\u3021-\u3028\u3099\u309A\uA640-\uA66D\uA674-\uA67D\uA69F\uA6F0-\uA6F1\uA7F8-\uA800\uA806\uA80B\uA823-\uA827\uA880-\uA881\uA8B4-\uA8C4\uA8D0-\uA8D9\uA8F3-\uA8F7\uA900-\uA909\uA926-\uA92D\uA930-\uA945\uA980-\uA983\uA9B3-\uA9C0\uAA00-\uAA27\uAA40-\uAA41\uAA4C-\uAA4D\uAA50-\uAA59\uAA7B\uAAE0-\uAAE9\uAAF2-\uAAF3\uABC0-\uABE1\uABEC\uABED\uABF0-\uABF9\uFB20-\uFB28\uFE00-\uFE0F\uFE20-\uFE26\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F]"), $1c811abb26f94012$var$nr = /[\n\r\u2028\u2029]/, $1c811abb26f94012$var$ir = /\r\n|[\n\r\u2028\u2029]/g, $1c811abb26f94012$var$or = function(t) {
    return t < 65 ? 36 === t : t < 91 || (t < 97 ? 95 === t : t < 123 || t >= 170 && $1c811abb26f94012$var$er.test(String.fromCharCode(t)));
}, $1c811abb26f94012$var$sr = function(t) {
    return t < 48 ? 36 === t : t < 58 || !(t < 65) && (t < 91 || (t < 97 ? 95 === t : t < 123 || t >= 170 && $1c811abb26f94012$var$rr.test(String.fromCharCode(t))));
};
function $1c811abb26f94012$var$ar() {
    this.line = $1c811abb26f94012$var$Ct, this.column = $1c811abb26f94012$var$Pt - $1c811abb26f94012$var$Nt;
}
function $1c811abb26f94012$var$ur(t, e) {
    $1c811abb26f94012$var$Ot = $1c811abb26f94012$var$Pt, $1c811abb26f94012$var$mt.locations && ($1c811abb26f94012$var$Tt = new $1c811abb26f94012$var$ar), $1c811abb26f94012$var$xt = t, $1c811abb26f94012$var$pr(), $1c811abb26f94012$var$At = e, $1c811abb26f94012$var$Rt = t.beforeExpr;
}
function $1c811abb26f94012$var$cr() {
    var t, e = $1c811abb26f94012$var$mt.onComment && $1c811abb26f94012$var$mt.locations && new $1c811abb26f94012$var$ar, r = $1c811abb26f94012$var$Pt, n = $1c811abb26f94012$var$bt.indexOf("*/", $1c811abb26f94012$var$Pt += 2);
    if (-1 === n && $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Pt - 2, "Unterminated comment"), $1c811abb26f94012$var$Pt = n + 2, $1c811abb26f94012$var$mt.locations) for($1c811abb26f94012$var$ir.lastIndex = r; (t = $1c811abb26f94012$var$ir.exec($1c811abb26f94012$var$bt)) && t.index < $1c811abb26f94012$var$Pt;)++$1c811abb26f94012$var$Ct, $1c811abb26f94012$var$Nt = t.index + t[0].length;
    $1c811abb26f94012$var$mt.onComment && $1c811abb26f94012$var$mt.onComment(!0, $1c811abb26f94012$var$bt.slice(r + 2, n), r, $1c811abb26f94012$var$Pt, e, $1c811abb26f94012$var$mt.locations && new $1c811abb26f94012$var$ar);
}
function $1c811abb26f94012$var$lr() {
    for(var t = $1c811abb26f94012$var$Pt, e = $1c811abb26f94012$var$mt.onComment && $1c811abb26f94012$var$mt.locations && new $1c811abb26f94012$var$ar, r = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt += 2); $1c811abb26f94012$var$Pt < $1c811abb26f94012$var$_t && 10 !== r && 13 !== r && 8232 !== r && 8233 !== r;)++$1c811abb26f94012$var$Pt, r = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt);
    $1c811abb26f94012$var$mt.onComment && $1c811abb26f94012$var$mt.onComment(!1, $1c811abb26f94012$var$bt.slice(t + 2, $1c811abb26f94012$var$Pt), t, $1c811abb26f94012$var$Pt, e, $1c811abb26f94012$var$mt.locations && new $1c811abb26f94012$var$ar);
}
function $1c811abb26f94012$var$pr() {
    for(; $1c811abb26f94012$var$Pt < $1c811abb26f94012$var$_t;){
        var t = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt);
        if (32 === t) ++$1c811abb26f94012$var$Pt;
        else if (13 === t) ++$1c811abb26f94012$var$Pt, 10 === (e = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt)) && ++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$mt.locations && (++$1c811abb26f94012$var$Ct, $1c811abb26f94012$var$Nt = $1c811abb26f94012$var$Pt);
        else if (10 === t || 8232 === t || 8233 === t) ++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$mt.locations && (++$1c811abb26f94012$var$Ct, $1c811abb26f94012$var$Nt = $1c811abb26f94012$var$Pt);
        else if (t > 8 && t < 14) ++$1c811abb26f94012$var$Pt;
        else if (47 === t) {
            var e;
            if (42 === (e = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 1))) $1c811abb26f94012$var$cr();
            else {
                if (47 !== e) break;
                $1c811abb26f94012$var$lr();
            }
        } else if (160 === t) ++$1c811abb26f94012$var$Pt;
        else {
            if (!(t >= 5760 && $1c811abb26f94012$var$Qe.test(String.fromCharCode(t)))) break;
            ++$1c811abb26f94012$var$Pt;
        }
    }
}
function $1c811abb26f94012$var$hr(t) {
    if (t ? $1c811abb26f94012$var$Pt = $1c811abb26f94012$var$Et + 1 : $1c811abb26f94012$var$Et = $1c811abb26f94012$var$Pt, $1c811abb26f94012$var$mt.locations && ($1c811abb26f94012$var$St = new $1c811abb26f94012$var$ar), t) return $1c811abb26f94012$var$fr();
    if ($1c811abb26f94012$var$Pt >= $1c811abb26f94012$var$_t) return $1c811abb26f94012$var$ur($1c811abb26f94012$var$Jt);
    var e = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt);
    if ($1c811abb26f94012$var$or(e) || 92 === e) return $1c811abb26f94012$var$br();
    var r = function(t) {
        switch(t){
            case 46:
                return function() {
                    var t = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 1);
                    return t >= 48 && t <= 57 ? $1c811abb26f94012$var$gr(!0) : (++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$ur($1c811abb26f94012$var$Re));
                }();
            case 40:
                return ++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$ur($1c811abb26f94012$var$Oe);
            case 41:
                return ++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$ur($1c811abb26f94012$var$Se);
            case 59:
                return ++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$ur($1c811abb26f94012$var$xe);
            case 44:
                return ++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$ur($1c811abb26f94012$var$Te);
            case 91:
                return ++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$ur($1c811abb26f94012$var$_e);
            case 93:
                return ++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$ur($1c811abb26f94012$var$we);
            case 123:
                return ++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$ur($1c811abb26f94012$var$Pe);
            case 125:
                return ++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$ur($1c811abb26f94012$var$Ee);
            case 58:
                return ++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$ur($1c811abb26f94012$var$Ae);
            case 63:
                return ++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$ur($1c811abb26f94012$var$Ce);
            case 48:
                var e = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 1);
                if (120 === e || 88 === e) return function() {
                    $1c811abb26f94012$var$Pt += 2;
                    var t = $1c811abb26f94012$var$yr(16);
                    return null == t && $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Et + 2, "Expected hexadecimal number"), $1c811abb26f94012$var$or($1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt)) && $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Pt, "Identifier directly after number"), $1c811abb26f94012$var$ur($1c811abb26f94012$var$qt, t);
                }();
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                return $1c811abb26f94012$var$gr(!1);
            case 34:
            case 39:
                return function(t) {
                    $1c811abb26f94012$var$Pt++;
                    for(var e = "";;){
                        $1c811abb26f94012$var$Pt >= $1c811abb26f94012$var$_t && $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Et, "Unterminated string constant");
                        var r = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt);
                        if (r === t) return ++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$ur($1c811abb26f94012$var$Yt, e);
                        if (92 === r) {
                            r = $1c811abb26f94012$var$bt.charCodeAt(++$1c811abb26f94012$var$Pt);
                            var n = /^[0-7]+/.exec($1c811abb26f94012$var$bt.slice($1c811abb26f94012$var$Pt, $1c811abb26f94012$var$Pt + 3));
                            for(n && (n = n[0]); n && parseInt(n, 8) > 255;)n = n.slice(0, -1);
                            if ("0" === n && (n = null), ++$1c811abb26f94012$var$Pt, n) $1c811abb26f94012$var$Lt && $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Pt - 2, "Octal literal in strict mode"), e += String.fromCharCode(parseInt(n, 8)), $1c811abb26f94012$var$Pt += n.length - 1;
                            else switch(r){
                                case 110:
                                    e += "\n";
                                    break;
                                case 114:
                                    e += "\r";
                                    break;
                                case 120:
                                    e += String.fromCharCode($1c811abb26f94012$var$vr(2));
                                    break;
                                case 117:
                                    e += String.fromCharCode($1c811abb26f94012$var$vr(4));
                                    break;
                                case 85:
                                    e += String.fromCharCode($1c811abb26f94012$var$vr(8));
                                    break;
                                case 116:
                                    e += "\t";
                                    break;
                                case 98:
                                    e += "\b";
                                    break;
                                case 118:
                                    e += "\v";
                                    break;
                                case 102:
                                    e += "\f";
                                    break;
                                case 48:
                                    e += "\0";
                                    break;
                                case 13:
                                    10 === $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt) && ++$1c811abb26f94012$var$Pt;
                                case 10:
                                    $1c811abb26f94012$var$mt.locations && ($1c811abb26f94012$var$Nt = $1c811abb26f94012$var$Pt, ++$1c811abb26f94012$var$Ct);
                                    break;
                                default:
                                    e += String.fromCharCode(r);
                            }
                        } else 13 !== r && 10 !== r && 8232 !== r && 8233 !== r || $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Et, "Unterminated string constant"), e += String.fromCharCode(r), ++$1c811abb26f94012$var$Pt;
                    }
                }(t);
            case 47:
                return function(t) {
                    var e = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 1);
                    return $1c811abb26f94012$var$Rt ? (++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$fr()) : 61 === e ? $1c811abb26f94012$var$dr($1c811abb26f94012$var$je, 2) : $1c811abb26f94012$var$dr($1c811abb26f94012$var$Ne, 1);
                }();
            case 37:
            case 42:
                return 61 === $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 1) ? $1c811abb26f94012$var$dr($1c811abb26f94012$var$je, 2) : $1c811abb26f94012$var$dr($1c811abb26f94012$var$Ye, 1);
            case 124:
            case 38:
                return function(t) {
                    var e = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 1);
                    return e === t ? $1c811abb26f94012$var$dr(124 === t ? $1c811abb26f94012$var$Fe : $1c811abb26f94012$var$Le, 2) : 61 === e ? $1c811abb26f94012$var$dr($1c811abb26f94012$var$je, 2) : $1c811abb26f94012$var$dr(124 === t ? $1c811abb26f94012$var$De : $1c811abb26f94012$var$Be, 1);
                }(t);
            case 94:
                return 61 === $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 1) ? $1c811abb26f94012$var$dr($1c811abb26f94012$var$je, 2) : $1c811abb26f94012$var$dr($1c811abb26f94012$var$Me, 1);
            case 43:
            case 45:
                return function(t) {
                    var e = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 1);
                    return e === t ? 45 == e && 62 == $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 2) && $1c811abb26f94012$var$nr.test($1c811abb26f94012$var$bt.slice($1c811abb26f94012$var$jt, $1c811abb26f94012$var$Pt)) ? ($1c811abb26f94012$var$Pt += 3, $1c811abb26f94012$var$lr(), $1c811abb26f94012$var$pr(), $1c811abb26f94012$var$hr()) : $1c811abb26f94012$var$dr($1c811abb26f94012$var$Ie, 2) : 61 === e ? $1c811abb26f94012$var$dr($1c811abb26f94012$var$je, 2) : $1c811abb26f94012$var$dr($1c811abb26f94012$var$We, 1);
                }(t);
            case 60:
            case 62:
                return function(t) {
                    var e = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 1), r = 1;
                    return e === t ? (r = 62 === t && 62 === $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 2) ? 3 : 2, 61 === $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + r) ? $1c811abb26f94012$var$dr($1c811abb26f94012$var$je, r + 1) : $1c811abb26f94012$var$dr($1c811abb26f94012$var$qe, r)) : 33 == e && 60 == t && 45 == $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 2) && 45 == $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 3) ? ($1c811abb26f94012$var$Pt += 4, $1c811abb26f94012$var$lr(), $1c811abb26f94012$var$pr(), $1c811abb26f94012$var$hr()) : (61 === e && (r = 61 === $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 2) ? 3 : 2), $1c811abb26f94012$var$dr($1c811abb26f94012$var$Ge, r));
                }(t);
            case 61:
            case 33:
                return function(t) {
                    return 61 === $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 1) ? $1c811abb26f94012$var$dr($1c811abb26f94012$var$Ve, 61 === $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt + 2) ? 3 : 2) : $1c811abb26f94012$var$dr(61 === t ? $1c811abb26f94012$var$ke : $1c811abb26f94012$var$Ue, 1);
                }(t);
            case 126:
                return $1c811abb26f94012$var$dr($1c811abb26f94012$var$Ue, 1);
        }
        return !1;
    }(e);
    if (!1 === r) {
        var n = String.fromCharCode(e);
        if ("\\" === n || $1c811abb26f94012$var$er.test(n)) return $1c811abb26f94012$var$br();
        $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Pt, "Unexpected character '" + n + "'");
    }
    return r;
}
function $1c811abb26f94012$var$dr(t, e) {
    var r = $1c811abb26f94012$var$bt.slice($1c811abb26f94012$var$Pt, $1c811abb26f94012$var$Pt + e);
    $1c811abb26f94012$var$Pt += e, $1c811abb26f94012$var$ur(t, r);
}
function $1c811abb26f94012$var$fr() {
    for(var t, e, r = $1c811abb26f94012$var$Pt;;){
        $1c811abb26f94012$var$Pt >= $1c811abb26f94012$var$_t && $1c811abb26f94012$var$Vt(r, "Unterminated regular expression");
        var n = $1c811abb26f94012$var$bt.charAt($1c811abb26f94012$var$Pt);
        if ($1c811abb26f94012$var$nr.test(n) && $1c811abb26f94012$var$Vt(r, "Unterminated regular expression"), t) t = !1;
        else {
            if ("[" === n) e = !0;
            else if ("]" === n && e) e = !1;
            else if ("/" === n && !e) break;
            t = "\\" === n;
        }
        ++$1c811abb26f94012$var$Pt;
    }
    var i = $1c811abb26f94012$var$bt.slice(r, $1c811abb26f94012$var$Pt);
    ++$1c811abb26f94012$var$Pt;
    var o = $1c811abb26f94012$var$mr();
    return o && !/^[gmsiy]*$/.test(o) && $1c811abb26f94012$var$Vt(r, "Invalid regexp flag"), $1c811abb26f94012$var$ur($1c811abb26f94012$var$Wt, new RegExp(i, o));
}
function $1c811abb26f94012$var$yr(t, e) {
    for(var r = $1c811abb26f94012$var$Pt, n = 0, i = 0, o = null == e ? 1 / 0 : e; i < o; ++i){
        var s, a = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt);
        if ((s = a >= 97 ? a - 97 + 10 : a >= 65 ? a - 65 + 10 : a >= 48 && a <= 57 ? a - 48 : 1 / 0) >= t) break;
        ++$1c811abb26f94012$var$Pt, n = n * t + s;
    }
    return $1c811abb26f94012$var$Pt === r || null != e && $1c811abb26f94012$var$Pt - r !== e ? null : n;
}
function $1c811abb26f94012$var$gr(t) {
    var e = $1c811abb26f94012$var$Pt, r = !1, n = 48 === $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt);
    t || null !== $1c811abb26f94012$var$yr(10) || $1c811abb26f94012$var$Vt(e, "Invalid number"), 46 === $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt) && (++$1c811abb26f94012$var$Pt, $1c811abb26f94012$var$yr(10), r = !0);
    var i = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt);
    69 !== i && 101 !== i || (43 !== (i = $1c811abb26f94012$var$bt.charCodeAt(++$1c811abb26f94012$var$Pt)) && 45 !== i || ++$1c811abb26f94012$var$Pt, null === $1c811abb26f94012$var$yr(10) && $1c811abb26f94012$var$Vt(e, "Invalid number"), r = !0), $1c811abb26f94012$var$or($1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt)) && $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Pt, "Identifier directly after number");
    var o, s = $1c811abb26f94012$var$bt.slice(e, $1c811abb26f94012$var$Pt);
    return r ? o = parseFloat(s) : n && 1 !== s.length ? /[89]/.test(s) || $1c811abb26f94012$var$Lt ? $1c811abb26f94012$var$Vt(e, "Invalid number") : o = parseInt(s, 8) : o = parseInt(s, 10), $1c811abb26f94012$var$ur($1c811abb26f94012$var$qt, o);
}
function $1c811abb26f94012$var$vr(t) {
    var e = $1c811abb26f94012$var$yr(16, t);
    return null === e && $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Et, "Bad character escape sequence"), e;
}
function $1c811abb26f94012$var$mr() {
    $1c811abb26f94012$var$Je = !1;
    for(var t, e = !0, r = $1c811abb26f94012$var$Pt;;){
        var n = $1c811abb26f94012$var$bt.charCodeAt($1c811abb26f94012$var$Pt);
        if ($1c811abb26f94012$var$sr(n)) $1c811abb26f94012$var$Je && (t += $1c811abb26f94012$var$bt.charAt($1c811abb26f94012$var$Pt)), ++$1c811abb26f94012$var$Pt;
        else {
            if (92 !== n) break;
            $1c811abb26f94012$var$Je || (t = $1c811abb26f94012$var$bt.slice(r, $1c811abb26f94012$var$Pt)), $1c811abb26f94012$var$Je = !0, 117 != $1c811abb26f94012$var$bt.charCodeAt(++$1c811abb26f94012$var$Pt) && $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Pt, "Expecting Unicode escape sequence \\uXXXX"), ++$1c811abb26f94012$var$Pt;
            var i = $1c811abb26f94012$var$vr(4), o = String.fromCharCode(i);
            o || $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Pt - 1, "Invalid Unicode escape"), (e ? $1c811abb26f94012$var$or(i) : $1c811abb26f94012$var$sr(i)) || $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Pt - 4, "Invalid Unicode escape"), t += o;
        }
        e = !1;
    }
    return $1c811abb26f94012$var$Je ? t : $1c811abb26f94012$var$bt.slice(r, $1c811abb26f94012$var$Pt);
}
function $1c811abb26f94012$var$br() {
    var t = $1c811abb26f94012$var$mr(), e = $1c811abb26f94012$var$zt;
    return $1c811abb26f94012$var$Je || ($1c811abb26f94012$var$Ke(t) ? e = $1c811abb26f94012$var$be[t] : ($1c811abb26f94012$var$mt.forbidReserved && (3 === $1c811abb26f94012$var$mt.ecmaVersion ? $1c811abb26f94012$var$He : $1c811abb26f94012$var$Xe)(t) || $1c811abb26f94012$var$Lt && $1c811abb26f94012$var$Ze(t)) && $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Et, "The keyword '" + t + "' is reserved")), $1c811abb26f94012$var$ur(e, t);
}
function $1c811abb26f94012$var$_r() {
    $1c811abb26f94012$var$kt = $1c811abb26f94012$var$Et, $1c811abb26f94012$var$jt = $1c811abb26f94012$var$Ot, $1c811abb26f94012$var$It = $1c811abb26f94012$var$Tt, $1c811abb26f94012$var$hr();
}
function $1c811abb26f94012$var$wr(t) {
    if ($1c811abb26f94012$var$Lt = t, $1c811abb26f94012$var$Pt = $1c811abb26f94012$var$jt, $1c811abb26f94012$var$mt.locations) for(; $1c811abb26f94012$var$Pt < $1c811abb26f94012$var$Nt;)$1c811abb26f94012$var$Nt = $1c811abb26f94012$var$bt.lastIndexOf("\n", $1c811abb26f94012$var$Nt - 2) + 1, --$1c811abb26f94012$var$Ct;
    $1c811abb26f94012$var$pr(), $1c811abb26f94012$var$hr();
}
function $1c811abb26f94012$var$Pr() {
    this.type = null, this.start = $1c811abb26f94012$var$Et, this.end = null;
}
function $1c811abb26f94012$var$Er() {
    this.start = $1c811abb26f94012$var$St, this.end = null, null !== $1c811abb26f94012$var$wt && (this.source = $1c811abb26f94012$var$wt);
}
function $1c811abb26f94012$var$Or() {
    var t = new $1c811abb26f94012$var$Pr;
    return $1c811abb26f94012$var$mt.locations && (t.loc = new $1c811abb26f94012$var$Er), $1c811abb26f94012$var$mt.directSourceFile && (t.sourceFile = $1c811abb26f94012$var$mt.directSourceFile), $1c811abb26f94012$var$mt.ranges && (t.range = [
        $1c811abb26f94012$var$Et,
        0
    ]), t;
}
function $1c811abb26f94012$var$Sr(t) {
    var e = new $1c811abb26f94012$var$Pr;
    return e.start = t.start, $1c811abb26f94012$var$mt.locations && (e.loc = new $1c811abb26f94012$var$Er, e.loc.start = t.loc.start), $1c811abb26f94012$var$mt.ranges && (e.range = [
        t.range[0],
        0
    ]), e;
}
function $1c811abb26f94012$var$Tr(t, e) {
    return t.type = e, t.end = $1c811abb26f94012$var$jt, $1c811abb26f94012$var$mt.locations && (t.loc.end = $1c811abb26f94012$var$It), $1c811abb26f94012$var$mt.ranges && (t.range[1] = $1c811abb26f94012$var$jt), t;
}
function $1c811abb26f94012$var$xr(t) {
    return $1c811abb26f94012$var$mt.ecmaVersion >= 5 && "ExpressionStatement" === t.type && "Literal" === t.expression.type && "use strict" === t.expression.value;
}
function $1c811abb26f94012$var$Ar(t) {
    if ($1c811abb26f94012$var$xt === t) return $1c811abb26f94012$var$_r(), !0;
}
function $1c811abb26f94012$var$Rr() {
    return !$1c811abb26f94012$var$mt.strictSemicolons && ($1c811abb26f94012$var$xt === $1c811abb26f94012$var$Jt || $1c811abb26f94012$var$xt === $1c811abb26f94012$var$Ee || $1c811abb26f94012$var$nr.test($1c811abb26f94012$var$bt.slice($1c811abb26f94012$var$jt, $1c811abb26f94012$var$Et)));
}
function $1c811abb26f94012$var$Cr() {
    $1c811abb26f94012$var$Ar($1c811abb26f94012$var$xe) || $1c811abb26f94012$var$Rr() || $1c811abb26f94012$var$kr();
}
function $1c811abb26f94012$var$Nr(t) {
    $1c811abb26f94012$var$xt === t ? $1c811abb26f94012$var$_r() : $1c811abb26f94012$var$kr();
}
function $1c811abb26f94012$var$kr() {
    $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Et, "Unexpected token");
}
function $1c811abb26f94012$var$jr(t) {
    "Identifier" !== t.type && "MemberExpression" !== t.type && $1c811abb26f94012$var$Vt(t.start, "Assigning to rvalue"), $1c811abb26f94012$var$Lt && "Identifier" === t.type && $1c811abb26f94012$var$$e(t.name) && $1c811abb26f94012$var$Vt(t.start, "Assigning to " + t.name + " in strict mode");
}
var $1c811abb26f94012$var$Ir = {
    kind: "loop"
}, $1c811abb26f94012$var$Ur = {
    kind: "switch"
};
function $1c811abb26f94012$var$Fr() {
    ($1c811abb26f94012$var$xt === $1c811abb26f94012$var$Ne || $1c811abb26f94012$var$xt === $1c811abb26f94012$var$je && "/=" == $1c811abb26f94012$var$At) && $1c811abb26f94012$var$hr(!0);
    var t = $1c811abb26f94012$var$xt, e = $1c811abb26f94012$var$Or();
    switch(t){
        case $1c811abb26f94012$var$Ht:
        case $1c811abb26f94012$var$$t:
            $1c811abb26f94012$var$_r();
            var r = t === $1c811abb26f94012$var$Ht;
            $1c811abb26f94012$var$Ar($1c811abb26f94012$var$xe) || $1c811abb26f94012$var$Rr() ? e.label = null : $1c811abb26f94012$var$xt !== $1c811abb26f94012$var$zt ? $1c811abb26f94012$var$kr() : (e.label = $1c811abb26f94012$var$$r(), $1c811abb26f94012$var$Cr());
            for(var n = 0; n < $1c811abb26f94012$var$Ft.length; ++n){
                var i = $1c811abb26f94012$var$Ft[n];
                if (null == e.label || i.name === e.label.name) {
                    if (null != i.kind && (r || "loop" === i.kind)) break;
                    if (e.label && r) break;
                }
            }
            return n === $1c811abb26f94012$var$Ft.length && $1c811abb26f94012$var$Vt(e.start, "Unsyntactic " + t.keyword), $1c811abb26f94012$var$Tr(e, r ? "BreakStatement" : "ContinueStatement");
        case $1c811abb26f94012$var$Kt:
            return $1c811abb26f94012$var$_r(), $1c811abb26f94012$var$Cr(), $1c811abb26f94012$var$Tr(e, "DebuggerStatement");
        case $1c811abb26f94012$var$te:
            return $1c811abb26f94012$var$_r(), $1c811abb26f94012$var$Ft.push($1c811abb26f94012$var$Ir), e.body = $1c811abb26f94012$var$Fr(), $1c811abb26f94012$var$Ft.pop(), $1c811abb26f94012$var$Nr($1c811abb26f94012$var$pe), e.test = $1c811abb26f94012$var$Lr(), $1c811abb26f94012$var$Cr(), $1c811abb26f94012$var$Tr(e, "DoWhileStatement");
        case $1c811abb26f94012$var$ne:
            if ($1c811abb26f94012$var$_r(), $1c811abb26f94012$var$Ft.push($1c811abb26f94012$var$Ir), $1c811abb26f94012$var$Nr($1c811abb26f94012$var$Oe), $1c811abb26f94012$var$xt === $1c811abb26f94012$var$xe) return $1c811abb26f94012$var$Mr(e, null);
            if ($1c811abb26f94012$var$xt === $1c811abb26f94012$var$le) {
                var o = $1c811abb26f94012$var$Or();
                return $1c811abb26f94012$var$_r(), $1c811abb26f94012$var$Vr(o, !0), $1c811abb26f94012$var$Tr(o, "VariableDeclaration"), 1 === o.declarations.length && $1c811abb26f94012$var$Ar($1c811abb26f94012$var$me) ? $1c811abb26f94012$var$Br(e, o) : $1c811abb26f94012$var$Mr(e, o);
            }
            return o = $1c811abb26f94012$var$Gr(!1, !0), $1c811abb26f94012$var$Ar($1c811abb26f94012$var$me) ? ($1c811abb26f94012$var$jr(o), $1c811abb26f94012$var$Br(e, o)) : $1c811abb26f94012$var$Mr(e, o);
        case $1c811abb26f94012$var$ie:
            return $1c811abb26f94012$var$_r(), $1c811abb26f94012$var$Xr(e, !0);
        case $1c811abb26f94012$var$oe:
            return $1c811abb26f94012$var$_r(), e.test = $1c811abb26f94012$var$Lr(), e.consequent = $1c811abb26f94012$var$Fr(), e.alternate = $1c811abb26f94012$var$Ar($1c811abb26f94012$var$ee) ? $1c811abb26f94012$var$Fr() : null, $1c811abb26f94012$var$Tr(e, "IfStatement");
        case $1c811abb26f94012$var$se:
            return $1c811abb26f94012$var$Ut || $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Et, "'return' outside of function"), $1c811abb26f94012$var$_r(), $1c811abb26f94012$var$Ar($1c811abb26f94012$var$xe) || $1c811abb26f94012$var$Rr() ? e.argument = null : (e.argument = $1c811abb26f94012$var$Gr(), $1c811abb26f94012$var$Cr()), $1c811abb26f94012$var$Tr(e, "ReturnStatement");
        case $1c811abb26f94012$var$ae:
            $1c811abb26f94012$var$_r(), e.discriminant = $1c811abb26f94012$var$Lr(), e.cases = [], $1c811abb26f94012$var$Nr($1c811abb26f94012$var$Pe), $1c811abb26f94012$var$Ft.push($1c811abb26f94012$var$Ur);
            for(var s, a; $1c811abb26f94012$var$xt != $1c811abb26f94012$var$Ee;)if ($1c811abb26f94012$var$xt === $1c811abb26f94012$var$Xt || $1c811abb26f94012$var$xt === $1c811abb26f94012$var$Qt) {
                var u = $1c811abb26f94012$var$xt === $1c811abb26f94012$var$Xt;
                s && $1c811abb26f94012$var$Tr(s, "SwitchCase"), e.cases.push(s = $1c811abb26f94012$var$Or()), s.consequent = [], $1c811abb26f94012$var$_r(), u ? s.test = $1c811abb26f94012$var$Gr() : (a && $1c811abb26f94012$var$Vt($1c811abb26f94012$var$kt, "Multiple default clauses"), a = !0, s.test = null), $1c811abb26f94012$var$Nr($1c811abb26f94012$var$Ae);
            } else s || $1c811abb26f94012$var$kr(), s.consequent.push($1c811abb26f94012$var$Fr());
            return s && $1c811abb26f94012$var$Tr(s, "SwitchCase"), $1c811abb26f94012$var$_r(), $1c811abb26f94012$var$Ft.pop(), $1c811abb26f94012$var$Tr(e, "SwitchStatement");
        case $1c811abb26f94012$var$ue:
            return $1c811abb26f94012$var$_r(), $1c811abb26f94012$var$nr.test($1c811abb26f94012$var$bt.slice($1c811abb26f94012$var$jt, $1c811abb26f94012$var$Et)) && $1c811abb26f94012$var$Vt($1c811abb26f94012$var$jt, "Illegal newline after throw"), e.argument = $1c811abb26f94012$var$Gr(), $1c811abb26f94012$var$Cr(), $1c811abb26f94012$var$Tr(e, "ThrowStatement");
        case $1c811abb26f94012$var$ce:
            if ($1c811abb26f94012$var$_r(), e.block = $1c811abb26f94012$var$Dr(), e.handler = null, $1c811abb26f94012$var$xt === $1c811abb26f94012$var$Zt) {
                var c = $1c811abb26f94012$var$Or();
                $1c811abb26f94012$var$_r(), $1c811abb26f94012$var$Nr($1c811abb26f94012$var$Oe), c.param = $1c811abb26f94012$var$$r(), $1c811abb26f94012$var$Lt && $1c811abb26f94012$var$$e(c.param.name) && $1c811abb26f94012$var$Vt(c.param.start, "Binding " + c.param.name + " in strict mode"), $1c811abb26f94012$var$Nr($1c811abb26f94012$var$Se), c.guard = null, c.body = $1c811abb26f94012$var$Dr(), e.handler = $1c811abb26f94012$var$Tr(c, "CatchClause");
            }
            return e.guardedHandlers = $1c811abb26f94012$var$Gt, e.finalizer = $1c811abb26f94012$var$Ar($1c811abb26f94012$var$re) ? $1c811abb26f94012$var$Dr() : null, e.handler || e.finalizer || $1c811abb26f94012$var$Vt(e.start, "Missing catch or finally clause"), $1c811abb26f94012$var$Tr(e, "TryStatement");
        case $1c811abb26f94012$var$le:
            return $1c811abb26f94012$var$_r(), $1c811abb26f94012$var$Vr(e), $1c811abb26f94012$var$Cr(), $1c811abb26f94012$var$Tr(e, "VariableDeclaration");
        case $1c811abb26f94012$var$pe:
            return $1c811abb26f94012$var$_r(), e.test = $1c811abb26f94012$var$Lr(), $1c811abb26f94012$var$Ft.push($1c811abb26f94012$var$Ir), e.body = $1c811abb26f94012$var$Fr(), $1c811abb26f94012$var$Ft.pop(), $1c811abb26f94012$var$Tr(e, "WhileStatement");
        case $1c811abb26f94012$var$he:
            return $1c811abb26f94012$var$Lt && $1c811abb26f94012$var$Vt($1c811abb26f94012$var$Et, "'with' in strict mode"), $1c811abb26f94012$var$_r(), e.object = $1c811abb26f94012$var$Lr(), e.body = $1c811abb26f94012$var$Fr(), $1c811abb26f94012$var$Tr(e, "WithStatement");
        case $1c811abb26f94012$var$Pe:
            return $1c811abb26f94012$var$Dr();
        case $1c811abb26f94012$var$xe:
            return $1c811abb26f94012$var$_r(), $1c811abb26f94012$var$Tr(e, "EmptyStatement");
        default:
            var l = $1c811abb26f94012$var$At, p = $1c811abb26f94012$var$Gr();
            if (t === $1c811abb26f94012$var$zt && "Identifier" === p.type && $1c811abb26f94012$var$Ar($1c811abb26f94012$var$Ae)) {
                for(n = 0; n < $1c811abb26f94012$var$Ft.length; ++n)$1c811abb26f94012$var$Ft[n].name === l && $1c811abb26f94012$var$Vt(p.start, "Label '" + l + "' is already declared");
                var h = $1c811abb26f94012$var$xt.isLoop ? "loop" : $1c811abb26f94012$var$xt === $1c811abb26f94012$var$ae ? "switch" : null;
                return $1c811abb26f94012$var$Ft.push({
                    name: l,
                    kind: h
                }), e.body = $1c811abb26f94012$var$Fr(), $1c811abb26f94012$var$Ft.pop(), e.label = p, $1c811abb26f94012$var$Tr(e, "LabeledStatement");
            }
            return e.expression = p, $1c811abb26f94012$var$Cr(), $1c811abb26f94012$var$Tr(e, "ExpressionStatement");
    }
}
function $1c811abb26f94012$var$Lr() {
    $1c811abb26f94012$var$Nr($1c811abb26f94012$var$Oe);
    var t = $1c811abb26f94012$var$Gr();
    return $1c811abb26f94012$var$Nr($1c811abb26f94012$var$Se), t;
}
function $1c811abb26f94012$var$Dr(t) {
    var e, r = $1c811abb26f94012$var$Or(), n = !0, i = !1;
    for(r.body = [], $1c811abb26f94012$var$Nr($1c811abb26f94012$var$Pe); !$1c811abb26f94012$var$Ar($1c811abb26f94012$var$Ee);){
        var o = $1c811abb26f94012$var$Fr();
        r.body.push(o), n && t && $1c811abb26f94012$var$xr(o) && (e = i, $1c811abb26f94012$var$wr(i = !0)), n = !1;
    }
    return i && !e && $1c811abb26f94012$var$wr(!1), $1c811abb26f94012$var$Tr(r, "BlockStatement");
}
function $1c811abb26f94012$var$Mr(t, e) {
    return t.init = e, $1c811abb26f94012$var$Nr($1c811abb26f94012$var$xe), t.test = $1c811abb26f94012$var$xt === $1c811abb26f94012$var$xe ? null : $1c811abb26f94012$var$Gr(), $1c811abb26f94012$var$Nr($1c811abb26f94012$var$xe), t.update = $1c811abb26f94012$var$xt === $1c811abb26f94012$var$Se ? null : $1c811abb26f94012$var$Gr(), $1c811abb26f94012$var$Nr($1c811abb26f94012$var$Se), t.body = $1c811abb26f94012$var$Fr(), $1c811abb26f94012$var$Ft.pop(), $1c811abb26f94012$var$Tr(t, "ForStatement");
}
function $1c811abb26f94012$var$Br(t, e) {
    return t.left = e, t.right = $1c811abb26f94012$var$Gr(), $1c811abb26f94012$var$Nr($1c811abb26f94012$var$Se), t.body = $1c811abb26f94012$var$Fr(), $1c811abb26f94012$var$Ft.pop(), $1c811abb26f94012$var$Tr(t, "ForInStatement");
}
function $1c811abb26f94012$var$Vr(t, e) {
    for(t.declarations = [], t.kind = "var";;){
        var r = $1c811abb26f94012$var$Or();
        if (r.id = $1c811abb26f94012$var$$r(), $1c811abb26f94012$var$Lt && $1c811abb26f94012$var$$e(r.id.name) && $1c811abb26f94012$var$Vt(r.id.start, "Binding " + r.id.name + " in strict mode"), r.init = $1c811abb26f94012$var$Ar($1c811abb26f94012$var$ke) ? $1c811abb26f94012$var$Gr(!0, e) : null, t.declarations.push($1c811abb26f94012$var$Tr(r, "VariableDeclarator")), !$1c811abb26f94012$var$Ar($1c811abb26f94012$var$Te)) break;
    }
    return t;
}
function $1c811abb26f94012$var$Gr(t, e) {
    var r = $1c811abb26f94012$var$qr(e);
    if (!t && $1c811abb26f94012$var$xt === $1c811abb26f94012$var$Te) {
        var n = $1c811abb26f94012$var$Sr(r);
        for(n.expressions = [
            r
        ]; $1c811abb26f94012$var$Ar($1c811abb26f94012$var$Te);)n.expressions.push($1c811abb26f94012$var$qr(e));
        return $1c811abb26f94012$var$Tr(n, "SequenceExpression");
    }
    return r;
}
function $1c811abb26f94012$var$qr(t) {
    var e = function(t) {
        var e = function(t) {
            return $1c811abb26f94012$var$Wr($1c811abb26f94012$var$Yr(), -1, t);
        }(t);
        if ($1c811abb26f94012$var$Ar($1c811abb26f94012$var$Ce)) {
            var r = $1c811abb26f94012$var$Sr(e);
            return r.test = e, r.consequent = $1c811abb26f94012$var$Gr(!0), $1c811abb26f94012$var$Nr($1c811abb26f94012$var$Ae), r.alternate = $1c811abb26f94012$var$Gr(!0, t), $1c811abb26f94012$var$Tr(r, "ConditionalExpression");
        }
        return e;
    }(t);
    if ($1c811abb26f94012$var$xt.isAssign) {
        var r = $1c811abb26f94012$var$Sr(e);
        return r.operator = $1c811abb26f94012$var$At, r.left = e, $1c811abb26f94012$var$_r(), r.right = $1c811abb26f94012$var$qr(t), $1c811abb26f94012$var$jr(e), $1c811abb26f94012$var$Tr(r, "AssignmentExpression");
    }
    return e;
}
function $1c811abb26f94012$var$Wr(t, e, r) {
    var n = $1c811abb26f94012$var$xt.binop;
    if (null != n && (!r || $1c811abb26f94012$var$xt !== $1c811abb26f94012$var$me) && n > e) {
        var i = $1c811abb26f94012$var$Sr(t);
        i.left = t, i.operator = $1c811abb26f94012$var$At;
        var o = $1c811abb26f94012$var$xt;
        return $1c811abb26f94012$var$_r(), i.right = $1c811abb26f94012$var$Wr($1c811abb26f94012$var$Yr(), n, r), $1c811abb26f94012$var$Wr($1c811abb26f94012$var$Tr(i, o === $1c811abb26f94012$var$Fe || o === $1c811abb26f94012$var$Le ? "LogicalExpression" : "BinaryExpression"), e, r);
    }
    return t;
}
function $1c811abb26f94012$var$Yr() {
    if ($1c811abb26f94012$var$xt.prefix) {
        var t = $1c811abb26f94012$var$Or(), e = $1c811abb26f94012$var$xt.isUpdate;
        return t.operator = $1c811abb26f94012$var$At, t.prefix = !0, $1c811abb26f94012$var$Rt = !0, $1c811abb26f94012$var$_r(), t.argument = $1c811abb26f94012$var$Yr(), e ? $1c811abb26f94012$var$jr(t.argument) : $1c811abb26f94012$var$Lt && "delete" === t.operator && "Identifier" === t.argument.type && $1c811abb26f94012$var$Vt(t.start, "Deleting local variable in strict mode"), $1c811abb26f94012$var$Tr(t, e ? "UpdateExpression" : "UnaryExpression");
    }
    for(var r = $1c811abb26f94012$var$zr($1c811abb26f94012$var$Jr()); $1c811abb26f94012$var$xt.postfix && !$1c811abb26f94012$var$Rr();)(t = $1c811abb26f94012$var$Sr(r)).operator = $1c811abb26f94012$var$At, t.prefix = !1, t.argument = r, $1c811abb26f94012$var$jr(r), $1c811abb26f94012$var$_r(), r = $1c811abb26f94012$var$Tr(t, "UpdateExpression");
    return r;
}
function $1c811abb26f94012$var$zr(t, e) {
    var r;
    return $1c811abb26f94012$var$Ar($1c811abb26f94012$var$Re) ? ((r = $1c811abb26f94012$var$Sr(t)).object = t, r.property = $1c811abb26f94012$var$$r(!0), r.computed = !1, $1c811abb26f94012$var$zr($1c811abb26f94012$var$Tr(r, "MemberExpression"), e)) : $1c811abb26f94012$var$Ar($1c811abb26f94012$var$_e) ? ((r = $1c811abb26f94012$var$Sr(t)).object = t, r.property = $1c811abb26f94012$var$Gr(), r.computed = !0, $1c811abb26f94012$var$Nr($1c811abb26f94012$var$we), $1c811abb26f94012$var$zr($1c811abb26f94012$var$Tr(r, "MemberExpression"), e)) : !e && $1c811abb26f94012$var$Ar($1c811abb26f94012$var$Oe) ? ((r = $1c811abb26f94012$var$Sr(t)).callee = t, r.arguments = $1c811abb26f94012$var$Zr($1c811abb26f94012$var$Se, !1), $1c811abb26f94012$var$zr($1c811abb26f94012$var$Tr(r, "CallExpression"), e)) : t;
}
function $1c811abb26f94012$var$Jr() {
    switch($1c811abb26f94012$var$xt){
        case $1c811abb26f94012$var$fe:
            var t = $1c811abb26f94012$var$Or();
            return $1c811abb26f94012$var$_r(), $1c811abb26f94012$var$Tr(t, "ThisExpression");
        case $1c811abb26f94012$var$zt:
            return $1c811abb26f94012$var$$r();
        case $1c811abb26f94012$var$qt:
        case $1c811abb26f94012$var$Yt:
        case $1c811abb26f94012$var$Wt:
            return (t = $1c811abb26f94012$var$Or()).value = $1c811abb26f94012$var$At, t.raw = $1c811abb26f94012$var$bt.slice($1c811abb26f94012$var$Et, $1c811abb26f94012$var$Ot), $1c811abb26f94012$var$_r(), $1c811abb26f94012$var$Tr(t, "Literal");
        case $1c811abb26f94012$var$ye:
        case $1c811abb26f94012$var$ge:
        case $1c811abb26f94012$var$ve:
            return (t = $1c811abb26f94012$var$Or()).value = $1c811abb26f94012$var$xt.atomValue, t.raw = $1c811abb26f94012$var$xt.keyword, $1c811abb26f94012$var$_r(), $1c811abb26f94012$var$Tr(t, "Literal");
        case $1c811abb26f94012$var$Oe:
            var e = $1c811abb26f94012$var$St, r = $1c811abb26f94012$var$Et;
            $1c811abb26f94012$var$_r();
            var n = $1c811abb26f94012$var$Gr();
            return n.start = r, n.end = $1c811abb26f94012$var$Ot, $1c811abb26f94012$var$mt.locations && (n.loc.start = e, n.loc.end = $1c811abb26f94012$var$Tt), $1c811abb26f94012$var$mt.ranges && (n.range = [
                r,
                $1c811abb26f94012$var$Ot
            ]), $1c811abb26f94012$var$Nr($1c811abb26f94012$var$Se), n;
        case $1c811abb26f94012$var$_e:
            return t = $1c811abb26f94012$var$Or(), $1c811abb26f94012$var$_r(), t.elements = $1c811abb26f94012$var$Zr($1c811abb26f94012$var$we, !0, !0), $1c811abb26f94012$var$Tr(t, "ArrayExpression");
        case $1c811abb26f94012$var$Pe:
            return function() {
                var t = $1c811abb26f94012$var$Or(), e = !0, r = !1;
                for(t.properties = [], $1c811abb26f94012$var$_r(); !$1c811abb26f94012$var$Ar($1c811abb26f94012$var$Ee);){
                    if (e) e = !1;
                    else if ($1c811abb26f94012$var$Nr($1c811abb26f94012$var$Te), $1c811abb26f94012$var$mt.allowTrailingCommas && $1c811abb26f94012$var$Ar($1c811abb26f94012$var$Ee)) break;
                    var n, i = {
                        key: $1c811abb26f94012$var$Hr()
                    }, o = !1;
                    if ($1c811abb26f94012$var$Ar($1c811abb26f94012$var$Ae) ? (i.value = $1c811abb26f94012$var$Gr(!0), n = i.kind = "init") : $1c811abb26f94012$var$mt.ecmaVersion >= 5 && "Identifier" === i.key.type && ("get" === i.key.name || "set" === i.key.name) ? (o = r = !0, n = i.kind = i.key.name, i.key = $1c811abb26f94012$var$Hr(), $1c811abb26f94012$var$xt !== $1c811abb26f94012$var$Oe && $1c811abb26f94012$var$kr(), i.value = $1c811abb26f94012$var$Xr($1c811abb26f94012$var$Or(), !1)) : $1c811abb26f94012$var$kr(), "Identifier" === i.key.type && ($1c811abb26f94012$var$Lt || r)) for(var s = 0; s < t.properties.length; ++s){
                        var a = t.properties[s];
                        if (a.key.name === i.key.name) {
                            var u = n == a.kind || o && "init" === a.kind || "init" === n && ("get" === a.kind || "set" === a.kind);
                            u && !$1c811abb26f94012$var$Lt && "init" === n && "init" === a.kind && (u = !1), u && $1c811abb26f94012$var$Vt(i.key.start, "Redefinition of property");
                        }
                    }
                    t.properties.push(i);
                }
                return $1c811abb26f94012$var$Tr(t, "ObjectExpression");
            }();
        case $1c811abb26f94012$var$ie:
            return t = $1c811abb26f94012$var$Or(), $1c811abb26f94012$var$_r(), $1c811abb26f94012$var$Xr(t, !1);
        case $1c811abb26f94012$var$de:
            return function() {
                var t = $1c811abb26f94012$var$Or();
                return $1c811abb26f94012$var$_r(), t.callee = $1c811abb26f94012$var$zr($1c811abb26f94012$var$Jr(), !0), $1c811abb26f94012$var$Ar($1c811abb26f94012$var$Oe) ? t.arguments = $1c811abb26f94012$var$Zr($1c811abb26f94012$var$Se, !1) : t.arguments = $1c811abb26f94012$var$Gt, $1c811abb26f94012$var$Tr(t, "NewExpression");
            }();
        default:
            $1c811abb26f94012$var$kr();
    }
}
function $1c811abb26f94012$var$Hr() {
    return $1c811abb26f94012$var$xt === $1c811abb26f94012$var$qt || $1c811abb26f94012$var$xt === $1c811abb26f94012$var$Yt ? $1c811abb26f94012$var$Jr() : $1c811abb26f94012$var$$r(!0);
}
function $1c811abb26f94012$var$Xr(t, e) {
    $1c811abb26f94012$var$xt === $1c811abb26f94012$var$zt ? t.id = $1c811abb26f94012$var$$r() : e ? $1c811abb26f94012$var$kr() : t.id = null, t.params = [];
    var r = !0;
    for($1c811abb26f94012$var$Nr($1c811abb26f94012$var$Oe); !$1c811abb26f94012$var$Ar($1c811abb26f94012$var$Se);)r ? r = !1 : $1c811abb26f94012$var$Nr($1c811abb26f94012$var$Te), t.params.push($1c811abb26f94012$var$$r());
    var n = $1c811abb26f94012$var$Ut, i = $1c811abb26f94012$var$Ft;
    if ($1c811abb26f94012$var$Ut = !0, $1c811abb26f94012$var$Ft = [], t.body = $1c811abb26f94012$var$Dr(!0), $1c811abb26f94012$var$Ut = n, $1c811abb26f94012$var$Ft = i, $1c811abb26f94012$var$Lt || t.body.body.length && $1c811abb26f94012$var$xr(t.body.body[0])) for(var o = t.id ? -1 : 0; o < t.params.length; ++o){
        var s = o < 0 ? t.id : t.params[o];
        if (($1c811abb26f94012$var$Ze(s.name) || $1c811abb26f94012$var$$e(s.name)) && $1c811abb26f94012$var$Vt(s.start, "Defining '" + s.name + "' in strict mode"), o >= 0) for(var a = 0; a < o; ++a)s.name === t.params[a].name && $1c811abb26f94012$var$Vt(s.start, "Argument name clash in strict mode");
    }
    return $1c811abb26f94012$var$Tr(t, e ? "FunctionDeclaration" : "FunctionExpression");
}
function $1c811abb26f94012$var$Zr(t, e, r) {
    for(var n = [], i = !0; !$1c811abb26f94012$var$Ar(t);){
        if (i) i = !1;
        else if ($1c811abb26f94012$var$Nr($1c811abb26f94012$var$Te), e && $1c811abb26f94012$var$mt.allowTrailingCommas && $1c811abb26f94012$var$Ar(t)) break;
        r && $1c811abb26f94012$var$xt === $1c811abb26f94012$var$Te ? n.push(null) : n.push($1c811abb26f94012$var$Gr(!0));
    }
    return n;
}
function $1c811abb26f94012$var$$r(t) {
    var e = $1c811abb26f94012$var$Or();
    return e.name = $1c811abb26f94012$var$xt === $1c811abb26f94012$var$zt ? $1c811abb26f94012$var$At : t && !$1c811abb26f94012$var$mt.forbidReserved && $1c811abb26f94012$var$xt.keyword || $1c811abb26f94012$var$kr(), $1c811abb26f94012$var$Rt = !1, $1c811abb26f94012$var$_r(), $1c811abb26f94012$var$Tr(e, "Identifier");
}
var $1c811abb26f94012$var$Kr = function() {
    function t(e, r) {
        var n, i = "string" == typeof e ? $1c811abb26f94012$var$Dt(e, t.PARSE_OPTIONS) : e;
        this.ast = i, this.initFunc_ = r, this.paused_ = !1, this.polyfills_ = [], this.functionCounter_ = 0, this.stepFunctions_ = Object.create(null);
        for(var o, s = /^step([A-Z]\w*)$/, a = Object.getOwnPropertyNames(t.prototype), u = 0; u < a.length; u++){
            var c = a[u];
            "function" == typeof t.prototype[c] && (o = c.match(s)) && (this.stepFunctions_[o[1]] = t.prototype[c].bind(this));
        }
        this.global = this.createScope(this.ast, null), this.ast = $1c811abb26f94012$var$Dt(this.polyfills_.join("\n"), t.PARSE_OPTIONS), this.polyfills_ = void 0, this.stripLocations_(this.ast, void 0, void 0), (n = new $1c811abb26f94012$var$tn(this.ast, this.global)).done = !1, this.stateStack = [
            n
        ], this.run(), this.value = void 0, this.ast = i, (n = new $1c811abb26f94012$var$tn(this.ast, this.global)).done = !1, this.stateStack.length = 0, this.stateStack[0] = n, this.nodeConstructor = n.node.constructor, this.stateStack = this.stateStack, this.OBJECT = this.OBJECT, this.OBJECT_PROTO = this.OBJECT_PROTO, this.FUNCTION = this.FUNCTION, this.FUNCTION_PROTO = this.FUNCTION_PROTO, this.ARRAY = this.ARRAY, this.ARRAY_PROTO = this.ARRAY_PROTO, this.REGEXP = this.REGEXP, this.REGEXP_PROTO = this.REGEXP_PROTO, this.UNDEFINED = void 0, this.NULL = null, this.NAN = NaN, this.TRUE = !0, this.FALSE = !1, this.STRING_EMPTY = "", this.NUMBER_ZERO = 0, this.NUMBER_ONE = 1;
    }
    return t.prototype.wrap = function(t) {
        return t;
    }, t.prototype.unwrap = function(t, e) {
        return t;
    }, t.prototype.appendCode = function(e) {
        var r = this.stateStack[0];
        if (!r || "Program" !== r.node.type) throw Error("Expecting original AST to start with a Program node.");
        var n = "string" == typeof e ? $1c811abb26f94012$var$Dt(e, t.PARSE_OPTIONS) : e;
        if (!n || "Program" !== n.type) throw Error("Expecting new AST to start with a Program node.");
        this.populateScope_(n, r.scope);
        for(var i, o = 0; i = n.body[o]; o++)r.node.body.push(i);
        r.done = !1;
    }, t.prototype.step = function() {
        var e = this.stateStack, r = e[e.length - 1];
        if (!r) return !1;
        var n = r.node, i = n.type;
        if ("Program" === i && r.done) return !1;
        if (this.paused_) return !0;
        try {
            var o = this.stepFunctions_[i](e, r, n);
        } catch (e) {
            if (e !== t.STEP_ERROR) throw e;
        }
        return o && e.push(o), !!n.end || this.step();
    }, t.prototype.run = function() {
        for(; !this.paused_ && this.step(););
        return this.paused_;
    }, t.prototype.initGlobalScope = function(e) {
        this.setProperty(e, "NaN", NaN, t.READONLY_DESCRIPTOR), this.setProperty(e, "Infinity", 1 / 0, t.READONLY_DESCRIPTOR), this.setProperty(e, "undefined", void 0, t.READONLY_DESCRIPTOR), this.setProperty(e, "window", e, t.READONLY_DESCRIPTOR), this.setProperty(e, "this", e, t.READONLY_DESCRIPTOR), this.setProperty(e, "self", e), this.OBJECT_PROTO = new $1c811abb26f94012$var$Qr(null), this.FUNCTION_PROTO = new $1c811abb26f94012$var$Qr(this.OBJECT_PROTO), this.initFunction(e), this.initObject(e), e.proto = this.OBJECT_PROTO, this.setProperty(e, "constructor", this.OBJECT), this.initArray(e), this.initString(e), this.initBoolean(e), this.initNumber(e), this.initDate(e), this.initRegExp(e), this.initError(e), this.initMath(e), this.initJSON(e);
        var r = this, n = this.createNativeFunction(function(t) {
            throw EvalError("Can't happen");
        }, !1);
        n.eval = !0, this.setProperty(e, "eval", n), this.setProperty(e, "parseInt", this.createNativeFunction(parseInt, !1)), this.setProperty(e, "parseFloat", this.createNativeFunction(parseFloat, !1)), this.setProperty(e, "isNaN", this.createNativeFunction(isNaN, !1)), this.setProperty(e, "isFinite", this.createNativeFunction(isFinite, !1));
        for(var i = [
            [
                escape,
                "escape"
            ],
            [
                unescape,
                "unescape"
            ],
            [
                decodeURI,
                "decodeURI"
            ],
            [
                decodeURIComponent,
                "decodeURIComponent"
            ],
            [
                encodeURI,
                "encodeURI"
            ],
            [
                encodeURIComponent,
                "encodeURIComponent"
            ]
        ], o = 0; o < i.length; o++){
            var s = function(t) {
                return function(e) {
                    try {
                        return t(e);
                    } catch (t) {
                        r.throwException(r.URI_ERROR, t.message);
                    }
                };
            }(i[o][0]);
            this.setProperty(e, i[o][1], this.createNativeFunction(s, !1), t.NONENUMERABLE_DESCRIPTOR);
        }
        this.initFunc_ && this.initFunc_(this, e);
    }, t.prototype.initFunction = function(e) {
        var r, n = this, i = /^[A-Za-z_$][\w$]*$/;
        r = function(e) {
            if (n.calledWithNew()) var r = this;
            else r = n.createObjectProto(n.FUNCTION_PROTO);
            if (arguments.length) var o = String(arguments[arguments.length - 1]);
            else o = "";
            for(var s = [], a = 0; a < arguments.length - 1; a++){
                var u = String(arguments[a]);
                u.match(i) || n.throwException(n.SYNTAX_ERROR, "Invalid function argument: " + u), s.push(u);
            }
            s = s.join(", "), r.parentScope = n.global;
            try {
                var c = $1c811abb26f94012$var$Dt("$ = function(" + s + ") {" + o + "};", t.PARSE_OPTIONS);
            } catch (t) {
                n.throwException(n.SYNTAX_ERROR, "Invalid code: " + t.message);
            }
            return 1 !== c.body.length && n.throwException(n.SYNTAX_ERROR, "Invalid code in function body."), r.node = c.body[0].expression.right, n.setProperty(r, "length", r.node.length, t.READONLY_DESCRIPTOR), r;
        }, r.id = this.functionCounter_++, this.FUNCTION = this.createObjectProto(this.FUNCTION_PROTO), this.setProperty(e, "Function", this.FUNCTION), this.setProperty(this.FUNCTION, "prototype", this.FUNCTION_PROTO), this.FUNCTION.nativeFunc = r, this.setProperty(this.FUNCTION_PROTO, "constructor", this.FUNCTION, t.NONENUMERABLE_DESCRIPTOR), this.FUNCTION_PROTO.nativeFunc = function() {}, this.FUNCTION_PROTO.nativeFunc.id = this.functionCounter_++, this.setProperty(this.FUNCTION_PROTO, "length", 0, t.READONLY_DESCRIPTOR);
        var o = function(t) {
            if (!(t && t.isObject || n.getScope().strict)) {
                if (null == t) t = n.global;
                else {
                    var e = n.createObjectProto(n.getPrototype(t));
                    e.data = t, t = e;
                }
            }
            return t;
        };
        r = function(t, e) {
            var r = n.stateStack[n.stateStack.length - 1];
            r.func_ = this, r.funcThis_ = o(t), r.arguments_ = [], null != e && (e.isObject ? r.arguments_ = n.pseudoToNative(e) : n.throwException(n.TYPE_ERROR, "CreateListFromArrayLike called on non-object")), r.doneExec_ = !1;
        }, this.setNativeFunctionPrototype(this.FUNCTION, "apply", r), r = function(t, e) {
            var r = n.stateStack[n.stateStack.length - 1];
            r.func_ = this, r.funcThis_ = o(t), r.arguments_ = [];
            for(var i = 1; i < arguments.length; i++)r.arguments_.push(arguments[i]);
            r.doneExec_ = !1;
        }, this.setNativeFunctionPrototype(this.FUNCTION, "call", r), this.polyfills_.push("Object.defineProperty(Function.prototype, 'bind',", "{configurable: true, writable: true, value:", "function(oThis) {", "if (typeof this !== 'function') {", "throw TypeError('What is trying to be bound is not callable');", "}", "var aArgs   = Array.prototype.slice.call(arguments, 1),", "fToBind = this,", "fNOP    = function() {},", "fBound  = function() {", "return fToBind.apply(this instanceof fNOP", "? this", ": oThis,", "aArgs.concat(Array.prototype.slice.call(arguments)));", "};", "if (this.prototype) {", "fNOP.prototype = this.prototype;", "}", "fBound.prototype = new fNOP();", "return fBound;", "}", "});", ""), r = function() {
            return this.toString();
        }, this.setNativeFunctionPrototype(this.FUNCTION, "toString", r), this.setProperty(this.FUNCTION, "toString", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), r = function() {
            return this.valueOf();
        }, this.setNativeFunctionPrototype(this.FUNCTION, "valueOf", r), this.setProperty(this.FUNCTION, "valueOf", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR);
    }, t.prototype.initObject = function(e) {
        var r, n = this;
        r = function(t) {
            if (null == t) return n.calledWithNew() ? this : n.createObjectProto(n.OBJECT_PROTO);
            if (!t.isObject) {
                var e = n.createObjectProto(n.getPrototype(t));
                return e.data = t, e;
            }
            return t;
        }, this.OBJECT = this.createNativeFunction(r, !0), this.setProperty(this.OBJECT, "prototype", this.OBJECT_PROTO), this.setProperty(this.OBJECT_PROTO, "constructor", this.OBJECT), this.setProperty(e, "Object", this.OBJECT);
        var i = function(t) {
            null == t && n.throwException(n.TYPE_ERROR, "Cannot convert '" + t + "' to object");
        };
        r = function(t) {
            i(t);
            var e = t.isObject ? t.properties : t;
            return n.nativeToPseudo(Object.getOwnPropertyNames(e));
        }, this.setProperty(this.OBJECT, "getOwnPropertyNames", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), r = function(t) {
            return i(t), t.isObject ? n.nativeToPseudo(Object.keys(t.properties)) : n.nativeToPseudo(Object.keys(t));
        }, this.setProperty(this.OBJECT, "keys", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), r = function(t) {
            return null === t ? n.createObjectProto(null) : (void 0 !== t && t.isObject || n.throwException(n.TYPE_ERROR, "Object prototype may only be an Object or null"), n.createObjectProto(t));
        }, this.setProperty(this.OBJECT, "create", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), this.polyfills_.push("(function() {", "var create_ = Object.create;", "Object.create = function(proto, props) {", "var obj = create_(proto);", "props && Object.defineProperties(obj, props);", "return obj;", "};", "})();", ""), r = function(t, e, r) {
            return e = String(e), t && t.isObject || n.throwException(n.TYPE_ERROR, "Object.defineProperty called on non-object"), r && r.isObject || n.throwException(n.TYPE_ERROR, "Property description must be an object"), !t.properties[e] && t.preventExtensions && n.throwException(n.TYPE_ERROR, "Can't define property '" + e + "', object is not extensible"), n.setProperty(t, e, ReferenceError, r.properties), t;
        }, this.setProperty(this.OBJECT, "defineProperty", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), this.polyfills_.push("(function() {", "var defineProperty_ = Object.defineProperty;", "Object.defineProperty = function(obj, prop, d1) {", "var d2 = {};", "if ('configurable' in d1) d2.configurable = d1.configurable;", "if ('enumerable' in d1) d2.enumerable = d1.enumerable;", "if ('writable' in d1) d2.writable = d1.writable;", "if ('value' in d1) d2.value = d1.value;", "if ('get' in d1) d2.get = d1.get;", "if ('set' in d1) d2.set = d1.set;", "return defineProperty_(obj, prop, d2);", "};", "})();", "Object.defineProperty(Object, 'defineProperties',", "{configurable: true, writable: true, value:", "function(obj, props) {", "var keys = Object.keys(props);", "for (var i = 0; i < keys.length; i++) {", "Object.defineProperty(obj, keys[i], props[keys[i]]);", "}", "return obj;", "}", "});", ""), r = function(t, e) {
            if (t && t.isObject || n.throwException(n.TYPE_ERROR, "Object.getOwnPropertyDescriptor called on non-object"), (e = String(e)) in t.properties) {
                var r = Object.getOwnPropertyDescriptor(t.properties, e), i = t.getter[e], o = t.setter[e];
                (i || o) && (r.get = i, r.set = o, delete r.value, delete r.writable);
                var s = n.nativeToPseudo(r);
                return "value" in r && n.setProperty(s, "value", r.value), s;
            }
        }, this.setProperty(this.OBJECT, "getOwnPropertyDescriptor", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), r = function(t) {
            return i(t), n.getPrototype(t);
        }, this.setProperty(this.OBJECT, "getPrototypeOf", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), r = function(t) {
            return Boolean(t) && !t.preventExtensions;
        }, this.setProperty(this.OBJECT, "isExtensible", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), r = function(t) {
            return t && t.isObject && (t.preventExtensions = !0), t;
        }, this.setProperty(this.OBJECT, "preventExtensions", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), this.setNativeFunctionPrototype(this.OBJECT, "toString", $1c811abb26f94012$var$Qr.prototype.toString), this.setNativeFunctionPrototype(this.OBJECT, "toLocaleString", $1c811abb26f94012$var$Qr.prototype.toString), this.setNativeFunctionPrototype(this.OBJECT, "valueOf", $1c811abb26f94012$var$Qr.prototype.valueOf), r = function(t) {
            return i(this), this.isObject ? String(t) in this.properties : this.hasOwnProperty(t);
        }, this.setNativeFunctionPrototype(this.OBJECT, "hasOwnProperty", r), r = function(t) {
            return i(this), Object.prototype.propertyIsEnumerable.call(this.properties, t);
        }, this.setNativeFunctionPrototype(this.OBJECT, "propertyIsEnumerable", r), r = function(t) {
            for(;;){
                if (!(t = n.getPrototype(t))) return !1;
                if (t === this) return !0;
            }
        }, this.setNativeFunctionPrototype(this.OBJECT, "isPrototypeOf", r);
    }, t.prototype.initArray = function(e) {
        var r, n = this;
        r = function(e) {
            if (n.calledWithNew()) var r = this;
            else r = n.createObjectProto(n.ARRAY_PROTO);
            var i = arguments[0];
            if (1 === arguments.length && "number" == typeof i) isNaN(t.legalArrayLength(i)) && n.throwException(n.RANGE_ERROR, "Invalid array length"), r.properties.length = i;
            else {
                for(var o = 0; o < arguments.length; o++)r.properties[o] = arguments[o];
                r.properties.length = o;
            }
            return r;
        }, this.ARRAY = this.createNativeFunction(r, !0), this.ARRAY_PROTO = this.ARRAY.properties.prototype, this.setProperty(e, "Array", this.ARRAY), r = function(t) {
            return t && "Array" === t.class;
        }, this.setProperty(this.ARRAY, "isArray", this.createNativeFunction(r, !1), t.NONENUMERABLE_DESCRIPTOR), r = function() {
            return Array.prototype.pop.call(this.properties);
        }, this.setNativeFunctionPrototype(this.ARRAY, "pop", r), r = function(t) {
            return Array.prototype.push.apply(this.properties, arguments);
        }, this.setNativeFunctionPrototype(this.ARRAY, "push", r), r = function() {
            return Array.prototype.shift.call(this.properties);
        }, this.setNativeFunctionPrototype(this.ARRAY, "shift", r), r = function(t) {
            return Array.prototype.unshift.apply(this.properties, arguments);
        }, this.setNativeFunctionPrototype(this.ARRAY, "unshift", r), r = function() {
            return Array.prototype.reverse.call(this.properties), this;
        }, this.setNativeFunctionPrototype(this.ARRAY, "reverse", r), r = function(t, e) {
            var r = Array.prototype.splice.apply(this.properties, arguments);
            return n.unwrap && (r = r.map(n.unwrap)), n.nativeToPseudo(r);
        }, this.setNativeFunctionPrototype(this.ARRAY, "splice", r), r = function(t, e) {
            var r = Array.prototype.slice.call(this.properties, t, e);
            return n.unwrap && (r = r.map(n.unwrap)), n.nativeToPseudo(r);
        }, this.setNativeFunctionPrototype(this.ARRAY, "slice", r), r = function(t) {
            return Array.prototype.join.call(this.properties, t);
        }, this.setNativeFunctionPrototype(this.ARRAY, "join", r), r = function(t) {
            for(var e = [], r = 0, i = n.getProperty(this, "length"), o = 0; o < i; o++){
                if (n.hasProperty(this, o)) {
                    var s = n.getProperty(this, o);
                    e[r] = s;
                }
                r++;
            }
            for(o = 0; o < arguments.length; o++){
                var a = arguments[o];
                if (n.isa(a, n.ARRAY)) for(var u = n.getProperty(a, "length"), c = 0; c < u; c++)n.hasProperty(a, c) && (e[r] = n.getProperty(a, c)), r++;
                else e[r] = a;
            }
            return n.unwrap && (e = e.map(n.unwrap)), n.nativeToPseudo(e);
        }, this.setNativeFunctionPrototype(this.ARRAY, "concat", r), r = function(t, e) {
            return Array.prototype.indexOf.apply(this.properties, arguments);
        }, this.setNativeFunctionPrototype(this.ARRAY, "indexOf", r), r = function(t, e) {
            return Array.prototype.lastIndexOf.apply(this.properties, arguments);
        }, this.setNativeFunctionPrototype(this.ARRAY, "lastIndexOf", r), r = function() {
            return Array.prototype.sort.call(this.properties), this;
        }, this.setNativeFunctionPrototype(this.ARRAY, "sort", r), this.polyfills_.push("Object.defineProperty(Array.prototype, 'every',", "{configurable: true, writable: true, value:", "function(callbackfn, thisArg) {", "if (!this || typeof callbackfn !== 'function') throw TypeError();", "var T, k;", "var O = Object(this);", "var len = O.length >>> 0;", "if (arguments.length > 1) T = thisArg;", "k = 0;", "while (k < len) {", "if (k in O && !callbackfn.call(T, O[k], k, O)) return false;", "k++;", "}", "return true;", "}", "});", "Object.defineProperty(Array.prototype, 'filter',", "{configurable: true, writable: true, value:", "function(fun/*, thisArg*/) {", "if (this === void 0 || this === null || typeof fun !== 'function') throw TypeError();", "var t = Object(this);", "var len = t.length >>> 0;", "var res = [];", "var thisArg = arguments.length >= 2 ? arguments[1] : void 0;", "for (var i = 0; i < len; i++) {", "if (i in t) {", "var val = t[i];", "if (fun.call(thisArg, val, i, t)) res.push(val);", "}", "}", "return res;", "}", "});", "Object.defineProperty(Array.prototype, 'forEach',", "{configurable: true, writable: true, value:", "function(callback, thisArg) {", "if (!this || typeof callback !== 'function') throw TypeError();", "var T, k;", "var O = Object(this);", "var len = O.length >>> 0;", "if (arguments.length > 1) T = thisArg;", "k = 0;", "while (k < len) {", "if (k in O) callback.call(T, O[k], k, O);", "k++;", "}", "}", "});", "Object.defineProperty(Array.prototype, 'map',", "{configurable: true, writable: true, value:", "function(callback, thisArg) {", "if (!this || typeof callback !== 'function') new TypeError;", "var T, A, k;", "var O = Object(this);", "var len = O.length >>> 0;", "if (arguments.length > 1) T = thisArg;", "A = new Array(len);", "k = 0;", "while (k < len) {", "if (k in O) A[k] = callback.call(T, O[k], k, O);", "k++;", "}", "return A;", "}", "});", "Object.defineProperty(Array.prototype, 'reduce',", "{configurable: true, writable: true, value:", "function(callback /*, initialValue*/) {", "if (!this || typeof callback !== 'function') throw TypeError();", "var t = Object(this), len = t.length >>> 0, k = 0, value;", "if (arguments.length === 2) {", "value = arguments[1];", "} else {", "while (k < len && !(k in t)) k++;", "if (k >= len) {", "throw TypeError('Reduce of empty array with no initial value');", "}", "value = t[k++];", "}", "for (; k < len; k++) {", "if (k in t) value = callback(value, t[k], k, t);", "}", "return value;", "}", "});", "Object.defineProperty(Array.prototype, 'reduceRight',", "{configurable: true, writable: true, value:", "function(callback /*, initialValue*/) {", "if (null === this || 'undefined' === typeof this || 'function' !== typeof callback) throw TypeError();", "var t = Object(this), len = t.length >>> 0, k = len - 1, value;", "if (arguments.length >= 2) {", "value = arguments[1];", "} else {", "while (k >= 0 && !(k in t)) k--;", "if (k < 0) {", "throw TypeError('Reduce of empty array with no initial value');", "}", "value = t[k--];", "}", "for (; k >= 0; k--) {", "if (k in t) value = callback(value, t[k], k, t);", "}", "return value;", "}", "});", "Object.defineProperty(Array.prototype, 'some',", "{configurable: true, writable: true, value:", "function(fun/*, thisArg*/) {", "if (!this || typeof fun !== 'function') throw TypeError();", "var t = Object(this);", "var len = t.length >>> 0;", "var thisArg = arguments.length >= 2 ? arguments[1] : void 0;", "for (var i = 0; i < len; i++) {", "if (i in t && fun.call(thisArg, t[i], i, t)) {", "return true;", "}", "}", "return false;", "}", "});", "(function() {", "var sort_ = Array.prototype.sort;", "Array.prototype.sort = function(opt_comp) {", "if (typeof opt_comp !== 'function') {", "return sort_.call(this);", "}", "for (var i = 0; i < this.length; i++) {", "var changes = 0;", "for (var j = 0; j < this.length - i - 1; j++) {", "if (opt_comp(this[j], this[j + 1]) > 0) {", "var swap = this[j];", "this[j] = this[j + 1];", "this[j + 1] = swap;", "changes++;", "}", "}", "if (!changes) break;", "}", "return this;", "};", "})();", "Object.defineProperty(Array.prototype, 'toLocaleString',", "{configurable: true, writable: true, value:", "function() {", "var out = [];", "for (var i = 0; i < this.length; i++) {", "out[i] = (this[i] === null || this[i] === undefined) ? '' : this[i].toLocaleString();", "}", "return out.join(',');", "}", "});", "");
    }, t.prototype.initString = function(e) {
        var r, n = this;
        r = function(t) {
            return t = String(t), n.calledWithNew() ? (this.data = t, this) : t;
        }, this.STRING = this.createNativeFunction(r, !0), this.setProperty(e, "String", this.STRING), this.setProperty(this.STRING, "fromCharCode", this.createNativeFunction(String.fromCharCode, !1), t.NONENUMERABLE_DESCRIPTOR);
        for(var i = [
            "trim",
            "toLowerCase",
            "toUpperCase",
            "toLocaleLowerCase",
            "toLocaleUpperCase",
            "charAt",
            "charCodeAt",
            "substring",
            "slice",
            "substr",
            "indexOf",
            "lastIndexOf",
            "concat"
        ], o = 0; o < i.length; o++)this.setNativeFunctionPrototype(this.STRING, i[o], String.prototype[i[o]]);
        r = function(t, e, r) {
            return e = e ? n.pseudoToNative(e) : void 0, r = r ? n.pseudoToNative(r) : void 0, String(this).localeCompare(t, e, r);
        }, this.setNativeFunctionPrototype(this.STRING, "localeCompare", r), r = function(t, e) {
            n.isa(t, n.REGEXP) && (t = t.data);
            var r = String(this).split(t, e);
            return n.nativeToPseudo(r);
        }, this.setNativeFunctionPrototype(this.STRING, "split", r), r = function(t) {
            t = t ? t.data : void 0;
            var e = String(this).match(t);
            return e ? n.nativeToPseudo(e) : null;
        }, this.setNativeFunctionPrototype(this.STRING, "match", r), r = function(t) {
            return n.isa(t, n.REGEXP) && (t = t.data), String(this).search(t);
        }, this.setNativeFunctionPrototype(this.STRING, "search", r), r = function(t, e) {
            return String(this).replace(t.data || t, e);
        }, this.setNativeFunctionPrototype(this.STRING, "replace", r), this.polyfills_.push("(function() {", "var replace_ = String.prototype.replace;", "String.prototype.replace = function(substr, newSubstr) {", "if (typeof newSubstr !== 'function') {", "return replace_.call(this, substr, newSubstr);", "}", "var str = this;", "if (substr instanceof RegExp) {", "var subs = [];", "var m = substr.exec(str);", "while (m) {", "m.push(m.index, str);", "var inject = newSubstr.apply(null, m);", "subs.push([m.index, m[0].length, inject]);", "m = substr.global ? substr.exec(str) : null;", "}", "for (var i = subs.length - 1; i >= 0; i--) {", "str = str.substring(0, subs[i][0]) + subs[i][2] + str.substring(subs[i][0] + subs[i][1]);", "}", "} else {", "var i = str.indexOf(substr);", "if (i !== -1) {", "var inject = newSubstr(str.substr(i, substr.length), i, str);", "str = str.substring(0, i) + inject + str.substring(i + substr.length);", "}", "}", "return str;", "};", "})();", "");
    }, t.prototype.initBoolean = function(t) {
        var e, r = this;
        e = function(t) {
            return t = Boolean(t), r.calledWithNew() ? (this.data = t, this) : t;
        }, this.BOOLEAN = this.createNativeFunction(e, !0), this.setProperty(t, "Boolean", this.BOOLEAN);
    }, t.prototype.initNumber = function(e) {
        var r, n = this;
        r = function(t) {
            return t = Number(t), n.calledWithNew() ? (this.data = t, this) : t;
        }, this.NUMBER = this.createNativeFunction(r, !0), this.setProperty(e, "Number", this.NUMBER);
        for(var i = [
            "MAX_VALUE",
            "MIN_VALUE",
            "NaN",
            "NEGATIVE_INFINITY",
            "POSITIVE_INFINITY"
        ], o = 0; o < i.length; o++)this.setProperty(this.NUMBER, i[o], Number[i[o]], t.READONLY_NONENUMERABLE_DESCRIPTOR);
        r = function(t) {
            try {
                return Number(this).toExponential(t);
            } catch (t) {
                n.throwException(n.ERROR, t.message);
            }
        }, this.setNativeFunctionPrototype(this.NUMBER, "toExponential", r), r = function(t) {
            try {
                return Number(this).toFixed(t);
            } catch (t) {
                n.throwException(n.ERROR, t.message);
            }
        }, this.setNativeFunctionPrototype(this.NUMBER, "toFixed", r), r = function(t) {
            try {
                return Number(this).toPrecision(t);
            } catch (t) {
                n.throwException(n.ERROR, t.message);
            }
        }, this.setNativeFunctionPrototype(this.NUMBER, "toPrecision", r), r = function(t) {
            try {
                return Number(this).toString(t);
            } catch (t) {
                n.throwException(n.ERROR, t.message);
            }
        }, this.setNativeFunctionPrototype(this.NUMBER, "toString", r), r = function(t, e) {
            return t = t ? n.pseudoToNative(t) : void 0, e = e ? n.pseudoToNative(e) : void 0, Number(this).toLocaleString(t, e);
        }, this.setNativeFunctionPrototype(this.NUMBER, "toLocaleString", r);
    }, t.prototype.initDate = function(e) {
        var r, n = this;
        r = function(t, e) {
            if (!n.calledWithNew()) return Date();
            var r = [
                null
            ].concat([].slice.call(arguments));
            return this.data = new (Function.prototype.bind.apply(Date, r)), this;
        }, this.DATE = this.createNativeFunction(r, !0), this.setProperty(e, "Date", this.DATE), this.setProperty(this.DATE, "now", this.createNativeFunction(Date.now, !1), t.NONENUMERABLE_DESCRIPTOR), this.setProperty(this.DATE, "parse", this.createNativeFunction(Date.parse, !1), t.NONENUMERABLE_DESCRIPTOR), this.setProperty(this.DATE, "UTC", this.createNativeFunction(Date.UTC, !1), t.NONENUMERABLE_DESCRIPTOR);
        for(var i = [
            "getDate",
            "getDay",
            "getFullYear",
            "getHours",
            "getMilliseconds",
            "getMinutes",
            "getMonth",
            "getSeconds",
            "getTime",
            "getTimezoneOffset",
            "getUTCDate",
            "getUTCDay",
            "getUTCFullYear",
            "getUTCHours",
            "getUTCMilliseconds",
            "getUTCMinutes",
            "getUTCMonth",
            "getUTCSeconds",
            "getYear",
            "setDate",
            "setFullYear",
            "setHours",
            "setMilliseconds",
            "setMinutes",
            "setMonth",
            "setSeconds",
            "setTime",
            "setUTCDate",
            "setUTCFullYear",
            "setUTCHours",
            "setUTCMilliseconds",
            "setUTCMinutes",
            "setUTCMonth",
            "setUTCSeconds",
            "setYear",
            "toDateString",
            "toISOString",
            "toJSON",
            "toGMTString",
            "toLocaleDateString",
            "toLocaleString",
            "toLocaleTimeString",
            "toTimeString",
            "toUTCString"
        ], o = 0; o < i.length; o++)r = function(t) {
            return function(e) {
                for(var r = [], i = 0; i < arguments.length; i++)r[i] = n.pseudoToNative(arguments[i]);
                return this.data[t].apply(this.data, r);
            };
        }(i[o]), this.setNativeFunctionPrototype(this.DATE, i[o], r);
    }, t.prototype.initRegExp = function(e) {
        var r, n = this;
        r = function(t, e) {
            if (n.calledWithNew()) var r = this;
            else r = n.createObjectProto(n.REGEXP_PROTO);
            return t = t ? t.toString() : "", e = e ? e.toString() : "", n.populateRegExp(r, new RegExp(t, e)), r;
        }, this.REGEXP = this.createNativeFunction(r, !0), this.REGEXP_PROTO = this.REGEXP.properties.prototype, this.setProperty(e, "RegExp", this.REGEXP), this.setProperty(this.REGEXP.properties.prototype, "global", void 0, t.READONLY_NONENUMERABLE_DESCRIPTOR), this.setProperty(this.REGEXP.properties.prototype, "ignoreCase", void 0, t.READONLY_NONENUMERABLE_DESCRIPTOR), this.setProperty(this.REGEXP.properties.prototype, "multiline", void 0, t.READONLY_NONENUMERABLE_DESCRIPTOR), this.setProperty(this.REGEXP.properties.prototype, "source", "(?:)", t.READONLY_NONENUMERABLE_DESCRIPTOR), r = function(t) {
            return this.data.test(t);
        }, this.setNativeFunctionPrototype(this.REGEXP, "test", r), r = function(t) {
            t = t.toString(), this.data.lastIndex = Number(n.getProperty(this, "lastIndex"));
            var e = this.data.exec(t);
            if (n.setProperty(this, "lastIndex", this.data.lastIndex), e) {
                for(var r = n.createObjectProto(n.ARRAY_PROTO), i = 0; i < e.length; i++)n.setProperty(r, i, e[i]);
                return n.setProperty(r, "index", e.index), n.setProperty(r, "input", e.input), r;
            }
            return null;
        }, this.setNativeFunctionPrototype(this.REGEXP, "exec", r);
    }, t.prototype.initError = function(e) {
        var r = this;
        this.ERROR = this.createNativeFunction(function(e) {
            if (r.calledWithNew()) var n = this;
            else n = r.createObject(r.ERROR);
            return e && r.setProperty(n, "message", String(e), t.NONENUMERABLE_DESCRIPTOR), n;
        }, !0), this.setProperty(e, "Error", this.ERROR), this.setProperty(this.ERROR.properties.prototype, "message", "", t.NONENUMERABLE_DESCRIPTOR), this.setProperty(this.ERROR.properties.prototype, "name", "Error", t.NONENUMERABLE_DESCRIPTOR);
        var n = function(n) {
            var i = r.createNativeFunction(function(e) {
                if (r.calledWithNew()) var n = this;
                else n = r.createObject(i);
                return e && r.setProperty(n, "message", String(e), t.NONENUMERABLE_DESCRIPTOR), n;
            }, !0);
            return r.setProperty(i, "prototype", r.createObject(r.ERROR)), r.setProperty(i.properties.prototype, "name", n, t.NONENUMERABLE_DESCRIPTOR), r.setProperty(e, n, i), i;
        };
        this.EVAL_ERROR = n("EvalError"), this.RANGE_ERROR = n("RangeError"), this.REFERENCE_ERROR = n("ReferenceError"), this.SYNTAX_ERROR = n("SyntaxError"), this.TYPE_ERROR = n("TypeError"), this.URI_ERROR = n("URIError");
    }, t.prototype.initMath = function(e) {
        var r = this.createObjectProto(this.OBJECT_PROTO);
        this.setProperty(e, "Math", r);
        for(var n = [
            "E",
            "LN2",
            "LN10",
            "LOG2E",
            "LOG10E",
            "PI",
            "SQRT1_2",
            "SQRT2"
        ], i = 0; i < n.length; i++)this.setProperty(r, n[i], Math[n[i]], t.READONLY_NONENUMERABLE_DESCRIPTOR);
        var o = [
            "abs",
            "acos",
            "asin",
            "atan",
            "atan2",
            "ceil",
            "cos",
            "exp",
            "floor",
            "log",
            "max",
            "min",
            "pow",
            "random",
            "round",
            "sin",
            "sqrt",
            "tan"
        ];
        for(i = 0; i < o.length; i++)this.setProperty(r, o[i], this.createNativeFunction(Math[o[i]], !1), t.NONENUMERABLE_DESCRIPTOR);
    }, t.prototype.initJSON = function(t) {
        var e = this, r = e.createObjectProto(this.OBJECT_PROTO);
        this.setProperty(t, "JSON", r);
        var n = function(t) {
            try {
                var r = JSON.parse(t.toString());
            } catch (t) {
                e.throwException(e.SYNTAX_ERROR, t.message);
            }
            return e.nativeToPseudo(r);
        };
        this.setProperty(r, "parse", this.createNativeFunction(n, !1)), n = function(t) {
            var r = e.pseudoToNative(t);
            try {
                var n = JSON.stringify(r);
            } catch (t) {
                e.throwException(e.TYPE_ERROR, t.message);
            }
            return n;
        }, this.setProperty(r, "stringify", this.createNativeFunction(n, !1));
    }, t.prototype.isa = function(t, e) {
        if (null == t || !e) return !1;
        var r = e.properties.prototype;
        if (t === r) return !0;
        for(var n = this.getPrototype(t); n;){
            if (n === r) return !0;
            n = n.proto;
        }
        return !1;
    }, t.legalArrayLength = function(t) {
        var e = t >>> 0;
        return e === Number(t) ? e : NaN;
    }, t.legalArrayIndex = function(t) {
        var e = t >>> 0;
        return String(e) === String(t) && 4294967295 !== e ? e : NaN;
    }, t.prototype.createObject = function(t) {
        return this.createObjectProto(t && t.properties.prototype);
    }, t.prototype.createObjectProto = function(t) {
        var e = new $1c811abb26f94012$var$Qr(t);
        return this.isa(e, this.FUNCTION) && (this.setProperty(e, "prototype", this.createObjectProto(this.OBJECT_PROTO || null)), e.class = "Function"), this.isa(e, this.ARRAY) && (this.setProperty(e, "length", 0, {
            configurable: !1,
            enumerable: !1,
            writable: !0
        }), e.class = "Array"), this.isa(e, this.ERROR) && (e.class = "Error"), e;
    }, t.prototype.populateRegExp = function(e, r) {
        e.data = r, this.setProperty(e, "lastIndex", r.lastIndex, t.NONENUMERABLE_DESCRIPTOR), this.setProperty(e, "source", r.source, t.READONLY_NONENUMERABLE_DESCRIPTOR), this.setProperty(e, "global", r.global, t.READONLY_NONENUMERABLE_DESCRIPTOR), this.setProperty(e, "ignoreCase", r.ignoreCase, t.READONLY_NONENUMERABLE_DESCRIPTOR), this.setProperty(e, "multiline", r.multiline, t.READONLY_NONENUMERABLE_DESCRIPTOR);
    }, t.prototype.createFunction = function(e, r) {
        var n = this.createObjectProto(this.FUNCTION_PROTO);
        return n.parentScope = r, n.node = e, this.setProperty(n, "length", n.node.params.length, t.READONLY_DESCRIPTOR), n;
    }, t.prototype.createNativeFunction = function(e, r) {
        var n = this.createObjectProto(this.FUNCTION_PROTO);
        return n.nativeFunc = e, e.id = this.functionCounter_++, this.setProperty(n, "length", e.length, t.READONLY_DESCRIPTOR), r ? this.setProperty(n.properties.prototype, "constructor", n, t.NONENUMERABLE_DESCRIPTOR) : !1 === r && (n.illegalConstructor = !0, this.setProperty(n, "prototype", void 0)), n;
    }, t.prototype.createAsyncFunction = function(e) {
        var r = this.createObjectProto(this.FUNCTION_PROTO);
        return r.asyncFunc = e, e.id = this.functionCounter_++, this.setProperty(r, "length", e.length, t.READONLY_DESCRIPTOR), r;
    }, t.prototype.nativeToPseudo = function(t) {
        if ("boolean" == typeof t || "number" == typeof t || "string" == typeof t || null == t) return t;
        if (t instanceof RegExp) {
            var e = this.createObjectProto(this.REGEXP_PROTO);
            return this.populateRegExp(e, t), e;
        }
        if (t instanceof Function) {
            var r = this;
            return this.createNativeFunction(function() {
                return r.nativeToPseudo(t.apply(r, Array.prototype.slice.call(arguments).map(function(t) {
                    return r.pseudoToNative(t);
                })));
            }, void 0);
        }
        var n;
        if (Array.isArray(t)) {
            n = this.createObjectProto(this.ARRAY_PROTO);
            for(var i = 0; i < t.length; i++)i in t && this.setProperty(n, i, this.wrap ? this.wrap(t[i]) : this.nativeToPseudo(t[i]));
        } else for(var o in n = this.createObjectProto(this.OBJECT_PROTO), t)this.setProperty(n, o, this.wrap ? this.wrap(t[i]) : this.nativeToPseudo(t[i]));
        return n;
    }, t.prototype.pseudoToNative = function(t, e) {
        if ("boolean" == typeof t || "number" == typeof t || "string" == typeof t || null == t) return t;
        if (this.isa(t, this.REGEXP)) return t.data;
        var r, n = e || {
            pseudo: [],
            native: []
        };
        if (-1 !== (o = n.pseudo.indexOf(t))) return n.native[o];
        if (n.pseudo.push(t), this.isa(t, this.ARRAY)) {
            r = [], n.native.push(r);
            for(var i = this.getProperty(t, "length"), o = 0; o < i; o++)this.hasProperty(t, o) && (r[o] = this.unwrap ? this.unwrap(this.getProperty(t, o), n) : this.pseudoToNative(this.getProperty(t, o), n));
        } else {
            if (t._native) return t._native;
            r = {}, n.native.push(r);
            var s = void 0;
            for(var a in t.properties)s = t.properties[a], r[a] = this.unwrap ? this.unwrap(s, n) : this.pseudoToNative(s, n);
        }
        return n.pseudo.pop(), n.native.pop(), r;
    }, t.prototype.getPrototype = function(t) {
        switch(typeof t){
            case "number":
                return this.NUMBER.properties.prototype;
            case "boolean":
                return this.BOOLEAN.properties.prototype;
            case "string":
                return this.STRING.properties.prototype;
        }
        return t ? t.proto : null;
    }, t.prototype.getProperty = function(e, r) {
        if (r = String(r), null == e && this.throwException(this.TYPE_ERROR, "Cannot read property '" + r + "' of " + e), "length" === r) {
            if (this.isa(e, this.STRING)) return String(e).length;
        } else if (r.charCodeAt(0) < 64 && this.isa(e, this.STRING)) {
            var n = t.legalArrayIndex(r);
            if (!isNaN(n) && n < String(e).length) return String(e)[n];
        }
        do {
            var i = e;
            if (i.properties && r in i.properties) {
                var o = i.getter[r];
                return o ? (o.isGetter = !0, o) : i.properties[r];
            }
            if (void 0 !== i._native && "_" !== r.charAt(0) && "function" != typeof i._native[r]) return this.wrap ? this.wrap(i._native[r]) : i._native[r];
        }while (e = this.getPrototype(e));
    }, t.prototype.hasProperty = function(e, r) {
        if (!e.isObject) throw TypeError("Primitive data type has no properties");
        if ("length" === (r = String(r)) && this.isa(e, this.STRING)) return !0;
        if (this.isa(e, this.STRING)) {
            var n = t.legalArrayIndex(r);
            if (!isNaN(n) && n < String(e).length) return !0;
        }
        do {
            var i = e;
            if (i.properties && r in i.properties) return !0;
            if (void 0 !== i._native && "_" != r.charAt(0)) {
                var o = typeof i._native[r];
                return "function" !== o && ("undefined" !== o || $1c811abb26f94012$var$en(i._native.constructor, r));
            }
        }while (e = this.getPrototype(e));
        return !1;
    }, t.prototype.setProperty = function(e, r, n, i) {
        r = String(r), null == e && this.throwException(this.TYPE_ERROR, "Cannot set property '" + r + "' of " + e), i && ("get" in i || "set" in i) && ("value" in i || "writable" in i) && this.throwException(this.TYPE_ERROR, "Invalid property descriptor. Cannot both specify accessors and a value or writable attribute");
        var o = !this.stateStack || this.getScope().strict;
        if (e.isObject) {
            if (this.isa(e, this.STRING)) {
                var s = t.legalArrayIndex(r);
                if ("length" === r || !isNaN(s) && s < String(e).length) return void (o && this.throwException(this.TYPE_ERROR, "Cannot assign to read only property '" + r + "' of String '" + e.data + "'"));
            }
            if ("Array" === e.class) {
                var a = e.properties.length, u = void 0;
                if ("length" === r) {
                    if (n = t.legalArrayLength(n), isNaN(n) && this.throwException(this.RANGE_ERROR, "Invalid array length"), n < a) for(u in e.properties)u = t.legalArrayIndex(u), !isNaN(u) && n <= u && delete e.properties[u];
                } else isNaN(u = t.legalArrayIndex(r)) || (e.properties.length = Math.max(a, u + 1));
            }
            if (!e.preventExtensions || r in e.properties) {
                if (i) {
                    "get" in i && (i.get ? e.getter[r] = i.get : delete e.getter[r]), "set" in i && (i.set ? e.setter[r] = i.set : delete e.setter[r]);
                    var c = {};
                    "configurable" in i && (c.configurable = i.configurable), "enumerable" in i && (c.enumerable = i.enumerable), "writable" in i && (c.writable = i.writable, delete e.getter[r], delete e.setter[r]), "value" in i ? (c.value = i.value, delete e.getter[r], delete e.setter[r]) : n !== ReferenceError && (c.value = n, delete e.getter[r], delete e.setter[r]);
                    try {
                        Object.defineProperty(e.properties, r, c);
                    } catch (t) {
                        this.throwException(this.TYPE_ERROR, "Cannot redefine property: " + r);
                    }
                } else {
                    if (n === ReferenceError) throw ReferenceError("Value not specified.");
                    if (void 0 !== e._native && "_" != r.charAt(0)) {
                        var l = typeof e._native[r];
                        if ("function" !== l && ("undefined" !== l || $1c811abb26f94012$var$en(e._native.constructor, r))) {
                            var p = this.unwrap ? this.unwrap(n) : n;
                            return void (e._native[r] = p);
                        }
                    }
                    for(var h = e; !(r in h.properties);)if (!(h = this.getPrototype(h))) {
                        h = e;
                        break;
                    }
                    if (h.setter && h.setter[r]) return h.setter[r];
                    if (h.getter && h.getter[r]) o && this.throwException(this.TYPE_ERROR, "Cannot set property '" + r + "' of object '" + e + "' which only has a getter");
                    else try {
                        e.properties[r] = n;
                    } catch (t) {
                        o && this.throwException(this.TYPE_ERROR, "Cannot assign to read only property '" + r + "' of object '" + e + "'");
                    }
                }
            } else o && this.throwException(this.TYPE_ERROR, "Can't add property '" + r + "', object is not extensible");
        } else o && this.throwException(this.TYPE_ERROR, "Can't create property '" + r + "' on '" + e + "'");
    }, t.prototype.setNativeFunctionPrototype = function(e, r, n) {
        this.setProperty(e.properties.prototype, r, this.createNativeFunction(n, !1), t.NONENUMERABLE_DESCRIPTOR);
    }, t.prototype.getScope = function() {
        var t = this.stateStack[this.stateStack.length - 1].scope;
        if (!t) throw Error("No scope found.");
        return t;
    }, t.prototype.createScope = function(t, e) {
        var r = this.createObjectProto(null);
        if (r.parentScope = e, e || this.initGlobalScope(r), this.populateScope_(t, r), r.strict = !1, e && e.strict) r.strict = !0;
        else {
            var n = t.body && t.body[0];
            n && n.expression && "Literal" === n.expression.type && "use strict" === n.expression.value && (r.strict = !0);
        }
        return r;
    }, t.prototype.createSpecialScope = function(t, e) {
        if (!t) throw Error("parentScope required");
        var r = e || this.createObjectProto(null);
        return r.parentScope = t, r.strict = t.strict, r;
    }, t.prototype.getValueFromScope = function(t) {
        for(var e = this.getScope(); e && e !== this.global;){
            if (t in e.properties) return e.properties[t];
            e = e.parentScope;
        }
        if (e === this.global && this.hasProperty(e, t)) return this.getProperty(e, t);
        var r = this.stateStack[this.stateStack.length - 1].node;
        "UnaryExpression" === r.type && "typeof" === r.operator || this.throwException(this.REFERENCE_ERROR, t + " is not defined");
    }, t.prototype.setValueToScope = function(t, e) {
        for(var r = this.getScope(), n = r.strict; r && r !== this.global;){
            if (t in r.properties) return void (r.properties[t] = e);
            r = r.parentScope;
        }
        if (r === this.global && (!n || this.hasProperty(r, t))) return this.setProperty(r, t, e);
        this.throwException(this.REFERENCE_ERROR, t + " is not defined");
    }, t.prototype.populateScope_ = function(e, r) {
        if ("VariableDeclaration" === e.type) for(var n = 0; n < e.declarations.length; n++)this.setProperty(r, e.declarations[n].id.name, void 0, t.VARIABLE_DESCRIPTOR);
        else {
            if ("FunctionDeclaration" === e.type) return void this.setProperty(r, e.id.name, this.createFunction(e, r), t.VARIABLE_DESCRIPTOR);
            if ("FunctionExpression" === e.type) return;
            if ("ExpressionStatement" === e.type) return;
        }
        var i = e.constructor;
        for(var o in e){
            var s = e[o];
            if (s && "object" == typeof s) {
                if (Array.isArray(s)) for(n = 0; n < s.length; n++)s[n] && s[n].constructor === i && this.populateScope_(s[n], r);
                else s.constructor === i && this.populateScope_(s, r);
            }
        }
    }, t.prototype.stripLocations_ = function(t, e, r) {
        for(var n in e ? t.start = e : delete t.start, r ? t.end = r : delete t.end, t)if (t.hasOwnProperty(n)) {
            var i = t[n];
            i && "object" == typeof i && this.stripLocations_(i, e, r);
        }
    }, t.prototype.calledWithNew = function() {
        return this.stateStack[this.stateStack.length - 1].isConstructor;
    }, t.prototype.getValue = function(e) {
        return e[0] === t.SCOPE_REFERENCE ? this.getValueFromScope(e[1]) : this.getProperty(e[0], e[1]);
    }, t.prototype.setValue = function(e, r) {
        return e[0] === t.SCOPE_REFERENCE ? this.setValueToScope(e[1], r) : this.setProperty(e[0], e[1], r);
    }, t.prototype.throwException = function(e, r) {
        if (void 0 === r) var n = e;
        else n = this.createObject(e), this.setProperty(n, "message", r, t.NONENUMERABLE_DESCRIPTOR);
        throw this.executeException(n), t.STEP_ERROR;
    }, t.prototype.executeException = function(t) {
        var e, r = this.stateStack.slice();
        do {
            this.stateStack.pop();
            var n = this.stateStack[this.stateStack.length - 1];
            if ("TryStatement" === n.node.type) return void (n.throwValue = t);
        }while (n && "Program" !== n.node.type);
        if (this.isa(t, this.ERROR)) {
            var i = {
                EvalError: EvalError,
                RangeError: RangeError,
                ReferenceError: ReferenceError,
                SyntaxError: SyntaxError,
                TypeError: TypeError,
                URIError: URIError
            }, o = this.getProperty(t, "name").toString(), s = this.getProperty(t, "message").valueOf();
            e = (i[o] || Error)(s);
        } else e = t.toString();
        throw this.stateStack = r, e;
    }, t.prototype.createGetter_ = function(t, e) {
        var r = Array.isArray(e) ? e[0] : e, n = new this.nodeConstructor;
        n.type = "CallExpression";
        var i = new $1c811abb26f94012$var$tn(n, this.stateStack[this.stateStack.length - 1].scope);
        return i.doneCallee_ = !0, i.funcThis_ = r, i.func_ = t, i.doneArgs_ = !0, i.arguments_ = [], i;
    }, t.prototype.createSetter_ = function(t, e, r) {
        var n = Array.isArray(e) ? e[0] : this.global, i = new this.nodeConstructor;
        i.type = "CallExpression";
        var o = new $1c811abb26f94012$var$tn(i, this.stateStack[this.stateStack.length - 1].scope);
        return o.doneCallee_ = !0, o.funcThis_ = n, o.func_ = t, o.doneArgs_ = !0, o.arguments_ = [
            r
        ], o;
    }, t.prototype.stepArrayExpression = function(t, e, r) {
        var n = r.elements, i = e.n_ || 0;
        for(e.array_ ? (this.setProperty(e.array_, i, e.value), i++) : (e.array_ = this.createObjectProto(this.ARRAY_PROTO), e.array_.properties.length = n.length); i < n.length;){
            if (n[i]) return e.n_ = i, new $1c811abb26f94012$var$tn(n[i], e.scope);
            i++;
        }
        t.pop(), t[t.length - 1].value = e.array_;
    }, t.prototype.stepAssignmentExpression = function(t, e, r) {
        if (!e.doneLeft_) {
            e.doneLeft_ = !0;
            var n = new $1c811abb26f94012$var$tn(r.left, e.scope);
            return n.components = !0, n;
        }
        if (!e.doneRight_) {
            if (e.leftReference_ || (e.leftReference_ = e.value), e.doneGetter_ && (e.leftValue_ = e.value), !e.doneGetter_ && "=" !== r.operator) {
                var i = this.getValue(e.leftReference_);
                if (e.leftValue_ = i, i && "object" == typeof i && i.isGetter) {
                    i.isGetter = !1, e.doneGetter_ = !0;
                    var o = i;
                    return this.createGetter_(o, e.leftReference_);
                }
            }
            return e.doneRight_ = !0, new $1c811abb26f94012$var$tn(r.right, e.scope);
        }
        if (e.doneSetter_) return t.pop(), void (t[t.length - 1].value = e.doneSetter_);
        var s = e.leftValue_, a = e.value;
        switch(r.operator){
            case "=":
                s = a;
                break;
            case "+=":
                s += a;
                break;
            case "-=":
                s -= a;
                break;
            case "*=":
                s *= a;
                break;
            case "/=":
                s /= a;
                break;
            case "%=":
                s %= a;
                break;
            case "<<=":
                s <<= a;
                break;
            case ">>=":
                s >>= a;
                break;
            case ">>>=":
                s >>>= a;
                break;
            case "&=":
                s &= a;
                break;
            case "^=":
                s ^= a;
                break;
            case "|=":
                s |= a;
                break;
            default:
                throw SyntaxError("Unknown assignment expression: " + r.operator);
        }
        var u = this.setValue(e.leftReference_, s);
        if (u) return e.doneSetter_ = s, this.createSetter_(u, e.leftReference_, s);
        t.pop(), t[t.length - 1].value = s;
    }, t.prototype.stepBinaryExpression = function(t, e, r) {
        if (!e.doneLeft_) return e.doneLeft_ = !0, new $1c811abb26f94012$var$tn(r.left, e.scope);
        if (!e.doneRight_) return e.doneRight_ = !0, e.leftValue_ = e.value, new $1c811abb26f94012$var$tn(r.right, e.scope);
        t.pop();
        var n, i = e.leftValue_, o = e.value;
        switch(r.operator){
            case "==":
                n = i == o;
                break;
            case "!=":
                n = i != o;
                break;
            case "===":
                n = i === o;
                break;
            case "!==":
                n = i !== o;
                break;
            case ">":
                n = i > o;
                break;
            case ">=":
                n = i >= o;
                break;
            case "<":
                n = i < o;
                break;
            case "<=":
                n = i <= o;
                break;
            case "+":
                n = i + o;
                break;
            case "-":
                n = i - o;
                break;
            case "*":
                n = i * o;
                break;
            case "/":
                n = i / o;
                break;
            case "%":
                n = i % o;
                break;
            case "&":
                n = i & o;
                break;
            case "|":
                n = i | o;
                break;
            case "^":
                n = i ^ o;
                break;
            case "<<":
                n = i << o;
                break;
            case ">>":
                n = i >> o;
                break;
            case ">>>":
                n = i >>> o;
                break;
            case "in":
                o && o.isObject || this.throwException(this.TYPE_ERROR, "'in' expects an object, not '" + o + "'"), n = this.hasProperty(o, i);
                break;
            case "instanceof":
                this.isa(o, this.FUNCTION) || this.throwException(this.TYPE_ERROR, "Right-hand side of instanceof is not an object"), n = !!i.isObject && this.isa(i, o);
                break;
            default:
                throw SyntaxError("Unknown binary operator: " + r.operator);
        }
        t[t.length - 1].value = n;
    }, t.prototype.stepBlockStatement = function(t, e, r) {
        var n = e.n_ || 0, i = r.body[n];
        if (i) return e.n_ = n + 1, new $1c811abb26f94012$var$tn(i, e.scope);
        t.pop();
    }, t.prototype.stepBreakStatement = function(t, e, r) {
        t.pop();
        var n = null;
        for(r.label && (n = r.label.name); e && "CallExpression" !== e.node.type && "NewExpression" !== e.node.type;){
            if (n) {
                if (e.labels && -1 !== e.labels.indexOf(n)) return;
            } else if (e.isLoop || e.isSwitch) return;
            e = t.pop();
        }
        throw SyntaxError("Illegal break statement");
    }, t.prototype.stepCallExpression = function(e, r, n) {
        if (!r.doneCallee_) {
            r.doneCallee_ = 1;
            var i = new $1c811abb26f94012$var$tn(n.callee, r.scope);
            return i.components = !0, i;
        }
        if (1 === r.doneCallee_) {
            r.doneCallee_ = 2;
            var o = r.value;
            if (Array.isArray(o)) {
                if (r.func_ = this.getValue(o), o[0] !== t.SCOPE_REFERENCE && (r.funcThis_ = o[0]), (o = r.func_) && "object" == typeof o && o.isGetter) return o.isGetter = !1, r.doneCallee_ = 1, this.createGetter_(o, r.value);
            } else r.func_ = o;
            r.arguments_ = [], r.n_ = 0;
        }
        if (o = r.func_, !r.doneArgs_) {
            if (0 !== r.n_ && r.arguments_.push(r.value), n.arguments[r.n_]) return new $1c811abb26f94012$var$tn(n.arguments[r.n_++], r.scope);
            "NewExpression" === n.type ? (o.illegalConstructor && this.throwException(this.TYPE_ERROR, o + " is not a constructor"), r.funcThis_ = this.createObject(o), r.isConstructor = !0) : void 0 === r.funcThis_ && (r.funcThis_ = r.scope.strict ? void 0 : this.global), r.doneArgs_ = !0;
        }
        if (r.doneExec_) e.pop(), r.isConstructor && "object" != typeof r.value ? e[e.length - 1].value = r.funcThis_ : e[e.length - 1].value = r.value;
        else {
            r.doneExec_ = !0, o && o.isObject || (console.log("non-function called", o, r), this.throwException(this.TYPE_ERROR, o + " is not a function"));
            var s = o.node;
            if (s) {
                for(var a = this.createScope(s.body, o.parentScope), u = 0; u < s.params.length; u++){
                    var c = s.params[u].name, l = r.arguments_.length > u ? r.arguments_[u] : void 0;
                    this.setProperty(a, c, l);
                }
                var p = this.createObjectProto(this.ARRAY_PROTO);
                for(u = 0; u < r.arguments_.length; u++)this.setProperty(p, u, r.arguments_[u]);
                this.setProperty(a, "arguments", p);
                var h = s.id && s.id.name;
                return h && this.setProperty(a, h, o), this.setProperty(a, "this", r.funcThis_, t.READONLY_DESCRIPTOR), r.value = void 0, new $1c811abb26f94012$var$tn(s.body, a);
            }
            if (o.eval) {
                var d = r.arguments_[0];
                if ("string" == typeof d) {
                    try {
                        var f = $1c811abb26f94012$var$Dt(d.toString(), t.PARSE_OPTIONS);
                    } catch (t) {
                        this.throwException(this.SYNTAX_ERROR, "Invalid code: " + t.message);
                    }
                    var y = new this.nodeConstructor;
                    return y.type = "EvalProgram_", y.body = f.body, this.stripLocations_(y, n.start, n.end), (a = r.scope).strict ? a = this.createScope(f, a) : this.populateScope_(f, a), this.value = void 0, new $1c811abb26f94012$var$tn(y, a);
                }
                r.value = d;
            } else if (o.nativeFunc) void 0 !== r.funcThis_ && void 0 !== r.funcThis_._native ? r.value = o.nativeFunc.call(r.funcThis_, r.arguments_) : r.value = o.nativeFunc.apply(r.funcThis_, r.arguments_);
            else {
                if (o.asyncFunc) {
                    var g = this, v = r.arguments_.concat(function(t) {
                        r.value = t, g.paused_ = !1;
                    });
                    return this.paused_ = !0, void o.asyncFunc.apply(r.funcThis_, v);
                }
                this.throwException(this.TYPE_ERROR, o.class + " is not a function");
            }
        }
    }, t.prototype.stepCatchClause = function(t, e, r) {
        if (!e.done_) {
            e.done_ = !0;
            var n = this.createSpecialScope(e.scope);
            return this.setProperty(n, r.param.name, e.throwValue), new $1c811abb26f94012$var$tn(r.body, n);
        }
        t.pop();
    }, t.prototype.stepConditionalExpression = function(t, e, r) {
        var n = e.mode_ || 0;
        if (0 === n) return e.mode_ = 1, new $1c811abb26f94012$var$tn(r.test, e.scope);
        if (1 === n) {
            e.mode_ = 2;
            var i = Boolean(e.value);
            if (i && r.consequent) return new $1c811abb26f94012$var$tn(r.consequent, e.scope);
            if (!i && r.alternate) return new $1c811abb26f94012$var$tn(r.alternate, e.scope);
            this.value = void 0;
        }
        t.pop(), "ConditionalExpression" === r.type && (t[t.length - 1].value = e.value);
    }, t.prototype.stepContinueStatement = function(t, e, r) {
        t.pop();
        var n = null;
        for(r.label && (n = r.label.name), e = t[t.length - 1]; e && "CallExpression" !== e.node.type && "NewExpression" !== e.node.type;){
            if (e.isLoop && (!n || e.labels && -1 !== e.labels.indexOf(n))) return;
            t.pop(), e = t[t.length - 1];
        }
        throw SyntaxError("Illegal continue statement");
    }, t.prototype.stepDebuggerStatement = function(t, e, r) {
        t.pop();
    }, t.prototype.stepDoWhileStatement = function(t, e, r) {
        if ("DoWhileStatement" === r.type && void 0 === e.test_ && (e.value = !0, e.test_ = !0), !e.test_) return e.test_ = !0, new $1c811abb26f94012$var$tn(r.test, e.scope);
        if (e.value) {
            if (r.body) return e.test_ = !1, e.isLoop = !0, new $1c811abb26f94012$var$tn(r.body, e.scope);
        } else t.pop();
    }, t.prototype.stepEmptyStatement = function(t, e, r) {
        t.pop();
    }, t.prototype.stepEvalProgram_ = function(t, e, r) {
        var n = e.n_ || 0, i = r.body[n];
        if (i) return e.n_ = n + 1, new $1c811abb26f94012$var$tn(i, e.scope);
        t.pop(), t[t.length - 1].value = this.value;
    }, t.prototype.stepExpressionStatement = function(t, e, r) {
        if (!e.done_) return e.done_ = !0, new $1c811abb26f94012$var$tn(r.expression, e.scope);
        t.pop(), this.value = e.value;
    }, t.prototype.stepForInStatement = function(e, r, n) {
        if (!r.doneInit_ && (r.doneInit_ = !0, n.left.declarations && n.left.declarations[0].init)) return r.scope.strict && this.throwException(this.SYNTAX_ERROR, "for-in loop variable declaration may not have an initializer."), new $1c811abb26f94012$var$tn(n.left, r.scope);
        if (!r.doneObject_) return r.doneObject_ = !0, r.variable_ || (r.variable_ = r.value), new $1c811abb26f94012$var$tn(n.right, r.scope);
        if (r.isLoop || (r.isLoop = !0, r.object_ = r.value, r.visited_ = Object.create(null)), void 0 === r.name_) {
            t: do {
                if (r.object_ && r.object_.isObject) {
                    r.props_ || (r.props_ = Object.getOwnPropertyNames(r.object_.properties));
                    do var i = r.props_.shift();
                    while (i && (r.visited_[i] || !Object.prototype.hasOwnProperty.call(r.object_.properties, i)));
                    if (i && (r.visited_[i] = !0, Object.prototype.propertyIsEnumerable.call(r.object_.properties, i))) {
                        r.name_ = i;
                        break t;
                    }
                } else if (null !== r.object_) {
                    r.props_ || (r.props_ = Object.getOwnPropertyNames(r.object_));
                    do i = r.props_.shift();
                    while (i && r.visited_[i]);
                    if (i) {
                        r.visited_[i] = !0, r.name_ = i;
                        break t;
                    }
                }
                r.object_ = this.getPrototype(r.object_), r.props_ = null;
            }while (null !== r.object_);
            if (null === r.object_) return void e.pop();
        }
        if (!r.doneVariable_) {
            r.doneVariable_ = !0;
            var o = n.left;
            if ("VariableDeclaration" !== o.type) {
                r.variable_ = null;
                var s = new $1c811abb26f94012$var$tn(o, r.scope);
                return s.components = !0, s;
            }
            r.variable_ = [
                t.SCOPE_REFERENCE,
                o.declarations[0].id.name
            ];
        }
        if (r.variable_ || (r.variable_ = r.value), !r.doneSetter_) {
            r.doneSetter_ = !0;
            var a = r.name_, u = this.setValue(r.variable_, a);
            if (u) return this.createSetter_(u, r.variable_, a);
        }
        return r.name_ = void 0, r.doneVariable_ = !1, r.doneSetter_ = !1, n.body ? new $1c811abb26f94012$var$tn(n.body, r.scope) : void 0;
    }, t.prototype.stepForStatement = function(t, e, r) {
        var n = e.mode_ || 0;
        if (0 === n) {
            if (e.mode_ = 1, r.init) return new $1c811abb26f94012$var$tn(r.init, e.scope);
        } else if (1 === n) {
            if (e.mode_ = 2, r.test) return new $1c811abb26f94012$var$tn(r.test, e.scope);
        } else if (2 === n) {
            if (e.mode_ = 3, !r.test || e.value) return e.isLoop = !0, new $1c811abb26f94012$var$tn(r.body, e.scope);
            t.pop();
        } else if (3 === n && (e.mode_ = 1, r.update)) return new $1c811abb26f94012$var$tn(r.update, e.scope);
    }, t.prototype.stepFunctionDeclaration = function(t, e, r) {
        t.pop();
    }, t.prototype.stepFunctionExpression = function(t, e, r) {
        t.pop(), t[t.length - 1].value = this.createFunction(r, e.scope);
    }, t.prototype.stepIdentifier = function(e, r, n) {
        if (e.pop(), r.components) e[e.length - 1].value = [
            t.SCOPE_REFERENCE,
            n.name
        ];
        else {
            var i = this.getValueFromScope(n.name);
            if (i && "object" == typeof i && i.isGetter) {
                i.isGetter = !1;
                for(var o = r.scope; !this.hasProperty(o, n.name);)o = o.parentScope;
                var s = i;
                return this.createGetter_(s, this.global);
            }
            e[e.length - 1].value = i;
        }
    }, t.prototype.stepIfStatement = function(t, e, r) {
        return this.stepConditionalExpression(t, e, r);
    }, t.prototype.stepLabeledStatement = function(t, e, r) {
        t.pop();
        var n = e.labels || [];
        n.push(r.label.name);
        var i = new $1c811abb26f94012$var$tn(r.body, e.scope);
        return i.labels = n, i;
    }, t.prototype.stepLiteral = function(t, e, r) {
        t.pop();
        var n = r.value;
        if (n instanceof RegExp) {
            var i = this.createObjectProto(this.REGEXP_PROTO);
            this.populateRegExp(i, n), n = i;
        }
        t[t.length - 1].value = n;
    }, t.prototype.stepLogicalExpression = function(t, e, r) {
        if ("&&" !== r.operator && "||" !== r.operator) throw SyntaxError("Unknown logical operator: " + r.operator);
        if (!e.doneLeft_) return e.doneLeft_ = !0, new $1c811abb26f94012$var$tn(r.left, e.scope);
        if (e.doneRight_) t.pop(), t[t.length - 1].value = e.value;
        else {
            if (!("&&" === r.operator && !e.value || "||" === r.operator && e.value)) return e.doneRight_ = !0, new $1c811abb26f94012$var$tn(r.right, e.scope);
            t.pop(), t[t.length - 1].value = e.value;
        }
    }, t.prototype.stepMemberExpression = function(t, e, r) {
        if (!e.doneObject_) return e.doneObject_ = !0, new $1c811abb26f94012$var$tn(r.object, e.scope);
        var n;
        if (r.computed) {
            if (!e.doneProperty_) return e.object_ = e.value, e.doneProperty_ = !0, new $1c811abb26f94012$var$tn(r.property, e.scope);
            n = e.value;
        } else e.object_ = e.value, n = r.property.name;
        if (t.pop(), e.components) t[t.length - 1].value = [
            e.object_,
            n
        ];
        else {
            var i = this.getProperty(e.object_, n);
            if (i && "object" == typeof i && i.isGetter) {
                i.isGetter = !1;
                var o = i;
                return this.createGetter_(o, e.object_);
            }
            t[t.length - 1].value = i;
        }
    }, t.prototype.stepNewExpression = function(t, e, r) {
        return this.stepCallExpression(t, e, r);
    }, t.prototype.stepObjectExpression = function(t, e, r) {
        var n = e.n_ || 0, i = r.properties[n];
        if (e.object_) {
            var o = i.key;
            if ("Identifier" === o.type) var s = o.name;
            else {
                if ("Literal" !== o.type) throw SyntaxError("Unknown object structure: " + o.type);
                s = o.value;
            }
            e.properties_[s] || (e.properties_[s] = {}), e.properties_[s][i.kind] = e.value, e.n_ = ++n, i = r.properties[n];
        } else e.object_ = this.createObjectProto(this.OBJECT_PROTO), e.properties_ = Object.create(null);
        if (i) return new $1c811abb26f94012$var$tn(i.value, e.scope);
        for(var a in e.properties_){
            var u = e.properties_[a];
            if ("get" in u || "set" in u) {
                var c = {
                    configurable: !0,
                    enumerable: !0,
                    get: u.get,
                    set: u.set
                };
                this.setProperty(e.object_, a, null, c);
            } else this.setProperty(e.object_, a, u.init);
        }
        t.pop(), t[t.length - 1].value = e.object_;
    }, t.prototype.stepProgram = function(t, e, r) {
        var n = e.n_ || 0, i = r.body[n];
        if (i) return e.done = !1, e.n_ = n + 1, new $1c811abb26f94012$var$tn(i, e.scope);
        e.done = !0;
    }, t.prototype.stepReturnStatement = function(t, e, r) {
        if (r.argument && !e.done_) return e.done_ = !0, new $1c811abb26f94012$var$tn(r.argument, e.scope);
        var n = e.value, i = t.length - 1;
        for(e = t[i]; "CallExpression" !== e.node.type && "NewExpression" !== e.node.type;){
            if ("TryStatement" !== e.node.type && t.splice(i, 1), --i < 0) throw SyntaxError("Illegal return statement");
            e = t[i];
        }
        e.value = n;
    }, t.prototype.stepSequenceExpression = function(t, e, r) {
        var n = e.n_ || 0, i = r.expressions[n];
        if (i) return e.n_ = n + 1, new $1c811abb26f94012$var$tn(i, e.scope);
        t.pop(), t[t.length - 1].value = e.value;
    }, t.prototype.stepSwitchStatement = function(t, e, r) {
        if (!e.test_) return e.test_ = 1, new $1c811abb26f94012$var$tn(r.discriminant, e.scope);
        for(1 === e.test_ && (e.test_ = 2, e.switchValue_ = e.value);;){
            var n = e.index_ || 0, i = r.cases[n];
            if (e.matched_ || !i || i.test) {
                if (i || e.matched_ || !e.defaultCase_) {
                    if (!i) return void t.pop();
                    if (!e.matched_ && !e.tested_ && i.test) return e.tested_ = !0, new $1c811abb26f94012$var$tn(i.test, e.scope);
                    if (e.matched_ || e.value === e.switchValue_) {
                        e.matched_ = !0;
                        var o = e.n_ || 0;
                        if (i.consequent[o]) return e.isSwitch = !0, e.n_ = o + 1, new $1c811abb26f94012$var$tn(i.consequent[o], e.scope);
                    }
                    e.tested_ = !1, e.n_ = 0, e.index_ = n + 1;
                } else e.matched_ = !0, e.index_ = e.defaultCase_;
            } else e.defaultCase_ = n, e.index_ = n + 1;
        }
    }, t.prototype.stepThisExpression = function(t, e, r) {
        t.pop(), t[t.length - 1].value = this.getValueFromScope("this");
    }, t.prototype.stepThrowStatement = function(t, e, r) {
        if (!e.done_) return e.done_ = !0, new $1c811abb26f94012$var$tn(r.argument, e.scope);
        this.throwException(e.value);
    }, t.prototype.stepTryStatement = function(t, e, r) {
        if (!e.doneBlock_) return e.doneBlock_ = !0, new $1c811abb26f94012$var$tn(r.block, e.scope);
        if (e.throwValue && !e.doneHandler_ && r.handler) {
            e.doneHandler_ = !0;
            var n = new $1c811abb26f94012$var$tn(r.handler, e.scope);
            return n.throwValue = e.throwValue, e.throwValue = null, n;
        }
        if (!e.doneFinalizer_ && r.finalizer) return e.doneFinalizer_ = !0, new $1c811abb26f94012$var$tn(r.finalizer, e.scope);
        e.throwValue ? this.executeException(e.throwValue) : t.pop();
    }, t.prototype.stepUnaryExpression = function(e, r, n) {
        if (!r.done_) {
            r.done_ = !0;
            var i = new $1c811abb26f94012$var$tn(n.argument, r.scope);
            return i.components = "delete" === n.operator, i;
        }
        e.pop();
        var o = r.value;
        if ("-" === n.operator) o = -o;
        else if ("+" === n.operator) o = +o;
        else if ("!" === n.operator) o = !o;
        else if ("~" === n.operator) o = ~o;
        else if ("delete" === n.operator) {
            var s = !0;
            if (Array.isArray(o)) {
                var a = o[0];
                a === t.SCOPE_REFERENCE && (a = r.scope);
                var u = String(o[1]);
                try {
                    delete a.properties[u];
                } catch (t) {
                    r.scope.strict ? this.throwException(this.TYPE_ERROR, "Cannot delete property '" + u + "' of '" + a + "'") : s = !1;
                }
            }
            o = s;
        } else if ("typeof" === n.operator) o = o && "Function" === o.class ? "function" : typeof o;
        else {
            if ("void" !== n.operator) throw SyntaxError("Unknown unary operator: " + n.operator);
            o = void 0;
        }
        e[e.length - 1].value = o;
    }, t.prototype.stepUpdateExpression = function(t, e, r) {
        if (!e.doneLeft_) {
            e.doneLeft_ = !0;
            var n = new $1c811abb26f94012$var$tn(r.argument, e.scope);
            return n.components = !0, n;
        }
        if (e.leftSide_ || (e.leftSide_ = e.value), e.doneGetter_ && (e.leftValue_ = e.value), !e.doneGetter_) {
            var i = this.getValue(e.leftSide_);
            if (e.leftValue_ = i, i && "object" == typeof i && i.isGetter) {
                i.isGetter = !1, e.doneGetter_ = !0;
                var o = i;
                return this.createGetter_(o, e.leftSide_);
            }
        }
        if (e.doneSetter_) return t.pop(), void (t[t.length - 1].value = e.doneSetter_);
        var s;
        if (i = Number(e.leftValue_), "++" === r.operator) s = i + 1;
        else {
            if ("--" !== r.operator) throw SyntaxError("Unknown update expression: " + r.operator);
            s = i - 1;
        }
        var a = r.prefix ? s : i, u = this.setValue(e.leftSide_, s);
        if (u) return e.doneSetter_ = a, this.createSetter_(u, e.leftSide_, s);
        t.pop(), t[t.length - 1].value = a;
    }, t.prototype.stepVariableDeclaration = function(t, e, r) {
        var n = r.declarations, i = e.n_ || 0, o = n[i];
        for(e.init_ && o && (this.setValueToScope(o.id.name, e.value), e.init_ = !1, o = n[++i]); o;){
            if (o.init) return e.n_ = i, e.init_ = !0, new $1c811abb26f94012$var$tn(o.init, e.scope);
            o = n[++i];
        }
        t.pop();
    }, t.prototype.stepWithStatement = function(t, e, r) {
        if (!e.doneObject_) return e.doneObject_ = !0, new $1c811abb26f94012$var$tn(r.object, e.scope);
        if (!e.doneBody_) {
            e.doneBody_ = !0;
            var n = this.createSpecialScope(e.scope, e.value);
            return new $1c811abb26f94012$var$tn(r.body, n);
        }
        t.pop();
    }, t.prototype.stepWhileStatement = function(t, e, r) {
        return this.stepDoWhileStatement(t, e, r);
    }, t.PARSE_OPTIONS = {
        ecmaVersion: 5
    }, t.READONLY_DESCRIPTOR = {
        configurable: !0,
        enumerable: !0,
        writable: !1
    }, t.NONENUMERABLE_DESCRIPTOR = {
        configurable: !0,
        enumerable: !1,
        writable: !0
    }, t.READONLY_NONENUMERABLE_DESCRIPTOR = {
        configurable: !0,
        enumerable: !1,
        writable: !1
    }, t.VARIABLE_DESCRIPTOR = {
        configurable: !1,
        enumerable: !0,
        writable: !0
    }, t.STEP_ERROR = {}, t.SCOPE_REFERENCE = {}, t.toStringCycles_ = [], t;
}(), $1c811abb26f94012$var$Qr = function() {
    function t(t) {
        this.proto = null, this.isObject = !0, this.class = "Object", this.data = null, this._native = void 0, this.getter = Object.create(null), this.setter = Object.create(null), this.properties = Object.create(null), this.proto = t;
    }
    return t.prototype.toString = function() {
        if ("Array" === this.class) {
            (n = $1c811abb26f94012$var$Kr.toStringCycles_).push(this);
            try {
                for(var t = [], e = 0; e < this.properties.length; e++){
                    var r = this.properties[e];
                    t[e] = r && r.isObject && -1 !== n.indexOf(r) ? "..." : r;
                }
            } finally{
                n.pop();
            }
            return t.join(",");
        }
        if ("Error" === this.class) {
            var n;
            if (-1 !== (n = $1c811abb26f94012$var$Kr.toStringCycles_).indexOf(this)) return "[object Error]";
            var i, o = void 0, s = this;
            do if ("name" in s.properties) {
                i = s.properties.name;
                break;
            }
            while (s = s.proto);
            s = this;
            do if ("message" in s.properties) {
                o = s.properties.message;
                break;
            }
            while (s = s.proto);
            n.push(this);
            try {
                i = i && i.toString(), o = o && o.toString();
            } finally{
                n.pop();
            }
            return o ? i + ": " + o : String(i);
        }
        return null !== this.data ? String(this.data) : "[object " + this.class + "]";
    }, t.prototype.valueOf = function() {
        return void 0 === this.data || null === this.data || this.data instanceof RegExp ? this : this.data instanceof Date ? this.data.valueOf() : this.data;
    }, t;
}(), $1c811abb26f94012$var$tn = function(t, e) {
    this.node = t, this.scope = e;
}, $1c811abb26f94012$var$en = function(t, e) {
    for(var r = t; r && r.prototype;){
        if (Object.getOwnPropertyNames(r.prototype).indexOf(e) >= 0) return !0;
        r = Object.getPrototypeOf(r);
    }
    return !1;
};
function $1c811abb26f94012$var$rn(t, e) {
    var r = {}, n = $1c811abb26f94012$var$Dt(t, {
        locations: !0,
        onComment: function(t, e, n, i, o, s) {
            r[s.line] = e;
        }
    });
    if ("Program" !== n.type || 1 !== n.body.length || "FunctionDeclaration" !== n.body[0].type) throw new Error("JavaScript program should only have one function definition");
    var i = n.body[0].body.body, o = [], s = [];
    return i.forEach(function(t) {
        if ("ExpressionStatement" === t.type) {
            var n = t.expression;
            if ("AssignmentExpression" === n.type && "=" === n.operator && "MemberExpression" === n.left.type && "ThisExpression" === n.left.object.type && "Identifier" === n.left.property.type) {
                for(var i = [], a = n.loc.start.line - 1; a >= 0 && void 0 !== r[a]; a--)i.push(r[a]);
                if (!(i.length <= 0)) {
                    var u = n.left.property.name;
                    if (!(Array.isArray(e) && e.indexOf(u) >= 0) && "FunctionExpression" !== n.right.type) {
                        var c = function(t, e, r) {
                            var n = {
                                name: t,
                                title: {},
                                className: null,
                                proposed: !1,
                                initialValue: null
                            };
                            if (e.forEach(function(t) {
                                var e = t.indexOf("@ui ");
                                if (e >= 0) n.description = t.substring(e + 4).trim();
                                else {
                                    var r = t.indexOf("@title ");
                                    if (r >= 0) {
                                        var i = t.substring(r + 7).trim();
                                        0 === i.indexOf("@ja ") ? n.title.ja = i.substring(4).trim() : n.title.default = i;
                                    } else if (t.indexOf("@proposed") >= 0) n.proposed = !0;
                                    else {
                                        var o = t.indexOf("@comment ");
                                        if (o >= 0) {
                                            var s = t.substring(o + 9).trim();
                                            return n.comment || (n.comment = {}), void (0 === s.indexOf("@ja ") ? n.comment.ja = s.substring(4).trim() : n.comment.default = s);
                                        }
                                    }
                                }
                            }), !n.description && !n.comment) return null;
                            if (n.proposed || n.comment) return n;
                            var i = n.description.indexOf("("), o = n.description.indexOf(")", i);
                            if (!(i < 0 || o < 0)) {
                                n.className = n.description.substr(0, i);
                                try {
                                    var s = new $1c811abb26f94012$var$Kr("[".concat(n.description.substr(i + 1, o - i - 1), "]")), a = Date.now();
                                    for(s.unwrap = null, s.wrap = null; s.step() && !(Date.now() - a > 100););
                                    n.params = s.pseudoToNative(s.value);
                                } catch (t) {}
                                return n.params || (n.params = []), n;
                            }
                        }(u, i);
                        s.push(n), c && o.push(c);
                    }
                }
            }
        }
    }), {
        widgets: o,
        fields: s,
        ast: n
    };
}
function $1c811abb26f94012$var$nn(t, e) {
    if (void 0 === e && (e = -1), !t) return {
        dependencyAtCursor: null,
        dependencies: []
    };
    for(var r = [], n = null, i = ("string" == typeof t ? $1c811abb26f94012$var$Dt(t, $1c811abb26f94012$var$Kr.PARSE_OPTIONS) : t).body[0].body.body.slice(0); i.length > 0;){
        var o = i.shift();
        if (null != o) {
            if ("CallExpression" !== o.type) o.expression && i.push(o.expression), o.object && i.push(o.object), o.property && i.push(o.property), o.name && "string" != typeof name && i.push(o.name), o.left && i.push(o.left), o.right && i.push(o.right), o.id && i.push(o.id), o.init && i.push(o.init), o.callee && i.push(o.callee), o.body && Array.isArray(o.body) && i.push.apply(i, o.body), o.declarations && Array.isArray(o.declarations) && i.push.apply(i, o.declarations), o.arguments && Array.isArray(o.arguments) && i.push.apply(i, o.arguments), o.params && Array.isArray(o.params) && i.push.apply(i, o.params);
            else if (o.callee.name && "require" === o.callee.name) {
                var s = o.arguments;
                if (s && Array.isArray(s) && 1 === s.length) {
                    var a = s[0];
                    if ("Literal" === a.type) {
                        var u = a.value;
                        r.push(u), o.start && o.end && o.start <= e && o.end >= e && (n = u);
                    }
                }
            }
        }
    }
    return {
        dependencyAtCursor: n,
        dependencies: r
    };
}
$1c811abb26f94012$var$Kr.Object = $1c811abb26f94012$var$Qr, $1c811abb26f94012$var$Kr.State = $1c811abb26f94012$var$tn;
var $1c811abb26f94012$var$on = function() {
    return $1c811abb26f94012$var$on = Object.assign || function(t) {
        for(var e, r = 1, n = arguments.length; r < n; r++)for(var i in e = arguments[r])Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
        return t;
    }, $1c811abb26f94012$var$on.apply(this, arguments);
};
function $1c811abb26f94012$var$sn(t, e, r) {
    for(var n, i = 0, o = e.length; i < o; i++)!n && i in e || (n || (n = Array.prototype.slice.call(e, 0, i)), n[i] = e[i]);
    return t.concat(n || Array.prototype.slice.call(e));
}
function $1c811abb26f94012$var$an(t) {
    return "boolean" == typeof t || "number" == typeof t || "string" == typeof t || null == t;
}
"function" == typeof SuppressedError && SuppressedError;
var $1c811abb26f94012$var$un = {
    type: "ExpressionStatement",
    start: null,
    end: null,
    expression: {
        type: "CallExpression",
        start: null,
        end: null,
        expression: null,
        arguments: null
    },
    arguments: null
}, $1c811abb26f94012$var$cn = function() {
    function t(t, e, r) {
        void 0 === r && (r = null), this.wrapperTable = t, this.ignoredPropNames = e, this.wrapMethodParameter = r, this.verbose = !1, this.initialize();
    }
    return t.prototype.initialize = function() {
        var t = this, e = new $1c811abb26f94012$var$Kr("", function(e, r) {
            t.globalScope = r;
        });
        this.interpreter = e, this.interpreter.wrap = function(e) {
            return t.wrap(e);
        }, this.interpreter.unwrap = function(e, r) {
            return t.unwrap(e, r);
        }, this.wrappers = {}, Object.keys(this.wrapperTable).forEach(function(e) {
            return t.wrapClass(t.wrapperTable[e], e);
        });
    }, t.prototype.createGlobalFunction = function(t, e) {
        var r, n = this, i = e.func, o = e.raw, s = e.isConstructor, a = e.async, u = function() {
            for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
            var r = i(o ? t : t.map(function(e, r) {
                return r < t.length - 1 || !a ? n.unwrap(e) : e;
            }));
            return o ? r : n.wrap(r);
        };
        r = a ? this.interpreter.createAsyncFunction(u) : this.interpreter.createNativeFunction(u, s), this.interpreter.setProperty(this.globalScope, t, r);
    }, t.prototype.createFunction = function(t, e) {
        return void 0 === e && (e = !1), this.interpreter.createNativeFunction(t, e);
    }, t.prototype.setProperty = function(t, e, r) {
        this.interpreter.setProperty(t, e, this.wrap(r));
    }, t.prototype.setRawProperty = function(t, e, r) {
        this.interpreter.setProperty(t, e, r);
    }, t.prototype.getProperty = function(t, e) {
        return this.unwrap(this.interpreter.getProperty(t, e));
    }, t.prototype.getRawProperty = function(t, e) {
        return this.interpreter.getProperty(t, e);
    }, t.prototype.prepareRun = function(t) {
        var e;
        e = "string" == typeof t ? $1c811abb26f94012$var$Dt(t, $1c811abb26f94012$var$Kr.PARSE_OPTIONS) : t;
        var r = this.interpreter.createScope(e, this.globalScope);
        return this.interpreter.stateStack = [
            {
                node: e,
                scope: r,
                done: !1
            }
        ], r;
    }, t.prototype.newStatementFor = function(t) {
        return $1c811abb26f94012$var$Dt("new " + t + "();", $1c811abb26f94012$var$Kr.PARSE_OPTIONS);
    }, t.prototype.prepareNewInstance = function(t, e) {
        var r = this.interpreter.createScope($1c811abb26f94012$var$Dt("", $1c811abb26f94012$var$Kr.PARSE_OPTIONS), e);
        return this.interpreter.stateStack = [
            {
                node: t,
                scope: r,
                thisExpression: r
            }
        ], r;
    }, t.prototype.exec = function(t, e, r, n) {
        var i = this, o = this.interpreter;
        $1c811abb26f94012$var$un.expression.arguments = [];
        var s = [];
        return r.forEach(function(t) {
            $1c811abb26f94012$var$un.expression.arguments.push(null), s.push(i.wrap(t));
        }), o.stateStack = [
            {
                node: {
                    type: "Program",
                    body: [
                        $1c811abb26f94012$var$un
                    ]
                },
                scope: this.globalScope,
                done: !0,
                n_: 1
            },
            {
                node: $1c811abb26f94012$var$un,
                scope: this.globalScope,
                done_: !0
            },
            {
                node: $1c811abb26f94012$var$un.expression,
                doneCallee_: 2,
                doneArgs_: !0,
                arguments_: s,
                funcThis_: t,
                func_: o.getProperty(t, e),
                scope: t,
                n_: s.length,
                value: [
                    t,
                    e
                ]
            }
        ], this.run(700, "call a method (" + t.className + "." + e + (n || "") + ")");
    }, t.prototype.run = function(t, e) {
        var r = this.interpreter, n = Date.now(), i = !1;
        try {
            for(; r.step();)if (Date.now() - n > t) {
                i = !0;
                break;
            }
        } catch (o) {
            throw this.verbose && console.log(r.stateStack), "string" == typeof o && (o = new Error(o)), r.stateStack.length > 0 && (o.node = r.stateStack[r.stateStack.length - 1].node), o;
        }
        if (i) {
            var o = new Error("timeout: spent too long time (> " + t + "ms) to " + e);
            throw r.stateStack.length > 0 && (o.node = r.stateStack[0].node), o;
        }
        return this.interpreter.value;
    }, t.prototype.cleanupProperties = function(t) {
        if (!t) return null;
        for(var e in this.ignoredPropNames.forEach(function(e) {
            void 0 !== t.properties[e] && delete t.properties[e];
        }), t.properties)this.cleanupProperty(t.properties[e]) || delete t.properties[e];
        return t.properties;
    }, t.prototype.cleanupProperty = function(t) {
        if ($1c811abb26f94012$var$an(t)) return !0;
        var e = t;
        if (e._native) return !0;
        var r = this.globalScope.properties;
        if (e.parent === r.Array) {
            for(var n = e.length, i = 0; i < e.length; i++)this.cleanupProperty(e.properties[i]) || (delete e.properties[i], n--);
            return e.length = n, n > 0;
        }
        if (e.parent === r.Object) {
            var o = !0;
            for(var s in e.properties)this.cleanupProperty(e.properties[s]) ? o = !1 : delete e.properties[s];
            return !o;
        }
        return !1;
    }, t.prototype.restoreProperties = function(t, e) {
        e && (t.properties = $1c811abb26f94012$var$on($1c811abb26f94012$var$on({}, t.properties), e));
    }, t.prototype.wrap = function(t) {
        if ("object" == typeof t && null !== t && void 0 !== t.constructor && "string" == typeof t.constructor.className) {
            var e = t.constructor.className, r = this.wrappers[e];
            if (void 0 === r) return;
            var n = this.interpreter.createObject(r);
            return n._native = t, n;
        }
        return this.verbose && ($1c811abb26f94012$var$an(t) || Array.isArray(t) || console.log("wrap complex obj:", String(t))), this.interpreter.nativeToPseudo(t);
    }, t.prototype.unwrap = function(t, e) {
        return "object" == typeof t && null !== t && t._native ? t._native : this.interpreter.pseudoToNative(t, e);
    }, t.prototype.wrapClass = function(t, e) {
        this.verbose && console.log("--- wrapping " + e + " ---"), t.className = e;
        var r = this, n = this.interpreter.createNativeFunction(function(e) {
            var i, o;
            if (i = r.interpreter.calledWithNew() ? this : r.interpreter.createObjectProto(n.properties.prototype), void 0 !== e) {
                if (Array.isArray(e)) for(var s = 0; s < e.length; s++)o[s] = r.unwrap(e[s]);
                else o = r.unwrap(e);
            }
            if (t) {
                var a = Object.create(t.prototype), u = t.apply(a, [
                    null
                ].concat(o).splice(1));
                i._native = null !== u && "object" == typeof u ? u : a;
            }
            return i;
        });
        return this.interpreter.setProperty(this.globalScope, e, n), this.wrapStaticMembers(n, t), this.wrapInstanceMembers(n, t), this.wrappers[e] = n, n;
    }, t.prototype.wrapStaticMembers = function(t, e) {
        var r = this, n = function(n) {
            var o = n;
            if (i.interpreter.setProperty(t, n, ReferenceError, {
                get: function() {
                    return r.wrap(e[o]);
                },
                set: function(t) {
                    return e[o] = r.unwrap(t);
                }
            }), i.verbose) {
                var s = void 0;
                try {
                    s = typeof e[o];
                } catch (t) {
                    s = "not accessible";
                }
                console.log("static " + o + " (" + s + ")");
            }
        }, i = this;
        for(var o in e)n(o);
    }, t.prototype.wrapInstanceMembers = function(t, e) {
        for(var r, n = new e, i = 0, o = $1c811abb26f94012$var$sn($1c811abb26f94012$var$sn([], Object.keys(n)), function(t) {
            for(var e = t, r = []; e && e.prototype;)r = $1c811abb26f94012$var$sn($1c811abb26f94012$var$sn([], r), Object.getOwnPropertyNames(e.prototype)), e = Object.getPrototypeOf(e);
            return r;
        }(e)).filter(function(t, e, r) {
            return r.indexOf(t) === e;
        }); i < o.length; i++){
            var s = o[i];
            if ("constructor" !== s && !this.interpreter.hasProperty(t, s) && !this.interpreter.hasProperty(t.properties.prototype, s) && "_" !== s.charAt(0)) {
                if (this.verbose) {
                    var a = void 0;
                    try {
                        a = typeof n[s];
                    } catch (t) {
                        a = "not accessible";
                    }
                    r = s + " (" + a + ")";
                }
                try {
                    if ("function" == typeof n[s]) {
                        var u = function(e, r) {
                            return function(n) {
                                var i;
                                return r.wrap((i = this._native)[e].apply(i, n.map(function(e) {
                                    var n = r.unwrap(e);
                                    return r.wrapMethodParameter ? r.wrapMethodParameter(t, n) : n;
                                })));
                            };
                        }(s, this);
                        this.interpreter.setProperty(t.properties.prototype, s, this.interpreter.createNativeFunction(u)), this.verbose && (r += " native method");
                    }
                } catch (t) {}
                this.verbose && console.log(r);
            }
        }
    }, t;
}();
function $1c811abb26f94012$var$ln(t) {
    var e = parseFloat(t);
    return isNaN(e) ? 0 : e;
}
function $1c811abb26f94012$var$pn(t) {
    var e;
    if ("undefined" == typeof window || !(null === (e = null === window || void 0 === window ? void 0 : window.location) || void 0 === e ? void 0 : e.search)) return null;
    for(var r = 0, n = window.location.search.substring(1).split("&"); r < n.length; r++){
        var i = n[r].split("=");
        if (decodeURIComponent(i[0]) === t) return decodeURIComponent(i[1]);
    }
    return null;
}
var $1c811abb26f94012$var$hn = function(t, e) {
    return $1c811abb26f94012$var$hn = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }, $1c811abb26f94012$var$hn(t, e);
};
function $1c811abb26f94012$var$dn(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function r() {
        this.constructor = t;
    }
    $1c811abb26f94012$var$hn(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
}
var $1c811abb26f94012$var$fn = function() {
    return $1c811abb26f94012$var$fn = Object.assign || function(t) {
        for(var e, r = 1, n = arguments.length; r < n; r++)for(var i in e = arguments[r])Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
        return t;
    }, $1c811abb26f94012$var$fn.apply(this, arguments);
};
function $1c811abb26f94012$var$yn(t, e, r, n) {
    return new (r || (r = Promise))(function(e, i) {
        function o(t) {
            try {
                a(n.next(t));
            } catch (t) {
                i(t);
            }
        }
        function s(t) {
            try {
                a(n.throw(t));
            } catch (t) {
                i(t);
            }
        }
        function a(t) {
            var n;
            t.done ? e(t.value) : (n = t.value, n instanceof r ? n : new r(function(t) {
                t(n);
            })).then(o, s);
        }
        a((n = n.apply(t, [])).next());
    });
}
function $1c811abb26f94012$var$gn(t, e) {
    var r, n, i, o, s = {
        label: 0,
        sent: function() {
            if (1 & i[0]) throw i[1];
            return i[1];
        },
        trys: [],
        ops: []
    };
    return o = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
        return this;
    }), o;
    function a(a) {
        return function(u) {
            return function(a) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; o && (o = 0, a[0] && (s = 0)), s;)try {
                    if (r = 1, n && (i = 2 & a[0] ? n.return : a[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, a[1])).done) return i;
                    switch(n = 0, i && (a = [
                        2 & a[0],
                        i.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            i = a;
                            break;
                        case 4:
                            return s.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            s.label++, n = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = s.ops.pop(), s.trys.pop();
                            continue;
                        default:
                            if (!((i = (i = s.trys).length > 0 && i[i.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                s = 0;
                                continue;
                            }
                            if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                                s.label = a[1];
                                break;
                            }
                            if (6 === a[0] && s.label < i[1]) {
                                s.label = i[1], i = a;
                                break;
                            }
                            if (i && s.label < i[2]) {
                                s.label = i[2], s.ops.push(a);
                                break;
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue;
                    }
                    a = e.call(t, s);
                } catch (t) {
                    a = [
                        6,
                        t
                    ], n = 0;
                } finally{
                    r = i = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                u
            ]);
        };
    }
}
function $1c811abb26f94012$var$vn(t, e, r) {
    if (2 === arguments.length) for(var n, i = 0, o = e.length; i < o; i++)!n && i in e || (n || (n = Array.prototype.slice.call(e, 0, i)), n[i] = e[i]);
    return t.concat(n || Array.prototype.slice.call(e));
}
"function" == typeof SuppressedError && SuppressedError;
var $1c811abb26f94012$var$mn, $1c811abb26f94012$var$bn, $1c811abb26f94012$var$_n = [
    0,
    0,
    0,
    0
], $1c811abb26f94012$export$e985807e6b50ff90 = function() {
    function t() {
        this._position = 0, this._wait = 50, this.update = this.update.bind(this);
    }
    return Object.defineProperty(t.prototype, "wait", {
        get: function() {
            return this._wait;
        },
        set: function(t) {
            this._wait = t, this._isPlaying && this.start();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isPlaying", {
        get: function() {
            return this._isPlaying;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "position", {
        get: function() {
            if (!this.isPlaying) return this._position;
            var t = this.basePosition.position + (Date.now() - this.basePosition.time);
            return Math.min(t, this.player.video.duration);
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.initialize = function(t) {
        var e = t.player, r = t.updater, n = t.emitter;
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(t) {
                return this.player = e, this.updateMediaPosition = r, this.emitter = n, [
                    2
                ];
            });
        });
    }, t.prototype.play = function() {
        this.start(), this.emitter.onPlay();
    }, t.prototype.stop = function() {
        this.clearInterval(), this._isPlaying = !1, this.seek(0), this.pause(), this.emitter.onStop();
    }, t.prototype.pause = function() {
        this.clearInterval(), this._isPlaying = !1, this.emitter.onPause();
    }, t.prototype.seek = function(t) {
        var e = this;
        this._position = t, this.updateMediaPosition(t).then(function() {
            e.emitter.onSeek(t), e.emitter.onSeekComplete(t);
        }), this.isPlaying && this.start();
    }, t.prototype.dispose = function() {
        this.clearInterval();
    }, t.prototype.clearInterval = function() {
        window.clearInterval(this.intervalId);
    }, t.prototype.start = function() {
        this.clearInterval(), this._isPlaying = !0, this.basePosition = {
            time: Date.now(),
            position: this._position
        }, this.intervalId = window.setInterval(this.update, this.wait);
    }, t.prototype.update = function() {
        this.player.video || this.stop();
        var t = this.basePosition.position + (Date.now() - this.basePosition.time);
        this._position = Math.min(t, this.player.video.duration), this.updateMediaPosition(this.position), this._position >= this.player.video.duration && this.stop();
    }, t;
}();

function $1c811abb26f94012$var$Pn() {
    return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
        return $1c811abb26f94012$var$gn(this, function(t) {
            return $1c811abb26f94012$var$bn && $1c811abb26f94012$var$bn.Player ? [
                2,
                $1c811abb26f94012$var$bn
            ] : "undefined" == typeof window ? [
                2,
                (parcelRequire("7gFhF"))
            ] : window.Songle && window.Songle.Player ? [
                2,
                window.Songle
            ] : ($1c811abb26f94012$var$mn || ($1c811abb26f94012$var$mn = new Promise(function(t) {
                var e = !1;
                window.onSongleAPIReady = function(r) {
                    e = !0, t($1c811abb26f94012$var$bn = r);
                }, setTimeout(function() {
                    if (!e) {
                        var t = [];
                        document.querySelectorAll("script").forEach(function(e) {
                            var r = e.getAttribute("src");
                            r && r.indexOf("songle.jp/v2/api.js") >= 0 && t.push(e);
                        }), t.forEach(function(t) {
                            return t.parentElement.removeChild(t);
                        });
                        var r = document.createElement("script");
                        r.src = "https://api.songle.jp/v2/api.js", document.head.appendChild(r);
                    }
                }, 1e3);
            })), [
                2,
                $1c811abb26f94012$var$mn
            ]);
        });
    });
}
var $1c811abb26f94012$export$c66cf4e5d83f6286 = function() {
    function t(t) {
        void 0 === t && (t = {}), this.options = t, this.wait = 50, this.volumeListener = {
            onVolumeUpdate: this.onVolumeUpdate.bind(this)
        }, this.resetProps();
    }
    return Object.defineProperty(t.prototype, "songlePlayer", {
        get: function() {
            return this._songlePlayer;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isPlaying", {
        get: function() {
            return !!this._songlePlayer && this._songlePlayer.isPlaying;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "withSync", {
        get: function() {
            var t, e;
            return !(!(null === (t = this.options) || void 0 === t ? void 0 : t.accessToken) && !(null === (e = this.options) || void 0 === e ? void 0 : e.secretToken));
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "position", {
        get: function() {
            var t;
            if (!this._songlePlayer) return 0;
            if (this.lastPosition > 0 && this.lastTime > 0) return Date.now() + this.lastPosition - this.lastTime;
            var e = this._songlePlayer.positionTime;
            if ("songle-api-html-media-element-media" === (null === (t = this._songlePlayer.media) || void 0 === t ? void 0 : t.dispatcherName)) {
                var r = this.lastTime, n = this.lastPosition, i = void 0;
                if (r > 0) {
                    var o = Date.now() - r;
                    i = Math.max(0, this.wait - o);
                } else i = this.wait;
                0 === n && e >= 500 ? e = 0 : 0 === r && e - n >= 800 && (e = n + i);
            }
            return e;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.initialize = function(t) {
        var e, r, n, i, o = t.player, s = t.updater, a = t.emitter, u = t.altSourceUrl;
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var t, l, p;
            return $1c811abb26f94012$var$gn(this, function(h) {
                switch(h.label){
                    case 0:
                        return this.player && this.player.removeListener(this.volumeListener), this.player = o, this.player.addListener(this.volumeListener), this.updateMediaPosition = s, this.emitter = a, this._songlePlayer ? [
                            3,
                            2
                        ] : [
                            4,
                            this.initializeSonglePlayer()
                        ];
                    case 1:
                        h.sent(), h.label = 2;
                    case 2:
                        return t = this.options.headless, l = u || this.options.altSourceUrls && (null === (e = this.player.data.song) || void 0 === e ? void 0 : e.permalink) && this.options.altSourceUrls[null === (r = this.player.data.song) || void 0 === r ? void 0 : r.permalink] || (null === (n = this.player.data.song) || void 0 === n ? void 0 : n.permalink) || void 0, $1c811abb26f94012$var$c.isUploaderUrl(l) && (l = $1c811abb26f94012$var$c.getAltSongUrlFromUploaderGuid($1c811abb26f94012$var$c.getUploaderGuid($1c811abb26f94012$var$c.getSongPathFromUrl(l)))), (p = (null === (i = this.player.data.song) || void 0 === i ? void 0 : i.permalink) || l) === l && (l = void 0), [
                            4,
                            this._songlePlayer.useMedia(p, {
                                headless: t,
                                altSourceUrl: l
                            })
                        ];
                    case 3:
                        return h.sent(), this.ignoreSonglePlayerEvents = !0, this._songlePlayer.volume = 0 * (1 - this.player.volume / 100) + 100 * this.player.volume / 100, this._songlePlayer.play(), this._songlePlayer.stop(), this.ignoreSonglePlayerEvents = !1, this.resetProps(), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.resetProps = function() {
        this.lastPosition = 0, this.lastTime = 0, this.elapsedTimes = [];
    }, t.prototype.initializeSonglePlayer = function() {
        var t;
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e, r, n, i, o, s, a, u = this;
            return $1c811abb26f94012$var$gn(this, function(c) {
                switch(c.label){
                    case 0:
                        return e = this.options, r = e.accessToken, n = e.secretToken, (o = this.options.songle) ? [
                            3,
                            2
                        ] : [
                            4,
                            $1c811abb26f94012$var$Pn()
                        ];
                    case 1:
                        o = c.sent(), c.label = 2;
                    case 2:
                        return (i = o).System && (i.System.showLicense = !1), s = null === (t = this.options) || void 0 === t ? void 0 : t.autoUseMedia, this._songlePlayer = this.withSync ? new i.SyncPlayer({
                            mediaElement: this.player.mediaSourceElement,
                            accessToken: r,
                            secretToken: n,
                            autoUseMedia: s
                        }) : new i.Player({
                            mediaElement: this.player.mediaSourceElement
                        }), a = !1, this._songlePlayer.on("play", function() {
                            u.ignoreSonglePlayerEvents || (a = !1, u.handler || (u.startPolling(), u.emitter.onPlay()));
                        }), this._songlePlayer.on("pause", function() {
                            return $1c811abb26f94012$var$yn(u, 0, void 0, function() {
                                return $1c811abb26f94012$var$gn(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            return this.ignoreSonglePlayerEvents ? [
                                                2
                                            ] : (a = !1, this.stopPolling(), this.emitter.onPause(), this.stopping ? (this.stopping = !1, [
                                                4,
                                                this.updateMediaPosition(0)
                                            ]) : [
                                                3,
                                                2
                                            ]);
                                        case 1:
                                            t.sent(), this.resetProps(), this.emitter.onStop(), t.label = 2;
                                        case 2:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        }), this._songlePlayer.on("finish", function() {
                            return $1c811abb26f94012$var$yn(u, 0, void 0, function() {
                                return $1c811abb26f94012$var$gn(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            return a = !1, this.handler ? (this.stopPolling(), [
                                                4,
                                                this.updateMediaPosition(0)
                                            ]) : [
                                                3,
                                                2
                                            ];
                                        case 1:
                                            t.sent(), this.emitter.onStop(), t.label = 2;
                                        case 2:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        }), this._songlePlayer.on("seek", function(t) {
                            var e = t.data;
                            return $1c811abb26f94012$var$yn(u, 0, void 0, function() {
                                return $1c811abb26f94012$var$gn(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            return this._songlePlayer.isPlaying ? [
                                                3,
                                                2
                                            ] : (a = !1, [
                                                4,
                                                this.updateMediaPosition(e.positionTime)
                                            ]);
                                        case 1:
                                            return t.sent(), this.emitter.onSeekComplete(e.positionTime), [
                                                3,
                                                4
                                            ];
                                        case 2:
                                            return a = !0, [
                                                4,
                                                this.updateMediaPosition(this._songlePlayer.positionTime)
                                            ];
                                        case 3:
                                            t.sent(), t.label = 4;
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        }), this._songlePlayer.on("mediaSeek", function() {
                            a && (u.emitter.onSeekComplete(u.position), a = !1);
                        }), this.withSync && (this._songlePlayer.on("mediaPlay", function() {
                            u.handler || (u.startPolling(), u.emitter.onPlay());
                        }), this._songlePlayer.on("mediaFinish", function() {
                            u.handler && (u.stopPolling(), u.emitter.onStop());
                        })), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.play = function() {
        if (this._songlePlayer) return this._songlePlayer.play();
        this.emitter.onPlay();
    }, t.prototype.stop = function() {
        if (this._songlePlayer) return this.stopping = this._songlePlayer.isPlaying, this._songlePlayer.stop();
        this.emitter.onStop();
    }, t.prototype.pause = function() {
        if (this._songlePlayer) return this.stopping = !1, this._songlePlayer.pause();
        this.emitter.onPause();
    }, t.prototype.seek = function(t) {
        var e = this;
        this._songlePlayer ? (this._songlePlayer.seekTo(t), this.emitter.onSeek(t)) : this.updateMediaPosition(t).then(function() {
            e.emitter.onSeek(t);
        });
    }, t.prototype.startPolling = function() {
        var t, e = this;
        if (this.lastTime > 0) {
            var r = Date.now() - this.lastTime;
            t = Math.max(0, this.wait - r);
        } else t = this.wait;
        this.handler = setTimeout(function() {
            return $1c811abb26f94012$var$yn(e, 0, void 0, function() {
                var e, r, n, i, o, s, a, u, c;
                return $1c811abb26f94012$var$gn(this, function(l) {
                    switch(l.label){
                        case 0:
                            return this._songlePlayer ? (r = (e = this).lastTime, n = e.lastPosition, i = this._songlePlayer.positionTime, o = !1, "songle-api-html-media-element-media" === (null === (c = this._songlePlayer.media) || void 0 === c ? void 0 : c.dispatcherName) && (0 === n && i >= 500 ? (i = 0, o = !0) : 0 === r && i - n >= 800 && (i = n + t, o = !0)), s = r > 0 ? Date.now() - r : t, this.updateElapsedTimes(s), a = n > 0 ? n + s : i, u = Math.abs(i - a), (a = u > 2 * this.wait ? i : a <= i ? .5 * (a + i) : Math.max(n, i)) < this.lastPosition && (this.lastPosition - a > 5 * this.wait || (a = this.lastPosition)), o || (this.lastTime = Date.now()), this.lastPosition = a, [
                                4,
                                this.updateMediaPosition(a)
                            ]) : [
                                2
                            ];
                        case 1:
                            return l.sent(), this.handler && this.startPolling(), [
                                2
                            ];
                    }
                });
            });
        }, t);
    }, t.prototype.updateElapsedTimes = function(t) {
        if (this.elapsedTimes.unshift(t), this.elapsedTimes = this.elapsedTimes.slice(0, 10), this.elapsedTimes.length >= 10) {
            var e = this.elapsedTimes.reduce(function(t, e) {
                return t + e;
            }) / 10;
            e > 5 * this.wait && (this.player.stageScale = Math.max(.25, .9 * this.player.stageScale), this.elapsedTimes = []), e < 1.2 * this.wait && this.player.stageScale < 1 && (this.player.stageScale = Math.min(1, this.player.stageScale / .9), this.elapsedTimes = []);
        }
    }, t.prototype.stopPolling = function() {
        var t;
        if (this.handler) {
            if (clearTimeout(this.handler), this._songlePlayer) {
                if ("songle-api-html-media-element-media" === (null === (t = this._songlePlayer.media) || void 0 === t ? void 0 : t.dispatcherName)) {
                    var e = this.lastTime, r = this.lastPosition, n = Date.now() - e;
                    this.lastPosition = r + n;
                } else this.lastPosition = this._songlePlayer.positionTime;
            }
            this.lastTime = 0;
        }
        this.handler = null;
    }, t.prototype.dispose = function() {
        if (this.player && this.player.removeListener(this.volumeListener), this._songlePlayer) {
            try {
                this._songlePlayer.stop();
            } catch (t) {}
            this._songlePlayer = null;
        }
    }, t.prototype.onVolumeUpdate = function(t) {
        this._songlePlayer && (this._songlePlayer.volume = t);
    }, t;
}(), $1c811abb26f94012$var$On = function() {
    function t(t) {
        this.listeners = [], this.throttleInterval = t && t.throttleInterval ? Number(t.throttleInterval) : 100;
    }
    return t.prototype.onVideoLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onVideoLoad && r.onVideoLoad(t, e);
        });
    }, t.prototype.onSongLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onSongLoad && r.onSongLoad(t, e);
        });
    }, t.prototype.onSongMapLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onSongMapLoad && r.onSongMapLoad(t, e);
        });
    }, t.prototype.onSongInfoLoad = function(t, e) {
        var r = !1;
        this.listeners.forEach(function(n) {
            n.onSongInfoLoad && (n.onSongInfoLoad(t, e), r = !0);
        }), r && console.warn('[TextAlive API] "onSongInfoLoad" event is deprecated; use "onSongMapLoad" event instead');
    }, t.prototype.onVocalAmplitudeLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onVocalAmplitudeLoad && r.onVocalAmplitudeLoad(t, e);
        });
    }, t.prototype.onValenceArousalLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onValenceArousalLoad && r.onValenceArousalLoad(t, e);
        });
    }, t.prototype.onLyricsLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onLyricsLoad && r.onLyricsLoad(t, e);
        });
    }, t.prototype.onTextLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onTextLoad && r.onTextLoad(t, e);
        });
    }, t.prototype.onAppLoad = function(t) {
        this.listeners.forEach(function(e) {
            return e.onAppLoad && e.onAppLoad(t);
        });
    }, t.prototype.onAppReady = function(t) {
        this.listeners.forEach(function(e) {
            return e.onAppReady && e.onAppReady(t);
        });
    }, t.prototype.onAppParameterUpdate = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onAppParameterUpdate && r.onAppParameterUpdate(t, e);
        });
    }, t.prototype.onAppMediaChange = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onAppMediaChange && r.onAppMediaChange(t, e);
        });
    }, t.prototype.onTemplateUpdate = function(t) {
        this.listeners.forEach(function(e) {
            return e.onTemplateUpdate && e.onTemplateUpdate(t);
        });
    }, t.prototype.onTemplateCommit = function(t) {
        this.listeners.forEach(function(e) {
            return e.onTemplateCommit && e.onTemplateCommit(t);
        });
    }, t.prototype.onTemplatesLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onTemplatesLoad && r.onTemplatesLoad(t, e);
        });
    }, t.prototype.onFontsLoad = function(t, e) {
        this.listeners.forEach(function(r) {
            return r.onFontsLoad && r.onFontsLoad(t, e);
        });
    }, t.prototype.onVideoReady = function(t) {
        this.listeners.forEach(function(e) {
            return e.onVideoReady && e.onVideoReady(t);
        });
    }, t.prototype.onTimerReady = function(t) {
        this.listeners.forEach(function(e) {
            return e.onTimerReady && e.onTimerReady(t);
        });
    }, t.prototype.onStageElementSet = function(t) {
        this.listeners.forEach(function(e) {
            return e.onStageElementSet && e.onStageElementSet(t);
        });
    }, t.prototype.onMediaElementSet = function(t) {
        this.listeners.forEach(function(e) {
            return e.onMediaElementSet && e.onMediaElementSet(t);
        });
    }, t.prototype.onTimeUpdate = function(t) {
        var e = this;
        this.listeners.forEach(function(e) {
            return e.onTimeUpdate && e.onTimeUpdate(t);
        }), this.position = t, this.throttledTimeUpdate || (this.throttledTimeUpdate = new Promise(function(t, r) {
            setTimeout(function() {
                e.onThrottledTimeUpdate(e.position), e.throttledTimeUpdate = null, t();
            }, e.throttleInterval);
        }));
    }, t.prototype.onThrottledTimeUpdate = function(t) {
        this.listeners.forEach(function(e) {
            return e.onThrottledTimeUpdate && e.onThrottledTimeUpdate(t);
        });
    }, t.prototype.onBackgroundGraphicsUpdate = function(t) {
        this.listeners.forEach(function(e) {
            return e.onBackgroundGraphicsUpdate && e.onBackgroundGraphicsUpdate(t);
        });
    }, t.prototype.onMediaSeek = function(t) {
        this.listeners.forEach(function(e) {
            return e.onMediaSeek && e.onMediaSeek(t);
        });
    }, t.prototype.onVideoSeekStart = function() {
        this.listeners.forEach(function(t) {
            return t.onVideoSeekStart && t.onVideoSeekStart();
        });
    }, t.prototype.onVideoSeekEnd = function() {
        this.listeners.forEach(function(t) {
            return t.onVideoSeekEnd && t.onVideoSeekEnd();
        });
    }, t.prototype.onVideoSeek = function(t) {
        this.listeners.forEach(function(e) {
            return e.onVideoSeek && e.onVideoSeek(t);
        });
    }, t.prototype.onPlay = function() {
        this.listeners.forEach(function(t) {
            return t.onPlay && t.onPlay();
        });
    }, t.prototype.onPause = function() {
        this.listeners.forEach(function(t) {
            return t.onPause && t.onPause();
        });
    }, t.prototype.onSeek = function(t) {
        this.listeners.forEach(function(e) {
            return e.onSeek && e.onSeek(t);
        });
    }, t.prototype.onSeekComplete = function(t) {
        this.listeners.forEach(function(e) {
            return e.onSeekComplete && e.onSeekComplete(t);
        });
    }, t.prototype.onStop = function() {
        this.listeners.forEach(function(t) {
            return t.onStop && t.onStop();
        });
    }, t.prototype.onDispose = function() {
        this.listeners.forEach(function(t) {
            return t.onDispose && t.onDispose();
        });
    }, t.prototype.onResize = function(t) {
        this.listeners.forEach(function(e) {
            return e.onResize && e.onResize(t);
        });
    }, t.prototype.onVolumeUpdate = function(t) {
        this.listeners.forEach(function(e) {
            return e.onVolumeUpdate && e.onVolumeUpdate(t);
        });
    }, t.prototype.addListener = function(t) {
        !t || this.listeners.indexOf(t) >= 0 || this.listeners.push(t);
    }, t.prototype.removeListener = function(t) {
        var e = !1;
        return this.listeners = this.listeners.filter(function(r) {
            var n = r === t;
            return e = e || n, !n;
        }), e;
    }, t;
}(), $1c811abb26f94012$var$Sn = function() {
    function t(t, e, r) {
        var n = this;
        this.player = t, this.manager = e, this.emitter = r, this._defaultBackgroundCss = null, this._background = null, t.addListener({
            onStageElementSet: function(t) {
                return n.doUpdateBackground(n.background);
            }
        });
    }
    return Object.defineProperty(t.prototype, "background", {
        get: function() {
            return this._background;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "defaultBackgroundCss", {
        get: function() {
            return this._defaultBackgroundCss ? this._defaultBackgroundCss : "";
        },
        set: function(t) {
            this._defaultBackgroundCss = t, this.updateBackground(this._background);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "ready", {
        get: function() {
            return null !== this._background;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.settingBackground = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.doSetBackground(t)
                        ];
                    case 1:
                        return [
                            2,
                            e.sent() && this.doUpdateBackground(t)
                        ];
                }
            });
        });
    }, t.prototype.setBackground = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e;
            return $1c811abb26f94012$var$gn(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.doSetBackground(t)
                        ];
                    case 1:
                        return [
                            2,
                            (e = r.sent()) && this.updateBackground(e)
                        ];
                }
            });
        });
    }, t.prototype.doSetBackground = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e, r, n;
            return $1c811abb26f94012$var$gn(this, function(i) {
                switch(i.label){
                    case 0:
                        return e = t && t.originalUrl ? t.originalUrl : "", this.manager.isBackgroundColorAsset(t) ? [
                            2,
                            {
                                css: e,
                                originalUrl: e
                            }
                        ] : this.manager.isBackgroundPiaproImageAsset(t) ? [
                            4,
                            this.manager.read(e)
                        ] : [
                            3,
                            2
                        ];
                    case 1:
                        return (r = i.sent()) && r.url && this.manager.checkBackgroundImageLicense(r.license) ? (r.originalUrl = e, t && (r.x = t.x, r.y = t.y), [
                            2,
                            r
                        ]) : [
                            2,
                            {
                                css: "",
                                originalUrl: e,
                                x: t ? t.x : void 0,
                                y: t ? t.y : void 0,
                                license: r ? r.license : void 0
                            }
                        ];
                    case 2:
                        return this.manager.isBackgroundSpecialImageAsset(t) ? [
                            2,
                            {
                                css: 'url("https://api.textalive.jp/images/backgrounds/snowmiku2016/' + (n = /^snowmiku2016-([0-9]{2})$/.exec(e))[1] + '.jpg")',
                                contentUrl: "https://api.textalive.jp/images/backgrounds/snowmiku2016/" + n[1] + ".jpg",
                                url: "https://snowmiku.com/2016/info_chara.html",
                                name: "SNOW MIKU 2016",
                                authorName: "\u8C46\u306E\u7D20",
                                originalUrl: e,
                                x: t ? t.x : void 0,
                                y: t ? t.y : void 0,
                                defaultY: 0
                            }
                        ] : [
                            2,
                            {
                                originalUrl: null,
                                css: "",
                                x: t ? t.x : void 0,
                                y: t ? t.y : void 0
                            }
                        ];
                }
            });
        });
    }, t.prototype.updateBackground = function(t) {
        return !!this.doUpdateBackground(t) && (this.emitter && this.emitter.onBackgroundGraphicsUpdate && this.emitter.onBackgroundGraphicsUpdate(t), !0);
    }, t.prototype.doUpdateBackground = function(t) {
        if (!t) return !1;
        if (!this.player.stageElement) return this._background = t, !0;
        var e = this.player.stageElement.style;
        return t.css.length <= 0 ? e.background = this.defaultBackgroundCss : e.background = t.css, "number" == typeof t.x || this._background && "number" == typeof this._background.x ? ("number" != typeof t.x && (t.x = this._background.x), e.backgroundPositionX = e.backgroundPositionX + "%") : e.backgroundPositionX = "number" == typeof t.defaultX ? t.defaultX + "%" : "center", "number" == typeof t.y || this._background && "number" == typeof this._background.y ? ("number" != typeof t.y && (t.y = this._background.y), e.backgroundPositionY = e.backgroundPositionY + "%") : e.backgroundPositionY = "number" == typeof t.defaultY ? t.defaultY + "%" : "center", e.backgroundSize = "cover", this._background = t, !0;
    }, t.prototype.export = function() {
        if (!this.background || !this.background.originalUrl) return null;
        var t = {
            originalUrl: this.background.originalUrl
        };
        return void 0 !== this.background.x && (t.x = this.background.x), void 0 !== this.background.y && (t.y = this.background.y), t;
    }, t.prototype.exportPartialVideoEntry = function(t) {
        return {
            background: this.export()
        };
    }, t;
}();

function $1c811abb26f94012$var$Tn(t, e, r) {
    return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
        var n, i, o, s, a, u, c, l, p, h, d, f, y, g;
        return $1c811abb26f94012$var$gn(this, function(v) {
            switch(v.label){
                case 0:
                    if (n = {
                        loaded: [],
                        failed: []
                    }, "undefined" == typeof window || !window.document || !window.document.head) return n.failed = t.slice(), [
                        2,
                        n
                    ];
                    for(i = r.split("").filter(function(t, e, r) {
                        return r.indexOf(t) === e;
                    }).sort(), o = !0, s = 0, i.forEach(function(t) {
                        var r = e.indexOf(t, s);
                        o = o && r >= 0, s = r;
                    }), a = window.document.head, u = [], c = 0; c < a.children.length; c++)"link" === (l = a.children.item(c)).tagName.toLowerCase() && "stylesheet" === l.getAttribute("rel") && u.push(l.getAttribute("href"));
                    if (p = [], h = [], d = [], t.forEach(function(t) {
                        if (t.google) d.push(t.key);
                        else {
                            var e = o && t.compactUrl || t.url;
                            u.includes(e) ? n.loaded.push(t) : (h.push(t.en), p.push(e));
                        }
                    }), f = {
                        classes: !1,
                        active: null,
                        inactive: null,
                        fontactive: function(e) {
                            n.loaded.push(t.find(function(t) {
                                return t.en === e;
                            })), n.failed = n.failed.filter(function(t) {
                                return t.en !== e;
                            });
                        },
                        fontinactive: function(e) {
                            n.failed.push(t.find(function(t) {
                                return t.en === e;
                            }));
                        },
                        timeout: 5e3
                    }, d.length > 0 && (f.google = {
                        families: d
                    }), h.length > 0 && (f.custom = {
                        families: h,
                        urls: p
                    }), !f.google && !f.custom) return [
                        3,
                        6
                    ];
                    v.label = 1;
                case 1:
                    return v.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]), (g = "undefined" != typeof window && (null === window || void 0 === window ? void 0 : window.WebFont)) ? [
                        3,
                        3
                    ] : [
                        4,
                        (parcelRequire("hWl2v"))
                    ];
                case 2:
                    g = v.sent(), v.label = 3;
                case 3:
                    return y = g, [
                        4,
                        new Promise(function(t) {
                            f.active = f.inactive = t, y.load(f);
                        })
                    ];
                case 4:
                case 5:
                    return v.sent(), [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2,
                        n
                    ];
            }
        });
    });
}
function $1c811abb26f94012$var$xn(t, e) {
    return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
        var r, n, i, o, s, a, u;
        return $1c811abb26f94012$var$gn(this, function(c) {
            switch(c.label){
                case 0:
                    if (r = {
                        loaded: [],
                        failed: []
                    }, !("undefined" != typeof window && window.document && window.document.head && window.Ts && window.Ts.loadFontAsync)) return r.failed = t.slice(), [
                        2,
                        r
                    ];
                    for(n = window.document.head, i = {}, o = function(t) {
                        var e = n.children.item(t);
                        if ("style" !== e.tagName.toLowerCase() || "text/css" !== e.getAttribute("type") || "stylesheet" !== e.getAttribute("rel") || !e.hasAttribute("data-cssName")) return "continue";
                        var r = e.getAttribute("data-cssName");
                        if (void 0 === i[r]) return i[r] = new Set(e.getAttribute("data-text")), "continue";
                        e.getAttribute("data-text").split("").forEach(function(t) {
                            return i[r].add(t);
                        });
                    }, s = 0; s < n.children.length; s++)o(s);
                    return a = window.Ts, u = [], t.forEach(function(t) {
                        var n = new Set(e + t.en + t.ja);
                        if (i[t.en] && i[t.en].forEach(function(t) {
                            return n.delete(t);
                        }), n.size <= 0) return r.loaded.push(t), r;
                        u.push(new Promise(function(e) {
                            return function(t, e, r, n, i) {
                                var o = e.en;
                                t.loadFontAsync({
                                    cssName: o,
                                    text: n,
                                    outputType: "json",
                                    callback: function(t) {
                                        try {
                                            !function(t, e, r) {
                                                var n = JSON.parse(r), i = JSON.parse(n.res), o = document.createElement("style");
                                                o.setAttribute("data-cssName", t), o.setAttribute("data-text", e), o.setAttribute("type", "text/css"), o.setAttribute("rel", "stylesheet"), o.innerHTML = "@font-face {font-family: '" + i.fontFamily + "';font-weight: " + i["font-weight"] + ";src: url(data:font/woff;base64," + i.src + ");}", document.head.appendChild(o);
                                            }(o, n, t.data), r.loaded.push(e);
                                        } catch (t) {
                                            r.failed.push(e);
                                        }
                                        i();
                                    }
                                });
                            }(a, t, r, Array.from(n.values()).join(""), e);
                        }));
                    }), [
                        4,
                        Promise.all(u)
                    ];
                case 1:
                    return c.sent(), [
                        2,
                        r
                    ];
            }
        });
    });
}
var $1c811abb26f94012$var$An = function(t) {
    function e(e, r) {
        var n = this.constructor, i = t.call(this, e) || this;
        return i.fonts = r, Object.setPrototypeOf(i, n.prototype), i;
    }
    return $1c811abb26f94012$var$dn(e, t), e;
}(Error), $1c811abb26f94012$var$Rn = function() {
    function t(t, e, r) {
        this.fontInfoManager = t, this.textFetcher = e, this.listener = r, this._failed = [], this._loaded = [];
    }
    return Object.defineProperty(t.prototype, "failed", {
        get: function() {
            return this._failed;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "loaded", {
        get: function() {
            return this._loaded;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.loadAll = function() {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var t;
            return $1c811abb26f94012$var$gn(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.listAvailableFonts()
                        ];
                    case 1:
                        return t = e.sent(), [
                            2,
                            this.loadFonts(t)
                        ];
                }
            });
        });
    }, t.prototype.loadForVideo = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e, r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return (e = this.listFontFamiliesInVideo(t)) ? [
                            4,
                            this.listAvailableFonts()
                        ] : (this.listener && this.listener.onFontsLoad && this.listener.onFontsLoad(this.loaded), [
                            2,
                            Promise.resolve(this.loaded)
                        ]);
                    case 1:
                        return r = n.sent(), [
                            2,
                            this.loadFonts(r.filter(function(t) {
                                return e.indexOf(t.en) >= 0;
                            }))
                        ];
                }
            });
        });
    }, t.prototype.listFontFamiliesInVideo = function(t) {
        if (!t || !t.phrases) return null;
        var e = [];
        return t.phrases.forEach(function(t) {
            return t.words.forEach(function(t) {
                return t.characters.forEach(function(t) {
                    return e.push(t.fontFamily);
                });
            });
        }), e.filter(function(t, e, r) {
            return r.indexOf(t) === e;
        });
    }, t.prototype.listAvailableFonts = function() {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(t) {
                return [
                    2,
                    this.fontInfoManager.listAvailableFonts()
                ];
            });
        });
    }, t.prototype.isLoading = function() {
        return !!this.queue;
    }, t.prototype.load = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e, r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return e = [], r = [], t.forEach(function(t) {
                            "string" == typeof t ? e.push(t) : r.push(t);
                        }), [
                            4,
                            this.fontInfoManager.listAvailableFonts()
                        ];
                    case 1:
                        return n.sent().forEach(function(t) {
                            e.indexOf(t.key) >= 0 && r.push(t);
                        }), [
                            2,
                            this.loadFonts(r)
                        ];
                }
            });
        });
    }, t.prototype.loadFonts = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e = this;
            return $1c811abb26f94012$var$gn(this, function(r) {
                return this.queue ? (this.listener && this.listener.onFontsLoad && this.listener.onFontsLoad(null, new $1c811abb26f94012$var$An("Failed to load some fonts because there is an ongoing font loding process", this.failed.slice())), [
                    2,
                    this.loaded
                ]) : (this.queue = this.doLoad(t).then(function(t) {
                    return e.queue = null, t;
                }), [
                    2,
                    this.queue
                ]);
            });
        });
    }, t.prototype.doLoad = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e, r, n, i, o = this;
            return $1c811abb26f94012$var$gn(this, function(s) {
                switch(s.label){
                    case 0:
                        return e = [], r = [], [
                            4,
                            this.fontInfoManager.getFrequentChars()
                        ];
                    case 1:
                        return n = s.sent(), t.forEach(function(t) {
                            t.typesquare || t.typekit || e.push(t), t.typesquare && r.push(t);
                        }), i = (this.textFetcher && this.textFetcher() || "").split("").filter(function(t, e, r) {
                            return r.indexOf(t) === e;
                        }).sort().join(""), [
                            2,
                            Promise.all([
                                $1c811abb26f94012$var$Tn(e, n, i),
                                $1c811abb26f94012$var$xn(r, i)
                            ]).then(function(t) {
                                var e = t[0], r = t[1], n = e.loaded.concat(r.loaded);
                                if (o.addLoadedFonts(n), e.failed.length > 0 || r.failed.length > 0) {
                                    var i = e.failed.concat(r.failed);
                                    o.addFailedFonts(i), o.listener && o.listener.onFontsLoad && o.listener.onFontsLoad(null, new $1c811abb26f94012$var$An("Failed to load some fonts", o.failed.slice()));
                                } else o.listener && o.listener.onFontsLoad && o.listener.onFontsLoad(n);
                                return o.loaded;
                            }).catch(function(t) {
                                return o.listener && o.listener.onFontsLoad && o.listener.onFontsLoad(null, new $1c811abb26f94012$var$An(t, o.failed.slice())), o.loaded;
                            })
                        ];
                }
            });
        });
    }, t.prototype.addLoadedFonts = function(t) {
        var e = this;
        this._loaded = this.loaded.concat(t.filter(function(t) {
            return e.failed.findIndex(function(e) {
                return e.key === t.key;
            }) < 0;
        }));
    }, t.prototype.addFailedFonts = function(t) {
        var e = this;
        this._failed = this.failed.concat(t.filter(function(t) {
            return e.failed.findIndex(function(e) {
                return e.key === t.key;
            }) < 0;
        }));
    }, t;
}(), $1c811abb26f94012$var$Cn = function() {
    function t() {}
    return Object.defineProperty(t.prototype, "duration", {
        get: function() {
            return this.endTime - this.startTime;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.contains = function(t) {
        return t >= this.startTime && t <= this.endTime;
    }, t.prototype.overlaps = function(t, e) {
        if ("object" == typeof t) return this.overlaps(t.startTime, t.endTime);
        var r = t;
        return this.contains(r) || this.contains(e) || this.startTime <= r && this.endTime >= e;
    }, t.prototype.progress = function(t) {
        return this.contains(t) ? this.startTime === this.endTime ? 0 : (t - this.startTime) / (this.endTime - this.startTime) : -1;
    }, t;
}(), $1c811abb26f94012$var$Nn = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.previous = e.next = null, e;
    }
    return $1c811abb26f94012$var$dn(e, t), Object.defineProperty(e.prototype, "endTime", {
        get: function() {
            return this.next ? this.next.startTime : this.startTime;
        },
        enumerable: !1,
        configurable: !0
    }), e;
}($1c811abb26f94012$var$Cn), $1c811abb26f94012$var$kn = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.previous = e.next = null, e;
    }
    return $1c811abb26f94012$var$dn(e, t), e;
}($1c811abb26f94012$var$Cn), $1c811abb26f94012$var$jn = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.previous = e.next = null, e;
    }
    return $1c811abb26f94012$var$dn(e, t), e;
}($1c811abb26f94012$var$Cn), $1c811abb26f94012$var$In = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.previous = e.next = null, e;
    }
    return $1c811abb26f94012$var$dn(e, t), e;
}($1c811abb26f94012$var$Cn), $1c811abb26f94012$var$Un = function() {
    function t(t) {
        var e = t.analysis, r = t.info;
        this.beats = [], this.chords = [], this.segments = [], this.voice = [], this._revisions = {
            beatId: (null == r ? void 0 : r.beatRevisionId) || -1,
            chordId: (null == r ? void 0 : r.chordRevisionId) || -1,
            repetitiveSegmentId: (null == r ? void 0 : r.chorusRevisionId) || -1
        }, this.parseBeats(null == e ? void 0 : e.beats), this.parseSegments(null == e ? void 0 : e.repetitive_segment), this.parseChords(null == e ? void 0 : e.chords), this.parseVoice(e.voice);
    }
    return Object.defineProperty(t.prototype, "revisions", {
        get: function() {
            return this._revisions;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.parseBeats = function(t) {
        var e = this;
        if (this.beats.splice(0, this.beats.length), Array.isArray(t) && Array.isArray(t[0])) {
            var r = null, n = 0;
            t[0].forEach(function(t) {
                var i = new $1c811abb26f94012$var$Nn;
                i.startTime = 1e3 * t[0], i.length = t[2], i.position = t[3], i.previous = r, null !== r && (r.next = i), i.index = n++, e.beats.push(i), r = i;
            }), null !== r && (r.next = null);
        }
    }, t.prototype.parseChords = function(t) {
        var e = this;
        if (this.chords.splice(0, this.chords.length), Array.isArray(t)) {
            var r = null, n = 0;
            t.forEach(function(t) {
                var i = new $1c811abb26f94012$var$kn;
                i.startTime = 1e3 * t[0], i.endTime = 1e3 * t[1], i.name = t[2], i.previous = r, null !== r && (r.next = i), i.index = n++, e.chords.push(i), r = i;
            }), null !== r && (r.next = null);
        }
    }, t.prototype.parseSegments = function(t) {
        var e = this;
        this.segments.splice(0, this.segments.length), Array.isArray(t) && t.forEach(function(t) {
            var r = {
                chorus: !!t.chorus,
                duration: 10 * t.segment_length,
                segments: null
            }, n = null, i = 0;
            r.segments = t.start_frames.map(function(t) {
                var e = new $1c811abb26f94012$var$jn;
                return e.startTime = 10 * t, e.endTime = e.startTime + r.duration, e.previous = n, null !== n && (n.next = e), e.index = i++, n = e, e;
            }), null !== n && (n.next = null), e.segments.push(r);
        });
    }, t.prototype.parseVoice = function(t) {
        var e = this;
        this.voice.splice(0, this.voice.length), Array.isArray(t) && t.forEach(function(t) {
            var r = [], n = null, i = 0, o = 0;
            t.forEach(function(t) {
                var e = new $1c811abb26f94012$var$In;
                e.startTime = o, e.endTime = e.startTime + 10 * t[1], e.f0 = t[0][0], e.initialF0 = t[0][1], e.previous = n, null !== n && (n.next = e), e.index = i++, r.push(e), n = e, o = e.endTime;
            }), null !== n && (n.next = null), e.voice.push(r);
        });
    }, t;
}(), $1c811abb26f94012$var$Fn = function() {
    function t(t) {
        var e = t.song, r = t.analysis, n = t.vocalAmplitude, i = t.maxVocalAmplitude, o = t.valenceArousal;
        this._song = e, this._analysis = r, this._vocalAmplitude = n, this._maxVocalAmplitude = i, this._valenceArousal = o;
    }
    return Object.defineProperty(t.prototype, "song", {
        get: function() {
            return this._song;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "analysis", {
        get: function() {
            return this._analysis;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "vocalAmplitude", {
        get: function() {
            return this._vocalAmplitude;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "maxVocalAmplitude", {
        get: function() {
            return this._maxVocalAmplitude;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "valenceArousal", {
        get: function() {
            return this._valenceArousal;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.getChoruses = function() {
        var t;
        if (!this._analysis) return [];
        var e = this._analysis.segments.filter(function(t) {
            return t.chorus;
        });
        return e.length <= 0 ? [] : (null === (t = e[0].segments) || void 0 === t ? void 0 : t.slice()) || [];
    }, t.prototype.findChorus = function(t, e) {
        return $1c811abb26f94012$export$9bae06dfae5441df(this.getChoruses(), t, e);
    }, t.prototype.findChorusBetween = function(t, e) {
        return this.findChorus(t, {
            endTime: e
        });
    }, t.prototype.findChorusChange = function(t, e) {
        return $1c811abb26f94012$export$212614cfc0556d1e(this.getChoruses(), t, e);
    }, t.prototype.getBeats = function() {
        var t, e;
        return (null === (e = null === (t = this._analysis) || void 0 === t ? void 0 : t.beats) || void 0 === e ? void 0 : e.slice()) || [];
    }, t.prototype.findBeat = function(t, e) {
        return $1c811abb26f94012$export$9bae06dfae5441df(this.getBeats(), t, e);
    }, t.prototype.findBeatChange = function(t, e) {
        return $1c811abb26f94012$export$212614cfc0556d1e(this.getBeats(), t, e);
    }, t.prototype.getChords = function() {
        var t, e;
        return (null === (e = null === (t = this._analysis) || void 0 === t ? void 0 : t.chords) || void 0 === e ? void 0 : e.slice()) || [];
    }, t.prototype.findChord = function(t, e) {
        return $1c811abb26f94012$export$9bae06dfae5441df(this.getChords(), t, e);
    }, t.prototype.findChordChange = function(t, e) {
        return $1c811abb26f94012$export$212614cfc0556d1e(this.getChords(), t, e);
    }, t.prototype.getVocalFrequency = function(t) {
        var e;
        if (!Array.isArray(null === (e = this._analysis) || void 0 === e ? void 0 : e.voice)) return -1;
        var n = this._analysis.voice[0];
        if (n.length <= 0) return -1;
        var i = $1c811abb26f94012$var$r.sortedIndex(n, t, function(t) {
            return t.endTime;
        });
        return n[i].contains(t) ? n[i].f0 : -1;
    }, t.prototype.getVocalAmplitude = function(t) {
        var e = this._vocalAmplitude, r = Math.round(t / 10);
        return !Array.isArray(this._vocalAmplitude) || r < 0 || r >= e.length ? -1 : this._vocalAmplitude[r];
    }, t.prototype.getMaxVocalAmplitude = function() {
        return "number" == typeof this._maxVocalAmplitude ? this._maxVocalAmplitude : -1;
    }, t.prototype.getValenceArousal = function(t) {
        var e = this._valenceArousal;
        if (!e) return null;
        var n = $1c811abb26f94012$var$r.sortedIndex(e.seq, t, function(t) {
            return 1e3 * t.t[1];
        });
        if (n < 0) return {
            a: e.seq[0].a,
            v: e.seq[0].v
        };
        if (n + 1 >= e.seq.length || t < 1e3 * e.seq[n + 1].t[0]) return {
            a: e.seq[Math.min(n, e.seq.length - 1)].a,
            v: e.seq[Math.min(n, e.seq.length - 1)].v
        };
        var i = e.seq[n], o = e.seq[n + 1], s = t / 1e3, a = o.t[0], u = i.t[1], c = u - a;
        return {
            a: (i.a * (u - s) + o.a * (s - a)) / c,
            v: (i.v * (u - s) + o.v * (s - a)) / c
        };
    }, t.prototype.getMedianValenceArousal = function() {
        var t = this._valenceArousal;
        return t ? t.stats.median : null;
    }, t;
}(), $1c811abb26f94012$var$Ln = function() {
    function t(t, e, r) {
        this.songManager = t, this.options = r, this.listener = e;
    }
    return Object.defineProperty(t.prototype, "song", {
        get: function() {
            return this._song;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "analysis", {
        get: function() {
            return this._analysis;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "vocalAmplitude", {
        get: function() {
            return this._vocalAmplitude;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "maxVocalAmplitude", {
        get: function() {
            return this._maxVocalAmplitude;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "valenceArousal", {
        get: function() {
            return this._valenceArousal;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.loadSong = function(t, e) {
        var r, n, i;
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var o, s;
            return $1c811abb26f94012$var$gn(this, function(a) {
                switch(a.label){
                    case 0:
                        return "number" == typeof t && t < 0 || !t ? (this.onSongLoad(null, new Error("Neither Songle ID or code provided")), [
                            2,
                            null
                        ]) : [
                            4,
                            this.songManager.load("number" == typeof t ? {
                                id: t
                            } : {
                                code: t
                            })
                        ];
                    case 1:
                        return o = a.sent(), this.onSongLoad(o, o ? void 0 : new Error("Song data not found")), o ? (s = {
                            chord: null == e ? void 0 : e.chordId,
                            beat: null == e ? void 0 : e.beatId,
                            chorus: null == e ? void 0 : e.repetitiveSegmentId
                        }, [
                            4,
                            Promise.all([
                                (null === (r = this.options) || void 0 === r ? void 0 : r.vocalFrequencyEnabled) ? this.loadSongDetailInfo(o.song.code, {
                                    revisions: s
                                }) : this.loadSongInfo(o.song.code, {
                                    revisions: s
                                }),
                                (null === (n = this.options) || void 0 === n ? void 0 : n.vocalAmplitudeEnabled) ? this.loadVocalAmplitude(o.song.code) : Promise.resolve(null),
                                (null === (i = this.options) || void 0 === i ? void 0 : i.valenceArousalEnabled) ? this.loadValenceArousal(o.song.code) : Promise.resolve(null)
                            ])
                        ]) : [
                            2,
                            null
                        ];
                    case 2:
                        return a.sent(), [
                            2,
                            new $1c811abb26f94012$var$Fn(this)
                        ];
                }
            });
        });
    }, t.prototype.onSongLoad = function(t, e) {
        this._song = t, this.listener && this.listener.onSongLoad && this.listener.onSongLoad(t, e);
    }, t.prototype.loadSongInfo = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.songManager.loadInfo(String(t), e)
                        ];
                    case 1:
                        return r = n.sent(), this.onSongMapLoad(r, r ? void 0 : new Error("Song analysis data not found")), [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.loadSongDetailInfo = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.songManager.loadDetailInfo(String(t), e)
                        ];
                    case 1:
                        return r = n.sent(), this.onSongMapLoad(r, r ? void 0 : new Error("Song analysis data not found")), [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.mockSongInfo = function(t) {
        var e = function(t) {
            for(var e = t.beat, r = t.chorusSegment, n = t.duration, i = [], o = 0; 60 * o / e.bpm < n / 1e3;)i.push([
                60 * o / e.bpm,
                1,
                e.length,
                o % e.length + 1,
                1
            ]), o++;
            return {
                beats: [
                    i
                ],
                chords: null,
                repetitive_segment: [
                    {
                        chorus: !0,
                        index: 0,
                        segment_length: r.duration / 10,
                        start_frames: r.startTimes.map(function(t) {
                            return t / 10;
                        })
                    }
                ],
                voice: null
            };
        }(t);
        return this._song = null, this.onSongMapLoad({
            analysis: e,
            info: null
        }), new $1c811abb26f94012$var$Fn(this);
    }, t.prototype.onSongMapLoad = function(t, e) {
        var r, n;
        this._analysis = new $1c811abb26f94012$var$Un(t), (null === (r = this.listener) || void 0 === r ? void 0 : r.onSongMapLoad) && this.listener.onSongMapLoad(this._analysis, e), (null === (n = this.listener) || void 0 === n ? void 0 : n.onSongInfoLoad) && this.listener.onSongInfoLoad(t, e);
    }, t.prototype.loadVocalAmplitude = function(t) {
        var e;
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            this.songManager.loadVocalAmplitude(String(t))
                        ];
                    case 1:
                        return r._vocalAmplitude = n.sent(), this._maxVocalAmplitude = Math.max.apply(Math, this._vocalAmplitude), (null === (e = this.listener) || void 0 === e ? void 0 : e.onVocalAmplitudeLoad) && this.listener.onVocalAmplitudeLoad(this._vocalAmplitude, this._vocalAmplitude ? void 0 : new Error("Vocal amplitude data not found")), [
                            2,
                            this._vocalAmplitude
                        ];
                }
            });
        });
    }, t.prototype.loadValenceArousal = function(t) {
        var e;
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            this.songManager.loadValenceArousal(String(t))
                        ];
                    case 1:
                        return r._valenceArousal = n.sent(), (null === (e = this.listener) || void 0 === e ? void 0 : e.onValenceArousalLoad) && this.listener.onValenceArousalLoad(this._valenceArousal, this._valenceArousal ? void 0 : new Error("Valence arousal data not found")), [
                            2,
                            this._valenceArousal
                        ];
                }
            });
        });
    }, t;
}(), $1c811abb26f94012$var$Dn = function() {
    function t(t, e, r) {
        this.managers = t, this.listener = e, this.options = r;
    }
    return t.prototype.loadRawText = function(t) {
        var e;
        return e = !t.phrases || t.phrases.length < 0 ? "" : t.phrases.map(function(t) {
            return t.words.map(function(t) {
                return t.characters.map(function(t) {
                    return t.char;
                }).join("");
            }).join("");
        }).join(""), this.onTextLoad({
            text: e
        }), {
            lyricsId: -1,
            lyrics: null,
            lyricsBody: {
                text: e,
                artist: null,
                name: null,
                url: null
            }
        };
    }, t.prototype.loadLyrics = function(t) {
        var e = t.songCode, r = t.lyricId, n = void 0 === r ? -1 : r, i = t.lyricDiffId, o = void 0 === i ? -1 : i, s = t.altLyricsUrl, a = t.directAccess;
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var t, r, i, u;
            return $1c811abb26f94012$var$gn(this, function(c) {
                switch(c.label){
                    case 0:
                        return n <= 0 ? (0 === n ? this.onLyricsLoad(null, new Error("Lyrics not loaded")) : this.onLyricsLoad(null, new Error("Lyrics not found")), [
                            2,
                            null
                        ]) : [
                            4,
                            this.managers.lyrics.loadDiff(e, n, o)
                        ];
                    case 1:
                        return (null == (t = c.sent()) ? void 0 : t.data) ? (r = $1c811abb26f94012$var$fn($1c811abb26f94012$var$fn({}, t), {
                            processing: !1,
                            failed: !1,
                            id: n,
                            diff: {
                                id: o
                            }
                        }), this.onLyricsLoad(r), s || a ? [
                            3,
                            3
                        ] : [
                            4,
                            this.managers.lyrics.fetchLocalLyricBody(n)
                        ]) : (this.onLyricsLoad(null, new Error("Lyrics timing information not found")), [
                            2,
                            null
                        ]);
                    case 2:
                        i = c.sent(), c.label = 3;
                    case 3:
                        if (null == i ? void 0 : i.text) return [
                            3,
                            7
                        ];
                        c.label = 4;
                    case 4:
                        return c.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]), [
                            4,
                            this.loadLyricsText(t, {
                                altLyricsUrl: s,
                                directAccess: a
                            })
                        ];
                    case 5:
                        return i = c.sent(), [
                            3,
                            7
                        ];
                    case 6:
                        return u = c.sent(), this.onTextLoad(null, u), [
                            3,
                            7
                        ];
                    case 7:
                        return i && this.onTextLoad(i), [
                            2,
                            {
                                lyricsId: r.id,
                                lyrics: r,
                                lyricsBody: i
                            }
                        ];
                }
            });
        });
    }, t.prototype.loadLyricsText = function(t, e) {
        var r = void 0 === e ? {} : e, n = r.altLyricsUrl, i = r.directAccess;
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e, r, o = this;
            return $1c811abb26f94012$var$gn(this, function(s) {
                switch(s.label){
                    case 0:
                        return e = this.options && "number" == typeof this.options.lyricsFetchTimeout && this.options.lyricsFetchTimeout >= 0, r = this.managers.lyrics.fetchLyricBody(n || t.url, {
                            parserPath: t.parser_path,
                            directAccess: i
                        }), [
                            4,
                            e ? Promise.race([
                                r,
                                new Promise(function(t, e) {
                                    return setTimeout(function() {
                                        return e(new Error("Fetching lyrics text timeout"));
                                    }, o.options.lyricsFetchTimeout);
                                })
                            ]) : r
                        ];
                    case 1:
                        return [
                            2,
                            s.sent()
                        ];
                }
            });
        });
    }, t.prototype.onLyricsLoad = function(t, e) {
        this.listener && this.listener.onLyricsLoad && this.listener.onLyricsLoad(t, e);
    }, t.prototype.onTextLoad = function(t, e) {
        this.listener && this.listener.onTextLoad && this.listener.onTextLoad(t, e);
    }, t;
}(), $1c811abb26f94012$var$Mn = function() {
    function t(t) {
        var e = t.video;
        this._video = e;
    }
    return Object.defineProperty(t.prototype, "video", {
        get: function() {
            return this._video;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "data", {
        get: function() {
            return this._video.json;
        },
        enumerable: !1,
        configurable: !0
    }), t;
}(), $1c811abb26f94012$var$Bn = function() {
    function t(t, e) {
        this.managers = t, this.listener = e, this.listener = e;
    }
    return Object.defineProperty(t.prototype, "video", {
        get: function() {
            return this._video;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.onVideoLoad = function(t, e) {
        var r = t ? Object.assign(t, e) : null;
        return r && ("string" == typeof r.json ? r.json = JSON.parse(r.json) : "object" == typeof r.json && null !== r.json || (r.json = {}), "string" == typeof r.config ? r.config = JSON.parse(r.config) : "object" == typeof r.config && null !== r.config || (r.config = {})), this._video = r, this.listener && this.listener.onVideoLoad && this.listener.onVideoLoad(r), new $1c811abb26f94012$var$Mn({
            video: r
        });
    }, t.prototype.createFromVideoId = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.managers.video.load(t)
                        ];
                    case 1:
                        return r = n.sent(), [
                            2,
                            this.onVideoLoad(r, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromVideo = function(t, e) {
        return this.onVideoLoad(t, e);
    }, t.prototype.createFromSongUrl = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(r) {
                return [
                    2,
                    this.createFromSongPath(this.managers.song.getSongPathFromUrl(t), e)
                ];
            });
        });
    }, t.prototype.createFromSongPath = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.managers.song.load({
                                songPath: t
                            })
                        ];
                    case 1:
                        return (r = n.sent()) ? [
                            2,
                            this.createFromSong(r.song, e)
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.createFromSongId = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.managers.song.load({
                                id: t
                            })
                        ];
                    case 1:
                        return (r = n.sent()) ? [
                            2,
                            this.createFromSong(r.song, e)
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.createFromSongCode = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.managers.song.load({
                                code: t
                            })
                        ];
                    case 1:
                        return (r = n.sent()) ? [
                            2,
                            this.createFromSong(r.song, e)
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.createFromSong = function(t, e) {
        var r;
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var n, i, o, s, a, u;
            return $1c811abb26f94012$var$gn(this, function(c) {
                switch(c.label){
                    case 0:
                        return n = null == e ? void 0 : e.lyricId, i = null == e ? void 0 : e.lyricDiffId, "number" != typeof n || n < 0 ? [
                            4,
                            this.managers.lyrics.load(t.code)
                        ] : [
                            3,
                            4
                        ];
                    case 1:
                        return o = c.sent(), (a = o && !o.status.failed && !o.status.processing && Array.isArray(o.lyrics) && o.lyrics.length > 0) ? [
                            4,
                            this.managers.lyrics.loadDetail(t.code, o.lyrics[0].id)
                        ] : [
                            3,
                            3
                        ];
                    case 2:
                        a = c.sent(), c.label = 3;
                    case 3:
                        (s = a) && (n = s.id, i = null === (r = s.diff) || void 0 === r ? void 0 : r.id), c.label = 4;
                    case 4:
                        return "number" != typeof n && (n = -1), "number" != typeof i && (i = -1), u = {
                            id: -1,
                            sourceId: -1,
                            sourceOriginId: -1,
                            songleId: t.id,
                            songleCode: t.code,
                            lyricId: n,
                            lyricDiffId: i,
                            title: null,
                            log: null,
                            background: null,
                            config: null,
                            json: null,
                            synthJson: null,
                            author: null,
                            createdDate: null,
                            accessCount: -1,
                            altUrl: null
                        }, [
                            2,
                            this.onVideoLoad(u, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromText = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r, n, i, o, s, a;
            return $1c811abb26f94012$var$gn(this, function(u) {
                switch(u.label){
                    case 0:
                        return [
                            4,
                            this.managers.text.parse(t)
                        ];
                    case 1:
                        return r = u.sent(), n = r && "success" === r.status ? this.createVideoDataFromParsedText(r, t) : this.createVideoDataFromText(t), i = n[n.length - 1], o = i && i.words[i.words.length - 1], s = o && o.characters[o.characters.length - 1], a = s ? s.endTime : 0, [
                            2,
                            this.createFromJSON({
                                phrases: n,
                                startTime: 0,
                                endTime: a,
                                duration: a
                            }, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromJSON = function(t, e) {
        var r = {
            id: -1,
            sourceId: -1,
            sourceOriginId: -1,
            songleId: -1,
            lyricId: -1,
            lyricDiffId: -1,
            title: null,
            log: null,
            background: null,
            config: null,
            json: t,
            synthJson: null,
            author: null,
            createdDate: null,
            accessCount: -1,
            altUrl: null
        };
        return this.onVideoLoad(r, e);
    }, t.prototype.createVideoDataFromParsedText = function(t, e) {
        var r = 0, n = e.split(/\r\n|[\n\v\f\r\x85\u2028\u2029]/);
        return t.result.map(function(t, e) {
            return {
                words: t.map(function(t) {
                    return {
                        characters: n[e].substr(t.startPosition, t.wordLength).split("").map(function(t) {
                            return {
                                char: t,
                                startTime: 300 * r,
                                endTime: 300 * ++r
                            };
                        }),
                        pos: t.PoS,
                        rawPoS: t.rawPoS,
                        language: t.language
                    };
                }),
                templates: [
                    {
                        type: "DefaultAlignment"
                    }
                ]
            };
        });
    }, t.prototype.createVideoDataFromText = function(t) {
        for(var e, r = {
            characters: []
        }, n = {
            words: [
                r
            ],
            templates: [
                {
                    type: "DefaultAlignment"
                }
            ]
        }, i = 0, o = [
            n
        ], s = 0; s < t.length; s++){
            var a = t.charAt(s);
            "\n" !== a ? " " !== a ? (e = {
                char: a,
                startTime: 300 * i,
                endTime: 300 * ++i
            }, r.characters.push(e)) : (r = {
                characters: []
            }, n.words.push(r)) : (n = {
                words: [
                    r = {
                        characters: []
                    }
                ],
                templates: [
                    {
                        type: "DefaultAlignment"
                    }
                ]
            }, o.push(n));
        }
        return r.characters.length <= 0 && n.words.pop(), n.words.length <= 0 && o.pop(), o;
    }, t;
}(), $1c811abb26f94012$var$Vn = function() {
    function t(t, e, r) {
        void 0 === e && (e = null);
        var n = this;
        this.managers = t, this.listener = e, this.options = r, this.fontLoader = new $1c811abb26f94012$var$Rn(t.font, function() {
            return n.text;
        }, e);
    }
    return Object.defineProperty(t.prototype, "permalink", {
        get: function() {
            var t;
            return "https://textalive.jp".concat((null === (t = this.song) || void 0 === t ? void 0 : t.permalink) ? "/songs/".concat(encodeURIComponent($1c811abb26f94012$var$c.getSongPathFromUrl(this.song.permalink))) : "");
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "video", {
        get: function() {
            var t;
            return null === (t = this.videoProvider) || void 0 === t ? void 0 : t.video;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "song", {
        get: function() {
            var t, e;
            return null === (e = null === (t = this.songProvider) || void 0 === t ? void 0 : t.song) || void 0 === e ? void 0 : e.song;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "songStatus", {
        get: function() {
            var t, e;
            return null === (e = null === (t = this.songProvider) || void 0 === t ? void 0 : t.song) || void 0 === e ? void 0 : e.status;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "songMap", {
        get: function() {
            var t;
            return null === (t = this.songProvider) || void 0 === t ? void 0 : t.analysis;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "lyricsId", {
        get: function() {
            var t, e;
            return null === (e = null === (t = this.textProvider) || void 0 === t ? void 0 : t.lyrics) || void 0 === e ? void 0 : e.id;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "lyrics", {
        get: function() {
            var t;
            return null === (t = this.textProvider) || void 0 === t ? void 0 : t.lyrics;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "lyricsBody", {
        get: function() {
            var t;
            return null === (t = this.textProvider) || void 0 === t ? void 0 : t.lyricsBody;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "text", {
        get: function() {
            var t, e;
            return null === (e = null === (t = this.textProvider) || void 0 === t ? void 0 : t.lyricsBody) || void 0 === e ? void 0 : e.text;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "fonts", {
        get: function() {
            return this.fontLoader;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.createFromVideoId = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            new $1c811abb26f94012$var$Bn(this.managers, this.listener).createFromVideoId(t, e)
                        ];
                    case 1:
                        return r.videoProvider = n.sent(), [
                            2,
                            this.videoProvider
                        ];
                }
            });
        });
    }, t.prototype.createFromVideo = function(t, e) {
        return this.videoProvider = new $1c811abb26f94012$var$Bn(this.managers, this.listener).createFromVideo(t, e), this.videoProvider;
    }, t.prototype.createFromSongUrl = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            new $1c811abb26f94012$var$Bn(this.managers, this.listener).createFromSongUrl(t, e)
                        ];
                    case 1:
                        return r.videoProvider = n.sent(), [
                            2,
                            this.videoProvider
                        ];
                }
            });
        });
    }, t.prototype.createFromSongPath = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            new $1c811abb26f94012$var$Bn(this.managers, this.listener).createFromSongPath(t, e)
                        ];
                    case 1:
                        return r.videoProvider = n.sent(), [
                            2,
                            this.videoProvider
                        ];
                }
            });
        });
    }, t.prototype.createFromSongId = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            new $1c811abb26f94012$var$Bn(this.managers, this.listener).createFromSongId(t, e)
                        ];
                    case 1:
                        return r.videoProvider = n.sent(), [
                            2,
                            this.videoProvider
                        ];
                }
            });
        });
    }, t.prototype.createFromSongCode = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            new $1c811abb26f94012$var$Bn(this.managers, this.listener).createFromSongCode(t, e)
                        ];
                    case 1:
                        return r.videoProvider = n.sent(), [
                            2,
                            this.videoProvider
                        ];
                }
            });
        });
    }, t.prototype.createFromText = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this, [
                            4,
                            new $1c811abb26f94012$var$Bn(this.managers, this.listener).createFromText(t, e)
                        ];
                    case 1:
                        return r.videoProvider = n.sent(), [
                            2,
                            this.videoProvider
                        ];
                }
            });
        });
    }, t.prototype.createFromJSON = function(t, e) {
        return this.videoProvider = new $1c811abb26f94012$var$Bn(this.managers, this.listener).createFromJSON(t, e), this.videoProvider;
    }, t.prototype.finalize = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.video ? [
                            4,
                            this.loadSong()
                        ] : [
                            2,
                            null
                        ];
                    case 1:
                        return e.sent(), [
                            4,
                            this.loadText(t)
                        ];
                    case 2:
                        return e.sent(), [
                            4,
                            this.loadFonts()
                        ];
                    case 3:
                        return e.sent(), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.mockSongInfo = function(t) {
        this.songProvider = new $1c811abb26f94012$var$Ln(this.managers.song, this.listener, this.options).mockSongInfo(t);
    }, t.prototype.loadSong = function() {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var t;
            return $1c811abb26f94012$var$gn(this, function(e) {
                switch(e.label){
                    case 0:
                        return t = this, [
                            4,
                            new $1c811abb26f94012$var$Ln(this.managers.song, this.listener, this.options).loadSong(this.video.songleCode || this.video.songleId, this.video)
                        ];
                    case 1:
                        return t.songProvider = e.sent(), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.loadText = function(t) {
        var e, r;
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var n, i, o, s, a, u, c, l;
            return $1c811abb26f94012$var$gn(this, function(p) {
                switch(p.label){
                    case 0:
                        return n = this.video, i = n.lyricId, o = n.lyricDiffId, s = this.song ? this.song.code : null, a = new $1c811abb26f94012$var$Dn(this.managers, this.listener, this.options), !s && i < 0 ? (u = a.loadRawText(null === (e = this.videoProvider) || void 0 === e ? void 0 : e.data), [
                            3,
                            3
                        ]) : [
                            3,
                            1
                        ];
                    case 1:
                        return c = (null == t ? void 0 : t.altLyricsUrl) || void 0, l = (null == t ? void 0 : t.lyricsDirectAccess) || void 0, [
                            4,
                            a.loadLyrics({
                                songCode: s,
                                lyricId: i,
                                lyricDiffId: o,
                                altLyricsUrl: c,
                                directAccess: l
                            })
                        ];
                    case 2:
                        u = p.sent(), p.label = 3;
                    case 3:
                        return this.textProvider = u, (null == u ? void 0 : u.lyrics) && (null === (r = null == u ? void 0 : u.lyricsBody) || void 0 === r ? void 0 : r.text) && this.importLyrics(), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.loadFonts = function() {
        var t, e, r;
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return "number" == typeof this.video.id && this.video.id >= 0 ? [
                            4,
                            this.fontLoader.loadForVideo(null === (t = this.videoProvider) || void 0 === t ? void 0 : t.data)
                        ] : [
                            3,
                            2
                        ];
                    case 1:
                    case 3:
                    case 5:
                        return n.sent(), [
                            2
                        ];
                    case 2:
                        return Array.isArray(null === (e = this.options) || void 0 === e ? void 0 : e.fontFamilies) ? [
                            4,
                            this.fontLoader.load(this.options.fontFamilies)
                        ] : [
                            3,
                            4
                        ];
                    case 4:
                        return null !== (null === (r = this.options) || void 0 === r ? void 0 : r.fontFamilies) ? [
                            3,
                            6
                        ] : [
                            4,
                            this.fontLoader.loadAll()
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.importLyrics = function() {
        var t = this.text.replace(/[\s\r\n]/g, ""), e = 0, r = {
            phrases: this.lyrics.data.map(function(r) {
                return {
                    words: r.map(function(r) {
                        return {
                            characters: r.map(function(r) {
                                return {
                                    char: t.charAt(e++),
                                    startTime: 1e3 * r.start_time,
                                    endTime: 1e3 * r.end_time
                                };
                            })
                        };
                    })
                };
            })
        };
        this.video.json && Array.isArray(this.video.json.phrases) ? this.video.json.phrases.forEach(function(t, e) {
            t.words.forEach(function(t, n) {
                t.characters.forEach(function(t, i) {
                    var o = r.phrases[e].words[n].characters[i];
                    t.char = o.char, t.startTime = o.startTime, t.endTime = o.endTime;
                });
            });
        }) : this.video.json = r;
    }, t.prototype.getChoruses = function() {
        var t;
        return null === (t = this.songProvider) || void 0 === t ? void 0 : t.getChoruses();
    }, t.prototype.findChorus = function(t, e) {
        var r;
        return null === (r = this.songProvider) || void 0 === r ? void 0 : r.findChorus(t, e);
    }, t.prototype.findChorusBetween = function(t, e) {
        var r;
        return null === (r = this.songProvider) || void 0 === r ? void 0 : r.findChorusBetween(t, e);
    }, t.prototype.findChorusChange = function(t, e) {
        var r;
        return null === (r = this.songProvider) || void 0 === r ? void 0 : r.findChorusChange(t, e);
    }, t.prototype.getBeats = function() {
        var t;
        return null === (t = this.songProvider) || void 0 === t ? void 0 : t.getBeats();
    }, t.prototype.findBeat = function(t, e) {
        var r;
        return null === (r = this.songProvider) || void 0 === r ? void 0 : r.findBeat(t, e);
    }, t.prototype.findBeatChange = function(t, e) {
        var r;
        return null === (r = this.songProvider) || void 0 === r ? void 0 : r.findBeatChange(t, e);
    }, t.prototype.getChords = function() {
        var t;
        return null === (t = this.songProvider) || void 0 === t ? void 0 : t.getChords();
    }, t.prototype.findChord = function(t, e) {
        var r;
        return null === (r = this.songProvider) || void 0 === r ? void 0 : r.findChord(t, e);
    }, t.prototype.findChordChange = function(t, e) {
        var r;
        return null === (r = this.songProvider) || void 0 === r ? void 0 : r.findChordChange(t, e);
    }, t.prototype.getVocalFrequency = function(t) {
        var e;
        return null === (e = this.songProvider) || void 0 === e ? void 0 : e.getVocalFrequency(t);
    }, t.prototype.getVocalAmplitude = function(t) {
        var e;
        return null === (e = this.songProvider) || void 0 === e ? void 0 : e.getVocalAmplitude(t);
    }, t.prototype.getMaxVocalAmplitude = function() {
        var t;
        return null === (t = this.songProvider) || void 0 === t ? void 0 : t.getMaxVocalAmplitude();
    }, t.prototype.getValenceArousal = function(t) {
        var e;
        return null === (e = this.songProvider) || void 0 === e ? void 0 : e.getValenceArousal(t);
    }, t.prototype.getMedianValenceArousal = function() {
        var t;
        return null === (t = this.songProvider) || void 0 === t ? void 0 : t.getMedianValenceArousal();
    }, t;
}(), $1c811abb26f94012$var$Gn = function() {
    function t(t, e) {
        this.player = t, this.listener = e, this.initialize();
    }
    return Object.defineProperty(t.prototype, "options", {
        get: function() {
            return this._options ? $1c811abb26f94012$var$fn({}, this._options) : null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "name", {
        get: function() {
            return this._name;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "author", {
        get: function() {
            return this._author;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "status", {
        get: function() {
            return this._status;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "server", {
        get: function() {
            return this._server;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "managed", {
        get: function() {
            return !!this._host;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "host", {
        get: function() {
            return this._host;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "songUrl", {
        get: function() {
            return this._songUrl;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "songOptions", {
        get: function() {
            return this._songOptions;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "parameters", {
        get: function() {
            return this._parameters;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isConnecting", {
        get: function() {
            return !!this.connecting;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.initialize = function() {
        var t, e, r, n;
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(i) {
                switch(i.label){
                    case 0:
                        return this._options = null === (e = null === (t = this.player) || void 0 === t ? void 0 : t.options) || void 0 === e ? void 0 : e.app, this._options && (this._options = $1c811abb26f94012$var$fn({}, this._options), this._name = null === (r = this._options) || void 0 === r ? void 0 : r.appName, this._author = null === (n = this._options) || void 0 === n ? void 0 : n.appAuthor, this._options.token && ($1c811abb26f94012$var$m.textalive.appToken = this._options.token)), this._parameters = {}, this.parseQueryString(), this.initializeServerConnection(), "undefined" != typeof window && this._options ? [
                            4,
                            this.connect()
                        ] : [
                            3,
                            2
                        ];
                    case 1:
                        i.sent(), this.initializePlayerListener(), this.initializeMessageListener(), i.label = 2;
                    case 2:
                        return this._songUrl && this.createFromSongUrl(), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.initializeServerConnection = function() {
        var t, e, r, n, i, o;
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var s, a, u, c, l;
            return $1c811abb26f94012$var$gn(this, function(p) {
                switch(p.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$A.getServerStatus()
                        ];
                    case 1:
                        return s = p.sent(), a = "ja" === (null == s ? void 0 : s.lang), $1c811abb26f94012$var$m.textalive.appToken && (null == s ? void 0 : s.app) && (s.app.data && (this._name = null === (t = s.app.data) || void 0 === t ? void 0 : t.name, this._author = null === (r = null === (e = s.app) || void 0 === e ? void 0 : e.data) || void 0 === r ? void 0 : r.author, u = null === (i = null === (n = s.app) || void 0 === n ? void 0 : n.data) || void 0 === i ? void 0 : i.status, this._status = "number" == typeof u ? u : -1), this._server = {
                            version: s.version,
                            message: s.app.message,
                            error: s.app.error
                        }, !this._server.error) ? (c = this._server.message ? "\n".concat(this._server.message) : "", a ? console.info("[TextAlive API] \u30AF\u30E9\u30A4\u30A2\u30F3\u30C8 v".concat($1c811abb26f94012$var$m.client.version, " \u3067\u30B5\u30FC\u30D0 v").concat(this._server.version || "0.0.0", " \u306B\u63A5\u7D9A").concat(c)) : console.info("[TextAlive API] App API client v".concat($1c811abb26f94012$var$m.client.version, " connected to server v").concat(this._server.version || "0.0.0").concat(c)), this.listener.onAppLoad(this), [
                            2
                        ]) : (l = (null === (o = this._server) || void 0 === o ? void 0 : o.error) ? "\n".concat(this._server.error) : "", a ? console.warn("[TextAlive API] \u3053\u306E\u30A2\u30D7\u30EA\u306F\u30C8\u30FC\u30AF\u30F3\u304C\u6B63\u3057\u304F\u6307\u5B9A\u3055\u308C\u3066\u3044\u306A\u3044\u305F\u3081\u52D5\u4F5C\u3057\u307E\u305B\u3093\u3002 https://developer.textalive.jp \u304B\u3089\u30C8\u30FC\u30AF\u30F3\u3092\u5165\u624B\u3057\u3066\u6307\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002".concat(l)) : console.warn("[TextAlive API] This app requires a valid app token to run properly. You could get a token from https://developer.textalive.jp. ".concat(l)), this.listener.onAppLoad(null, l), [
                            2
                        ]);
                }
            });
        });
    }, t.prototype.initializePlayerListener = function() {
        var t = this;
        this.playerListener = {
            onVideoReady: function(e) {
                t._host && window.parent.postMessage({
                    kind: "ta_video",
                    options: {
                        lyrics: !!t.player.data.lyrics,
                        duration: t.player.video.duration
                    }
                }, "*");
            },
            onThrottledTimeUpdate: function(e) {
                t._host && window.parent.postMessage({
                    kind: "ta_position",
                    options: {
                        position: e
                    }
                }, "*");
            },
            onPlay: function() {
                t._host && window.parent.postMessage({
                    kind: "ta_status",
                    options: {
                        status: "play"
                    }
                }, "*");
            },
            onPause: function() {
                t._host && window.parent.postMessage({
                    kind: "ta_status",
                    options: {
                        status: "pause"
                    }
                }, "*");
            },
            onStop: function() {
                t._host && window.parent.postMessage({
                    kind: "ta_status",
                    options: {
                        status: "stop"
                    }
                }, "*");
            },
            onVolumeUpdate: function(e) {
                t._host && window.parent.postMessage({
                    kind: "ta_volume",
                    options: {
                        volume: e
                    }
                }, "*");
            },
            onDispose: function() {
                t.dispose();
            }
        }, this.player.addListener(this.playerListener);
    }, t.prototype.initializeMessageListener = function() {
        var t = this;
        this.messageListener = function(e) {
            if (e.data.kind && /^ta_/.test(e.data.kind)) {
                var r = t.player;
                switch(e.data.kind.substring(3)){
                    case "status":
                        switch(e.data.options.status){
                            case "play":
                                r.requestPlay();
                                break;
                            case "pause":
                                r.requestPause();
                                break;
                            case "stop":
                                r.requestStop();
                        }
                        break;
                    case "seek":
                        r.requestMediaSeek(e.data.options.position);
                        break;
                    case "volume":
                        r.volume = e.data.options.volume;
                        break;
                    case "parameter":
                        var n = e.data.options, i = n.name, o = n.value;
                        t.parameters[i] = o, t.listener.onAppParameterUpdate(i, o);
                        break;
                    case "media":
                        t._songUrl = e.data.options.url, t._songOptions = e.data.options.options || {}, r.requestStop();
                        var s = t.createFromSongUrl();
                        t.listener.onAppMediaChange(t._songUrl, s);
                }
            }
        }, window.addEventListener("message", this.messageListener);
    }, t.prototype.createFromSongUrl = function() {
        var t, e = this._songOptions;
        return e && (t = {
            video: {}
        }, e.altLyricsUrl && (t.altLyricsUrl = e.altLyricsUrl), e.lyricsDirectAccess && (t.lyricsDirectAccess = e.lyricsDirectAccess), e.lyricId && (t.video.lyricId = e.lyricId), e.lyricDiffId && (t.video.lyricDiffId = e.lyricDiffId), e.chordId && (t.video.chordId = e.chordId), e.beatId && (t.video.beatId = e.beatId), e.repetitiveSegmentId && (t.video.repetitiveSegmentId = e.repetitiveSegmentId)), this.player.createFromSongUrl(this._songUrl, t);
    }, t.prototype.parseQueryString = function() {
        var t = $1c811abb26f94012$var$pn("ta_app_token");
        t && ($1c811abb26f94012$var$m.textalive.appToken = t), this._songUrl = $1c811abb26f94012$var$pn("ta_song_url"), this._songOptions = {};
        var e = $1c811abb26f94012$var$pn("ta_lyric_id");
        e && (this._songOptions.lyricId = parseInt(e), isNaN(this._songOptions.lyricId) && delete this._songOptions.lyricId);
        var r = $1c811abb26f94012$var$pn("ta_lyric_diff_id");
        r && (this._songOptions.lyricDiffId = parseInt(r), isNaN(this._songOptions.lyricDiffId) && delete this._songOptions.lyricDiffId);
        var n = $1c811abb26f94012$var$pn("ta_alt_lyrics_url");
        n && (this._songOptions.altLyricsUrl = n);
        var i = $1c811abb26f94012$var$pn("ta_lyrics_direct_access");
        i && (this._songOptions.lyricsDirectAccess = "true" === i, this._songOptions.lyricsDirectAccess || delete this._songOptions.lyricsDirectAccess);
        var o = $1c811abb26f94012$var$pn("ta_chord_id");
        o && (this._songOptions.chordId = parseInt(o), isNaN(this._songOptions.chordId) && delete this._songOptions.chordId);
        var s = $1c811abb26f94012$var$pn("ta_beat_id");
        s && (this._songOptions.beatId = parseInt(s), isNaN(this._songOptions.beatId) && delete this._songOptions.beatId);
        var a = $1c811abb26f94012$var$pn("ta_repetitive_segment_id");
        a && (this._songOptions.repetitiveSegmentId = parseInt(a), isNaN(this._songOptions.repetitiveSegmentId) && delete this._songOptions.repetitiveSegmentId);
    }, t.prototype.connect = function() {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var t, e = this;
            return $1c811abb26f94012$var$gn(this, function(r) {
                switch(r.label){
                    case 0:
                        return this.connecting ? [
                            2,
                            this.connecting
                        ] : "undefined" != typeof window && this.options && window.parent && window !== window.parent ? [
                            3,
                            2
                        ] : [
                            4,
                            new Promise(function(t) {
                                return setTimeout(t, 1);
                            })
                        ];
                    case 1:
                        return r.sent(), this.listener.onAppReady(this), [
                            2,
                            !1
                        ];
                    case 2:
                        return this.connecting = Promise.race([
                            new Promise(function(r) {
                                t = function(n) {
                                    n.data.kind && /^ta_/.test(n.data.kind) && "ack" === n.data.kind.substring(3) && (window.removeEventListener("message", t), e._host = n.data.options, r(!0));
                                }, window.addEventListener("message", t);
                            }),
                            $1c811abb26f94012$var$yn(e, 0, void 0, function() {
                                var e;
                                return $1c811abb26f94012$var$gn(this, function(r) {
                                    switch(r.label){
                                        case 0:
                                            e = 0, r.label = 1;
                                        case 1:
                                            return e < 5 ? (window.parent.postMessage({
                                                kind: "ta_connect",
                                                options: this.options
                                            }, "*"), [
                                                4,
                                                new Promise(function(t) {
                                                    return setTimeout(t, 200);
                                                })
                                            ]) : [
                                                3,
                                                4
                                            ];
                                        case 2:
                                            if (r.sent(), this._host) return [
                                                3,
                                                4
                                            ];
                                            r.label = 3;
                                        case 3:
                                            return e++, [
                                                3,
                                                1
                                            ];
                                        case 4:
                                            return !this._host && t && window.removeEventListener("message", t), [
                                                2,
                                                !!this._host
                                            ];
                                    }
                                });
                            })
                        ]), this.connecting.finally(function() {
                            e.connecting = null, e.listener.onAppReady(e);
                        }), [
                            2,
                            this.connecting
                        ];
                }
            });
        });
    }, t.prototype.dispose = function() {
        "undefined" != typeof window && this.options && (this.player.removeListener(this.playerListener), window.removeEventListener("message", this.messageListener)), this._host = null, this.player = null;
    }, t;
}();
function $1c811abb26f94012$var$qn(t) {
    return t;
}
function $1c811abb26f94012$var$Wn(t) {
    return t < -1 ? t = -1 : t > 1 && (t = 1), function(e) {
        return 0 == t ? e : t < 0 ? e * (e * -t + 1 + t) : e * ((2 - e) * t + (1 - t));
    };
}
function $1c811abb26f94012$var$Yn(t) {
    return function(e) {
        return Math.pow(e, t);
    };
}
function $1c811abb26f94012$var$zn(t) {
    return function(e) {
        return 1 - Math.pow(1 - e, t);
    };
}
function $1c811abb26f94012$var$Jn(t) {
    return function(e) {
        return (e *= 2) < 1 ? .5 * Math.pow(e, t) : 1 - .5 * Math.abs(Math.pow(2 - e, t));
    };
}
var $1c811abb26f94012$var$Hn = $1c811abb26f94012$var$Yn(2), $1c811abb26f94012$var$Xn = $1c811abb26f94012$var$zn(2), $1c811abb26f94012$var$Zn = $1c811abb26f94012$var$Jn(2), $1c811abb26f94012$var$$n = $1c811abb26f94012$var$Yn(3), $1c811abb26f94012$var$Kn = $1c811abb26f94012$var$zn(3), $1c811abb26f94012$var$Qn = $1c811abb26f94012$var$Jn(3), $1c811abb26f94012$var$ti = $1c811abb26f94012$var$Yn(4), $1c811abb26f94012$var$ei = $1c811abb26f94012$var$zn(4), $1c811abb26f94012$var$ri = $1c811abb26f94012$var$Jn(4), $1c811abb26f94012$var$ni = $1c811abb26f94012$var$Yn(5), $1c811abb26f94012$var$ii = $1c811abb26f94012$var$zn(5), $1c811abb26f94012$var$oi = $1c811abb26f94012$var$Jn(5);
function $1c811abb26f94012$var$si(t) {
    return 1 - Math.cos(t * Math.PI / 2);
}
function $1c811abb26f94012$var$ai(t) {
    return Math.sin(t * Math.PI / 2);
}
function $1c811abb26f94012$var$ui(t) {
    return -0.5 * (Math.cos(Math.PI * t) - 1);
}
function $1c811abb26f94012$var$ci(t) {
    return function(e) {
        return e * e * ((t + 1) * e - t);
    };
}
var $1c811abb26f94012$var$li = $1c811abb26f94012$var$ci(1.7);
function $1c811abb26f94012$var$pi(t) {
    return function(e) {
        return --e * e * ((t + 1) * e + t) + 1;
    };
}
var $1c811abb26f94012$var$hi = $1c811abb26f94012$var$pi(1.7);
function $1c811abb26f94012$var$di(t) {
    return t *= 1.525, function(e) {
        return (e *= 2) < 1 ? e * e * ((t + 1) * e - t) * .5 : .5 * ((e -= 2) * e * ((t + 1) * e + t) + 2);
    };
}
var $1c811abb26f94012$var$fi = $1c811abb26f94012$var$di(1.7);
function $1c811abb26f94012$var$yi(t) {
    return -(Math.sqrt(1 - t * t) - 1);
}
function $1c811abb26f94012$var$gi(t) {
    return Math.sqrt(1 - --t * t);
}
function $1c811abb26f94012$var$vi(t) {
    return (t *= 2) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
}
function $1c811abb26f94012$var$mi(t) {
    return 1 - $1c811abb26f94012$var$bi(1 - t);
}
function $1c811abb26f94012$var$bi(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
}
function $1c811abb26f94012$var$_i(t) {
    return t < .5 ? .5 * $1c811abb26f94012$var$mi(2 * t) : .5 * $1c811abb26f94012$var$bi(2 * t - 1) + .5;
}
function $1c811abb26f94012$var$wi(t, e) {
    var r = 2 * Math.PI;
    return function(n) {
        if (0 == n || 1 == n) return n;
        var i = e / r * Math.asin(1 / t);
        return -t * Math.pow(2, 10 * (n -= 1)) * Math.sin((n - i) * r / e);
    };
}
var $1c811abb26f94012$var$Pi = $1c811abb26f94012$var$wi(1, .3);
function $1c811abb26f94012$var$Ei(t, e) {
    var r = 2 * Math.PI;
    return function(n) {
        if (0 == n || 1 == n) return n;
        var i = e / r * Math.asin(1 / t);
        return t * Math.pow(2, -10 * n) * Math.sin((n - i) * r / e) + 1;
    };
}
var $1c811abb26f94012$var$Oi = $1c811abb26f94012$var$Ei(1, .3);
function $1c811abb26f94012$var$Si(t, e) {
    var r = 2 * Math.PI;
    return function(n) {
        var i = e / r * Math.asin(1 / t);
        return (n *= 2) < 1 ? t * Math.pow(2, 10 * (n -= 1)) * Math.sin((n - i) * r / e) * -0.5 : t * Math.pow(2, -10 * (n -= 1)) * Math.sin((n - i) * r / e) * .5 + 1;
    };
}
var $1c811abb26f94012$var$Ti = $1c811abb26f94012$var$Si(1, .3 * 1.5), $1c811abb26f94012$var$xi = Object.freeze({
    __proto__: null,
    backIn: $1c811abb26f94012$var$li,
    backInOut: $1c811abb26f94012$var$fi,
    backOut: $1c811abb26f94012$var$hi,
    bounceIn: $1c811abb26f94012$var$mi,
    bounceInOut: $1c811abb26f94012$var$_i,
    bounceOut: $1c811abb26f94012$var$bi,
    circIn: $1c811abb26f94012$var$yi,
    circInOut: $1c811abb26f94012$var$vi,
    circOut: $1c811abb26f94012$var$gi,
    cubicIn: $1c811abb26f94012$var$$n,
    cubicInOut: $1c811abb26f94012$var$Qn,
    cubicOut: $1c811abb26f94012$var$Kn,
    elasticIn: $1c811abb26f94012$var$Pi,
    elasticInOut: $1c811abb26f94012$var$Ti,
    elasticOut: $1c811abb26f94012$var$Oi,
    get: $1c811abb26f94012$var$Wn,
    getBackIn: $1c811abb26f94012$var$ci,
    getBackInOut: $1c811abb26f94012$var$di,
    getBackOut: $1c811abb26f94012$var$pi,
    getElasticIn: $1c811abb26f94012$var$wi,
    getElasticInOut: $1c811abb26f94012$var$Si,
    getElasticOut: $1c811abb26f94012$var$Ei,
    getPowIn: $1c811abb26f94012$var$Yn,
    getPowInOut: $1c811abb26f94012$var$Jn,
    getPowOut: $1c811abb26f94012$var$zn,
    linear: $1c811abb26f94012$var$qn,
    quadIn: $1c811abb26f94012$var$Hn,
    quadInOut: $1c811abb26f94012$var$Zn,
    quadOut: $1c811abb26f94012$var$Xn,
    quartIn: $1c811abb26f94012$var$ti,
    quartInOut: $1c811abb26f94012$var$ri,
    quartOut: $1c811abb26f94012$var$ei,
    quintIn: $1c811abb26f94012$var$ni,
    quintInOut: $1c811abb26f94012$var$oi,
    quintOut: $1c811abb26f94012$var$ii,
    sineIn: $1c811abb26f94012$var$si,
    sineInOut: $1c811abb26f94012$var$ui,
    sineOut: $1c811abb26f94012$var$ai
}), $1c811abb26f94012$export$e60daad661aebae6 = function() {
    function t() {}
    return t.linear = $1c811abb26f94012$var$qn, t.get = $1c811abb26f94012$var$Wn, t.getPowIn = $1c811abb26f94012$var$Yn, t.getPowOut = $1c811abb26f94012$var$zn, t.getPowInOut = $1c811abb26f94012$var$Jn, t.quadIn = $1c811abb26f94012$var$Hn, t.quadOut = $1c811abb26f94012$var$Xn, t.quadInOut = $1c811abb26f94012$var$Zn, t.cubicIn = $1c811abb26f94012$var$$n, t.cubicOut = $1c811abb26f94012$var$Kn, t.cubicInOut = $1c811abb26f94012$var$Qn, t.quartIn = $1c811abb26f94012$var$ti, t.quartOut = $1c811abb26f94012$var$ei, t.quartInOut = $1c811abb26f94012$var$ri, t.quintIn = $1c811abb26f94012$var$ni, t.quintOut = $1c811abb26f94012$var$ii, t.quintInOut = $1c811abb26f94012$var$oi, t.sineIn = $1c811abb26f94012$var$si, t.sineOut = $1c811abb26f94012$var$ai, t.sineInOut = $1c811abb26f94012$var$ui, t.getBackIn = $1c811abb26f94012$var$ci, t.backIn = $1c811abb26f94012$var$li, t.getBackOut = $1c811abb26f94012$var$pi, t.backOut = $1c811abb26f94012$var$hi, t.getBackInOut = $1c811abb26f94012$var$di, t.backInOut = $1c811abb26f94012$var$fi, t.circIn = $1c811abb26f94012$var$yi, t.circOut = $1c811abb26f94012$var$gi, t.circInOut = $1c811abb26f94012$var$vi, t.bounceIn = $1c811abb26f94012$var$mi, t.bounceOut = $1c811abb26f94012$var$bi, t.bounceInOut = $1c811abb26f94012$var$_i, t.getElasticIn = $1c811abb26f94012$var$wi, t.elasticIn = $1c811abb26f94012$var$Pi, t.getElasticOut = $1c811abb26f94012$var$Ei, t.elasticOut = $1c811abb26f94012$var$Oi, t.getElasticInOut = $1c811abb26f94012$var$Si, t.elasticInOut = $1c811abb26f94012$var$Ti, t;
}(), $1c811abb26f94012$var$Ri = function() {
    function t() {
        this.cursor = -1, this.widgets = [], this.instances = [], this.model = {
            id: -1,
            type: $1c811abb26f94012$export$6ba26ae1c58c0147.NONE,
            sourceId: -1,
            author: null,
            originalAuthor: null,
            className: null,
            createdDate: null
        };
    }
    return Object.defineProperty(t.prototype, "id", {
        get: function() {
            return this.model ? this.model.id : -1;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "script", {
        get: function() {
            return this.model ? this.model.script : null;
        },
        enumerable: !1,
        configurable: !0
    }), t;
}(), $1c811abb26f94012$var$Ci = function() {}, $1c811abb26f94012$var$Ni = function() {
    function t(t, e) {
        this.onTemplateLoad = e, this._emitter = null, this._loaded = null, this._loading = null, this.verbose = !1, this._emitter = t, this.clear();
    }
    return Object.defineProperty(t.prototype, "loaded", {
        get: function() {
            return this._loaded;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "loading", {
        get: function() {
            return this._loading;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.clear = function() {
        this._loaded = {}, this._loading = {};
    }, t.prototype.loadLatest = function(t) {
        return void 0 === t && (t = 100), $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e;
            return $1c811abb26f94012$var$gn(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$q.list({
                                maxResults: t,
                                withoutAuthors: !0,
                                withoutOriginalAuthors: !0,
                                script: !0
                            })
                        ];
                    case 1:
                        return (e = r.sent()) && e.list ? (this.verbose && console.log("--- loading template classes ---"), [
                            2,
                            this.registerMany(e.list)
                        ]) : [
                            2
                        ];
                }
            });
        });
    }, t.prototype.loadForVideo = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e, r = this;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$q.loadForVideo(t)
                        ];
                    case 1:
                        return (e = n.sent()) && e.list ? (this.verbose && console.log("--- loading template classes for vid:".concat(t, " ---")), [
                            4,
                            this.registerMany(e.list)
                        ]) : [
                            2,
                            null
                        ];
                    case 2:
                        return [
                            2,
                            n.sent().map(function(t) {
                                return t ? r.getByName(t) : null;
                            })
                        ];
                }
            });
        });
    }, t.prototype.loadByNames = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e, r = this;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return !Array.isArray(t) || t.length <= 0 ? [
                            2,
                            []
                        ] : (this.verbose && console.log("--- loading template classes ---"), [
                            4,
                            Promise.all(t.map(function(t) {
                                return r.doLoadByName(t);
                            }))
                        ]);
                    case 1:
                        return (e = n.sent()) && this._emitter.onTemplatesLoad(e.filter(function(t) {
                            return !!t;
                        }).map(function(t) {
                            return t.className;
                        })), [
                            2,
                            e
                        ];
                }
            });
        });
    }, t.prototype.loadByName = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e, r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return n.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]), [
                            4,
                            this.doLoadByName(t)
                        ];
                    case 1:
                        return e = n.sent(), this._emitter.onTemplatesLoad([
                            e.className
                        ]), [
                            2,
                            e
                        ];
                    case 2:
                        return r = n.sent(), this._emitter.onTemplatesLoad(null, r), [
                            2,
                            null
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.doLoadByName = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e, r, n = this;
            return $1c811abb26f94012$var$gn(this, function(i) {
                return null !== (e = this.getByName(t)) ? [
                    2,
                    e
                ] : this._loading[t] ? [
                    2,
                    this._loading[t]
                ] : (r = new Promise(function(e) {
                    return $1c811abb26f94012$var$q.loadByName(t).then(function(t) {
                        return n.onTemplateLoad(t);
                    }).then(e);
                }), this._loading[t] = r, r.finally(function() {
                    return delete n._loading[t];
                }), [
                    2,
                    r
                ]);
            });
        });
    }, t.prototype.loadById = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e, r, n;
            return $1c811abb26f94012$var$gn(this, function(i) {
                switch(i.label){
                    case 0:
                        return i.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]), [
                            4,
                            this.doLoadById(t)
                        ];
                    case 1:
                        return e = i.sent(), r = null, [
                            3,
                            3
                        ];
                    case 2:
                        return n = i.sent(), r = n, [
                            3,
                            3
                        ];
                    case 3:
                        return this._emitter.onTemplatesLoad(e ? [
                            e.className
                        ] : null, r), [
                            2,
                            e
                        ];
                }
            });
        });
    }, t.prototype.doLoadById = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e, r, n = this;
            return $1c811abb26f94012$var$gn(this, function(i) {
                return (e = this.getById(t)) ? [
                    2,
                    e
                ] : this._loading[t] ? [
                    2,
                    this._loading[t]
                ] : (r = new Promise(function(e) {
                    return $1c811abb26f94012$var$q.load(t).then(function(t) {
                        return n.onTemplateLoad(t);
                    }).then(e);
                }), this._loading[t] = r, r.finally(function() {
                    return delete n._loading[t];
                }), [
                    2,
                    r
                ]);
            });
        });
    }, t.prototype.registerMany = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e, r, n = this;
            return $1c811abb26f94012$var$gn(this, function(i) {
                switch(i.label){
                    case 0:
                        return e = t.map(function(t) {
                            var e = n.onTemplateLoad(t);
                            return n._loading[t.className] = e, n._loading["".concat(t.className, "@").concat(t.id)] = e, e;
                        }), [
                            4,
                            Promise.all(e.map(function(t) {
                                return t.then(function(t) {
                                    return t.className;
                                }).catch(function(t) {
                                    return null;
                                });
                            }))
                        ];
                    case 1:
                        return r = i.sent().filter(function(t) {
                            return !!t;
                        }), this._emitter.onTemplatesLoad(r), [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.commit = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            $1c811abb26f94012$var$q.create({
                                sourceId: t.model.sourceId,
                                script: t.model.script,
                                log: e
                            })
                        ];
                    case 1:
                        return (r = n.sent()).success && (t.model.id = r.id, this._emitter.onTemplateCommit(t.className)), [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.getByName = function(t, e) {
        var r;
        if (void 0 === e && (e = !1), t && (r = t.match(/(.+)@([0-9]+)/))) {
            t = r[1];
            var n = parseInt(r[2]);
            if (!this._loaded[t]) return null;
            var i = this._loaded[t].model;
            if (i.id !== n) {
                if (!e) return null;
                this.verbose && console.log("[warning] template ".concat(t, " version ").concat(n, " is requested but ").concat(i.id, " is used"));
            }
        }
        return this._loaded[t] ? this._loaded[t] : null;
    }, t.prototype.getById = function(t) {
        var e = null;
        for(var r in this._loaded)if (this._loaded[r].model.id === t) {
            e = this._loaded[r];
            break;
        }
        return e;
    }, t;
}(), $1c811abb26f94012$var$ki = {
    Matrix2D: $1c811abb26f94012$export$26e6ecd136a15474,
    Point: $1c811abb26f94012$export$baf26146a414f24a,
    Color: $1c811abb26f94012$export$892596cec99bc70e,
    Font: $1c811abb26f94012$var$Z,
    RenderingUnit: $1c811abb26f94012$var$K,
    TextUnit: $1c811abb26f94012$var$et,
    Graphic: $1c811abb26f94012$var$nt,
    Phrase: $1c811abb26f94012$var$ot,
    Word: $1c811abb26f94012$var$it,
    Char: $1c811abb26f94012$var$rt,
    Beat: $1c811abb26f94012$var$Nn,
    RepetitiveSegment: $1c811abb26f94012$var$jn
}, $1c811abb26f94012$var$ji = [
    "headTime",
    "tailTime",
    "insomnia"
], $1c811abb26f94012$var$Ii = [
    "animate",
    "getAssignedUnit",
    "name",
    "type"
], $1c811abb26f94012$var$Ui = function() {
    function t(t, e, r) {
        this._emitter = null, this._player = null, this.interpreter = null, this.unsafeAcceleration = !1, this._verbose = !1, this.ignoreVersion = !1, this.rawConsole = !1, this._player = t, this._emitter = e, this.unsafeAcceleration = r, this.loader = new $1c811abb26f94012$var$Ni(e, this.register.bind(this)), t.addListener({
            onVideoReady: this.onVideoReady.bind(this)
        });
    }
    return Object.defineProperty(t.prototype, "verbose", {
        get: function() {
            return this._verbose;
        },
        set: function(t) {
            this._verbose = this.loader.verbose = t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "ready", {
        get: function() {
            return !!this.interpreter;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "loaded", {
        get: function() {
            return this.loader.loaded;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.initialize = function() {
        var t = this;
        if (!this.ready) {
            var e = function(t) {
                var e = t.player, r = t.ignoredPropNames, i = t.rawConsole, o = t.templateGetter, s = e.graphics.wrapperTable, a = new $1c811abb26f94012$var$cn($1c811abb26f94012$var$fn($1c811abb26f94012$var$fn({}, $1c811abb26f94012$var$ki), s), r, function(t, r) {
                    return e.graphics.isGraphics(t) && r instanceof $1c811abb26f94012$export$892596cec99bc70e ? r.toString() : r;
                }), u = {
                    require: {
                        func: function(t) {
                            if (!(t.length < 1 || "string" != typeof t[0])) {
                                var e = t[0], r = o(e);
                                return null === r ? void 0 : r.functionDefinition;
                            }
                        },
                        raw: !0,
                        isConstructor: !0
                    },
                    print: {
                        func: function(t) {
                            e.isEditing && console.log.apply(console, t);
                        },
                        raw: i
                    },
                    findChorus: {
                        func: function(t) {
                            return t.length < 1 || "number" != typeof t[0] ? null : e.findChorus(t[0]);
                        }
                    },
                    findBeat: {
                        func: function(t) {
                            return t.length < 1 || "number" != typeof t[0] ? null : e.findBeat(t[0]);
                        }
                    },
                    getVocalFrequency: {
                        func: function(t) {
                            return t.length < 1 || "number" != typeof t[0] ? null : e.getVocalFrequency(t[0]);
                        }
                    },
                    getVocalAmplitude: {
                        func: function(t) {
                            return t.length < 1 || "number" != typeof t[0] ? -1 : e.getVocalAmplitude(t[0]);
                        }
                    },
                    getMaxVocalAmplitude: {
                        func: function(t) {
                            return e.getMaxVocalAmplitude();
                        }
                    },
                    getValenceArousal: {
                        func: function(t) {
                            return t.length < 1 || "number" != typeof t[0] ? null : e.getValenceArousal(t[0]);
                        }
                    },
                    getMedianValenceArousal: {
                        func: function(t) {
                            return e.getMedianValenceArousal();
                        }
                    }
                };
                Object.keys($1c811abb26f94012$export$6ba26ae1c58c0147).forEach(function(t) {
                    a.setProperty(a.globalScope, t, $1c811abb26f94012$export$6ba26ae1c58c0147[t]), u[t] = {
                        value: $1c811abb26f94012$export$6ba26ae1c58c0147[t]
                    };
                }), Object.keys($1c811abb26f94012$var$xi).forEach(function(t) {
                    var e = $1c811abb26f94012$var$xi[t];
                    0 !== t.indexOf("get") && (u[t] = {
                        func: e
                    });
                });
                var c = Object.keys(a.wrapperTable);
                return c && c.forEach(function(t) {
                    return u[t] = {
                        cls: a.wrapperTable[t]
                    };
                }), Object.keys(u).forEach(function(t) {
                    var e = u[t];
                    e.func ? a.createGlobalFunction(t, e) : e.value && a.setProperty(a.globalScope, t, e.value);
                }), {
                    interpreter: a,
                    unsafeGlobalScope: u
                };
            }({
                player: this._player,
                ignoredPropNames: $1c811abb26f94012$var$Ii,
                rawConsole: this.rawConsole,
                templateGetter: function(e) {
                    return t.getByName(e, !0);
                }
            }), r = e.interpreter, i = e.unsafeGlobalScope;
            this.unsafeGlobalScope = i, this.interpreter = r, this.onVideoReady(this._player.video);
        }
    }, t.prototype.getByName = function(t, e) {
        return void 0 === e && (e = !1), this.loader.getByName(t, e);
    }, t.prototype.getById = function(t) {
        return this.loader.getById(t);
    }, t.prototype.clear = function() {
        this.loader.clear();
    }, t.prototype.loadLatest = function(t) {
        return void 0 === t && (t = 100), $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(e) {
                return this.ready || this.initialize(), [
                    2,
                    this.loader.loadLatest(t)
                ];
            });
        });
    }, t.prototype.loadForVideo = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(e) {
                return this.ready || this.initialize(), [
                    2,
                    this.loader.loadForVideo(t)
                ];
            });
        });
    }, t.prototype.loadByNames = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(e) {
                return this.ready || this.initialize(), [
                    2,
                    this.loader.loadByNames(t)
                ];
            });
        });
    }, t.prototype.loadByName = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(e) {
                return this.ready || this.initialize(), [
                    2,
                    this.loader.loadByName(t)
                ];
            });
        });
    }, t.prototype.loadById = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(e) {
                return this.ready || this.initialize(), [
                    2,
                    this.loader.loadById(t)
                ];
            });
        });
    }, t.prototype.commit = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(r) {
                return [
                    2,
                    this.loader.commit(t, e)
                ];
            });
        });
    }, t.prototype.register = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e, r, n, i, o, s, a = this;
            return $1c811abb26f94012$var$gn(this, function(u) {
                switch(u.label){
                    case 0:
                        if (!t) return [
                            2,
                            null
                        ];
                        if ("number" == typeof t.sourceId) {
                            if (e = t, !(r = this.createClass(t.script))) return [
                                2,
                                null
                            ];
                        } else r = t;
                        n = $1c811abb26f94012$var$nn(r.ast).dependencies, u.label = 1;
                    case 1:
                        return u.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4,
                            Promise.all(n.map(function(t) {
                                var e = a.getByName(t, a.ignoreVersion);
                                return e ? Promise.resolve(e) : a.loadByName(t);
                            }))
                        ];
                    case 2:
                        return u.sent(), this.verbose && console.log("load dependencies for", r.className, n), [
                            3,
                            4
                        ];
                    case 3:
                        return i = u.sent(), this.verbose && console.error("failed loading dependencies for", r.className, i), [
                            3,
                            4
                        ];
                    case 4:
                        try {
                            if (!(e ? this.loadModel(r, e) : this.createModel(r))) throw new Error("failed to create a template instance");
                            return [
                                2,
                                this.registerClass(r)
                            ];
                        } catch (t) {
                            throw o = void 0, e && (delete (s = $1c811abb26f94012$var$fn({}, e)).script, o = s), {
                                error: t.message,
                                stack: t.stack,
                                cause: o
                            };
                        }
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.updateClassScript = function(t, e) {
        var r = this.createClass(e);
        return this.updateClass(t, r);
    }, t.prototype.registerClass = function(t) {
        if (!t) return null;
        if (this.loader.loaded[t.className]) {
            this.verbose && console.log("updating", t.className, t.model.id);
            var e = this.updateClass(this.loader.loaded[t.className], t);
            return this.verbose && console.log("updated", e.className, e.id), e;
        }
        return this.loader.loaded[t.className] = t, this.verbose && console.log("loaded", t.className, t.model.id), t;
    }, t.prototype.updateClass = function(t, e) {
        var r = t, n = e;
        if (!n) return null;
        if (r.model.script === n.model.script) return this.verbose && console.log("no diff for", r.className), r;
        if (!this.createModel(n)) return null;
        if (r.className !== n.className) {
            var i = this.getByName(n.className);
            if (!i) return n.cursor = r.cursor, this.loader.loaded[n.className] = n, this.verbose && console.log("create", n.className), n;
            r = i;
        }
        return r.newStatement = n.newStatement, r.widgets = n.widgets, r.scope = n.scope, r.functionDefinition = n.functionDefinition, r.newStatement = n.newStatement, r.unsafeConstructorGenerator = n.unsafeConstructorGenerator, r.ast = n.ast, r.cursor < 0 && (r.cursor = n.cursor), n.id >= 0 ? (this.verbose && console.log("replace", n.className, r.id, n.id), r.model = n.model) : (this.verbose && console.log("update", n.className, r.id, n.id), r.model.type = n.model.type, r.model.className = n.model.className, r.model.prettyName = n.model.prettyName, r.model.script = n.model.script, r.model.createdDate = null, r.id >= 0 && (r.model.sourceId = r.model.id, r.model.id = -1)), n = r, this.updateInstances(r.instances.slice(), n), this._emitter.onTemplateUpdate(n.className), n;
    }, t.prototype.loadModel = function(t, e) {
        var r = this.newRawInstance(t);
        return t.model = e, this.updateWidgetInitialValues(t, r), r;
    }, t.prototype.createModel = function(t) {
        var e = this.newRawInstance(t);
        if (null === e) return !1;
        if (t.id >= 0) return !0;
        var r = e.templateInstance, n = t.model.script;
        return t.model = {
            id: -1,
            sourceId: -1,
            className: t.className,
            prettyName: r ? this.interpreter.getProperty(r, "name") : e.unsafeTemplateInstance.name,
            type: r ? this.interpreter.getProperty(r, "type") : e.unsafeTemplateInstance.type,
            script: n,
            author: null,
            originalAuthor: null,
            createdDate: null
        }, this.updateWidgetInitialValues(t, e), e;
    }, t.prototype.updateWidgetInitialValues = function(t, e) {
        var r = this;
        t.widgets.forEach(function(t) {
            t.initialValue = r.getProperty(e, t.name);
        });
    }, t.prototype.updateInstances = function(t, e) {
        var r = this;
        t.forEach(function(t) {
            try {
                r.updateInstance(t, e);
            } catch (r) {
                console.log("failed updating template for", t.assignedUnit, ":", e);
            }
        }), this._player.isPlaying || this._player.requestStageUpdate();
    }, t.prototype.createClass = function(t) {
        var e = this;
        this.ready || this.initialize();
        var r = new $1c811abb26f94012$var$Ri;
        r.model = {
            id: -1,
            sourceId: -1,
            className: null,
            prettyName: null,
            type: 0,
            script: t,
            author: null,
            originalAuthor: null,
            createdDate: null
        };
        var n = $1c811abb26f94012$var$rn(t, $1c811abb26f94012$var$Ii), i = n.ast, o = n.widgets;
        if (r.ast = i, r.widgets = o, r.className = r.ast.body[0].id.name, r.scope = this.interpreter.prepareRun(r.ast), this.interpreter.run(1e3, "to define " + r.className), r.functionDefinition = this.interpreter.getRawProperty(r.scope, r.className), r.newStatement = this.interpreter.newStatementFor(r.className), this.unsafeAcceleration) {
            var s = Object.keys(this.unsafeGlobalScope), a = Object.keys(this.getGlobalProperties()).map(function(t) {
                return "".concat(t, "=props.").concat(t);
            }).join(","), u = "return function(props){var ".concat(a, ";").concat(t, "return ").concat(r.className, ";}"), c = new (Function.bind.apply(Function, $1c811abb26f94012$var$vn($1c811abb26f94012$var$vn([
                void 0
            ], s, !1), [
                u
            ], !1))), l = function(t) {
                var r = e.getByName(t);
                return r ? r.unsafeConstructorGenerator(e.getGlobalProperties()) : null;
            }, p = s.map(function(t) {
                if ("require" === t) return l;
                var r = e.unsafeGlobalScope[t];
                return r.func ? function() {
                    for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
                    return r.func(t);
                } : r.cls || r.value;
            });
            r.unsafeConstructorGenerator = c.apply({}, p);
        }
        return r;
    }, t.prototype.getGlobalProperties = function() {
        var t;
        return {
            width: this._player.videoWidth,
            height: this._player.videoHeight,
            margin: this._player.margin,
            duration: (null === (t = this._player.video) || void 0 === t ? void 0 : t.duration) || 0
        };
    }, t.prototype.newRawInstance = function(t) {
        var e = t, r = new $1c811abb26f94012$var$Ci;
        if (this.unsafeAcceleration) {
            var n = new (e.unsafeConstructorGenerator(this.getGlobalProperties()));
            r.unsafeTemplateInstance = n;
        } else {
            this.interpreter.prepareNewInstance(e.newStatement, e.scope);
            var i = this.interpreter.run(700, "to instantiate " + e.className);
            r.templateInstance = i, r.templateInstance._nativeInstance = r;
        }
        return r.templateClass = e, r.ignore = !1, r;
    }, t.prototype.setProperty = function(t, e, r) {
        this.unsafeAcceleration ? t.unsafeTemplateInstance[e] = r : this.interpreter.setProperty(t.templateInstance, e, r);
    }, t.prototype.getProperty = function(t, e) {
        return this.unsafeAcceleration ? t.unsafeTemplateInstance[e] : this.interpreter.getProperty(t.templateInstance, e);
    }, t.prototype.exportInstance = function(t) {
        for(var e = {}, r = 0, n = t.templateClass.widgets.map(function(t) {
            return t.name;
        }).concat($1c811abb26f94012$var$ji); r < n.length; r++){
            var i = n[r], o = this.getProperty(t, i);
            try {
                var s = $1c811abb26f94012$var$gt(o);
                void 0 !== s && (e[i] = s);
            } catch (e) {
                console.error("cannot export ".concat(t.templateClass.className, ".").concat(i), o, "assigned to", t.assignedUnit);
            }
        }
        return {
            type: t.templateClass.className,
            value: e
        };
    }, t.prototype.importInstances = function(t, e) {
        try {
            this.importPhraseTemplates(t.firstCredit, e.credits), this.importPhraseTemplates(t.firstPhrase, e.phrases);
            for(var r = e.graphics, n = t.firstGraphic, i = 0; null !== n;){
                var o = r[i++];
                this.importTemplates(n, o.templates), n = n.next;
            }
        } catch (t) {
            return console.error("restoring templates failed", t), !1;
        }
        return !0;
    }, t.prototype.importPhraseTemplates = function(t, e) {
        if (Array.isArray(e)) for(var r = 0; t;){
            var n = e[r++];
            this.importTemplates(t, n.templates);
            for(var i = t.firstWord, o = 0; o < t.wordCount; o++){
                var s = n.words[o];
                this.importTemplates(i, s.templates);
                for(var a = i.firstChar, u = 0; u < i.charCount; u++){
                    var c = s.characters[u];
                    this.importTemplates(a, c.templates), a = a.next;
                }
                i = i.next;
            }
            if (e.length < r + 1) break;
            t = t.next;
        }
    }, t.prototype.importTemplates = function(t, e) {
        if (Array.isArray(e)) for(var r = 0, n = e; r < n.length; r++){
            var i = n[r], o = this.importInstance(i);
            o && t.addTemplate(o);
        }
    }, t.prototype.importInstance = function(t) {
        var e = this.getByName(t.type), r = this.newInstance(e);
        if (!r || !t.value) return null;
        for(var n = 0, i = Object.keys(t.value); n < i.length; n++){
            var o = i[n], s = $1c811abb26f94012$var$vt(t.value[o], this.interpreter.wrapperTable);
            void 0 !== s && this.setProperty(r, o, s);
        }
        return r;
    }, t.prototype.updateInstance = function(t, e) {
        var r = t, n = e, i = this.newRawInstance(n), o = r.templateInstance, s = this.interpreter.cleanupProperties(o);
        r.templateClass !== n && (this.disposeInstance(r), n.instances.push(r)), r.templateClass = n, r.scope = i.scope, r.templateInstance = i.templateInstance, r.ignore = i.ignore, this.interpreter.restoreProperties(r.templateInstance, s), this.attachGetAssignedUnitMethod(r);
    }, t.prototype.newInstance = function(t) {
        var e;
        try {
            if (null === (e = this.newRawInstance(t))) return null;
        } catch (t) {
            return null;
        }
        return this.attachGetAssignedUnitMethod(e), t.instances.push(e), e;
    }, t.prototype.attachGetAssignedUnitMethod = function(t) {
        var e = this;
        if (this.unsafeAcceleration) t.unsafeTemplateInstance.getAssignedUnit = function() {
            return t.assignedUnit;
        };
        else {
            var r = this.interpreter.createFunction(function() {
                return e.interpreter.wrap(t.assignedUnit);
            });
            this.interpreter.setRawProperty(t.templateInstance, "getAssignedUnit", r);
        }
    }, t.prototype.disposeInstance = function(t) {
        var e = t.templateClass;
        e.instances = e.instances.filter(function(e) {
            return e !== t;
        });
    }, t.prototype.disposeInstances = function(t) {
        var e = this;
        if (Array.isArray(t)) t.forEach(function(t) {
            return e.disposeInstance(t);
        });
        else {
            var r = t;
            [
                r.firstCredit,
                r.firstPhrase,
                r.firstWord,
                r.firstChar,
                r.firstGraphic
            ].forEach(function(t) {
                for(; t;)e.disposeInstances(t.removeTemplates()), t = t.next;
            });
        }
    }, t.prototype.setTemplate = function(t, e) {
        this.removeTemplates(t), t.addTemplate(e);
    }, t.prototype.clearTemplate = function(t) {
        this.removeTemplates(t);
    }, t.prototype.removeTemplateAt = function(t, e) {
        var r = t.removeTemplateAt(e);
        r && this.disposeInstance(r);
    }, t.prototype.removeTemplates = function(t) {
        var e = t.removeTemplates();
        this.disposeInstances(e);
    }, t.prototype.getRequiredTemplates = function(t) {
        return $1c811abb26f94012$var$nn(t).dependencies;
    }, t.prototype.getRequiredTemplateAt = function(t, e) {
        return $1c811abb26f94012$var$nn(t, e).dependencyAtCursor;
    }, t.prototype.exec = function(t, e, r) {
        if (t.unsafeTemplateInstance) {
            var n = t.unsafeTemplateInstance;
            return n[e].apply(n, r);
        }
        var i = this.interpreter.exec(t.templateInstance, e, r, t.assignedUnit ? " assigned to " + t.assignedUnit.toString() : "");
        return this.interpreter.unwrap(i);
    }, t.prototype.declareVariable = function(t, e, r, n) {
        return this.updateClassScript(t, function(t, e, r, n) {
            try {
                var i = $1c811abb26f94012$var$rn(t), o = i.ast, s = i.fields, a = s[s.length - 1], u = t.match(/(\r\n|[\n\v\f\r\x85\u2028\u2029])/), c = u ? u.pop() : "\n", l = t.split(c), p = a ? Array(a.loc.start.column + 1).join(" ") : "  ", h = a ? a.loc.end.line : 0;
                if (h <= 0) {
                    var d = o.body[0].body, f = l[d.loc.start.line - 1], y = f.substring(0, d.loc.start.column + 1), g = f.substring(d.loc.start.column + 1);
                    l[d.loc.start.line - 1] = y, l.splice(d.loc.start.line, 0, g), h = d.loc.start.line;
                }
                for(var v = void 0; (v = "var" + Math.random().toString().substring(2)).length > 8 && (v = v.substring(0, 8)), !(t.indexOf(v) < 0););
                l.length > h && l[h].length > 0 && l.splice(h, 0, ""), l.splice(h, 0, "", p + "// @proposed", p + "// @title " + e, p + "// " + function(t, e) {
                    if ("Slider" === t) return "@ui Slider(" + e.min + ", " + e.max + ")";
                    if ("Check" === t) return "@ui Check()";
                    if ("Color" === t) return "@ui Color()";
                    var r = e.etc;
                    return "@comment " + (r = r.replace(/(\r\n|[\n\v\f\r\x85\u2028\u2029])/g, "")).replace(/\/[*/]/g, "");
                }(r, n), p + "this." + v + " = " + function(t, e) {
                    return "Slider" === t ? ((e.min + e.max) / 2).toString() : "Check" === t ? "false" : "Color" === t ? 'new Color("#000000")' : "null";
                }(r, n) + ";"), t = l.join(c);
            } catch (t) {}
            return t;
        }(t.model.script, e, r, n));
    }, t.prototype.onVideoReady = function(t) {
        this.ready && (this.interpreter.setRawProperty(this.interpreter.globalScope, "width", this._player.resolutionWidth), this.interpreter.setRawProperty(this.interpreter.globalScope, "height", this._player.resolutionHeight), this.interpreter.setRawProperty(this.interpreter.globalScope, "margin", this.interpreter.wrap(this._player.margin)), this.interpreter.setRawProperty(this.interpreter.globalScope, "duration", (null == t ? void 0 : t.duration) || 0));
    }, t;
}(), $1c811abb26f94012$export$ff76868b9ee07b99 = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><defs><style>.bg{fill:#1f4391;}.fg{fill:#fff;}</style></defs><g class="logo-sq"><rect class="bg" x="-20" y="-20" width="240" height="240"/><g class="textalive-logo-art"><path class="fg" d="M97.33,130.81V142a3,3,0,0,0,4.78,2.41l56.81-42.09a3,3,0,0,0,0-4.81l-8.33-6.14Z"/><path class="fg" d="M137.14,81.43l-35-25.84A3,3,0,0,0,97.33,58v52.92Z"/><path class="fg" d="M51,55H80.33a2,2,0,0,1,2,2V71.67a0,0,0,0,1,0,0H51a2,2,0,0,1-2-2V57A2,2,0,0,1,51,55Z"/><path class="fg" d="M44.83,107.5h56.33a2,2,0,0,1,2,2v12.67a2,2,0,0,1-2,2H44.83a0,0,0,0,1,0,0V107.5A0,0,0,0,1,44.83,107.5Z" transform="translate(189.83 41.84) rotate(90)"/></g></g></svg>', $1c811abb26f94012$var$Li = "https://textalive.jp", $1c811abb26f94012$var$Di = function() {
    function t(t) {
        var e, r = this;
        if (this.player = t, this._position = "embed", this._rounded = !1, this._bordered = !1, this._shadowed = !1, this._background = "#fff", this._color = "#1f4391", void 0 !== (null === (e = t.options) || void 0 === e ? void 0 : e.mediaBannerPosition) && (this._position = t.options.mediaBannerPosition), this.domEnabled) {
            this.logoAnchor = document.createElement("a"), this.logoAnchor.className = "textalive-logo", this.logoAnchor.innerHTML = $1c811abb26f94012$export$ff76868b9ee07b99, this.logoAnchor.style.padding = this.bordered ? "1px 2px" : "1px 3px", this.logoAnchor.href = $1c811abb26f94012$var$Li, this.logoAnchor.target = "_blank", this.logoAnchor.title = "Powered by TextAlive App API", this.logoSvg = this.logoAnchor.querySelector("svg"), this.logoSvg.style.width = "24px", this.songNameDiv = document.createElement("div"), this.songNameDiv.className = "name", this.songNameDiv.style.fontWeight = "bold", this.songNameDiv.style.overflow = "hidden", this.songNameDiv.style.textOverflow = "ellipsis", this.songNameDiv.style.marginBottom = "2px", this.songNameDiv.textContent = "-", this.songArtistDiv = document.createElement("div"), this.songArtistDiv.className = "artist", this.songArtistDiv.textContent = "-", this.songArtistDiv.style.overflow = "hidden", this.songArtistDiv.style.textOverflow = "ellipsis";
            var n = document.createElement("span");
            n.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150"><g class="song"><path d="M120.95,45.77l-59.12,13a2.57,2.57,0,0,0-2,2.51v47.8c0,13.61-12.4,23.74-24.2,23.74-8.92,0-14.82-4.23-14.82-13,0-13,12.86-21.93,23.9-21.93a16.33,16.33,0,0,1,10,3V35a2.57,2.57,0,0,1,2-2.51l69.41-15.29a2.57,2.57,0,0,1,3.13,2.51V92.84c0,13.61-12.1,23.9-24.2,23.9-8.92,0-14.82-4.24-14.82-13,0-13.16,12.86-21.93,23.9-21.93a16.31,16.31,0,0,1,10,2.87V48.29A2.57,2.57,0,0,0,120.95,45.77Z"/><path d="M35.61,134.36c-10.22,0-16.32-5.42-16.32-14.51,0-13.81,13.38-23.43,25.4-23.43a18.4,18.4,0,0,1,8.48,1.88V35a4,4,0,0,1,3.2-4l69.41-15.29a4.07,4.07,0,0,1,5,4V92.83c0,15-13.54,25.4-25.7,25.4-10.22,0-16.32-5.42-16.32-14.51,0-13.81,13.38-23.43,25.4-23.43A19,19,0,0,1,122.57,82V48.29a1.07,1.07,0,0,0-1.3-1h0l-59.12,13a1.08,1.08,0,0,0-.84,1v47.8C61.3,124,47.76,134.36,35.61,134.36Zm9.07-34.94c-10.57,0-22.4,8.74-22.4,20.43,0,10,8.35,11.51,13.32,11.51,13.38,0,22.7-11.72,22.7-22.24V61.31a4.1,4.1,0,0,1,3.2-4l59.12-13h0a4.07,4.07,0,0,1,5,4V87.56l-2.37-1.67a14.88,14.88,0,0,0-9.12-2.6c-10.59,0-22.4,8.39-22.4,20.43,0,10,8.35,11.51,13.32,11.51,10.74,0,22.7-9.2,22.7-22.4V19.72a1.07,1.07,0,0,0-1.3-1L57,34a1.07,1.07,0,0,0-.84,1v68.83l-2.37-1.67A14.87,14.87,0,0,0,44.68,99.42Z"/></g></svg>', n.style.padding = "0 3px 0 0", this.songSvg = n.querySelector("svg"), this.songSvg.style.width = "14px", this.songWrapper = document.createElement("div"), this.songWrapper.style.width = "203px", this.songWrapper.style.maxWidth = "203px", this.songWrapper.appendChild(this.songNameDiv), this.songWrapper.appendChild(this.songArtistDiv), this.songAnchor = document.createElement("a"), this.songAnchor.className = "song", this.songAnchor.target = "_blank", this.songAnchor.style.display = "flex", this.songAnchor.style.lineHeight = "1.2em", this.songAnchor.style.padding = "4px 3px 3px 3px", this.songAnchor.style.textDecoration = "none", this.songAnchor.appendChild(n), this.songAnchor.appendChild(this.songWrapper), this.lyricsNameDiv = document.createElement("div"), this.lyricsNameDiv.className = "name", this.lyricsNameDiv.style.fontWeight = "bold", this.lyricsNameDiv.textContent = "-", this.lyricsNameDiv.style.overflow = "hidden", this.lyricsNameDiv.style.textOverflow = "ellipsis", this.lyricsNameDiv.style.marginBottom = "2px", this.lyricsArtistDiv = document.createElement("div"), this.lyricsArtistDiv.className = "artist", this.lyricsArtistDiv.textContent = "-", this.lyricsArtistDiv.style.overflow = "hidden", this.lyricsArtistDiv.style.textOverflow = "ellipsis";
            var i = document.createElement("span");
            i.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150"><g class="lyrics"><path d="M78,126.3H67.52l-6.26-23.82H24.4L18.14,126.3H7.7L35.7,22H50ZM27,92.39H58.65l-15.82-61Z"/><path d="M78,128.3H67.52a2,2,0,0,1-1.93-1.49l-5.87-22.33H25.94l-5.87,22.33a2,2,0,0,1-1.93,1.49H7.7a2,2,0,0,1-1.93-2.52l28-104.34A2,2,0,0,1,35.7,20H50a2,2,0,0,1,1.93,1.48l28,104.34A2,2,0,0,1,78,128.3Zm-8.89-4h6.29L48.43,24H37.23L10.31,124.3h6.28L22.46,102a2,2,0,0,1,1.93-1.49H61.26A2,2,0,0,1,63.2,102ZM58.65,94.39H27a2,2,0,0,1-1.94-2.5l15.82-61a2,2,0,0,1,3.87,0l15.82,61a2,2,0,0,1-1.94,2.5Zm-29.06-4H56.07L42.83,39.32Z"/><path d="M106.82,128c-17.74,0-26.43-13-26.43-36.52S89.09,55,106.82,55a21.78,21.78,0,0,1,15.83,6.43L134,56.22V112c0,5.22,1.56,8,4.7,8a7.31,7.31,0,0,0,3.65-1v6.61A17.77,17.77,0,0,1,133.6,128a9.61,9.61,0,0,1-9.74-7.65A22.4,22.4,0,0,1,106.82,128Zm0-10.09a18.15,18.15,0,0,0,16.69-10.61V75.7a18.15,18.15,0,0,0-16.69-10.61c-11.3,0-16,9.56-16,26.43S95.52,118,106.82,118Z"/><path d="M133.6,130A11.61,11.61,0,0,1,123.08,124,24.48,24.48,0,0,1,106.82,130c-13,0-28.43-6.68-28.43-38.52S93.85,53,106.82,53A23.88,23.88,0,0,1,123,59.05l10.08-4.65A2,2,0,0,1,136,56.22V112c0,4,.91,6,2.7,6a5.3,5.3,0,0,0,2.66-.78,2,2,0,0,1,3,1.74v6.61a2,2,0,0,1-1,1.74A19.64,19.64,0,0,1,133.6,130Zm-9.74-11.65a2,2,0,0,1,1.95,1.55,7.63,7.63,0,0,0,7.79,6.1,15.19,15.19,0,0,0,6.69-1.64v-2.52a8.51,8.51,0,0,1-1.65.16c-2.5,0-6.7-1.3-6.7-10V59.34l-8.46,3.91a2,2,0,0,1-2.25-.4A19.67,19.67,0,0,0,106.82,57C90.61,57,82.39,68.62,82.39,91.52S90.61,126,106.82,126a20.33,20.33,0,0,0,15.55-7A2,2,0,0,1,123.86,118.39Zm-17,1.57c-11.94,0-18-9.57-18-28.43s6.06-28.43,18-28.43a20.07,20.07,0,0,1,18.5,11.75,2,2,0,0,1,.19.86v31.65a2,2,0,0,1-.19.86A20.06,20.06,0,0,1,106.82,120Zm0-52.86c-12.55,0-14,13.94-14,24.43,0,21.9,8,24.43,14,24.43a16.13,16.13,0,0,0,14.69-9.07V76.16A16.13,16.13,0,0,0,106.82,67.09Z"/></g></svg>', i.style.padding = "0 3px 0 0", this.lyricsSvg = i.querySelector("svg"), this.lyricsSvg.style.width = "14px", this.lyricsWrapper = document.createElement("div"), this.lyricsWrapper.style.width = "90px", this.lyricsWrapper.style.maxWidth = "90px", this.lyricsWrapper.appendChild(this.lyricsNameDiv), this.lyricsWrapper.appendChild(this.lyricsArtistDiv), this.lyricsAnchor = document.createElement("a"), this.lyricsAnchor.className = "lyrics", this.lyricsAnchor.target = "_blank", this.lyricsAnchor.style.display = "flex", this.lyricsAnchor.style.lineHeight = "1.2em", this.lyricsAnchor.style.padding = "4px 3px 3px 3px", this.lyricsAnchor.style.textDecoration = "none", this.lyricsAnchor.appendChild(i), this.lyricsAnchor.appendChild(this.lyricsWrapper), this.bannerDiv = document.createElement("div"), this.bannerDiv.className = "textalive-banner", this.bannerDiv.style.cursor = "pointer", this.bannerDiv.style.zIndex = "10000", this.bannerDiv.style.background = "#1f4391", this.bannerDiv.style.lineHeight = "0", this.bannerDiv.style.display = "flex", this.bannerDiv.style.maxWidth = "256px", this.bannerDiv.style.fontFamily = "'Hiragino Kaku Gothic Pro','\u6E38\u30B4\u30B7\u30C3\u30AF\u4F53','Yu Gothic',YuGothic,Meiryo,HelveticaNeue,'Helvetica Neue',Helvetica,Arial,sans-serif", this.bannerDiv.style.fontSize = "9px", this.bannerDiv.style.alignItems = "center", this.bannerDiv.style.whiteSpace = "nowrap", this.bannerDiv.appendChild(this.logoAnchor), this.bannerDiv.appendChild(this.songAnchor), this.bannerDiv.appendChild(this.lyricsAnchor), this.songAnchor.style.display = "none", this.lyricsAnchor.style.display = "none", this.updatePosition(), this.updateRounded(), this.updateBordered(), this.updateShadowed(), this.updateBackground(), this.updateColor();
        }
        this.listener = {
            onAppReady: function() {
                r.updatePosition();
            },
            onMediaElementSet: function(t) {
                r.domEnabled && (r.bannerDiv && r.bannerDiv.parentElement && r.bannerDiv.parentElement.removeChild(r.bannerDiv), r.player.mediaBannerElement && r.player.mediaBannerElement.appendChild(r.bannerDiv));
            },
            onVideoLoad: function() {
                r.domEnabled && (r.logoAnchor.href = $1c811abb26f94012$var$Li, r.songAnchor.style.display = "none", r.lyricsAnchor.style.display = "none", r.songAnchor.style.borderRadius = "0");
            },
            onSongLoad: function(t) {
                return $1c811abb26f94012$var$yn(r, 0, void 0, function() {
                    var e, r, n, i, o, s, a, u, l;
                    return $1c811abb26f94012$var$gn(this, function(p) {
                        switch(p.label){
                            case 0:
                                return t ? (e = null === (a = null === (s = null == t ? void 0 : t.song) || void 0 === s ? void 0 : s.artist) || void 0 === a ? void 0 : a.name, r = null === (u = null == t ? void 0 : t.song) || void 0 === u ? void 0 : u.name, n = null === (l = null == t ? void 0 : t.song) || void 0 === l ? void 0 : l.permalink, i = "".concat($1c811abb26f94012$var$Li).concat(n ? "/songs/".concat(encodeURIComponent($1c811abb26f94012$var$c.getSongPathFromUrl(n))) : ""), this.domEnabled && (this.logoAnchor.href = i, this.songArtistDiv.textContent = $1c811abb26f94012$var$Mi(e), this.songNameDiv.textContent = $1c811abb26f94012$var$Mi(r), this.songAnchor.title = "".concat($1c811abb26f94012$var$Mi(r), " by ").concat($1c811abb26f94012$var$Mi(e)), this.songAnchor.href = n, this.songAnchor.style.display = "flex", this.songAnchor.style.borderRadius = this.rounded ? "0 4px 4px 0" : "0", this.songWrapper.style.width = "auto"), [
                                    4,
                                    $1c811abb26f94012$var$A.getServerStatus()
                                ]) : [
                                    2
                                ];
                            case 1:
                                return "ja" === (null == (o = p.sent()) ? void 0 : o.lang) ? console.warn("[TextAlive API] \u697D\u66F2 \u30A2\u30FC\u30C6\u30A3\u30B9\u30C8:", $1c811abb26f94012$var$Mi(e), "/ \u697D\u66F2\u540D:", $1c811abb26f94012$var$Mi(r), "/ \u914D\u4FE1\u5143\u30B5\u30A4\u30C8:", $1c811abb26f94012$var$Mi(n)) : console.warn("[TextAlive API] Song artist:", $1c811abb26f94012$var$Mi(e), "/ song name:", $1c811abb26f94012$var$Mi(r), "/ distributed at:", $1c811abb26f94012$var$Mi(n)), [
                                    2
                                ];
                        }
                    });
                });
            },
            onLyricsLoad: function(t) {
                t && r.domEnabled && (r.songWrapper.style.maxWidth = "90px", r.lyricsAnchor.style.display = "flex", r.songAnchor.style.borderRadius = "0");
            },
            onTextLoad: function(t) {
                return $1c811abb26f94012$var$yn(r, 0, void 0, function() {
                    var e, r, n, i, o;
                    return $1c811abb26f94012$var$gn(this, function(s) {
                        switch(s.label){
                            case 0:
                                return t ? (e = null === (o = null == t ? void 0 : t.artist) || void 0 === o ? void 0 : o.name, r = null == t ? void 0 : t.name, n = null == t ? void 0 : t.url, this.domEnabled && (this.lyricsArtistDiv.textContent = $1c811abb26f94012$var$Mi(e), this.lyricsNameDiv.textContent = $1c811abb26f94012$var$Mi(r), this.lyricsAnchor.title = "".concat($1c811abb26f94012$var$Mi(r), " by ").concat($1c811abb26f94012$var$Mi(e)), this.lyricsAnchor.href = n, this.lyricsWrapper.style.width = "auto"), [
                                    4,
                                    $1c811abb26f94012$var$A.getServerStatus()
                                ]) : [
                                    2
                                ];
                            case 1:
                                return "ja" === (null == (i = s.sent()) ? void 0 : i.lang) ? console.warn("[TextAlive API] \u6B4C\u8A5E \u30A2\u30FC\u30C6\u30A3\u30B9\u30C8:", $1c811abb26f94012$var$Mi(e), "/ \u6B4C\u8A5E\u540D:", $1c811abb26f94012$var$Mi(r), "/ \u914D\u4FE1\u5143\u30B5\u30A4\u30C8:", $1c811abb26f94012$var$Mi(n)) : console.warn("[TextAlive API] Song lyrics artist:", $1c811abb26f94012$var$Mi(e), "/ lyrics name:", $1c811abb26f94012$var$Mi(r), "/ distributed at:", $1c811abb26f94012$var$Mi(n)), [
                                    2
                                ];
                        }
                    });
                });
            },
            onDispose: function() {
                r.dispose();
            }
        }, t.addListener(this.listener), t.mediaBannerElement && this.player.mediaBannerElement.appendChild(this.bannerDiv);
    }
    return Object.defineProperty(t.prototype, "domEnabled", {
        get: function() {
            return "undefined" != typeof window && "undefined" != typeof document && "function" == typeof document.createElement;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "position", {
        get: function() {
            return this._position;
        },
        set: function(t) {
            this._position = t, this.updatePosition();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "rounded", {
        get: function() {
            return this._rounded;
        },
        set: function(t) {
            this._rounded = t, this.updateRounded();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "bordered", {
        get: function() {
            return this._bordered;
        },
        set: function(t) {
            this._bordered = t, this.updateBordered();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "shadowed", {
        get: function() {
            return this._shadowed;
        },
        set: function(t) {
            this._shadowed = t, this.updateShadowed();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "background", {
        get: function() {
            return this._background;
        },
        set: function(t) {
            this._background = t, this.updateBackground();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "color", {
        get: function() {
            return this._color;
        },
        set: function(t) {
            this._color = t, this.updateColor();
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.dispose = function() {
        this.player.removeListener(this.listener);
    }, t.prototype.updatePosition = function() {
        var t, e;
        if (this.domEnabled) {
            var r = this.position, n = this.player;
            if (null === r || !(null === (t = n.options) || void 0 === t ? void 0 : t.app) || (null === (e = n.app) || void 0 === e ? void 0 : e.managed)) this.bannerDiv.style.display = "none";
            else if (this.bannerDiv.style.display = "flex", "embed" === r) this.bannerDiv.style.position = "initial", this.bannerDiv.style.marginTop = "4px", this.songAnchor.style.flexGrow = "1", this.lyricsAnchor.style.flexGrow = "1";
            else {
                this.bannerDiv.style.position = "fixed", this.bannerDiv.style.marginTop = "0";
                var i = r.indexOf("top") >= 0, o = r.indexOf("right") >= 0, s = r.indexOf("bottom") >= 0, a = r.indexOf("left") >= 0;
                this.bannerDiv.style.top = i ? "4px" : "initial", this.bannerDiv.style.right = o ? "4px" : "initial", this.bannerDiv.style.bottom = s ? "4px" : "initial", this.bannerDiv.style.left = a ? "4px" : "initial", this.songAnchor.style.flexGrow = "0", this.lyricsAnchor.style.flexGrow = "0";
            }
        }
    }, t.prototype.updateRounded = function() {
        if (this.domEnabled) {
            var t = this.rounded;
            this.logoSvg.style.borderRadius = t ? "4px 0 0 4px" : "0", this.lyricsAnchor.style.borderRadius = t ? "0 4px 4px 0" : "0", this.bannerDiv.style.borderRadius = t ? "4px" : "0";
        }
    }, t.prototype.updateBordered = function() {
        if (this.domEnabled) {
            var t = this.bordered;
            this.logoAnchor.style.padding = t ? "1px 2px" : "1px 3px", this.bannerDiv.style.border = t ? "1px solid rgba(31, 67, 145, 0.3)" : "none";
        }
    }, t.prototype.updateShadowed = function() {
        if (this.domEnabled) {
            var t = this.shadowed;
            this.bannerDiv.style.boxShadow = t ? "1px 1px 3px 0 rgba(9, 19, 42, 0.9)" : "none";
        }
    }, t.prototype.updateBackground = function() {
        this.domEnabled && (this.songAnchor.style.background = this.background, this.lyricsAnchor.style.background = this.background);
    }, t.prototype.updateColor = function() {
        this.domEnabled && (this.songSvg.style.fill = this.color, this.songAnchor.style.color = this.color, this.lyricsSvg.style.fill = this.color, this.lyricsAnchor.style.color = this.color);
    }, t;
}();
function $1c811abb26f94012$var$Mi(t) {
    return t && "" !== t ? t : "-";
}
var $1c811abb26f94012$var$Bi = function() {
    this.halted = [], this.errors = [];
}, $1c811abb26f94012$var$Vi = function() {
    function t(t, e) {
        var r = this;
        this.listener = e, this.player = null, this._scale = 1, this.playerListener = {
            onResize: function(t) {
                r.elementWidth = Math.floor(t.width), r.updateSize();
            },
            onVideoReady: function() {
                r.elementWidth = r.calcWidth(), r.updateSize();
            },
            onStageElementSet: function(t) {
                r.elementWidth = r.calcWidth(), r.updateSize(), r.player.graphics.setCanvas(t);
            },
            onDispose: function() {
                r.dispose();
            }
        }, this.requestedTime = 0, this.request = null, this.player = t, t.addListener(this.playerListener);
    }
    return Object.defineProperty(t.prototype, "scale", {
        get: function() {
            return this._scale;
        },
        set: function(t) {
            this._scale = t, this.updateSize();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "width", {
        get: function() {
            return this.player.graphics.width;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "height", {
        get: function() {
            return this.player.graphics.height;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.requestUpdate = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e = this;
            return $1c811abb26f94012$var$gn(this, function(r) {
                return this.requestedTime = void 0 === t ? this.player.videoPosition : t, this.request || (this.request = new Promise(function(t) {
                    setTimeout(function() {
                        try {
                            e.update(e.requestedTime);
                        } catch (t) {}
                        e.request = null, t(e.requestedTime);
                    }, 0);
                })), [
                    2,
                    this.request
                ];
            });
        });
    }, t.prototype.update = function(t) {
        t || (t = this.player.mediaPosition), "number" == typeof t && (this.player.graphics.reset(), this.animate(t), this.player.graphics.update(), this.listener.onStageUpdate(t));
    }, t.prototype.animate = function(t) {
        for(var e = new $1c811abb26f94012$var$Bi, r = e.errors, n = e.halted, i = 0, o = [
            this.player.video.firstCredit,
            this.player.video.firstPhrase,
            this.player.video.firstWord,
            this.player.video.firstChar,
            this.player.video.firstGraphic
        ]; i < o.length; i++)for(var s = o[i]; s;)this.animateRenderingUnit(t, s, e), s = s.next;
        if (n.length > 0) {
            console.error("---");
            for(var a = 0; a < n.length; a++)console.error("halted", n[a], r[a]);
        }
    }, t.prototype.animateRenderingUnit = function(t, e, r) {
        if (e.animate) e.animate(t, e);
        else if (e.templateCount <= 0) $1c811abb26f94012$var$Gi(e) && e.getType() === $1c811abb26f94012$export$6ba26ae1c58c0147.CHAR && (e.rendering.visible = !1);
        else for(var i = 0; i < e.templateCount; i++)this.animateTemplate(t, e, e.getTemplate(i), r);
    }, t.prototype.animateTemplate = function(t, e, r, i) {
        var o = this;
        if (r.ignore) e.rendering.visible = !1;
        else {
            if (e.getType() !== $1c811abb26f94012$export$6ba26ae1c58c0147.GRAPHIC) for(var s = e.parent; s;){
                if (s.templateCount > 0 && (!s.rendering.visible || 0 === s.rendering.alpha)) return void (e.rendering.visible = !1);
                s = s.parent;
            }
            var a = this.player.templates.getProperty(r, "insomnia"), u = $1c811abb26f94012$var$Gi(e);
            if (!a && u) {
                var c = function(t, e, r, i) {
                    var o = i && t(i, "headTime") || 500, s = i && t(i, "tailTime") || 500;
                    return !(r.startTime - o <= e && r.endTime + s >= e) && (r.getType() !== $1c811abb26f94012$export$6ba26ae1c58c0147.GRAPHIC && (r.rendering.visible = !1), !0);
                }(function(t, e) {
                    return o.player.templates.getProperty(t, e);
                }, t, e, r);
                if (c) return;
            }
            this.doAnimateTemplate(t, r, i);
        }
    }, t.prototype.doAnimateTemplate = function(t, e, r) {
        var n = r.errors, i = r.halted;
        try {
            this.player.templates.exec(e, "animate", [
                t
            ]);
        } catch (t) {
            n.push(t), i.push(e);
        }
    }, t.prototype.calcWidth = function() {
        var t = this.player.stageElement;
        if (!t) return 0;
        var e = window.getComputedStyle(t);
        return t.offsetWidth - $1c811abb26f94012$var$ln(e.borderLeftWidth) - $1c811abb26f94012$var$ln(e.borderRightWidth) - $1c811abb26f94012$var$ln(e.paddingLeft) - $1c811abb26f94012$var$ln(e.paddingRight);
    }, t.prototype.updateSize = function() {
        var t = this.player.stageElement;
        if (t) {
            var e = this.elementWidth * this.player.videoProportion;
            if (t.style.height = "".concat(e, "px"), t.width = this.elementWidth * this._scale, t.height = e * this._scale, this.player.video) {
                var r = t.width / this.player.videoWidth;
                this.player.graphics.updateStageTx(r, this.player.margin), this.player.isPlaying || this.requestUpdate();
            }
        }
    }, t.prototype.dispose = function() {
        this.player.removeListener(this.playerListener), this.player = null;
    }, t;
}();
function $1c811abb26f94012$var$Gi(t) {
    if (t.getType() === $1c811abb26f94012$export$6ba26ae1c58c0147.GRAPHIC) return !0;
    for(var e = !0, r = t.parent; r;){
        if (r.templateCount > 0) {
            e = !1;
            break;
        }
        r = r.parent;
    }
    return e;
}
var $1c811abb26f94012$var$qi = function(t) {
    function e(e, r) {
        var n = this.constructor, i = t.call(this, e) || this;
        return i.video = r, Object.setPrototypeOf(i, n.prototype), i;
    }
    return $1c811abb26f94012$var$dn(e, t), e;
}(Error);
function $1c811abb26f94012$var$Wi(t, e) {
    var r = e.parser;
    return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
        var e, n, i;
        return $1c811abb26f94012$var$gn(this, function(o) {
            switch(o.label){
                case 0:
                    return t && t.length > 0 && t[0].words && t[0].words.length > 0 && t[0].words[0] && !t[0].words[0].pos ? (e = t.map(function(t) {
                        return t.words.map(function(t) {
                            return t.characters.map(function(t) {
                                return t.char;
                            }).join("");
                        }).join(" ");
                    }), n = e.join("\n"), [
                        4,
                        r(n)
                    ]) : [
                        2
                    ];
                case 1:
                    return (i = o.sent()) && "success" === i.status ? (t.forEach(function(t, r) {
                        var n = i.result[r], o = 0;
                        t.words.forEach(function(t) {
                            var i = t.characters.map(function(t) {
                                return t.char;
                            }).join(""), s = e[r].indexOf(i, o);
                            if (!(s < 0)) {
                                o = s;
                                var a = n.find(function(t) {
                                    return t.startPosition <= s && t.endPosition >= s;
                                });
                                a && (t.pos = a.PoS, t.rawPoS = a.rawPoS, t.language = a.language);
                            }
                        });
                    }), [
                        2
                    ]) : [
                        2
                    ];
            }
        });
    });
}
function $1c811abb26f94012$var$Yi(t) {
    for(; t.firstElementChild;)t.removeChild(t.firstElementChild);
}
function $1c811abb26f94012$var$zi(t, e) {
    var r = e.id, n = e.data, i = e.loader, o = e.deserializer;
    return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
        return $1c811abb26f94012$var$gn(this, function(e) {
            switch(e.label){
                case 0:
                    return r && r >= 0 ? [
                        4,
                        i(r)
                    ] : [
                        3,
                        2
                    ];
                case 1:
                    e.sent(), e.label = 2;
                case 2:
                    return o(t, n), [
                        2
                    ];
            }
        });
    });
}
function $1c811abb26f94012$var$Ji(t) {
    return "string" != typeof t ? t : "undefined" == typeof window ? null : document.querySelector(t);
}
var $1c811abb26f94012$export$2616165974278734 = function() {
    function t(t) {
        this._mediaPosition = 0, this._videoPosition = 0, this.isEditing = !1, this._isVideoSeeking = !1, this._volume = 100, this._options = t, this.emitter = new $1c811abb26f94012$var$On(t), this._templates = new $1c811abb26f94012$var$Ui(this, this.emitter, t && t.unsafeAcceleration);
        var e = Object.assign({}, $1c811abb26f94012$var$Y);
        t && t.managers && (e = Object.assign(e, t.managers)), this.managers = e, this._timer = t && t.timer || this.createDefaultTimer(), this._data = new $1c811abb26f94012$var$Vn(e, this.emitter, t), this._backgroundGraphics = new $1c811abb26f94012$var$Sn(this, e.asset, this.emitter), this._graphics = t && t.graphics || this.createDefaultGraphicsDriver(), this.stage = new $1c811abb26f94012$var$Vi(this, {
            onStageUpdate: this.onStageUpdate.bind(this)
        }), this._banner = new $1c811abb26f94012$var$Di(this), this.stageElement = $1c811abb26f94012$var$Ji(null == t ? void 0 : t.stageElement) || null, this.mediaElement = $1c811abb26f94012$var$Ji(null == t ? void 0 : t.mediaElement) || null, this._app = new $1c811abb26f94012$var$Gn(this, this.emitter);
    }
    return Object.defineProperty(t.prototype, "options", {
        get: function() {
            return this._options ? $1c811abb26f94012$var$fn({}, this._options) : null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "app", {
        get: function() {
            return this._app;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "data", {
        get: function() {
            return this._data;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "backgroundGraphics", {
        get: function() {
            return this._backgroundGraphics;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "video", {
        get: function() {
            return this._video;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "templates", {
        get: function() {
            return this._templates;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "graphics", {
        get: function() {
            return this._graphics;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "stageElement", {
        get: function() {
            return this._stageElement;
        },
        set: function(t) {
            this._stageElement = t, this.emitter.onStageElementSet(t);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "stageScale", {
        get: function() {
            return this.stage.scale;
        },
        set: function(t) {
            this.stage.scale = t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "mediaElement", {
        get: function() {
            return this._mediaElement;
        },
        set: function(t) {
            this.updateMediaElement(t);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "mediaSourceElement", {
        get: function() {
            return this._mediaSourceElement;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "mediaBannerElement", {
        get: function() {
            return this._mediaBannerElement;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "mediaPosition", {
        get: function() {
            return this._mediaPosition;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "videoPosition", {
        get: function() {
            return this._videoPosition;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "wait", {
        get: function() {
            return this._timer ? this._timer.wait : 0;
        },
        set: function(t) {
            this._timer && (this._timer.wait = t);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "fps", {
        get: function() {
            return 1e3 / this.wait;
        },
        set: function(t) {
            this.wait = 1e3 / t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "resolutionWidth", {
        get: function() {
            var t, e, r, n;
            return "object" == typeof (null === (e = null === (t = this._data) || void 0 === t ? void 0 : t.video) || void 0 === e ? void 0 : e.config) && "number" == typeof this._data.video.config.width ? this._data.video.config.width : "number" == typeof (null === (n = null === (r = this._options) || void 0 === r ? void 0 : r.defaultVideoSize) || void 0 === n ? void 0 : n.width) ? this._options.defaultVideoSize.width : 1280;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "resolutionHeight", {
        get: function() {
            var t, e, r, n;
            return "object" == typeof (null === (e = null === (t = this._data) || void 0 === t ? void 0 : t.video) || void 0 === e ? void 0 : e.config) && "number" == typeof this._data.video.config.height ? this._data.video.config.height : "number" == typeof (null === (n = null === (r = this._options) || void 0 === r ? void 0 : r.defaultVideoSize) || void 0 === n ? void 0 : n.height) ? this._options.defaultVideoSize.height : 720;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "resolutionProportion", {
        get: function() {
            return this.resolutionHeight / this.resolutionWidth;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "margin", {
        get: function() {
            var t, e, r, n;
            return "object" == typeof (null === (e = null === (t = this._data) || void 0 === t ? void 0 : t.video) || void 0 === e ? void 0 : e.config) && this._data.video.config.margin ? this._data.video.config.margin : (null === (n = null === (r = this._options) || void 0 === r ? void 0 : r.defaultVideoSize) || void 0 === n ? void 0 : n.margin) || $1c811abb26f94012$var$_n;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "videoWidth", {
        get: function() {
            var t = this.resolutionWidth, e = this.margin;
            return t + e[1] + e[3];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "videoHeight", {
        get: function() {
            var t = this.resolutionHeight, e = this.margin;
            return t + e[0] + e[2];
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "videoProportion", {
        get: function() {
            return this.videoHeight / this.videoWidth;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "stageWidth", {
        get: function() {
            return this.stage.width;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "stageHeight", {
        get: function() {
            return this.stage.height;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isLoading", {
        get: function() {
            return !!this._videoPromise;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isPlaying", {
        get: function() {
            return !!this._timer && this._timer.isPlaying;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isVideoSeeking", {
        get: function() {
            return this._isVideoSeeking;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "banner", {
        get: function() {
            return this._banner;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "timer", {
        get: function() {
            return this._timer;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "volume", {
        get: function() {
            return this._volume;
        },
        set: function(t) {
            isNaN(t) || (this._volume = Math.min(100, Math.max(0, t)), this.emitter.onVolumeUpdate(this._volume));
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.createDefaultTimer = function() {
        try {
            if ("undefined" != typeof window && "basic" !== $1c811abb26f94012$var$pn("ta_timer")) return new $1c811abb26f94012$export$c66cf4e5d83f6286;
        } catch (t) {}
        return new $1c811abb26f94012$export$e985807e6b50ff90;
    }, t.prototype.createDefaultGraphicsDriver = function() {
        return new $1c811abb26f94012$var$yt;
    }, t.prototype.addListener = function(t) {
        return this.emitter.addListener(t);
    }, t.prototype.removeListener = function(t) {
        return this.emitter.removeListener(t);
    }, t.prototype.createFromVideoId = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r = this;
            return $1c811abb26f94012$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromVideoId(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromVideoId = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            (r = new $1c811abb26f94012$var$Vn(this.managers, this.emitter, this._options)).createFromVideoId(t, null == e ? void 0 : e.video)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            this.finalize(r, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromVideo = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r = this;
            return $1c811abb26f94012$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromVideo(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromVideo = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                return (r = new $1c811abb26f94012$var$Vn(this.managers, this.emitter, this._options)).createFromVideo(t, null == e ? void 0 : e.video), [
                    2,
                    this.finalize(r, e)
                ];
            });
        });
    }, t.prototype.createFromSongUrl = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r = this;
            return $1c811abb26f94012$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromSongUrl(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromSongUrl = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            (r = new $1c811abb26f94012$var$Vn(this.managers, this.emitter, this._options)).createFromSongUrl(t, null == e ? void 0 : e.video)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            this.finalize(r, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromSongPath = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r = this;
            return $1c811abb26f94012$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromSongPath(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromSongPath = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            (r = new $1c811abb26f94012$var$Vn(this.managers, this.emitter, this._options)).createFromSongPath(t, null == e ? void 0 : e.video)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            this.finalize(r, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromSongId = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r = this;
            return $1c811abb26f94012$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromSongId(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromSongId = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            (r = new $1c811abb26f94012$var$Vn(this.managers, this.emitter, this._options)).createFromSongId(t, null == e ? void 0 : e.video)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            this.finalize(r, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromSongCode = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r = this;
            return $1c811abb26f94012$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromSongCode(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromSongCode = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            (r = new $1c811abb26f94012$var$Vn(this.managers, this.emitter, this._options)).createFromSongCode(t, null == e ? void 0 : e.video)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            this.finalize(r, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromText = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r = this;
            return $1c811abb26f94012$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromText(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromText = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            (r = new $1c811abb26f94012$var$Vn(this.managers, this.emitter, this._options)).createFromText(t, null == e ? void 0 : e.video)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            this.finalize(r, e)
                        ];
                }
            });
        });
    }, t.prototype.createFromJSON = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r = this;
            return $1c811abb26f94012$var$gn(this, function(n) {
                return [
                    2,
                    this.create(function() {
                        return r.doCreateFromJSON(t, e);
                    }, null == e ? void 0 : e.dryRun)
                ];
            });
        });
    }, t.prototype.doCreateFromJSON = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r;
            return $1c811abb26f94012$var$gn(this, function(n) {
                return (r = new $1c811abb26f94012$var$Vn(this.managers, this.emitter, this._options)).createFromJSON(t, null == e ? void 0 : e.video), [
                    2,
                    this.finalize(r, e)
                ];
            });
        });
    }, t.prototype.create = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r, n = this;
            return $1c811abb26f94012$var$gn(this, function(i) {
                if (this._videoPromise && !e) throw new $1c811abb26f94012$var$qi("Player.createFrom* method calls cannot run in parallel", this._videoPromise);
                return r = t(), e || (this._videoPromise = r, r.finally(function() {
                    return n._videoPromise = null;
                })), [
                    2,
                    r
                ];
            });
        });
    }, t.prototype.finalize = function(t, e) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var r, n, i, o = this;
            return $1c811abb26f94012$var$gn(this, function(s) {
                switch(s.label){
                    case 0:
                        return t.video ? [
                            4,
                            Promise.all([
                                t.finalize(e),
                                this.backgroundGraphics.setBackground(t.video.background)
                            ])
                        ] : [
                            2,
                            null
                        ];
                    case 1:
                        return s.sent(), (null == e ? void 0 : e.dryRun) ? [
                            2,
                            null
                        ] : (r = t.video.json, function(t, e) {
                            var r = e.config, n = e.song;
                            r && "object" == typeof r && "number" == typeof r.duration ? t.duration = r.duration : n ? t.duration = 1e3 * n.length : t.duration || (t.duration = t.endTime);
                        }(n = new $1c811abb26f94012$var$ut(r), {
                            config: t.video.config,
                            song: t.song
                        }), [
                            4,
                            Promise.all([
                                this.graphics.createRuntime(n),
                                $1c811abb26f94012$var$zi(n, {
                                    id: t.video.id,
                                    data: r,
                                    loader: function(t) {
                                        return $1c811abb26f94012$var$yn(o, 0, void 0, function() {
                                            return $1c811abb26f94012$var$gn(this, function(e) {
                                                switch(e.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.templates.loadForVideo(t)
                                                        ];
                                                    case 1:
                                                        return e.sent(), [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                    },
                                    deserializer: function(t, e) {
                                        return o.templates.importInstances(t, e);
                                    }
                                }),
                                $1c811abb26f94012$var$Wi(null == r ? void 0 : r.phrases, {
                                    parser: $1c811abb26f94012$var$R.parse.bind($1c811abb26f94012$var$R)
                                })
                            ])
                        ]);
                    case 2:
                        return s.sent(), this._data, this._video && this.templates.disposeInstances(this._video), this._data = t, this._video = n, this.emitter.onVideoReady(n), i = (null == e ? void 0 : e.altSourceUrl) || void 0, [
                            4,
                            this._timer.initialize({
                                player: this,
                                updater: this.updateMediaPosition.bind(this),
                                emitter: this.emitter,
                                altSourceUrl: i
                            })
                        ];
                    case 3:
                        return s.sent(), this.emitter.onTimerReady(this._timer), [
                            2,
                            n
                        ];
                }
            });
        });
    }, t.prototype.updateMediaPosition = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e = this;
            return $1c811abb26f94012$var$gn(this, function(r) {
                return this._isVideoSeeking ? (this._mediaPosition = t, this.emitter.onMediaSeek(t), [
                    2,
                    t
                ]) : [
                    2,
                    this.stage.requestUpdate(t).then(function(t) {
                        return e._mediaPosition = t, e._videoPosition = t, e.emitter.onMediaSeek(t), t;
                    })
                ];
            });
        });
    }, t.prototype.exportVideo = function(t) {
        var e, r, n, i, o, s, a;
        return void 0 === t && (t = {
            legacyStringMode: !0
        }), $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var u, c, l, p;
            return $1c811abb26f94012$var$gn(this, function(h) {
                return u = {
                    sourceId: (null === (e = this._data.video) || void 0 === e ? void 0 : e.id) || -1,
                    sourceOriginId: (null === (r = this._data.video) || void 0 === r ? void 0 : r.sourceOriginId) || -1,
                    songleId: (null === (n = this._data.song) || void 0 === n ? void 0 : n.id) || -1,
                    lyricId: this._data.lyricsId || -1,
                    lyricDiffId: (null === (i = this._data.lyrics) || void 0 === i ? void 0 : i.id) || -1,
                    config: ((null == t ? void 0 : t.legacyStringMode) ? (null === (o = this._data.video) || void 0 === o ? void 0 : o.config) && JSON.stringify(this._data.video.config) : null === (s = this._data.video) || void 0 === s ? void 0 : s.config) || null
                }, c = this.backgroundGraphics.exportPartialVideoEntry(t), l = (null === (a = this._video) || void 0 === a ? void 0 : a.exportData(this._templates)) || null, p = (null == t ? void 0 : t.legacyStringMode) ? JSON.stringify(l) : l, [
                    2,
                    $1c811abb26f94012$var$fn($1c811abb26f94012$var$fn($1c811abb26f94012$var$fn({}, u), c), {
                        json: p
                    })
                ];
            });
        });
    }, t.prototype.getChoruses = function() {
        return this._data.getChoruses();
    }, t.prototype.findChorus = function(t, e) {
        return this._data.findChorus(t, e);
    }, t.prototype.findChorusBetween = function(t, e) {
        return this._data.findChorusBetween(t, e);
    }, t.prototype.findChorusChange = function(t, e) {
        return this._data.findChorusChange(t, e);
    }, t.prototype.getBeats = function() {
        return this._data.getBeats();
    }, t.prototype.findBeat = function(t, e) {
        return this._data.findBeat(t, e);
    }, t.prototype.findBeatChange = function(t, e) {
        return this._data.findBeatChange(t, e);
    }, t.prototype.getChords = function() {
        return this._data.getChords();
    }, t.prototype.findChord = function(t, e) {
        return this._data.findChord(t, e);
    }, t.prototype.findChordChange = function(t, e) {
        return this._data.findChordChange(t, e);
    }, t.prototype.getVocalFrequency = function(t) {
        return this._data.getVocalFrequency(t);
    }, t.prototype.getVocalAmplitude = function(t) {
        return this._data.getVocalAmplitude(t);
    }, t.prototype.getMaxVocalAmplitude = function() {
        return this._data.getMaxVocalAmplitude();
    }, t.prototype.getValenceArousal = function(t) {
        return this._data.getValenceArousal(t);
    }, t.prototype.getMedianValenceArousal = function() {
        return this._data.getMedianValenceArousal();
    }, t.prototype.resize = function(t) {
        return this.emitter.onResize(t);
    }, t.prototype.onResize = function(t) {
        return this.resize(t);
    }, t.prototype.setStageElement = function(t) {
        return this._stageElement = t, this.emitter.onStageElementSet(t);
    }, t.prototype.setMediaElement = function(t) {
        this.mediaElement = t;
    }, t.prototype.updateMediaElement = function(t) {
        "undefined" != typeof document && (this._mediaElement && $1c811abb26f94012$var$Yi(this._mediaElement), t ? ($1c811abb26f94012$var$Yi(t), this._mediaSourceElement || (this._mediaSourceElement = document.createElement("div"), this._mediaSourceElement.classList.add("textalive-media-wrapper")), t.appendChild(this._mediaSourceElement), this._mediaBannerElement || (this._mediaBannerElement = document.createElement("div"), this._mediaSourceElement.classList.add("textalive-banner-wrapper")), t.appendChild(this._mediaBannerElement)) : (this._mediaSourceElement = null, this._mediaBannerElement = null)), this._mediaElement = t, this.emitter.onMediaElementSet(t);
    }, t.prototype.setVideoPosition = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            var e = this;
            return $1c811abb26f94012$var$gn(this, function(r) {
                return [
                    2,
                    this.stage.requestUpdate(t).then(function(t) {
                        return e._videoPosition = t, e.emitter.onVideoSeek(t), t;
                    })
                ];
            });
        });
    }, t.prototype.setMediaPosition = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(e) {
                return this.requestMediaSeek(t), [
                    2
                ];
            });
        });
    }, t.prototype.requestPlay = function() {
        return this._timer.play(), !0;
    }, t.prototype.requestStop = function() {
        return this._timer.stop(), !0;
    }, t.prototype.requestPause = function() {
        return this._timer.pause(), !0;
    }, t.prototype.requestMediaSeek = function(t) {
        return this._timer.seek(t), !0;
    }, t.prototype.startVideoSeek = function() {
        return this._isVideoSeeking = !0, this.emitter.onVideoSeekStart();
    }, t.prototype.endVideoSeek = function() {
        return this._isVideoSeeking = !1, this.emitter.onVideoSeekEnd();
    }, t.prototype.requestSettingBackground = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(e) {
                return [
                    2,
                    this.backgroundGraphics.settingBackground(t)
                ];
            });
        });
    }, t.prototype.requestSetBackground = function(t) {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(e) {
                return [
                    2,
                    this.backgroundGraphics.setBackground(t)
                ];
            });
        });
    }, t.prototype.requestStageUpdate = function() {
        return $1c811abb26f94012$var$yn(this, 0, void 0, function() {
            return $1c811abb26f94012$var$gn(this, function(t) {
                return [
                    2,
                    this.stage.requestUpdate()
                ];
            });
        });
    }, t.prototype.onStageUpdate = function(t) {
        this._isVideoSeeking || this.emitter.onTimeUpdate(t);
    }, t.prototype.dispose = function() {
        this._timer && (this._timer.dispose(), this._timer = null), this.mediaElement && ($1c811abb26f94012$var$Yi(this._mediaElement), this._mediaElement = null), this.stageElement && (this._stageElement = null), this.emitter.onDispose();
    }, t;
}();
console.log("# \u30E9\u30A4\u30BB\u30F3\u30B9\u8868\u8A18\u306B\u95A2\u3059\u308B\u30AC\u30A4\u30C9\u30E9\u30A4\u30F3\n\n\u56FD\u7ACB\u7814\u7A76\u958B\u767A\u6CD5\u4EBA\u7523\u696D\u6280\u8853\u7DCF\u5408\u7814\u7A76\u6240\n\u4EBA\u9593\u60C5\u5831\u30A4\u30F3\u30BF\u30E9\u30AF\u30B7\u30E7\u30F3\u7814\u7A76\u90E8\u9580\n\u30E1\u30C7\u30A3\u30A2\u30A4\u30F3\u30BF\u30E9\u30AF\u30B7\u30E7\u30F3\u7814\u7A76\u30B0\u30EB\u30FC\u30D7\n\nTextAlive App API\u306F\u975E\u5546\u7528\u5229\u7528\u306B\u9650\u308A\u3001\u3069\u306A\u305F\u3067\u3082\u7121\u6599\u30FB\u7121\u4FDD\u8A3C\u3067\u5229\u7528\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\n\u305F\u3060\u3057\u3001\u539F\u5247\u3068\u3057\u3066TextAlive App API\u3092\u5229\u7528\u3057\u3066\u3044\u308B\u65E8\u3092 TextAlive https://textalive.jp/ \u30B5\u30A4\u30C8\u5185\u697D\u66F2\u30DA\u30FC\u30B8\u307E\u305F\u306F https://developer.textalive.jp/ \u306B\u30CF\u30A4\u30D1\u30FC\u30EA\u30F3\u30AF\u3057\u305F\u4E0A\u3067\u3001\u5229\u7528\u3057\u3066\u3044\u308B\u30B7\u30B9\u30C6\u30E0\u3082\u3057\u304F\u306F\u5916\u90E8\u30B5\u30A4\u30C8\u7B49\u306B\u8868\u793A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\n\n# \u304A\u554F\u3044\u5408\u308F\u305B\n\ntextalive-ml@aist.go.jp");
var $1c811abb26f94012$export$3bf46e7874a0fbad = $1c811abb26f94012$var$r.sortedIndex;

});
parcelRegister("agjCl", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("7O3nv")).default);

var $7O3nv = parcelRequire("7O3nv");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $778a9d9dd4d05b01$export$1c00760e9e5a4e95, AxiosError: $778a9d9dd4d05b01$export$c1fbed17c2f6a328, CanceledError: $778a9d9dd4d05b01$export$1ab0c6b20d94fa14, isCancel: $778a9d9dd4d05b01$export$3b22524397b493c6, CancelToken: $778a9d9dd4d05b01$export$fd08e3cb425f0d61, VERSION: $778a9d9dd4d05b01$export$a4ad2735b021c132, all: $778a9d9dd4d05b01$export$84bf76cd7afc7469, Cancel: $778a9d9dd4d05b01$export$848c9b7ead0df967, isAxiosError: $778a9d9dd4d05b01$export$fbafdbe06a5b5a9a, spread: $778a9d9dd4d05b01$export$3ae0fd4797ed47c8, toFormData: $778a9d9dd4d05b01$export$10ae0d317ea97f8b, AxiosHeaders: $778a9d9dd4d05b01$export$4e7d6ff0f3e6520, HttpStatusCode: $778a9d9dd4d05b01$export$a972f69c851492b3, formToJSON: $778a9d9dd4d05b01$export$86d7c59254d6a2c9, getAdapter: $778a9d9dd4d05b01$export$17ddc20a97d669e2, mergeConfig: $778a9d9dd4d05b01$export$7ec1ebcfa9d8bd6a } = (0, $7O3nv.default);

});
parcelRegister("7O3nv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aefd2bf5ae3dd44$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");

var $cS861 = parcelRequire("cS861");

var $878KO = parcelRequire("878KO");

var $h2mZt = parcelRequire("h2mZt");

var $ltPla = parcelRequire("ltPla");

var $l2QlU = parcelRequire("l2QlU");

var $8cHYv = parcelRequire("8cHYv");

var $2XZvW = parcelRequire("2XZvW");

var $56i1z = parcelRequire("56i1z");

var $iLWpM = parcelRequire("iLWpM");

var $1wFBM = parcelRequire("1wFBM");

var $lwS9c = parcelRequire("lwS9c");

var $eikjl = parcelRequire("eikjl");

var $d4N0E = parcelRequire("d4N0E");

var $WpxS6 = parcelRequire("WpxS6");

var $dcqJf = parcelRequire("dcqJf");

var $bhWqa = parcelRequire("bhWqa");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5aefd2bf5ae3dd44$var$createInstance(defaultConfig) {
    const context = new (0, $878KO.default)(defaultConfig);
    const instance = (0, $cS861.default)((0, $878KO.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $itHdb.default).extend(instance, (0, $878KO.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $itHdb.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5aefd2bf5ae3dd44$var$createInstance((0, $h2mZt.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5aefd2bf5ae3dd44$var$axios = $5aefd2bf5ae3dd44$var$createInstance((0, $ltPla.default));
// Expose Axios class to allow class inheritance
$5aefd2bf5ae3dd44$var$axios.Axios = (0, $878KO.default);
// Expose Cancel & CancelToken
$5aefd2bf5ae3dd44$var$axios.CanceledError = (0, $8cHYv.default);
$5aefd2bf5ae3dd44$var$axios.CancelToken = (0, $2XZvW.default);
$5aefd2bf5ae3dd44$var$axios.isCancel = (0, $56i1z.default);
$5aefd2bf5ae3dd44$var$axios.VERSION = (0, $iLWpM.VERSION);
$5aefd2bf5ae3dd44$var$axios.toFormData = (0, $1wFBM.default);
// Expose AxiosError class
$5aefd2bf5ae3dd44$var$axios.AxiosError = (0, $lwS9c.default);
// alias for CanceledError for backward compatibility
$5aefd2bf5ae3dd44$var$axios.Cancel = $5aefd2bf5ae3dd44$var$axios.CanceledError;
// Expose all/spread
$5aefd2bf5ae3dd44$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5aefd2bf5ae3dd44$var$axios.spread = (0, $eikjl.default);
// Expose isAxiosError
$5aefd2bf5ae3dd44$var$axios.isAxiosError = (0, $d4N0E.default);
// Expose mergeConfig
$5aefd2bf5ae3dd44$var$axios.mergeConfig = (0, $h2mZt.default);
$5aefd2bf5ae3dd44$var$axios.AxiosHeaders = (0, $WpxS6.default);
$5aefd2bf5ae3dd44$var$axios.formToJSON = (thing)=>(0, $l2QlU.default)((0, $itHdb.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$5aefd2bf5ae3dd44$var$axios.getAdapter = (0, $dcqJf.default).getAdapter;
$5aefd2bf5ae3dd44$var$axios.HttpStatusCode = (0, $bhWqa.default);
$5aefd2bf5ae3dd44$var$axios.default = $5aefd2bf5ae3dd44$var$axios;
var // this module should only have a default export
$5aefd2bf5ae3dd44$export$2e2bcd8739ae039 = $5aefd2bf5ae3dd44$var$axios;

});
parcelRegister("itHdb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d73c74615016ce58$export$2e2bcd8739ae039);

var $cS861 = parcelRequire("cS861");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $d73c74615016ce58$var$toString } = Object.prototype;
const { getPrototypeOf: $d73c74615016ce58$var$getPrototypeOf } = Object;
const { iterator: $d73c74615016ce58$var$iterator, toStringTag: $d73c74615016ce58$var$toStringTag } = Symbol;
const $d73c74615016ce58$var$kindOf = ((cache)=>(thing)=>{
        const str = $d73c74615016ce58$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $d73c74615016ce58$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$d73c74615016ce58$var$kindOf(thing) === type;
};
const $d73c74615016ce58$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $d73c74615016ce58$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $d73c74615016ce58$var$isUndefined = $d73c74615016ce58$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $d73c74615016ce58$var$isBuffer(val) {
    return val !== null && !$d73c74615016ce58$var$isUndefined(val) && val.constructor !== null && !$d73c74615016ce58$var$isUndefined(val.constructor) && $d73c74615016ce58$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $d73c74615016ce58$var$isArrayBuffer = $d73c74615016ce58$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $d73c74615016ce58$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $d73c74615016ce58$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $d73c74615016ce58$var$isString = $d73c74615016ce58$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $d73c74615016ce58$var$isFunction = $d73c74615016ce58$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $d73c74615016ce58$var$isNumber = $d73c74615016ce58$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $d73c74615016ce58$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $d73c74615016ce58$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $d73c74615016ce58$var$isPlainObject = (val)=>{
    if ($d73c74615016ce58$var$kindOf(val) !== 'object') return false;
    const prototype = $d73c74615016ce58$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($d73c74615016ce58$var$toStringTag in val) && !($d73c74615016ce58$var$iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $d73c74615016ce58$var$isDate = $d73c74615016ce58$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $d73c74615016ce58$var$isFile = $d73c74615016ce58$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $d73c74615016ce58$var$isBlob = $d73c74615016ce58$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $d73c74615016ce58$var$isFileList = $d73c74615016ce58$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $d73c74615016ce58$var$isStream = (val)=>$d73c74615016ce58$var$isObject(val) && $d73c74615016ce58$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $d73c74615016ce58$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $d73c74615016ce58$var$isFunction(thing.append) && ((kind = $d73c74615016ce58$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $d73c74615016ce58$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $d73c74615016ce58$var$isURLSearchParams = $d73c74615016ce58$var$kindOfTest('URLSearchParams');
const [$d73c74615016ce58$var$isReadableStream, $d73c74615016ce58$var$isRequest, $d73c74615016ce58$var$isResponse, $d73c74615016ce58$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($d73c74615016ce58$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $d73c74615016ce58$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $d73c74615016ce58$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($d73c74615016ce58$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $d73c74615016ce58$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $d73c74615016ce58$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $d73c74615016ce58$var$isContextDefined = (context)=>!$d73c74615016ce58$var$isUndefined(context) && context !== $d73c74615016ce58$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $d73c74615016ce58$var$merge() {
    const { caseless: caseless } = $d73c74615016ce58$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $d73c74615016ce58$var$findKey(result, key) || key;
        if ($d73c74615016ce58$var$isPlainObject(result[targetKey]) && $d73c74615016ce58$var$isPlainObject(val)) result[targetKey] = $d73c74615016ce58$var$merge(result[targetKey], val);
        else if ($d73c74615016ce58$var$isPlainObject(val)) result[targetKey] = $d73c74615016ce58$var$merge({}, val);
        else if ($d73c74615016ce58$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $d73c74615016ce58$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $d73c74615016ce58$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $d73c74615016ce58$var$forEach(b, (val, key)=>{
        if (thisArg && $d73c74615016ce58$var$isFunction(val)) a[key] = (0, $cS861.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $d73c74615016ce58$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $d73c74615016ce58$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $d73c74615016ce58$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $d73c74615016ce58$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $d73c74615016ce58$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $d73c74615016ce58$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($d73c74615016ce58$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$d73c74615016ce58$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $d73c74615016ce58$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $d73c74615016ce58$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $d73c74615016ce58$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$d73c74615016ce58$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $d73c74615016ce58$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $d73c74615016ce58$var$isHTMLForm = $d73c74615016ce58$var$kindOfTest('HTMLFormElement');
const $d73c74615016ce58$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $d73c74615016ce58$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $d73c74615016ce58$var$isRegExp = $d73c74615016ce58$var$kindOfTest('RegExp');
const $d73c74615016ce58$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $d73c74615016ce58$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $d73c74615016ce58$var$freezeMethods = (obj)=>{
    $d73c74615016ce58$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($d73c74615016ce58$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$d73c74615016ce58$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $d73c74615016ce58$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $d73c74615016ce58$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $d73c74615016ce58$var$noop = ()=>{};
const $d73c74615016ce58$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $d73c74615016ce58$var$isSpecCompliantForm(thing) {
    return !!(thing && $d73c74615016ce58$var$isFunction(thing.append) && thing[$d73c74615016ce58$var$toStringTag] === 'FormData' && thing[$d73c74615016ce58$var$iterator]);
}
const $d73c74615016ce58$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($d73c74615016ce58$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $d73c74615016ce58$var$isArray(source) ? [] : {};
                $d73c74615016ce58$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$d73c74615016ce58$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $d73c74615016ce58$var$isAsyncFn = $d73c74615016ce58$var$kindOfTest('AsyncFunction');
const $d73c74615016ce58$var$isThenable = (thing)=>thing && ($d73c74615016ce58$var$isObject(thing) || $d73c74615016ce58$var$isFunction(thing)) && $d73c74615016ce58$var$isFunction(thing.then) && $d73c74615016ce58$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $d73c74615016ce58$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $d73c74615016ce58$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $d73c74615016ce58$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $d73c74615016ce58$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $d73c74615016ce58$var$isFunction($d73c74615016ce58$var$_global.postMessage));
const $d73c74615016ce58$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($d73c74615016ce58$var$_global) : $d73c74615016ce58$var$_setImmediate;
// *********************
const $d73c74615016ce58$var$isIterable = (thing)=>thing != null && $d73c74615016ce58$var$isFunction(thing[$d73c74615016ce58$var$iterator]);
var $d73c74615016ce58$export$2e2bcd8739ae039 = {
    isArray: $d73c74615016ce58$var$isArray,
    isArrayBuffer: $d73c74615016ce58$var$isArrayBuffer,
    isBuffer: $d73c74615016ce58$var$isBuffer,
    isFormData: $d73c74615016ce58$var$isFormData,
    isArrayBufferView: $d73c74615016ce58$var$isArrayBufferView,
    isString: $d73c74615016ce58$var$isString,
    isNumber: $d73c74615016ce58$var$isNumber,
    isBoolean: $d73c74615016ce58$var$isBoolean,
    isObject: $d73c74615016ce58$var$isObject,
    isPlainObject: $d73c74615016ce58$var$isPlainObject,
    isReadableStream: $d73c74615016ce58$var$isReadableStream,
    isRequest: $d73c74615016ce58$var$isRequest,
    isResponse: $d73c74615016ce58$var$isResponse,
    isHeaders: $d73c74615016ce58$var$isHeaders,
    isUndefined: $d73c74615016ce58$var$isUndefined,
    isDate: $d73c74615016ce58$var$isDate,
    isFile: $d73c74615016ce58$var$isFile,
    isBlob: $d73c74615016ce58$var$isBlob,
    isRegExp: $d73c74615016ce58$var$isRegExp,
    isFunction: $d73c74615016ce58$var$isFunction,
    isStream: $d73c74615016ce58$var$isStream,
    isURLSearchParams: $d73c74615016ce58$var$isURLSearchParams,
    isTypedArray: $d73c74615016ce58$var$isTypedArray,
    isFileList: $d73c74615016ce58$var$isFileList,
    forEach: $d73c74615016ce58$var$forEach,
    merge: $d73c74615016ce58$var$merge,
    extend: $d73c74615016ce58$var$extend,
    trim: $d73c74615016ce58$var$trim,
    stripBOM: $d73c74615016ce58$var$stripBOM,
    inherits: $d73c74615016ce58$var$inherits,
    toFlatObject: $d73c74615016ce58$var$toFlatObject,
    kindOf: $d73c74615016ce58$var$kindOf,
    kindOfTest: $d73c74615016ce58$var$kindOfTest,
    endsWith: $d73c74615016ce58$var$endsWith,
    toArray: $d73c74615016ce58$var$toArray,
    forEachEntry: $d73c74615016ce58$var$forEachEntry,
    matchAll: $d73c74615016ce58$var$matchAll,
    isHTMLForm: $d73c74615016ce58$var$isHTMLForm,
    hasOwnProperty: $d73c74615016ce58$var$hasOwnProperty,
    hasOwnProp: $d73c74615016ce58$var$hasOwnProperty,
    reduceDescriptors: $d73c74615016ce58$var$reduceDescriptors,
    freezeMethods: $d73c74615016ce58$var$freezeMethods,
    toObjectSet: $d73c74615016ce58$var$toObjectSet,
    toCamelCase: $d73c74615016ce58$var$toCamelCase,
    noop: $d73c74615016ce58$var$noop,
    toFiniteNumber: $d73c74615016ce58$var$toFiniteNumber,
    findKey: $d73c74615016ce58$var$findKey,
    global: $d73c74615016ce58$var$_global,
    isContextDefined: $d73c74615016ce58$var$isContextDefined,
    isSpecCompliantForm: $d73c74615016ce58$var$isSpecCompliantForm,
    toJSONObject: $d73c74615016ce58$var$toJSONObject,
    isAsyncFn: $d73c74615016ce58$var$isAsyncFn,
    isThenable: $d73c74615016ce58$var$isThenable,
    setImmediate: $d73c74615016ce58$var$_setImmediate,
    asap: $d73c74615016ce58$var$asap,
    isIterable: $d73c74615016ce58$var$isIterable
};

});
parcelRegister("cS861", function(module, exports) {

$parcel$export(module.exports, "default", () => $95f0cee75fa3d449$export$2e2bcd8739ae039);
'use strict';
function $95f0cee75fa3d449$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("878KO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e85c48a7edf9393$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");

var $c38kp = parcelRequire("c38kp");

var $96JVq = parcelRequire("96JVq");

var $1uFg5 = parcelRequire("1uFg5");

var $h2mZt = parcelRequire("h2mZt");

var $3Typa = parcelRequire("3Typa");

var $f73uM = parcelRequire("f73uM");

var $WpxS6 = parcelRequire("WpxS6");
'use strict';
const $5e85c48a7edf9393$var$validators = (0, $f73uM.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $5e85c48a7edf9393$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $96JVq.default)(),
            response: new (0, $96JVq.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $h2mZt.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $f73uM.default).assertOptions(transitional, {
            silentJSONParsing: $5e85c48a7edf9393$var$validators.transitional($5e85c48a7edf9393$var$validators.boolean),
            forcedJSONParsing: $5e85c48a7edf9393$var$validators.transitional($5e85c48a7edf9393$var$validators.boolean),
            clarifyTimeoutError: $5e85c48a7edf9393$var$validators.transitional($5e85c48a7edf9393$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $itHdb.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $f73uM.default).assertOptions(paramsSerializer, {
                encode: $5e85c48a7edf9393$var$validators.function,
                serialize: $5e85c48a7edf9393$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $f73uM.default).assertOptions(config, {
            baseUrl: $5e85c48a7edf9393$var$validators.spelling('baseURL'),
            withXsrfToken: $5e85c48a7edf9393$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $itHdb.default).merge(headers.common, headers[config.method]);
        headers && (0, $itHdb.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $WpxS6.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $1uFg5.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $1uFg5.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $h2mZt.default)(this.defaults, config);
        const fullPath = (0, $3Typa.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $c38kp.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $itHdb.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $5e85c48a7edf9393$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $h2mZt.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $itHdb.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $h2mZt.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $5e85c48a7edf9393$var$Axios.prototype[method] = generateHTTPMethod();
    $5e85c48a7edf9393$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $5e85c48a7edf9393$export$2e2bcd8739ae039 = $5e85c48a7edf9393$var$Axios;

});
parcelRegister("c38kp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c5c39a88fed3352$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");

var $c6FQJ = parcelRequire("c6FQJ");
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8c5c39a88fed3352$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $8c5c39a88fed3352$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8c5c39a88fed3352$var$encode;
    if ((0, $itHdb.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $itHdb.default).isURLSearchParams(params) ? params.toString() : new (0, $c6FQJ.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("c6FQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d0682060d78f09c$export$2e2bcd8739ae039);

var $1wFBM = parcelRequire("1wFBM");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $8d0682060d78f09c$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $8d0682060d78f09c$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $1wFBM.default)(params, this, options);
}
const $8d0682060d78f09c$var$prototype = $8d0682060d78f09c$var$AxiosURLSearchParams.prototype;
$8d0682060d78f09c$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$8d0682060d78f09c$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $8d0682060d78f09c$var$encode);
    } : $8d0682060d78f09c$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $8d0682060d78f09c$export$2e2bcd8739ae039 = $8d0682060d78f09c$var$AxiosURLSearchParams;

});
parcelRegister("1wFBM", function(module, exports) {

$parcel$export(module.exports, "default", () => $11c90e2e1cd2ee5b$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");

var $lwS9c = parcelRequire("lwS9c");

var $eBxCP = parcelRequire("eBxCP");

var $cbQCu = parcelRequire("cbQCu");
var $11c90e2e1cd2ee5b$require$Buffer = $cbQCu.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $11c90e2e1cd2ee5b$var$isVisitable(thing) {
    return (0, $itHdb.default).isPlainObject(thing) || (0, $itHdb.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $11c90e2e1cd2ee5b$var$removeBrackets(key) {
    return (0, $itHdb.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $11c90e2e1cd2ee5b$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $11c90e2e1cd2ee5b$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $11c90e2e1cd2ee5b$var$isFlatArray(arr) {
    return (0, $itHdb.default).isArray(arr) && !arr.some($11c90e2e1cd2ee5b$var$isVisitable);
}
const $11c90e2e1cd2ee5b$var$predicates = (0, $itHdb.default).toFlatObject((0, $itHdb.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $11c90e2e1cd2ee5b$var$toFormData(obj, formData, options) {
    if (!(0, $itHdb.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $eBxCP.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $itHdb.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $itHdb.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $itHdb.default).isSpecCompliantForm(formData);
    if (!(0, $itHdb.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $itHdb.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $itHdb.default).isBlob(value)) throw new (0, $lwS9c.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $itHdb.default).isArrayBuffer(value) || (0, $itHdb.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $11c90e2e1cd2ee5b$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $itHdb.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $itHdb.default).isArray(value) && $11c90e2e1cd2ee5b$var$isFlatArray(value) || ((0, $itHdb.default).isFileList(value) || (0, $itHdb.default).endsWith(key, '[]')) && (arr = (0, $itHdb.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $11c90e2e1cd2ee5b$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $itHdb.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $11c90e2e1cd2ee5b$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($11c90e2e1cd2ee5b$var$isVisitable(value)) return true;
        formData.append($11c90e2e1cd2ee5b$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($11c90e2e1cd2ee5b$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $11c90e2e1cd2ee5b$var$isVisitable
    });
    function build(value, path) {
        if ((0, $itHdb.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $itHdb.default).forEach(value, function each(el, key) {
            const result = !((0, $itHdb.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $itHdb.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $itHdb.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $11c90e2e1cd2ee5b$export$2e2bcd8739ae039 = $11c90e2e1cd2ee5b$var$toFormData;

});
parcelRegister("lwS9c", function(module, exports) {

$parcel$export(module.exports, "default", () => $fac696ae2985ee56$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");
'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $fac696ae2985ee56$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $itHdb.default).inherits($fac696ae2985ee56$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $itHdb.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $fac696ae2985ee56$var$prototype = $fac696ae2985ee56$var$AxiosError.prototype;
const $fac696ae2985ee56$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $fac696ae2985ee56$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($fac696ae2985ee56$var$AxiosError, $fac696ae2985ee56$var$descriptors);
Object.defineProperty($fac696ae2985ee56$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$fac696ae2985ee56$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($fac696ae2985ee56$var$prototype);
    (0, $itHdb.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $fac696ae2985ee56$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $fac696ae2985ee56$export$2e2bcd8739ae039 = $fac696ae2985ee56$var$AxiosError;

});

parcelRegister("eBxCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa1e9aadb3af62f1$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $aa1e9aadb3af62f1$export$2e2bcd8739ae039 = null;

});




parcelRegister("96JVq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a184c5d4b6a9470$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");
'use strict';
class $6a184c5d4b6a9470$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $itHdb.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $6a184c5d4b6a9470$export$2e2bcd8739ae039 = $6a184c5d4b6a9470$var$InterceptorManager;

});

parcelRegister("1uFg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $116898dcbe29adc8$export$2e2bcd8739ae039);

var $cdKEg = parcelRequire("cdKEg");

var $56i1z = parcelRequire("56i1z");

var $ltPla = parcelRequire("ltPla");

var $8cHYv = parcelRequire("8cHYv");

var $WpxS6 = parcelRequire("WpxS6");

var $dcqJf = parcelRequire("dcqJf");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $116898dcbe29adc8$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $8cHYv.default)(null, config);
}
function $116898dcbe29adc8$export$2e2bcd8739ae039(config) {
    $116898dcbe29adc8$var$throwIfCancellationRequested(config);
    config.headers = (0, $WpxS6.default).from(config.headers);
    // Transform request data
    config.data = (0, $cdKEg.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $dcqJf.default).getAdapter(config.adapter || (0, $ltPla.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $116898dcbe29adc8$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $cdKEg.default).call(config, config.transformResponse, response);
        response.headers = (0, $WpxS6.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $56i1z.default)(reason)) {
            $116898dcbe29adc8$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $cdKEg.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $WpxS6.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("cdKEg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e5ae25b00fd4210$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");

var $ltPla = parcelRequire("ltPla");

var $WpxS6 = parcelRequire("WpxS6");
'use strict';
function $8e5ae25b00fd4210$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $ltPla.default);
    const context = response || config;
    const headers = (0, $WpxS6.default).from(context.headers);
    let data = context.data;
    (0, $itHdb.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("ltPla", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa3421858053a1d0$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");

var $lwS9c = parcelRequire("lwS9c");

var $hgU1e = parcelRequire("hgU1e");

var $1wFBM = parcelRequire("1wFBM");

var $4SYFW = parcelRequire("4SYFW");

var $1DU1D = parcelRequire("1DU1D");

var $l2QlU = parcelRequire("l2QlU");
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $fa3421858053a1d0$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $itHdb.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $itHdb.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $fa3421858053a1d0$var$defaults = {
    transitional: (0, $hgU1e.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $itHdb.default).isObject(data);
            if (isObjectPayload && (0, $itHdb.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $itHdb.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $l2QlU.default)(data)) : data;
            if ((0, $itHdb.default).isArrayBuffer(data) || (0, $itHdb.default).isBuffer(data) || (0, $itHdb.default).isStream(data) || (0, $itHdb.default).isFile(data) || (0, $itHdb.default).isBlob(data) || (0, $itHdb.default).isReadableStream(data)) return data;
            if ((0, $itHdb.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $itHdb.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $4SYFW.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $itHdb.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $1wFBM.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $fa3421858053a1d0$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $fa3421858053a1d0$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $itHdb.default).isResponse(data) || (0, $itHdb.default).isReadableStream(data)) return data;
            if (data && (0, $itHdb.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $lwS9c.default).from(e, (0, $lwS9c.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $1DU1D.default).classes.FormData,
        Blob: (0, $1DU1D.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $itHdb.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $fa3421858053a1d0$var$defaults.headers[method] = {};
});
var $fa3421858053a1d0$export$2e2bcd8739ae039 = $fa3421858053a1d0$var$defaults;

});
parcelRegister("hgU1e", function(module, exports) {

$parcel$export(module.exports, "default", () => $c92f627dbd69840a$export$2e2bcd8739ae039);
'use strict';
var $c92f627dbd69840a$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("4SYFW", function(module, exports) {

$parcel$export(module.exports, "default", () => $38eb457193a749c6$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");

var $1wFBM = parcelRequire("1wFBM");

var $1DU1D = parcelRequire("1DU1D");
'use strict';
function $38eb457193a749c6$export$2e2bcd8739ae039(data, options) {
    return (0, $1wFBM.default)(data, new (0, $1DU1D.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $1DU1D.default).isNode && (0, $itHdb.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("1DU1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $1324e46a1576a551$export$2e2bcd8739ae039);

var $emVLu = parcelRequire("emVLu");

var $afkfU = parcelRequire("afkfU");
var $1324e46a1576a551$export$2e2bcd8739ae039 = {
    ...$afkfU,
    ...(0, $emVLu.default)
};

});
parcelRegister("emVLu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a75fedb07276c6c3$export$2e2bcd8739ae039);

var $he9mE = parcelRequire("he9mE");

var $2G7ay = parcelRequire("2G7ay");

var $7DN3l = parcelRequire("7DN3l");
var $a75fedb07276c6c3$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $he9mE.default,
        FormData: $2G7ay.default,
        Blob: $7DN3l.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("he9mE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ab020e790e6550$export$2e2bcd8739ae039);

var $c6FQJ = parcelRequire("c6FQJ");
'use strict';
var $c8ab020e790e6550$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $c6FQJ.default);

});

parcelRegister("2G7ay", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f3510aebfbcfea1$export$2e2bcd8739ae039);
'use strict';
var $1f3510aebfbcfea1$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("7DN3l", function(module, exports) {

$parcel$export(module.exports, "default", () => $590239d2fdff7377$export$2e2bcd8739ae039);
'use strict';
var $590239d2fdff7377$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("afkfU", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $775b046dea14246b$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "navigator", () => $775b046dea14246b$export$ec7c8efa7f5790ae);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $775b046dea14246b$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $775b046dea14246b$export$c81692cf5af97dac);
$parcel$export(module.exports, "origin", () => $775b046dea14246b$export$f710a83a91838a36);
const $775b046dea14246b$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $775b046dea14246b$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $775b046dea14246b$export$c0bcc9250309d66 = $775b046dea14246b$export$c4996c4b7b93b0bf && (!$775b046dea14246b$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($775b046dea14246b$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $775b046dea14246b$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $775b046dea14246b$export$f710a83a91838a36 = $775b046dea14246b$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("l2QlU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f52264fd788aaa6d$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $f52264fd788aaa6d$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $itHdb.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $f52264fd788aaa6d$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $f52264fd788aaa6d$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $itHdb.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $itHdb.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $itHdb.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $itHdb.default).isArray(target[name])) target[name] = $f52264fd788aaa6d$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $itHdb.default).isFormData(formData) && (0, $itHdb.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $itHdb.default).forEachEntry(formData, (name, value)=>{
            buildPath($f52264fd788aaa6d$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $f52264fd788aaa6d$export$2e2bcd8739ae039 = $f52264fd788aaa6d$var$formDataToJSON;

});


parcelRegister("WpxS6", function(module, exports) {

$parcel$export(module.exports, "default", () => $0af93ba995e94720$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");

var $agxsZ = parcelRequire("agxsZ");
'use strict';
const $0af93ba995e94720$var$$internals = Symbol('internals');
function $0af93ba995e94720$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $0af93ba995e94720$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $itHdb.default).isArray(value) ? value.map($0af93ba995e94720$var$normalizeValue) : String(value);
}
function $0af93ba995e94720$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $0af93ba995e94720$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $0af93ba995e94720$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $itHdb.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $itHdb.default).isString(value)) return;
    if ((0, $itHdb.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $itHdb.default).isRegExp(filter)) return filter.test(value);
}
function $0af93ba995e94720$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $0af93ba995e94720$var$buildAccessors(obj, header) {
    const accessorName = (0, $itHdb.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $0af93ba995e94720$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $0af93ba995e94720$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $itHdb.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $0af93ba995e94720$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $itHdb.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $itHdb.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $itHdb.default).isString(header) && (header = header.trim()) && !$0af93ba995e94720$var$isValidHeaderName(header)) setHeaders((0, $agxsZ.default)(header), valueOrRewrite);
        else if ((0, $itHdb.default).isObject(header) && (0, $itHdb.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $itHdb.default).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $itHdb.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $0af93ba995e94720$var$normalizeHeader(header);
        if (header) {
            const key = (0, $itHdb.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $0af93ba995e94720$var$parseTokens(value);
                if ((0, $itHdb.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $itHdb.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $0af93ba995e94720$var$normalizeHeader(header);
        if (header) {
            const key = (0, $itHdb.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $0af93ba995e94720$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $0af93ba995e94720$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $itHdb.default).findKey(self, _header);
                if (key && (!matcher || $0af93ba995e94720$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $itHdb.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $0af93ba995e94720$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $itHdb.default).forEach(this, (value, header)=>{
            const key = (0, $itHdb.default).findKey(headers, header);
            if (key) {
                self[key] = $0af93ba995e94720$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $0af93ba995e94720$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $0af93ba995e94720$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $itHdb.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $itHdb.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$0af93ba995e94720$var$$internals] = this[$0af93ba995e94720$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $0af93ba995e94720$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $0af93ba995e94720$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $itHdb.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$0af93ba995e94720$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $itHdb.default).reduceDescriptors($0af93ba995e94720$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $itHdb.default).freezeMethods($0af93ba995e94720$var$AxiosHeaders);
var $0af93ba995e94720$export$2e2bcd8739ae039 = $0af93ba995e94720$var$AxiosHeaders;

});
parcelRegister("agxsZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $77955bc4146a1def$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $77955bc4146a1def$var$ignoreDuplicateOf = (0, $itHdb.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $77955bc4146a1def$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $77955bc4146a1def$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});



parcelRegister("56i1z", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6b7e89eab1107d$export$2e2bcd8739ae039);
'use strict';
function $3b6b7e89eab1107d$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("8cHYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f918e3a3f90704e$export$2e2bcd8739ae039);

var $lwS9c = parcelRequire("lwS9c");

var $itHdb = parcelRequire("itHdb");
'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $5f918e3a3f90704e$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $lwS9c.default).call(this, message == null ? 'canceled' : message, (0, $lwS9c.default).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $itHdb.default).inherits($5f918e3a3f90704e$var$CanceledError, (0, $lwS9c.default), {
    __CANCEL__: true
});
var $5f918e3a3f90704e$export$2e2bcd8739ae039 = $5f918e3a3f90704e$var$CanceledError;

});

parcelRegister("dcqJf", function(module, exports) {

$parcel$export(module.exports, "default", () => $99c1211f3b56400e$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");

var $eBxCP = parcelRequire("eBxCP");

var $expG9 = parcelRequire("expG9");

var $3ytRn = parcelRequire("3ytRn");

var $lwS9c = parcelRequire("lwS9c");
const $99c1211f3b56400e$var$knownAdapters = {
    http: (0, $eBxCP.default),
    xhr: (0, $expG9.default),
    fetch: (0, $3ytRn.default)
};
(0, $itHdb.default).forEach($99c1211f3b56400e$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $99c1211f3b56400e$var$renderReason = (reason)=>`- ${reason}`;
const $99c1211f3b56400e$var$isResolvedHandle = (adapter)=>(0, $itHdb.default).isFunction(adapter) || adapter === null || adapter === false;
var $99c1211f3b56400e$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $itHdb.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$99c1211f3b56400e$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $99c1211f3b56400e$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $lwS9c.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($99c1211f3b56400e$var$renderReason).join('\n') : ' ' + $99c1211f3b56400e$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $lwS9c.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $99c1211f3b56400e$var$knownAdapters
};

});
parcelRegister("expG9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a958110f6ae3c5cf$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");

var $1Enxc = parcelRequire("1Enxc");

var $hgU1e = parcelRequire("hgU1e");

var $lwS9c = parcelRequire("lwS9c");

var $8cHYv = parcelRequire("8cHYv");

var $7I2TN = parcelRequire("7I2TN");

var $1DU1D = parcelRequire("1DU1D");

var $WpxS6 = parcelRequire("WpxS6");

var $bSmO3 = parcelRequire("bSmO3");

var $2aBTq = parcelRequire("2aBTq");
const $a958110f6ae3c5cf$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $a958110f6ae3c5cf$export$2e2bcd8739ae039 = $a958110f6ae3c5cf$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $2aBTq.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $WpxS6.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $WpxS6.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $1Enxc.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $lwS9c.default)('Request aborted', (0, $lwS9c.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $lwS9c.default)('Network Error', (0, $lwS9c.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $hgU1e.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $lwS9c.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $lwS9c.default).ETIMEDOUT : (0, $lwS9c.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $itHdb.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $itHdb.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $bSmO3.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $bSmO3.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $8cHYv.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $7I2TN.default)(_config.url);
        if (protocol && (0, $1DU1D.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $lwS9c.default)('Unsupported protocol ' + protocol + ':', (0, $lwS9c.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("1Enxc", function(module, exports) {

$parcel$export(module.exports, "default", () => $133bc858f9dafbaa$export$2e2bcd8739ae039);

var $lwS9c = parcelRequire("lwS9c");
'use strict';
function $133bc858f9dafbaa$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $lwS9c.default)('Request failed with status code ' + response.status, [
        (0, $lwS9c.default).ERR_BAD_REQUEST,
        (0, $lwS9c.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("7I2TN", function(module, exports) {

$parcel$export(module.exports, "default", () => $59cee42021b50246$export$2e2bcd8739ae039);
'use strict';
function $59cee42021b50246$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("bSmO3", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", () => $8a566dbcf2fdf594$export$c1b28109d46c3592);
$parcel$export(module.exports, "progressEventDecorator", () => $8a566dbcf2fdf594$export$d9fadd12586c18d6);
$parcel$export(module.exports, "asyncDecorator", () => $8a566dbcf2fdf594$export$5d35863c355a22a9);

var $Pf10k = parcelRequire("Pf10k");

var $7kbkP = parcelRequire("7kbkP");

var $itHdb = parcelRequire("itHdb");
const $8a566dbcf2fdf594$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $Pf10k.default)(50, 250);
    return (0, $7kbkP.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $8a566dbcf2fdf594$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $8a566dbcf2fdf594$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $itHdb.default).asap(()=>fn(...args));

});
parcelRegister("Pf10k", function(module, exports) {

$parcel$export(module.exports, "default", () => $09a0693d9e4211de$export$2e2bcd8739ae039);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $09a0693d9e4211de$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $09a0693d9e4211de$export$2e2bcd8739ae039 = $09a0693d9e4211de$var$speedometer;

});

parcelRegister("7kbkP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5553318ec452b13e$export$2e2bcd8739ae039);
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $5553318ec452b13e$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $5553318ec452b13e$export$2e2bcd8739ae039 = $5553318ec452b13e$var$throttle;

});


parcelRegister("2aBTq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1949e8b54f4c0d29$export$2e2bcd8739ae039);

var $1DU1D = parcelRequire("1DU1D");

var $itHdb = parcelRequire("itHdb");

var $41Ao1 = parcelRequire("41Ao1");

var $kWMAU = parcelRequire("kWMAU");

var $3Typa = parcelRequire("3Typa");

var $h2mZt = parcelRequire("h2mZt");

var $WpxS6 = parcelRequire("WpxS6");

var $c38kp = parcelRequire("c38kp");
var $1949e8b54f4c0d29$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $h2mZt.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $WpxS6.default).from(headers);
    newConfig.url = (0, $c38kp.default)((0, $3Typa.default)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $itHdb.default).isFormData(data)) {
        if ((0, $1DU1D.default).hasStandardBrowserEnv || (0, $1DU1D.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $1DU1D.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $itHdb.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $41Ao1.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $kWMAU.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("41Ao1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ee37b0684d8d70d$export$2e2bcd8739ae039);

var $1DU1D = parcelRequire("1DU1D");
var $2ee37b0684d8d70d$export$2e2bcd8739ae039 = (0, $1DU1D.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $1DU1D.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $1DU1D.default).origin), (0, $1DU1D.default).navigator && /(msie|trident)/i.test((0, $1DU1D.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("kWMAU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3feeb42b1334a7e$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");

var $1DU1D = parcelRequire("1DU1D");
var $f3feeb42b1334a7e$export$2e2bcd8739ae039 = (0, $1DU1D.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $itHdb.default).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $itHdb.default).isString(path) && cookie.push('path=' + path);
        (0, $itHdb.default).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("3Typa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d613241cb01bbc5$export$2e2bcd8739ae039);

var $haqAw = parcelRequire("haqAw");

var $eKH6Q = parcelRequire("eKH6Q");
'use strict';
function $2d613241cb01bbc5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $haqAw.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $eKH6Q.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("haqAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7f7fea8f50478b8$export$2e2bcd8739ae039);
'use strict';
function $c7f7fea8f50478b8$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("eKH6Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $abd6cd359ab92832$export$2e2bcd8739ae039);
'use strict';
function $abd6cd359ab92832$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("h2mZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c67475004a42ac76$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");

var $WpxS6 = parcelRequire("WpxS6");
'use strict';
const $c67475004a42ac76$var$headersToObject = (thing)=>thing instanceof (0, $WpxS6.default) ? {
        ...thing
    } : thing;
function $c67475004a42ac76$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $itHdb.default).isPlainObject(target) && (0, $itHdb.default).isPlainObject(source)) return (0, $itHdb.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $itHdb.default).isPlainObject(source)) return (0, $itHdb.default).merge({}, source);
        else if ((0, $itHdb.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $itHdb.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $itHdb.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $itHdb.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $itHdb.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $itHdb.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($c67475004a42ac76$var$headersToObject(a), $c67475004a42ac76$var$headersToObject(b), prop, true)
    };
    (0, $itHdb.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $itHdb.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("3ytRn", function(module, exports) {

$parcel$export(module.exports, "default", () => $296bb5a09bc3de7e$export$2e2bcd8739ae039);

var $1DU1D = parcelRequire("1DU1D");

var $itHdb = parcelRequire("itHdb");

var $lwS9c = parcelRequire("lwS9c");

var $fCbXb = parcelRequire("fCbXb");

var $hdYW9 = parcelRequire("hdYW9");

var $WpxS6 = parcelRequire("WpxS6");

var $bSmO3 = parcelRequire("bSmO3");

var $2aBTq = parcelRequire("2aBTq");

var $1Enxc = parcelRequire("1Enxc");
const $296bb5a09bc3de7e$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $296bb5a09bc3de7e$var$isReadableStreamSupported = $296bb5a09bc3de7e$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $296bb5a09bc3de7e$var$encodeText = $296bb5a09bc3de7e$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $296bb5a09bc3de7e$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $296bb5a09bc3de7e$var$supportsRequestStream = $296bb5a09bc3de7e$var$isReadableStreamSupported && $296bb5a09bc3de7e$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $1DU1D.default).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $296bb5a09bc3de7e$var$DEFAULT_CHUNK_SIZE = 65536;
const $296bb5a09bc3de7e$var$supportsResponseStream = $296bb5a09bc3de7e$var$isReadableStreamSupported && $296bb5a09bc3de7e$var$test(()=>(0, $itHdb.default).isReadableStream(new Response('').body));
const $296bb5a09bc3de7e$var$resolvers = {
    stream: $296bb5a09bc3de7e$var$supportsResponseStream && ((res)=>res.body)
};
$296bb5a09bc3de7e$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$296bb5a09bc3de7e$var$resolvers[type] && ($296bb5a09bc3de7e$var$resolvers[type] = (0, $itHdb.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $lwS9c.default)(`Response type '${type}' is not supported`, (0, $lwS9c.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $296bb5a09bc3de7e$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $itHdb.default).isBlob(body)) return body.size;
    if ((0, $itHdb.default).isSpecCompliantForm(body)) {
        const _request = new Request((0, $1DU1D.default).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $itHdb.default).isArrayBufferView(body) || (0, $itHdb.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, $itHdb.default).isURLSearchParams(body)) body = body + '';
    if ((0, $itHdb.default).isString(body)) return (await $296bb5a09bc3de7e$var$encodeText(body)).byteLength;
};
const $296bb5a09bc3de7e$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $itHdb.default).toFiniteNumber(headers.getContentLength());
    return length == null ? $296bb5a09bc3de7e$var$getBodyLength(body) : length;
};
var $296bb5a09bc3de7e$export$2e2bcd8739ae039 = $296bb5a09bc3de7e$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $2aBTq.default)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $fCbXb.default)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $296bb5a09bc3de7e$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $296bb5a09bc3de7e$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $itHdb.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $bSmO3.progressEventDecorator)(requestContentLength, (0, $bSmO3.progressEventReducer)((0, $bSmO3.asyncDecorator)(onUploadProgress)));
                data = (0, $hdYW9.trackStream)(_request.body, $296bb5a09bc3de7e$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $itHdb.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $296bb5a09bc3de7e$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($296bb5a09bc3de7e$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $itHdb.default).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $bSmO3.progressEventDecorator)(responseContentLength, (0, $bSmO3.progressEventReducer)((0, $bSmO3.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, $hdYW9.trackStream)(response.body, $296bb5a09bc3de7e$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $296bb5a09bc3de7e$var$resolvers[(0, $itHdb.default).findKey($296bb5a09bc3de7e$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $1Enxc.default)(resolve, reject, {
                data: responseData,
                headers: (0, $WpxS6.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $lwS9c.default)('Network Error', (0, $lwS9c.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $lwS9c.default).from(err, err && err.code, config, request);
    }
});

});
parcelRegister("fCbXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5e3ad5b8403d90c$export$2e2bcd8739ae039);

var $8cHYv = parcelRequire("8cHYv");

var $lwS9c = parcelRequire("lwS9c");

var $itHdb = parcelRequire("itHdb");
const $b5e3ad5b8403d90c$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $lwS9c.default) ? err : new (0, $8cHYv.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $lwS9c.default)(`timeout ${timeout} of ms exceeded`, (0, $lwS9c.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $itHdb.default).asap(unsubscribe);
        return signal;
    }
};
var $b5e3ad5b8403d90c$export$2e2bcd8739ae039 = $b5e3ad5b8403d90c$var$composeSignals;

});

parcelRegister("hdYW9", function(module, exports) {

$parcel$export(module.exports, "trackStream", () => $c8a2eb5915f743ad$export$b0119225647bd83);
const $c8a2eb5915f743ad$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c8a2eb5915f743ad$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c8a2eb5915f743ad$var$readStream(iterable))yield* $c8a2eb5915f743ad$export$71b051935044bd5d(chunk, chunkSize);
};
const $c8a2eb5915f743ad$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c8a2eb5915f743ad$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c8a2eb5915f743ad$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("f73uM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b00a389ad44b697c$export$2e2bcd8739ae039);

var $iLWpM = parcelRequire("iLWpM");

var $lwS9c = parcelRequire("lwS9c");
'use strict';
const $b00a389ad44b697c$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $b00a389ad44b697c$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $b00a389ad44b697c$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $b00a389ad44b697c$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $iLWpM.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $lwS9c.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $lwS9c.default).ERR_DEPRECATED);
        if (version && !$b00a389ad44b697c$var$deprecatedWarnings[opt]) {
            $b00a389ad44b697c$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$b00a389ad44b697c$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $b00a389ad44b697c$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $lwS9c.default)('options must be an object', (0, $lwS9c.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $lwS9c.default)('option ' + opt + ' must be ' + result, (0, $lwS9c.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $lwS9c.default)('Unknown option ' + opt, (0, $lwS9c.default).ERR_BAD_OPTION);
    }
}
var $b00a389ad44b697c$export$2e2bcd8739ae039 = {
    assertOptions: $b00a389ad44b697c$var$assertOptions,
    validators: $b00a389ad44b697c$var$validators
};

});
parcelRegister("iLWpM", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $daa9edc019a88561$export$a4ad2735b021c132);
const $daa9edc019a88561$export$a4ad2735b021c132 = "1.9.0";

});



parcelRegister("2XZvW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2290ceea30bcb259$export$2e2bcd8739ae039);

var $8cHYv = parcelRequire("8cHYv");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $2290ceea30bcb259$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $8cHYv.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $2290ceea30bcb259$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $2290ceea30bcb259$export$2e2bcd8739ae039 = $2290ceea30bcb259$var$CancelToken;

});

parcelRegister("eikjl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a682807911212efd$export$2e2bcd8739ae039);
'use strict';
function $a682807911212efd$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("d4N0E", function(module, exports) {

$parcel$export(module.exports, "default", () => $9851aa5a344142d6$export$2e2bcd8739ae039);

var $itHdb = parcelRequire("itHdb");
'use strict';
function $9851aa5a344142d6$export$2e2bcd8739ae039(payload) {
    return (0, $itHdb.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("bhWqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $837e99702b45b2bd$export$2e2bcd8739ae039);
const $837e99702b45b2bd$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($837e99702b45b2bd$var$HttpStatusCode).forEach(([key, value])=>{
    $837e99702b45b2bd$var$HttpStatusCode[value] = key;
});
var $837e99702b45b2bd$export$2e2bcd8739ae039 = $837e99702b45b2bd$var$HttpStatusCode;

});



parcelRegister("7gFhF", function(module, exports) {
module.exports = import("5IZRN").then(()=>parcelRequire('S0tDS'));

});

parcelRegister("hWl2v", function(module, exports) {
module.exports = import("d8Ia4").then(()=>parcelRequire('5lTq7'));

});


parcelRegister("b7lSL", function(module, exports) {

$parcel$export(module.exports, "Word", () => $8181528bb0533893$export$1ee6d718c47c2db0);

var $arHBl = parcelRequire("arHBl");

var $KjYoF = parcelRequire("KjYoF");

var $ikHJv = parcelRequire("ikHJv");
parcelRequire("4NX2m");
class $8181528bb0533893$export$1ee6d718c47c2db0 extends (0, $ikHJv.CircularButtonBase) {
    initialScreenStateTime = null;
    currentPlayerPosition = null;
    outroDuration = 500;
    clickHandlerRan = false;
    missHandlerRan = false;
    constructor(word, x, y, startTime, duration, currentPlayerPosition, introDuration, onClick, onMiss, configureCanvas){
        super(x, y, 50, onClick, configureCanvas);
        this.word = word;
        this.startTime = startTime;
        this.duration = duration;
        this.endTime = startTime + duration;
        this.initialPlayerPosition = currentPlayerPosition; //Not in use
        this.introDuration = introDuration || 1000;
        this.onMiss = onMiss;
    }
    /**
   * Checks if cursors are intersecting object.
   * @param {Cursor[]} cursors A list of cursors to check
   * @param {ScreenState} screenState The current state of the screen
   * @returns {Boolean} true if there are cursors intersecting the object.
   */ checkHover(cursors, screenState) {
        const [newX, newY, newRadius] = [
            screenState.X(this.x),
            screenState.Y(this.y),
            this.WordLength ? Math.max(screenState.S(this.radius), this.WordLength) : screenState.S(this.radius)
        ];
        for(let i = 0; i < cursors.length; i++){
            if ((0, $ikHJv.__check_circle_collision)(cursors[i].x, cursors[i].y, cursors[i].radius, newX, newY, newRadius)) return true;
        }
    }
    /**
   * Update the object's state based on the state of the cursor.
   * @param {Cursor[]} cursors The list of cursor objects to check if the button is colliding with the cursor. 
   * @param {ScreenState} screenState The current state of the screen
   */ updateHover(cursors, screenState) {
        const animationStep = screenState.animationStep;
        if (!this.initialScreenStateTime) this.initialScreenStateTime = animationStep;
        // if (!this.currentPlayerPosition){
        //   this.currentPlayerPosition = this.initialPlayerPosition + (animationStep - this.initialScreenStateTime);
        // }
        // this.currentPlayerPosition = this.initialPlayerPosition + (animationStep - this.initialScreenStateTime);
        if (!this.clickHandlerRan && this.currentPlayerPosition >= this.startTime && this.currentPlayerPosition <= this.endTime && this.checkHover(cursors, screenState)) {
            this.onClick(this);
            this.clickHandlerRan = true;
            this.outroDuration = Math.max(this.endTime - this.currentPlayerPosition, this.outroDuration);
            this.endTime = this.currentPlayerPosition;
            return true;
        }
        return false;
    }
    /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ configure(screenState) {}
    /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ render(screenState) {
        if (!this.initialScreenStateTime) this.initialScreenStateTime = screenState.animationStep;
        const baseFontSize = screenState.S(36);
        this.currentPlayerPosition = screenState.playerPosition || 0;
        super.render(screenState);
        // this.currentPlayerPosition = this.initialPlayerPosition + (screenState.animationStep - this.initialScreenStateTime);
        // if (!this.currentPlayerPosition){
        // }
        // screenState.canvasCtx.font = `${baseFontSize}px Yusei Magic`;
        screenState.canvasCtx.textAlign = 'center';
        screenState.canvasCtx.textBaseline = 'middle';
        if (!this.WordLength) this.WordLength = (screenState.canvasCtx.measureText(this.word).width + 30) / 2;
        const xPos = screenState.X(this.x);
        const yPos = screenState.Y(this.y);
        const radius = Math.max(screenState.S(this.radius), this.WordLength);
        screenState.canvasCtx.lineWidth = screenState.S(3);
        screenState.canvasCtx.strokeStyle = (0, $KjYoF.rgb)(228, 255, 26);
        if (this.currentPlayerPosition <= this.startTime) {
            screenState.canvasCtx.font = `${baseFontSize}px Yusei Magic`;
            // console.log(this.currentPlayerPosition)
            // NOTE: This progress runs backwards, 0 when currentPos == startTime
            if (this.startTime - this.currentPlayerPosition >= this.introDuration) return;
            const introProgress = (0, $arHBl.easeOutCubic)(Math.min((this.startTime - this.currentPlayerPosition) / this.introDuration, 1));
            const color = (0, $KjYoF.rgb)(15, 223, 23);
            // const strokeColor = rgba(0, 0, 255, 1);
            const transitionProgress = (0, $arHBl.easeOutExpo)(1 - introProgress);
            screenState.canvasCtx.globalAlpha = transitionProgress;
            const outer_radius = radius * 3 * introProgress + radius;
            screenState.canvasCtx.strokeStyle = (0, $KjYoF.rgba)(228, 255, 26, 1 - introProgress);
            screenState.canvasCtx.fillStyle = color;
            // screenState.canvasCtx.strokeColor = strokeColor;
            screenState.canvasCtx.beginPath();
            screenState.canvasCtx.arc(xPos, yPos, radius, 0, 2 * Math.PI);
            screenState.canvasCtx.fill();
            screenState.canvasCtx.shadowColor = (0, $KjYoF.rgb)(228, 255, 26);
            screenState.canvasCtx.shadowBlur = 15;
            screenState.canvasCtx.beginPath();
            screenState.canvasCtx.arc(xPos, yPos, outer_radius, 0, 2 * Math.PI);
            screenState.canvasCtx.stroke();
            screenState.canvasCtx.shadowBlur = 0;
            screenState.canvasCtx.fillStyle = (0, $KjYoF.rgba)(255, 255, 255, transitionProgress);
            screenState.canvasCtx.fillText(this.word, xPos, yPos);
            screenState.canvasCtx.globalAlpha = 1;
        } else if (this.currentPlayerPosition >= this.endTime) {
            // console.log(`Completed: ${this.word}`)
            // this.destroy();
            // return;
            const outroProgress = 1 - (0, $arHBl.easeOutCubic)(Math.min((this.currentPlayerPosition - this.endTime) / this.outroDuration, 1));
            if (!this.missHandlerRan && !this.clickHandlerRan && this.onMiss) {
                this.onMiss();
                this.missHandlerRan = true;
            }
            if (outroProgress <= 0) {
                // console.log(`Completed: ${this.word}`)
                this.destroy();
                return;
            }
            screenState.canvasCtx.font = `${this.clickHandlerRan ? baseFontSize + baseFontSize * 2 * (1 - outroProgress) : baseFontSize}px Yusei Magic`;
            const color = this.clickHandlerRan ? (0, $KjYoF.rgb)(168, 234, 141) : (0, $KjYoF.rgb)(235, 94, 85);
            screenState.canvasCtx.globalAlpha = outroProgress;
            screenState.canvasCtx.fillStyle = color;
            // screenState.canvasCtx.strokeColor = rgba(0,0,255,1);
            screenState.canvasCtx.beginPath();
            screenState.canvasCtx.arc(xPos, yPos, this.clickHandlerRan ? radius * outroProgress : radius, 0, 2 * Math.PI);
            screenState.canvasCtx.fill();
            // screenState.canvasCtx.beginPath();
            // screenState.canvasCtx.arc(xPos, yPos, radius, 0,2*Math.PI);
            // screenState.canvasCtx.stroke();
            let fadeProgress;
            if (this.clickHandlerRan) {
                fadeProgress = (0, $arHBl.easeOutExpo)(outroProgress);
                screenState.canvasCtx.globalAlpha = fadeProgress;
            } else fadeProgress = outroProgress;
            screenState.canvasCtx.shadowBlur = 15 * (1 - outroProgress);
            screenState.canvasCtx.fillStyle = (0, $KjYoF.rgba)(255, 255, 255, fadeProgress);
            screenState.canvasCtx.shadowColor = (0, $KjYoF.rgb)(255, 255, 255);
            screenState.canvasCtx.fillText(this.word, xPos, yPos);
            screenState.canvasCtx.shadowBlur = 0;
            screenState.canvasCtx.globalAlpha = 1;
        } else {
            screenState.canvasCtx.font = `${baseFontSize}px Yusei Magic`;
            const color = this.clickHandlerRan ? (0, $KjYoF.rgb)(15, 223, 23, 1) : (0, $KjYoF.rgb)(232, 170, 20);
            screenState.canvasCtx.fillStyle = color;
            // screenState.canvasCtx.strokeColor = rgba(0,0,255,1);
            screenState.canvasCtx.beginPath();
            screenState.canvasCtx.arc(xPos, yPos, radius, 0, 2 * Math.PI);
            screenState.canvasCtx.fill();
            screenState.canvasCtx.shadowColor = (0, $KjYoF.rgb)(228, 255, 26);
            screenState.canvasCtx.shadowBlur = 15;
            screenState.canvasCtx.beginPath();
            screenState.canvasCtx.arc(xPos, yPos, radius, -Math.PI / 2, 2 * Math.PI * (1 - (this.currentPlayerPosition - this.startTime) / this.duration) - Math.PI / 2);
            screenState.canvasCtx.stroke();
            screenState.canvasCtx.shadowBlur = 0;
            screenState.canvasCtx.fillStyle = (0, $KjYoF.rgb)(255, 255, 255);
            screenState.canvasCtx.fillText(this.word, xPos, yPos);
        }
    }
}

});

parcelRegister("5J4VT", function(module, exports) {

$parcel$export(module.exports, "PointsCounter", () => $42b4fb49bfd6e8cc$export$2d5729ee5aebe89e);

var $jTmqR = parcelRequire("jTmqR");
parcelRequire("4NX2m");

var $KjYoF = parcelRequire("KjYoF");

var $arHBl = parcelRequire("arHBl");
parcelRequire("eaQG2");
class $42b4fb49bfd6e8cc$export$2d5729ee5aebe89e extends (0, $jTmqR.Drawable) {
    takesSegmentationMask = true;
    currentPlayerPosition = null;
    score = 0;
    combo = 0;
    /**
  * Initialiases the Dummy drawable.
  * @param {number} x A positive number indicating x coordinate on screen
  * @param {number} y A positive number indicating y coordinate on screen
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  */ constructor(noteIcon, songTitle, songArtist, songDifficulty, duration, currentPlayerPosition, segmentationColoursData, configureCanvas){
        super(undefined, undefined, configureCanvas);
        this.noteIcon = noteIcon;
        this.songTitle = songTitle;
        this.songArtist = songArtist;
        this.songDifficulty = songDifficulty;
        this.duration = duration;
        this.initialPlayerPosition = currentPlayerPosition;
        this.segmentationColoursData = segmentationColoursData;
    }
    /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ configure(screenState) {}
    /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  * @param {RenderableSegmentationMask | undefined} segmentationMask The segmentation mask of the user if avaliable.
  */ render(screenState, segmentationMask) {
        super.render(screenState);
        if (!this.initialScreenStateTime && this.duration) this.initialScreenStateTime = screenState.animationStep;
        // if (this.initialScreenStateTime){
        //   this.currentPlayerPosition = this.initialPlayerPosition + (screenState.animationStep - this.initialScreenStateTime);
        // }
        // Prevent music seek from reseting after music finish. 
        const timeSinceInit = screenState.animationStep - this.initTime;
        if (timeSinceInit < 3000) this.currentPlayerPosition = 0;
        else if (timeSinceInit > 10000) this.currentPlayerPosition = screenState.playerPosition || this.duration // (screenState.animationStep - this.initTime > this.duration*0.75) ? this.duration : 0;
        ;
        else this.currentPlayerPosition = screenState.playerPosition || 0 // (screenState.animationStep - this.initTime > this.duration*0.75) ? this.duration : 0;
        ;
        // Background
        screenState.canvasCtx.fillStyle = (0, $KjYoF.rgb)(0, 0, 0);
        if (screenState.transitionProgress < 1) {
            const transitionProgress = (0, $arHBl.easeOutQuint)(screenState.transitionProgress);
            const halfOfScreenHeight = screenState.height / 2 * transitionProgress;
            screenState.canvasCtx.globalAlpha = transitionProgress;
            screenState.canvasCtx.fillRect(screenState.offsetX, screenState.offsetY, screenState.width, halfOfScreenHeight);
            screenState.canvasCtx.fillRect(screenState.offsetX, screenState.offsetY + screenState.height - halfOfScreenHeight, screenState.width, halfOfScreenHeight);
        } else {
            screenState.canvasCtx.globalAlpha = 1;
            screenState.canvasCtx.fillRect(screenState.offsetX, screenState.offsetY, screenState.width, screenState.height);
        }
        // Segmentation Mask
        if (segmentationMask) {
            if (this.segmentationColoursData && Object.keys(this.segmentationColoursData).length > 0 && this.segmentationColoursData["0"]) {
                if (Object.keys(this.segmentationColoursData).length == 1) {
                    const maskColour = this.segmentationColoursData["0"];
                    segmentationMask.recolor_mask(maskColour.r, maskColour.g, maskColour.b, screenState.transitionProgress);
                    segmentationMask.render(screenState);
                } else {
                    if (!this.prevSegmentationMaskColor) this.prevSegmentationMaskColor = this.segmentationColoursData["0"];
                    if (!this.currentSegmentationMaskColorTime || this.currentSegmentationMaskColorTime < this.currentPlayerPosition) {
                        if (this.currentSegmentationMaskColorTime) this.prevSegmentationMaskColor = this.segmentationColoursData[this.currentSegmentationMaskColorTime.toString()];
                        const segmentationMaskColorTimings = Object.keys(this.segmentationColoursData).map(Number).sort((a, b)=>a - b);
                        for(let i = 0; i < segmentationMaskColorTimings.length; i++)if (segmentationMaskColorTimings[i] >= this.currentPlayerPosition || i + 1 == segmentationMaskColorTimings.length) {
                            this.currentSegmentationMaskColorTime = segmentationMaskColorTimings[i];
                            break;
                        }
                    }
                    const newMaskColour = this.segmentationColoursData[this.currentSegmentationMaskColorTime.toString()];
                    const transitionAmount = 1 - Math.min(this.currentSegmentationMaskColorTime - this.currentPlayerPosition, 500) / 500;
                    const finalMaskColour = (0, $KjYoF.fadeRGB)(this.prevSegmentationMaskColor.r, this.prevSegmentationMaskColor.g, this.prevSegmentationMaskColor.b, newMaskColour.r, newMaskColour.g, newMaskColour.b, (0, $arHBl.easeOutSine)(Math.min(transitionAmount, 1)));
                    segmentationMask.recolor_mask(...finalMaskColour, screenState.transitionProgress);
                    segmentationMask.render(screenState);
                }
            } else {
                segmentationMask.recolor_mask(108, 212, 255, screenState.transitionProgress);
                segmentationMask.render(screenState);
            }
        }
        // Intro Text & Countdown
        if (timeSinceInit <= 4000) {
            screenState.canvasCtx.globalAlpha = timeSinceInit > 3000 ? 1 - (timeSinceInit - 3000) / 1000 : 1;
            screenState.canvasCtx.fillStyle = (0, $KjYoF.rgba)(255, 255, 255, 1);
            screenState.canvasCtx.font = `bold ${screenState.S(45)}px Yusei Magic`;
            screenState.canvasCtx.textAlign = 'center';
            screenState.canvasCtx.textBaseline = 'middle';
            const [introTxtXpos, introTxtYpos] = [
                screenState.X(710),
                screenState.Y(294)
            ];
            const iconSize = screenState.S(75);
            const txtBounding = screenState.canvasCtx.measureText(this.songTitle);
            const txtHeight = txtBounding.actualBoundingBoxAscent + txtBounding.actualBoundingBoxDescent;
            this.noteIcon.render(screenState.canvasCtx, introTxtXpos, introTxtYpos - txtHeight - iconSize / 2, iconSize, iconSize, (0, $KjYoF.rgb)(255, 255, 255));
            screenState.canvasCtx.fillText(this.songTitle, introTxtXpos, introTxtYpos);
            screenState.canvasCtx.font = `${screenState.S(28)}px Yusei Magic`;
            const txtBounding2 = screenState.canvasCtx.measureText(this.songArtist);
            const txtHeight2 = txtBounding2.actualBoundingBoxAscent + txtBounding2.actualBoundingBoxDescent;
            screenState.canvasCtx.fillStyle = (0, $KjYoF.rgba)(255, 255, 255, screenState.transitionProgress);
            screenState.canvasCtx.fillText(this.songArtist, introTxtXpos, introTxtYpos + txtHeight + 10);
            screenState.canvasCtx.fillText(this.songDifficulty, introTxtXpos, introTxtYpos + txtHeight + txtHeight2 + 20);
            if (timeSinceInit > 1000) {
                screenState.canvasCtx.globalAlpha = 1;
                screenState.canvasCtx.textBaseline = 'top';
                screenState.canvasCtx.font = `${screenState.S(72)}px Yusei Magic`;
                screenState.canvasCtx.fillText(Math.ceil((4000 - timeSinceInit) / 1000).toString(), screenState.X(710), screenState.Y(365) + txtHeight + txtHeight2);
            }
        }
        let transitionProgress;
        if (this.outroTimestamp) {
            if (this.outroTimestamp === true) this.outroTimestamp = screenState.animationStep;
            transitionProgress = (0, $arHBl.easeInCubic)(Math.max(1 - (screenState.animationStep - this.outroTimestamp) / 1000, 0));
        } else transitionProgress = screenState.transitionProgress;
        screenState.canvasCtx.globalAlpha = transitionProgress;
        screenState.canvasCtx.font = `${screenState.S(48)}px Yusei Magic`;
        const scoreText = this.score.toString().padStart(6, "0");
        const comboText = this.combo.toString().padStart(2, "0");
        const finalScoreWidth = screenState.canvasCtx.measureText(scoreText).width + screenState.S(100);
        const scoreBoxHeight = screenState.Y(150) - screenState.offsetY;
        const finalComboWidth = screenState.canvasCtx.measureText(comboText).width + screenState.S(50);
        const comboBoxHeight = Math.max(screenState.Y(150) - screenState.offsetY, finalComboWidth);
        // const progressWidth = screenState.width - finalScoreWidth*0.75 - finalComboWidth*0.75;
        // const progressHeight =  screenState.S(75);
        screenState.canvasCtx.fillStyle = (0, $KjYoF.rgb)(108, 212, 255);
        screenState.canvasCtx.strokeStyle = (0, $KjYoF.rgb)(228, 255, 26);
        screenState.canvasCtx.shadowColor = (0, $KjYoF.rgb)(228, 255, 26);
        screenState.canvasCtx.lineWidth = 5;
        screenState.canvasCtx.shadowBlur = 15;
        // // Progress Bar
        // const progressXpos = screenState.offsetX + finalScoreWidth*0.75;
        // screenState.canvasCtx.beginPath();
        // screenState.canvasCtx.rect(progressXpos, screenState.offsetY, progressWidth, progressHeight);
        // screenState.canvasCtx.fill();
        // screenState.canvasCtx.beginPath();
        // screenState.canvasCtx.moveTo(progressXpos, screenState.offsetY + progressHeight);
        // screenState.canvasCtx.lineTo(progressXpos + progressWidth, screenState.offsetY + progressHeight);
        // screenState.canvasCtx.stroke();
        // Score box
        const scoreYpos = screenState.Y(150);
        const scoreXpos = screenState.offsetX;
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.moveTo(scoreXpos, scoreYpos);
        screenState.canvasCtx.lineTo(finalScoreWidth - scoreBoxHeight + screenState.offsetX, scoreYpos);
        screenState.canvasCtx.arc(finalScoreWidth - scoreBoxHeight, screenState.Y(0), scoreBoxHeight, Math.PI / 2, 0, true);
        screenState.canvasCtx.lineTo(scoreXpos, screenState.Y(0));
        screenState.canvasCtx.lineTo(scoreXpos, scoreYpos);
        screenState.canvasCtx.closePath();
        screenState.canvasCtx.fill();
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.moveTo(scoreXpos, scoreYpos);
        screenState.canvasCtx.lineTo(finalScoreWidth - scoreBoxHeight + screenState.offsetX, scoreYpos);
        screenState.canvasCtx.arc(finalScoreWidth - scoreBoxHeight, screenState.Y(0), scoreBoxHeight, Math.PI / 2, 0, true);
        screenState.canvasCtx.stroke();
        // Combo box
        const comboBoxXpos = screenState.offsetX + screenState.width;
        // const comboBoxXpos2 = comboBoxXpos - finalComboWidth;
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.arc(comboBoxXpos, screenState.offsetY, comboBoxHeight, Math.PI * 1.5, Math.PI / 2, true);
        screenState.canvasCtx.lineTo(comboBoxXpos, screenState.offsetY);
        screenState.canvasCtx.closePath();
        screenState.canvasCtx.fill();
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.arc(comboBoxXpos, screenState.offsetY, comboBoxHeight, Math.PI * 1.5, Math.PI / 2, true);
        screenState.canvasCtx.stroke();
        // screenState.canvasCtx.beginPath();
        // screenState.canvasCtx.moveTo(comboBoxXpos, screenState.offsetY);
        // screenState.canvasCtx.lineTo(comboBoxXpos2 - comboBoxHeight, screenState.offsetY);
        // screenState.canvasCtx.arc(comboBoxXpos2, screenState.offsetY, comboBoxHeight, Math.PI*1.5, Math.PI/2, true);
        // screenState.canvasCtx.lineTo(comboBoxXpos, screenState.offsetY + comboBoxHeight);
        // screenState.canvasCtx.lineTo(comboBoxXpos, screenState.offsetY);
        // screenState.canvasCtx.closePath()
        // screenState.canvasCtx.fill();
        // screenState.canvasCtx.beginPath();
        // screenState.canvasCtx.moveTo(comboBoxXpos2 - comboBoxHeight, screenState.offsetY);
        // screenState.canvasCtx.arc(comboBoxXpos2, screenState.offsetY, comboBoxHeight, Math.PI*1.5, Math.PI/2, true);
        // screenState.canvasCtx.lineTo(comboBoxXpos, screenState.offsetY + comboBoxHeight);
        // screenState.canvasCtx.stroke()
        // Scorebox Text
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.textAlign = 'center';
        screenState.canvasCtx.textBaseline = 'middle';
        screenState.canvasCtx.fillStyle = (0, $KjYoF.rgba)(255, 255, 255, transitionProgress);
        screenState.canvasCtx.fillText(scoreText, finalScoreWidth / 2.25 + screenState.offsetX, scoreBoxHeight / 2 + screenState.offsetY);
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.font = `${screenState.S(30)}px Yusei Magic`;
        screenState.canvasCtx.textAlign = 'left';
        screenState.canvasCtx.textBaseline = 'top';
        screenState.canvasCtx.fillText("Score", screenState.X(10), screenState.Y(10));
        // Combobox Text
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.textAlign = 'right';
        screenState.canvasCtx.fillText("Combo", comboBoxXpos - screenState.S(10), screenState.Y(10));
        screenState.canvasCtx.textAlign = 'center';
        screenState.canvasCtx.textBaseline = 'middle';
        screenState.canvasCtx.font = `${screenState.S(48)}px Yusei Magic`;
        screenState.canvasCtx.fillText(comboText, comboBoxXpos - comboBoxHeight / 2.25, screenState.offsetY + comboBoxHeight / 2);
        // Progress Bar
        screenState.canvasCtx.globalAlpha = screenState.transitionProgress;
        screenState.canvasCtx.lineWidth = screenState.S(10);
        screenState.canvasCtx.strokeStyle = (0, $KjYoF.rgb)(228, 255, 26);
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.moveTo(screenState.offsetX, screenState.offsetY);
        let progressWidth;
        if (timeSinceInit <= 3000) progressWidth = 0;
        else progressWidth = this.currentPlayerPosition ? screenState.offsetX + screenState.width * Math.min(this.currentPlayerPosition / this.duration, 1) : timeSinceInit > 10000 ? screenState.offsetX + screenState.width : 0;
        screenState.canvasCtx.lineTo(progressWidth, screenState.offsetY);
        screenState.canvasCtx.stroke();
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.moveTo(progressWidth, screenState.offsetY);
        screenState.canvasCtx.strokeStyle = (0, $KjYoF.rgb)(149, 169, 0);
        screenState.canvasCtx.shadowColor = (0, $KjYoF.rgb)(149, 169, 0);
        screenState.canvasCtx.lineTo(screenState.offsetX + screenState.width, screenState.offsetY);
        screenState.canvasCtx.stroke();
        screenState.canvasCtx.globalAlpha = 1;
        screenState.canvasCtx.shadowBlur = 0;
    }
}

});

parcelRegister("aR0P0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e6f7dcaf88bc5ee$export$2e2bcd8739ae039);

var $jTmqR = parcelRequire("jTmqR");
parcelRequire("4NX2m");

var $dDUeu = parcelRequire("dDUeu");

var $KjYoF = parcelRequire("KjYoF");

var $arHBl = parcelRequire("arHBl");

var $ikHJv = parcelRequire("ikHJv");
class $7e6f7dcaf88bc5ee$var$ScoreBoard extends (0, $jTmqR.Drawable) {
    /**
  * Initialiases the Score Board drawable.
  * @param {boolean[]} comboBarData 
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  */ constructor(score, maxScore, maxCombo, avgReactTime, comboBarData, exitCallback, configureCanvas){
        super(0, 0, configureCanvas);
        this.score = score;
        this.maxScore = maxScore;
        this.scorePercentage = score / maxScore;
        this.maxCombo = maxCombo;
        this.avgReactTime = avgReactTime;
        this.comboBarData = comboBarData;
        this.missedWordsCount = comboBarData.filter((val)=>!val).length;
        this.exitCallback = exitCallback;
        this.exitButton = new (0, $ikHJv.CircularButton)(460, 535, 60, "Exit");
        this.exitButton.onClick = ()=>{
            this.exitButton.disabled = true;
            this.exitCallback();
        };
    // this.parsedComboData = new Array();
    // let baseCount = 0;
    // let currentComboState = comboBarData[0];
    // for (let i = 0; i < comboBarData.length; i++){
    //   if (i+1 == comboBarData.length){
    //     if (currentComboState == comboBarData[i]){
    //       baseCount++;
    //       this.parsedComboData.push(baseCount);
    //     }
    //     else{
    //       this.parsedComboData.push(baseCount);
    //       this.parsedComboData.push(1);
    //     }
    //     break;
    //   }
    //   else if (currentComboState == comboBarData[i]){
    //     baseCount++;
    //   }
    //   else{
    //     this.parsedComboData.push(baseCount);
    //     baseCount = 1
    //     currentComboState = !currentComboState;
    //   }
    // }
    }
    /**
   * Update the object's state based on the state of the cursor.
   * @param {Cursor[]} cursors The list of cursor objects to check if the button is colliding with the cursor. 
   * @param {ScreenState} screenState A positive number indicating current animation timeline
   */ updateHover(cursors, screenState) {
        const animationStep = screenState.animationStep;
        const timeSinceInit = animationStep - this.initTime;
        if (timeSinceInit > 1000) return this.exitButton.updateHover(cursors, screenState);
        return false;
    }
    // generatePraise(lang){
    //   return 'Good Job!'
    // }
    generateRankAndColour() {
        if (this.scorePercentage >= 0.85) return [
            'S',
            'green'
        ];
        else if (this.scorePercentage >= 0.7) return [
            'A',
            'green'
        ];
        else if (this.scorePercentage >= 0.6) return [
            'B',
            (0, $KjYoF.rgb)(232, 170, 20)
        ];
        else if (this.scorePercentage >= 0.5) return [
            'C',
            (0, $KjYoF.rgb)(232, 170, 20)
        ];
        else return [
            'D',
            'red'
        ];
    }
    /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ configure(screenState) {}
    /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ render(screenState) {
        super.render(screenState);
        const timeSinceInit = screenState.animationStep - this.initTime;
        const transitionProgress = timeSinceInit <= 1000 ? (0, $arHBl.easeOutExpo)(timeSinceInit / 1000) : screenState.transitionProgress;
        const scoreBoardComponent = new (0, $dDUeu.default)(210, 60, 1060, 635, screenState);
        const scoreBoardBounding = scoreBoardComponent.rectResizeV2(0, 5, 1000, 600, transitionProgress);
        screenState.canvasCtx.fillStyle = (0, $KjYoF.rgb)(108, 212, 255);
        screenState.canvasCtx.strokeStyle = (0, $KjYoF.rgb)(228, 255, 26);
        screenState.canvasCtx.lineWidth = 8;
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.roundRect(...scoreBoardBounding, [
            60
        ]);
        screenState.canvasCtx.fill();
        screenState.canvasCtx.stroke();
        const scoreBoardBoundingCenter = scoreBoardComponent.calculateCenter(...scoreBoardBounding);
        const [grade, gradeColour] = this.generateRankAndColour();
        const [gradeBoxX, gradeBoxY, gradeBoxWidth, gradeBoxHeight] = [
            ...scoreBoardComponent.resizeXY_V2(4, 124, ...scoreBoardBoundingCenter, transitionProgress),
            495 * scoreBoardComponent.scaling * transitionProgress,
            214 * scoreBoardComponent.scaling * transitionProgress
        ];
        screenState.canvasCtx.fillStyle = gradeColour;
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.rect(gradeBoxX, gradeBoxY, gradeBoxWidth, gradeBoxHeight);
        screenState.canvasCtx.fill();
        screenState.canvasCtx.strokeStyle = (0, $KjYoF.rgb)(255, 255, 255);
        screenState.canvasCtx.lineWidth = 10;
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.moveTo(...scoreBoardComponent.resizeXY_V2(0, 120, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.lineTo(...scoreBoardComponent.resizeXY_V2(1000, 120, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.stroke();
        screenState.canvasCtx.lineWidth = 5;
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.moveTo(...scoreBoardComponent.resizeXY_V2(500, 120, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.lineTo(...scoreBoardComponent.resizeXY_V2(500, 605, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.stroke();
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.moveTo(...scoreBoardComponent.resizeXY_V2(500, 282, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.lineTo(...scoreBoardComponent.resizeXY_V2(1000, 282, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.stroke();
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.moveTo(...scoreBoardComponent.resizeXY_V2(500, 444, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.lineTo(...scoreBoardComponent.resizeXY_V2(1000, 444, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.stroke();
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.moveTo(...scoreBoardComponent.resizeXY_V2(0, 340, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.lineTo(...scoreBoardComponent.resizeXY_V2(500, 340, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.stroke();
        // screenState.canvasCtx.setLineDash([18, 9]);
        // // screenState.canvasCtx.lineDashOffset = 20;
        // screenState.canvasCtx.lineDashOffset = -(screenState.animationStep/50 % 27);
        // screenState.canvasCtx.fillStyle = gradeColour;
        // screenState.canvasCtx.beginPath();
        const [gradeBoxCenterX, gradeBoxCenterY] = scoreBoardComponent.resizeXY_V2(252, 231, ...scoreBoardBoundingCenter, transitionProgress);
        // screenState.canvasCtx.arc(gradeBoxX, gradeBoxY, screenState.S(90*transitionProgress), 0, 2*Math.PI);
        // screenState.canvasCtx.fill();
        // screenState.canvasCtx.stroke();
        // screenState.canvasCtx.setLineDash([]);
        // screenState.canvasCtx.lineDashOffset = 0;
        screenState.canvasCtx.font = `bold ${screenState.S(30 * transitionProgress)}px Yusei Magic`;
        const gradeLabelMetrics = screenState.canvasCtx.measureText('Rank');
        const gradeLabelHeight = gradeLabelMetrics.actualBoundingBoxAscent + gradeLabelMetrics.actualBoundingBoxDescent;
        screenState.canvasCtx.font = `bold ${screenState.S(100 * transitionProgress)}px Yusei Magic`;
        const gradeMetrics = screenState.canvasCtx.measureText(grade);
        const gradeHeight = gradeMetrics.actualBoundingBoxAscent + gradeMetrics.actualBoundingBoxDescent;
        screenState.canvasCtx.fillStyle = (0, $KjYoF.rgb)(255, 255, 255);
        screenState.canvasCtx.textAlign = 'center';
        screenState.canvasCtx.textBaseline = 'middle';
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.fillText(grade, gradeBoxCenterX, gradeBoxCenterY - gradeLabelHeight / 2);
        screenState.canvasCtx.font = `bold ${screenState.S(30 * transitionProgress)}px Yusei Magic`;
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.fillText('Rank', gradeBoxCenterX, gradeBoxCenterY + gradeLabelHeight / 2 + gradeHeight / 2);
        screenState.canvasCtx.font = `bold ${screenState.S(72 * transitionProgress)}px Yusei Magic`;
        // screenState.canvasCtx.fillStyle = rgb(255, 255, 255);
        screenState.canvasCtx.textAlign = 'center';
        screenState.canvasCtx.textBaseline = 'middle';
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.fillText(`${this.score}/${this.maxScore} (${Math.round(this.scorePercentage * 100)}%)`, ...scoreBoardComponent.resizeXY_V2(500, 60, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.font = `bold ${screenState.S(36 * transitionProgress)}px Yusei Magic`;
        screenState.canvasCtx.textAlign = 'left';
        screenState.canvasCtx.textBaseline = 'top';
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.fillText(screenState.lang == 'jp' ? "\u6700\u5927\u30B3\u30F3\u30DC" : "Max Combo", ...scoreBoardComponent.resizeXY_V2(510, 130, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.fillText(screenState.lang == 'jp' ? "\u30DF\u30B9" : "Missed", ...scoreBoardComponent.resizeXY_V2(510, 288, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.fillText(screenState.lang == 'jp' ? "\u5E73\u5747\u53CD\u5FDC\u6642\u9593" : "Avg. Response Time", ...scoreBoardComponent.resizeXY_V2(510, 450, ...scoreBoardBoundingCenter, transitionProgress));
        // screenState.canvasCtx.textAlign = 'center';
        // screenState.canvasCtx.textBaseline = 'middle';
        // screenState.canvasCtx.beginPath();
        // screenState.canvasCtx.fillText(this.generatePraise('en'), ...scoreBoardComponent.resizeXY_V2(800, 585, ...scoreBoardBoundingCenter, transitionProgress));
        // screenState.canvasCtx.beginPath();
        // screenState.canvasCtx.fillText('Combo Bar', ...scoreBoardComponent.resizeXY_V2(310, 285, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.font = `${screenState.S(60 * transitionProgress)}px Yusei Magic`;
        // screenState.canvasCtx.textAlign = 'right';
        screenState.canvasCtx.textBaseline = 'top';
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.fillText(this.maxCombo, ...scoreBoardComponent.resizeXY_V2(510, 180, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.fillText(this.missedWordsCount, ...scoreBoardComponent.resizeXY_V2(510, 338, ...scoreBoardBoundingCenter, transitionProgress));
        screenState.canvasCtx.beginPath();
        screenState.canvasCtx.fillText(`${(Math.round(this.avgReactTime * 10) / 10).toString().replace('.', '.\u2005')}ms`, ...scoreBoardComponent.resizeXY_V2(510, 500, ...scoreBoardBoundingCenter, transitionProgress));
        [this.exitButton.overrideXpos, this.exitButton.overrideYpos] = scoreBoardComponent.resizeXY_V2(250, 475, ...scoreBoardBoundingCenter, transitionProgress);
        this.exitButton.overrideTransitionProgress = transitionProgress;
        this.exitButton.text = screenState.lang == 'jp' ? "\u7D42\u4E86" : 'Exit';
        this.exitButton.render(screenState);
    }
}
var $7e6f7dcaf88bc5ee$export$2e2bcd8739ae039 = $7e6f7dcaf88bc5ee$var$ScoreBoard;

});

parcelRegister("9rddt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6df0e326b8430fef$export$2e2bcd8739ae039);

var $arHBl = parcelRequire("arHBl");

var $jTmqR = parcelRequire("jTmqR");
parcelRequire("4NX2m");

var $KjYoF = parcelRequire("KjYoF");
class $6df0e326b8430fef$var$GameManual extends (0, $jTmqR.Drawable) {
    /**
  * Initialiases the Game Manual drawable. Designed to be displayed on the first screen.
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  */ constructor(img1, img2, img3, configureCanvas){
        super(0, 0, configureCanvas);
        this.img1 = img1;
        this.img2 = img2;
        this.img3 = img3;
    }
    /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ configure(screenState) {}
    /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */ render(screenState) {
        super.render(screenState);
        const timeSinceInit = screenState.animationStep - this.initTime;
        if (timeSinceInit < 500) screenState.canvasCtx.globalAlpha = 0;
        else if (timeSinceInit >= 500 < 1500) screenState.canvasCtx.globalAlpha = (0, $arHBl.easeInCubic)((timeSinceInit - 500) / 1000);
        else screenState.canvasCtx.globalAlpha = 1;
        // if (timeSinceInit >= 750 && this.player.isPlaying){//Safari has no volume control, thus must stop music.
        //   this.player.requestPause();
        // }
        if (screenState.gameMode == 'webcam') {
            const instructions = screenState.lang === 'en' ? [
                '1. Ensure there is only 1 person in frame.',
                '   For the best experience, have an empty background.',
                '2. Stand or sit 0.\u20055 metres away from your webcam.',
                '3. Ensure your upper body is visible in the webcam,',
                '   Curling your hand like knocking a door may make it easier. ',
                '4. Click on buttons by hovering your hand over them.',
                '5. When the timing is right, tap the lyric using your hand.',
                '(Double click with mouse to toggle full screen)'
            ] : [
                "1. \u753B\u9762\u306B1\u4EBA\u3060\u3051\u304C\u6620\u308B\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                "   \u80CC\u666F\u306F\u3067\u304D\u308B\u3060\u3051\u4F55\u3082\u306A\u3044\u65B9\u304C\u671B\u307E\u3057\u3044\u3067\u3059\u3002",
                "2. \u30A6\u30A7\u30D6\u30AB\u30E1\u30E9\u304B\u3089\u7D040.5\u30E1\u30FC\u30C8\u30EB\u96E2\u308C\u3066\u304F\u3060\u3055\u3044\u3002",
                "3. \u4E0A\u534A\u8EAB\u304C\u6620\u308B\u3088\u3046\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                "   \u624B\u3092\u30C9\u30A2\u3092\u30CE\u30C3\u30AF\u3059\u308B\u5F62\u306B\u3059\u308B\u3068\u64CD\u4F5C\u3057\u3084\u3059\u304F\u306A\u308A\u307E\u3059\u3002",
                "4. \u624B\u3092\u30DC\u30BF\u30F3\u306E\u4E0A\u306B\u304B\u3056\u3057\u3066\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002",
                "5. \u30BF\u30A4\u30DF\u30F3\u30B0\u306B\u5408\u308F\u305B\u3066\u6B4C\u8A5E\u3092\u30BF\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                "\uFF08\u30DE\u30A6\u30B9\u3067\u30C0\u30D6\u30EB\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u5168\u753B\u9762\u8868\u793A\u3092\u5207\u308A\u66FF\u3048\u3089\u308C\u307E\u3059\uFF09"
            ];
            // screenState.canvasCtx.imageSmoothingEnabled = false;
            const img1Height = this.img1.height / 8;
            this.img1.render(screenState.canvasCtx, ...screenState.rectResizeV2Static(20, 20, this.img1.width / 8, img1Height));
            const img2Bounding = screenState.rectResizeV2Static(20, 20 + img1Height + screenState.S(20), this.img2.width / 8, this.img2.width / 8);
            this.img2.render(screenState.canvasCtx, ...img2Bounding);
            // screenState.canvasCtx.imageSmoothingEnabled = true;
            const img3Width = this.img3.width / 5;
            const img3Height = this.img3.height / 5;
            this.img3.render(screenState.canvasCtx, ...screenState.rectResize(1400 - img3Width, 300 - img3Height / 2, img3Width, img3Height));
            screenState.canvasCtx.fillStyle = (0, $KjYoF.rgb)(255, 87, 20);
            screenState.canvasCtx.font = `${screenState.S(24)}px Yusei Magic`;
            screenState.canvasCtx.textAlign = 'left';
            screenState.canvasCtx.textBaseline = 'bottom';
            let text_instructions_width = 0;
            let textHeights = new Array();
            for(let i = instructions.length - 1; i >= 0; i--){
                const text_instructions_bounding = screenState.canvasCtx.measureText(instructions[i]);
                text_instructions_width = Math.max(text_instructions_width, text_instructions_bounding.width);
                textHeights.push(text_instructions_bounding.actualBoundingBoxAscent + text_instructions_bounding.actualBoundingBoxDescent + screenState.S(2));
            }
            const baseXpos = Math.max(screenState.X(780) - text_instructions_width / 2, img2Bounding[0] + img2Bounding[2] + screenState.S(15));
            const baseYpos = screenState.Y(690);
            let heightAccumulator = 0;
            for(let i = instructions.length - 1; i >= 0; i--){
                screenState.canvasCtx.fillText(instructions[i], baseXpos, baseYpos - heightAccumulator);
                heightAccumulator += textHeights[i];
            }
        // screenState.canvasCtx.beginPath();
        } else {
            const instructions = screenState.lang === 'en' ? [
                '1. Click on buttons by hovering your cursor over them.',
                '2. When the timing is right, tap or hover your cursor over the lyric.',
                '(Double click/tap to toggle full screen in game menus)'
            ] : [
                "1. \u624B\u3092\u30AB\u30FC\u30BD\u30EB\u306E\u4E0A\u306B\u304B\u3056\u3057\u3066\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002",
                "2. \u30BF\u30A4\u30DF\u30F3\u30B0\u306B\u5408\u308F\u305B\u3066\u3001\u6B4C\u8A5E\u306B\u30BF\u30C3\u30D7\u307E\u305F\u306F\u30AB\u30FC\u30BD\u30EB\u3092\u91CD\u306D\u307E\u3059",
                "\uFF08\u30E1\u30CB\u30E5\u30FC\u753B\u9762\u3067\u30C0\u30D6\u30EB\u30AF\u30EA\u30C3\u30AF\uFF0F\u30BF\u30C3\u30D7\u3067\u5168\u753B\u9762\u8868\u793A\u3092\u5207\u308A\u66FF\u3048\u3089\u308C\u307E\u3059\uFF09"
            ];
            screenState.canvasCtx.fillStyle = (0, $KjYoF.rgb)(255, 87, 20);
            screenState.canvasCtx.font = `${screenState.S(28)}px Yusei Magic`;
            screenState.canvasCtx.textAlign = 'left';
            screenState.canvasCtx.textBaseline = 'bottom';
            let text_instructions_width = 0;
            let textHeights = new Array();
            for(let i = instructions.length - 1; i >= 0; i--){
                const text_instructions_bounding = screenState.canvasCtx.measureText(instructions[i]);
                text_instructions_width = Math.max(text_instructions_width, text_instructions_bounding.width);
                textHeights.push(text_instructions_bounding.actualBoundingBoxAscent + text_instructions_bounding.actualBoundingBoxDescent + screenState.S(2));
            }
            const baseXpos = screenState.X(710) - text_instructions_width / 2;
            const baseYpos = screenState.Y(700);
            let heightAccumulator = 0;
            for(let i = instructions.length - 1; i >= 0; i--){
                screenState.canvasCtx.fillText(instructions[i], baseXpos, baseYpos - heightAccumulator);
                heightAccumulator += textHeights[i];
            }
        }
        screenState.canvasCtx.globalAlpha = 1;
    }
}
var $6df0e326b8430fef$export$2e2bcd8739ae039 = $6df0e326b8430fef$var$GameManual;

});



//# sourceMappingURL=mirai.c2367a7b.js.map
